(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"), require("keymirror"), require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("react"), require("prop-types"), require("lwr-client"), require("datefns"), require("leaflet.markercluster"), require("css!leaflet.markercluster-css"), require("css!leaflet.markercluster-default-css"), require("react-dom"), require("react-bootstrap"), require("css!map-css"));
	else if(typeof define === 'function' && define.amd)
		define(["leaflet", "keymirror", "liferay-widgets-react-web/js/liferay-widgets-react-web", "react", "prop-types", "lwr-client", "datefns", "leaflet.markercluster", "css!leaflet.markercluster-css", "css!leaflet.markercluster-default-css", "react-dom", "react-bootstrap", "css!map-css"], factory);
	else if(typeof exports === 'object')
		exports["map-portlet"] = factory(require("leaflet"), require("keymirror"), require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("react"), require("prop-types"), require("lwr-client"), require("datefns"), require("leaflet.markercluster"), require("css!leaflet.markercluster-css"), require("css!leaflet.markercluster-default-css"), require("react-dom"), require("react-bootstrap"), require("css!map-css"));
	else
		root["map-portlet"] = factory(root["leaflet"], root["keymirror"], root["liferay-widgets-react-web/js/liferay-widgets-react-web"], root["react"], root["prop-types"], root["lwr-client"], root["datefns"], root["leaflet.markercluster"], root["css!leaflet.markercluster-css"], root["css!leaflet.markercluster-default-css"], root["react-dom"], root["react-bootstrap"], root["css!map-css"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_26__, __WEBPACK_EXTERNAL_MODULE_27__, __WEBPACK_EXTERNAL_MODULE_29__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_31__, __WEBPACK_EXTERNAL_MODULE_68__, __WEBPACK_EXTERNAL_MODULE_78__, __WEBPACK_EXTERNAL_MODULE_146__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(6);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MapConfigWidget = exports.LayerConfigWidget = exports.MapWidget = exports.map_plugins_OrthoPhotoPlugin = exports.map_plugins_CoordinatesSearchPlugin = exports.map_plugins_LayerInfoPlugin = exports.map_plugins_SearchPlugin = exports.map_plugins_DisplayCoordinatesPlugin = exports.map_plugins_SituationMapPrintPlugin = exports.map_plugins_PrintPlugin = exports.map_plugins_SelectionDisplayPlugin = exports.map_plugins_GeoJsonPlugin = exports.map_plugins_HWRMPlugin = exports.map_plugins_BoundingboxInputPlugin = exports.map_plugins_ExportToImagePlugin = exports.map_plugins_RememberMapStatePlugin = exports.map_plugins_GeometryInputPlugin = exports.map_plugins_LayerChooserPlugin = exports.map_plugins_FeatureDisplayPlugin = exports.map_plugins_FullscreenPlugin = exports.map_plugins_LeafletLayerManagerPlugin = exports.map_plugins_MapConfigPlugin = exports.map_plugins_DefaultPosition = exports.LayerDataSource = exports.LogicalLayer = exports.MapConfig = exports.OrthoPhotoPlugin = exports.CoordinatesSearchPlugin = exports.LayerInfoPlugin = exports.SearchPlugin = exports.DisplayCoordinatesPlugin = exports.SituationMapPrintPlugin = exports.PrintPlugin = exports.GeoJsonPlugin = exports.HWRMPlugin = exports.ExportToImagePlugin = exports.BoundingboxInputPlugin = exports.LayerChooserPlugin = exports.RememberMapStatePlugin = exports.GeometryInputPlugin = exports.FeatureDisplayPlugin = exports.MapScalePlugin = exports.FullscreenPlugin = exports.LeafletLayerManagerPlugin = exports.MapConfigPlugin = exports.DefaultPosition = exports.DrawerPlugin = exports.LeafletSidebarScss = exports.ResizableControl = exports.LeafletSidebar = exports.GeoJsonActions = exports.MapActions = exports.Map = exports.DrawerGeoJsonLayer = exports.RemoteDataStoreGeoJsonLayer = exports.RemoteDataGeoJsonLayer = exports.LayerChooserSidebar = exports.MapLinkListItem = exports.LocationInput = exports.GeometryInput = exports.GeometryEditControl = exports.GeoJsonWebApi = exports.LayerWebApi = exports.LayerDataSourceWebApi = exports.LogicalLayerWebApi = exports.MapConfigWebApi = exports.FliwasCanvasRenderer = exports.DefaultFeatureRendererClass = exports.transformGeometryToFeatures = exports.getFeatureId = exports.getBoundsFromGeometry = exports.DefaultFeatureRenderer = exports.featureUtils = exports.FeatureManager = exports.ClassNames = undefined;
	
	var _icons = __webpack_require__(7);
	
	Object.keys(_icons).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _icons[key];
	        }
	    });
	});
	
	var _mapConfigUtil = __webpack_require__(10);
	
	Object.keys(_mapConfigUtil).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _mapConfigUtil[key];
	        }
	    });
	});
	
	var _ClassNames = __webpack_require__(11);
	
	Object.defineProperty(exports, 'ClassNames', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ClassNames).default;
	    }
	});
	
	var _FeatureManager = __webpack_require__(13);
	
	Object.defineProperty(exports, 'FeatureManager', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FeatureManager).default;
	    }
	});
	
	var _featureUtil = __webpack_require__(8);
	
	Object.defineProperty(exports, 'featureUtils', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_featureUtil).default;
	    }
	});
	
	var _DefaultFeatureRenderer = __webpack_require__(16);
	
	Object.defineProperty(exports, 'DefaultFeatureRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DefaultFeatureRenderer).default;
	    }
	});
	
	var _geoUtils = __webpack_require__(14);
	
	Object.defineProperty(exports, 'getBoundsFromGeometry', {
	    enumerable: true,
	    get: function get() {
	        return _geoUtils.getBoundsFromGeometry;
	    }
	});
	Object.defineProperty(exports, 'getFeatureId', {
	    enumerable: true,
	    get: function get() {
	        return _geoUtils.getFeatureId;
	    }
	});
	Object.defineProperty(exports, 'transformGeometryToFeatures', {
	    enumerable: true,
	    get: function get() {
	        return _geoUtils.transformGeometryToFeatures;
	    }
	});
	Object.defineProperty(exports, 'DefaultFeatureRendererClass', {
	    enumerable: true,
	    get: function get() {
	        return _DefaultFeatureRenderer.DefaultFeatureRenderer;
	    }
	});
	
	var _FliwasCanvasRenderer = __webpack_require__(17);
	
	Object.defineProperty(exports, 'FliwasCanvasRenderer', {
	    enumerable: true,
	    get: function get() {
	        return _FliwasCanvasRenderer.FliwasCanvasRenderer;
	    }
	});
	
	var _GeometryEditControl = __webpack_require__(18);
	
	Object.defineProperty(exports, 'GeometryEditControl', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_GeometryEditControl).default;
	    }
	});
	
	var _GeometryInput = __webpack_require__(97);
	
	Object.defineProperty(exports, 'GeometryInput', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_GeometryInput).default;
	    }
	});
	
	var _LocationInput = __webpack_require__(98);
	
	Object.defineProperty(exports, 'LocationInput', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_LocationInput).default;
	    }
	});
	
	var _MapLinkListItem = __webpack_require__(99);
	
	Object.defineProperty(exports, 'MapLinkListItem', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_MapLinkListItem).default;
	    }
	});
	
	var _LayerChooserSidebar = __webpack_require__(100);
	
	Object.defineProperty(exports, 'LayerChooserSidebar', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_LayerChooserSidebar).default;
	    }
	});
	
	var _RemoteDataGeoJsonLayer = __webpack_require__(102);
	
	Object.defineProperty(exports, 'RemoteDataGeoJsonLayer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_RemoteDataGeoJsonLayer).default;
	    }
	});
	
	var _RemoteDataStoreGeoJsonLayer = __webpack_require__(103);
	
	Object.defineProperty(exports, 'RemoteDataStoreGeoJsonLayer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_RemoteDataStoreGeoJsonLayer).default;
	    }
	});
	
	var _DrawerGeoJsonLayer = __webpack_require__(91);
	
	Object.defineProperty(exports, 'DrawerGeoJsonLayer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DrawerGeoJsonLayer).default;
	    }
	});
	
	var _Map = __webpack_require__(21);
	
	Object.defineProperty(exports, 'Map', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Map).default;
	    }
	});
	
	var _MapActions = __webpack_require__(104);
	
	Object.defineProperty(exports, 'MapActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_MapActions).default;
	    }
	});
	
	var _GeoJsonActions = __webpack_require__(106);
	
	Object.defineProperty(exports, 'GeoJsonActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_GeoJsonActions).default;
	    }
	});
	
	var _LControl = __webpack_require__(107);
	
	Object.defineProperty(exports, 'LeafletSidebar', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_LControl).default;
	    }
	});
	
	var _ResizableControl = __webpack_require__(108);
	
	Object.defineProperty(exports, 'ResizableControl', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ResizableControl).default;
	    }
	});
	
	var _leafletSidebar = __webpack_require__(111);
	
	Object.defineProperty(exports, 'LeafletSidebarScss', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_leafletSidebar).default;
	    }
	});
	
	var _DrawerPlugin = __webpack_require__(90);
	
	Object.defineProperty(exports, 'DrawerPlugin', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DrawerPlugin).default;
	    }
	});
	
	var _StoreFactory = __webpack_require__(44);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _MapWidget = __webpack_require__(113);
	
	Object.defineProperty(exports, 'MapWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_MapWidget).default;
	    }
	});
	
	var _LayerConfigWidget = __webpack_require__(117);
	
	Object.defineProperty(exports, 'LayerConfigWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_LayerConfigWidget).default;
	    }
	});
	
	var _MapConfigWidget = __webpack_require__(128);
	
	Object.defineProperty(exports, 'MapConfigWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_MapConfigWidget).default;
	    }
	});
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	__webpack_require__(146);
	
	var _MapConfigWebApi = __webpack_require__(50);
	
	var _MapConfigWebApi2 = _interopRequireDefault(_MapConfigWebApi);
	
	var _LogicalLayerWebApi = __webpack_require__(46);
	
	var _LogicalLayerWebApi2 = _interopRequireDefault(_LogicalLayerWebApi);
	
	var _LayerDataSourceWebApi = __webpack_require__(48);
	
	var _LayerDataSourceWebApi2 = _interopRequireDefault(_LayerDataSourceWebApi);
	
	var _LayerWebApi = __webpack_require__(147);
	
	var _LayerWebApi2 = _interopRequireDefault(_LayerWebApi);
	
	var _GeoJsonWebApi = __webpack_require__(148);
	
	var _GeoJsonWebApi2 = _interopRequireDefault(_GeoJsonWebApi);
	
	var _MapConfigActions = __webpack_require__(114);
	
	var _MapConfigActions2 = _interopRequireDefault(_MapConfigActions);
	
	var _DefaultPosition = __webpack_require__(41);
	
	var _DefaultPosition2 = _interopRequireDefault(_DefaultPosition);
	
	var _MapConfigPlugin = __webpack_require__(22);
	
	var _MapConfigPlugin2 = _interopRequireDefault(_MapConfigPlugin);
	
	var _LeafletLayerManagerPlugin = __webpack_require__(23);
	
	var _LeafletLayerManagerPlugin2 = _interopRequireDefault(_LeafletLayerManagerPlugin);
	
	var _FullscreenPlugin = __webpack_require__(149);
	
	var _FullscreenPlugin2 = _interopRequireDefault(_FullscreenPlugin);
	
	var _MapScalePlugin = __webpack_require__(42);
	
	var _MapScalePlugin2 = _interopRequireDefault(_MapScalePlugin);
	
	var _FeatureDisplayPlugin = __webpack_require__(150);
	
	var _FeatureDisplayPlugin2 = _interopRequireDefault(_FeatureDisplayPlugin);
	
	var _GeometryInputPlugin = __webpack_require__(65);
	
	var _GeometryInputPlugin2 = _interopRequireDefault(_GeometryInputPlugin);
	
	var _RememberMapStatePlugin = __webpack_require__(151);
	
	var _RememberMapStatePlugin2 = _interopRequireDefault(_RememberMapStatePlugin);
	
	var _LayerChooserPlugin = __webpack_require__(74);
	
	var _LayerChooserPlugin2 = _interopRequireDefault(_LayerChooserPlugin);
	
	var _BoundingboxInputPlugin = __webpack_require__(116);
	
	var _BoundingboxInputPlugin2 = _interopRequireDefault(_BoundingboxInputPlugin);
	
	var _ExportToImagePlugin = __webpack_require__(152);
	
	var _ExportToImagePlugin2 = _interopRequireDefault(_ExportToImagePlugin);
	
	var _HWRMPlugin = __webpack_require__(153);
	
	var _HWRMPlugin2 = _interopRequireDefault(_HWRMPlugin);
	
	var _GeoJsonPlugin = __webpack_require__(154);
	
	var _GeoJsonPlugin2 = _interopRequireDefault(_GeoJsonPlugin);
	
	var _SelectionDisplayPlugin = __webpack_require__(43);
	
	var _SelectionDisplayPlugin2 = _interopRequireDefault(_SelectionDisplayPlugin);
	
	var _PrintPlugin = __webpack_require__(155);
	
	var _PrintPlugin2 = _interopRequireDefault(_PrintPlugin);
	
	var _SituationMapPrintPlugin = __webpack_require__(156);
	
	var _SituationMapPrintPlugin2 = _interopRequireDefault(_SituationMapPrintPlugin);
	
	var _DisplayCoordinatesPlugin = __webpack_require__(157);
	
	var _DisplayCoordinatesPlugin2 = _interopRequireDefault(_DisplayCoordinatesPlugin);
	
	var _LayerInfoPlugin = __webpack_require__(76);
	
	var _LayerInfoPlugin2 = _interopRequireDefault(_LayerInfoPlugin);
	
	var _SearchPlugin = __webpack_require__(67);
	
	var _SearchPlugin2 = _interopRequireDefault(_SearchPlugin);
	
	var _OrthoPhotoPlugin = __webpack_require__(160);
	
	var _OrthoPhotoPlugin2 = _interopRequireDefault(_OrthoPhotoPlugin);
	
	__webpack_require__(163);
	
	var _CoordinatesSearchPlugin = __webpack_require__(73);
	
	var _CoordinatesSearchPlugin2 = _interopRequireDefault(_CoordinatesSearchPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MapConfigWebApi = _MapConfigWebApi2.default;
	exports.LogicalLayerWebApi = _LogicalLayerWebApi2.default;
	exports.LayerDataSourceWebApi = _LayerDataSourceWebApi2.default;
	exports.LayerWebApi = _LayerWebApi2.default;
	exports.GeoJsonWebApi = _GeoJsonWebApi2.default;
	
	
	_liferayWidgetsReactWeb.AppContext.registerBundle({
	    webApis: {
	        MapConfigWebApi: _MapConfigWebApi2.default,
	        LogicalLayerWebApi: _LogicalLayerWebApi2.default,
	        LayerDataSourceWebApi: _LayerDataSourceWebApi2.default,
	        GeoJsonWebApi: _GeoJsonWebApi2.default
	        //LayerWebApi
	    }
	});
	
	exports.DefaultPosition = _DefaultPosition2.default;
	exports.MapConfigPlugin = _MapConfigPlugin2.default;
	exports.LeafletLayerManagerPlugin = _LeafletLayerManagerPlugin2.default;
	exports.FullscreenPlugin = _FullscreenPlugin2.default;
	exports.MapScalePlugin = _MapScalePlugin2.default;
	exports.FeatureDisplayPlugin = _FeatureDisplayPlugin2.default;
	exports.GeometryInputPlugin = _GeometryInputPlugin2.default;
	exports.RememberMapStatePlugin = _RememberMapStatePlugin2.default;
	exports.LayerChooserPlugin = _LayerChooserPlugin2.default;
	exports.BoundingboxInputPlugin = _BoundingboxInputPlugin2.default;
	exports.ExportToImagePlugin = _ExportToImagePlugin2.default;
	exports.HWRMPlugin = _HWRMPlugin2.default;
	exports.GeoJsonPlugin = _GeoJsonPlugin2.default;
	exports.PrintPlugin = _PrintPlugin2.default;
	exports.SituationMapPrintPlugin = _SituationMapPrintPlugin2.default;
	exports.DisplayCoordinatesPlugin = _DisplayCoordinatesPlugin2.default;
	exports.SearchPlugin = _SearchPlugin2.default;
	exports.LayerInfoPlugin = _LayerInfoPlugin2.default;
	exports.CoordinatesSearchPlugin = _CoordinatesSearchPlugin2.default;
	exports.OrthoPhotoPlugin = _OrthoPhotoPlugin2.default;
	
	
	var MapPlugins = {
	    DefaultPosition: _DefaultPosition2.default,
	    MapConfigPlugin: _MapConfigPlugin2.default,
	    LeafletLayerManagerPlugin: _LeafletLayerManagerPlugin2.default,
	    FullscreenPlugin: _FullscreenPlugin2.default,
	    FeatureDisplayPlugin: _FeatureDisplayPlugin2.default,
	    LayerChooserPlugin: _LayerChooserPlugin2.default,
	    GeometryInputPlugin: _GeometryInputPlugin2.default,
	    RememberMapStatePlugin: _RememberMapStatePlugin2.default,
	    ExportToImagePlugin: _ExportToImagePlugin2.default,
	    BoundingboxInputPlugin: _BoundingboxInputPlugin2.default,
	    HWRMPlugin: _HWRMPlugin2.default,
	    SelectionDisplayPlugin: _SelectionDisplayPlugin2.default,
	    GeoJsonPlugin: _GeoJsonPlugin2.default,
	    PrintPlugin: _PrintPlugin2.default,
	    SituationMapPrintPlugin: _SituationMapPrintPlugin2.default,
	    DisplayCoordinatesPlugin: _DisplayCoordinatesPlugin2.default,
	    SearchPlugin: _SearchPlugin2.default,
	    LayerInfoPlugin: _LayerInfoPlugin2.default,
	    CoordinatesSearchPlugin: _CoordinatesSearchPlugin2.default,
	    OrthoPhotoPlugin: _OrthoPhotoPlugin2.default
	};
	
	var MapConfig = exports.MapConfig = undefined;
	var LogicalLayer = exports.LogicalLayer = undefined;
	var LayerDataSource = exports.LayerDataSource = undefined;
	var map_plugins_DefaultPosition = exports.map_plugins_DefaultPosition = _DefaultPosition2.default;
	var map_plugins_MapConfigPlugin = exports.map_plugins_MapConfigPlugin = _MapConfigPlugin2.default;
	var map_plugins_LeafletLayerManagerPlugin = exports.map_plugins_LeafletLayerManagerPlugin = _LeafletLayerManagerPlugin2.default;
	var map_plugins_FullscreenPlugin = exports.map_plugins_FullscreenPlugin = _FullscreenPlugin2.default;
	var map_plugins_FeatureDisplayPlugin = exports.map_plugins_FeatureDisplayPlugin = _FeatureDisplayPlugin2.default;
	var map_plugins_LayerChooserPlugin = exports.map_plugins_LayerChooserPlugin = _LayerChooserPlugin2.default;
	var map_plugins_GeometryInputPlugin = exports.map_plugins_GeometryInputPlugin = _GeometryInputPlugin2.default;
	var map_plugins_RememberMapStatePlugin = exports.map_plugins_RememberMapStatePlugin = _RememberMapStatePlugin2.default;
	var map_plugins_ExportToImagePlugin = exports.map_plugins_ExportToImagePlugin = _ExportToImagePlugin2.default;
	var map_plugins_BoundingboxInputPlugin = exports.map_plugins_BoundingboxInputPlugin = _BoundingboxInputPlugin2.default;
	var map_plugins_HWRMPlugin = exports.map_plugins_HWRMPlugin = _HWRMPlugin2.default;
	var map_plugins_GeoJsonPlugin = exports.map_plugins_GeoJsonPlugin = _GeoJsonPlugin2.default;
	var map_plugins_SelectionDisplayPlugin = exports.map_plugins_SelectionDisplayPlugin = _SelectionDisplayPlugin2.default;
	var map_plugins_PrintPlugin = exports.map_plugins_PrintPlugin = _PrintPlugin2.default;
	var map_plugins_SituationMapPrintPlugin = exports.map_plugins_SituationMapPrintPlugin = _SituationMapPrintPlugin2.default;
	var map_plugins_DisplayCoordinatesPlugin = exports.map_plugins_DisplayCoordinatesPlugin = _DisplayCoordinatesPlugin2.default;
	var map_plugins_SearchPlugin = exports.map_plugins_SearchPlugin = _SearchPlugin2.default;
	var map_plugins_LayerInfoPlugin = exports.map_plugins_LayerInfoPlugin = _LayerInfoPlugin2.default;
	var map_plugins_CoordinatesSearchPlugin = exports.map_plugins_CoordinatesSearchPlugin = _CoordinatesSearchPlugin2.default;
	var map_plugins_OrthoPhotoPlugin = exports.map_plugins_OrthoPhotoPlugin = _OrthoPhotoPlugin2.default;
	
	Object.keys(MapPlugins).filter(function (k) {
	    return !k.staticPlugin;
	}).map(function (k) {
	    var name = 'map_plugins_' + k;
	    (0, _liferayWidgetsReactWeb.amdDefine)(name, [], function () {
	        console.log('Defined Map Plugin from Module Map ' + name);
	    });
	});
	
	_MapConfigActions2.default.itemDefaultGrouped('GroupDefaultMapConfig', { groupId: _liferayWidgetsReactWeb.AppContext.getScopeGroupId() }); //early load Default Group MapConfig*/
	
	L.Icon.Default.imagePath = '/o/de.xdot.liferay.map.web/js/lib/leaflet/dist/css/images/';

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: n.gorte
	 * Date: 08.04.2019
	 * Time: 09:53
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.boIcon = boIcon;
	
	var _featureUtil = __webpack_require__(8);
	
	var ICONS_PATH = '/o/de.xdot.liferay.map.web/icons/2x/';
	
	var createDefaultIcon = function createDefaultIcon(iconUrl) {
	    return L.Icon.extend({
	        options: {
	            iconUrl: iconUrl,
	            popupAnchor: [0, -50],
	            iconSize: [25, 41],
	            iconAnchor: [12, 41]
	        }
	    });
	};
	
	var createHighlightIconIcon = function createHighlightIconIcon(iconUrl) {
	    return L.Icon.extend({
	        options: {
	            iconUrl: iconUrl,
	            popupAnchor: [0, -60],
	            iconSize: [35, 58],
	            iconAnchor: [17, 51]
	        }
	    });
	};
	
	var keysByClassNameType = {
	    'GaugingStation': 'pm',
	    'GaugingStation-default': 'pe',
	    'GaugingStation-local': 'pm',
	    'GaugingStation-automated-local': 'pk',
	    'GaugingStation-central': 'pl',
	    'FloodRetentionBasin': 'hrb',
	    'CriticalObject': 'ko',
	    'FloodProtectionObjectLine': 'hsl',
	    'FloodProtectionObjectPoint': 'hso',
	    'Group': 'kommune',
	    'PlannedActionVersion': 'massnahme',
	    'Task': 'progress-check',
	    'NewsMessage': 'news',
	    'DikeBreak': 'dike_break_b',
	    'DikeBreak-breachPoint': 'dike_break_b',
	    'DikeBreak-reliefPoint': 'dike_break_be',
	    'PrecipitationStation': 'np',
	    'RealPrecipitationStation': 'nr',
	    'PrecipitationStation-point': 'np',
	    'PrecipitationStation-area': 'nf',
	    'Quarter': 'tg',
	    'ManualBooleanState': 'mbs'
	};
	
	var iconCache = { h: {}, d: {} };
	
	function boIcon(className, typeKey, highlight, state) {
	    var key = keysByClassNameType[className + (typeKey ? '-' + typeKey : '')] || keysByClassNameType[className];
	    var path = ICONS_PATH + key + (state ? '_warn-level-' + _featureUtil.stateToValueMap[state] : '') + '@2x.png';
	    var cache = iconCache[highlight ? 'h' : 'd'];
	
	    return cache[path] || (cache[path] = new (highlight ? createHighlightIconIcon(path) : createDefaultIcon(path))());
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.stateToValueMap = undefined;
	exports.getFeature = getFeature;
	exports.asFeature = asFeature;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateToValueMap = exports.stateToValueMap = {
	    unknown: 0,
	    no: 1,
	    green: 1,
	    yellow: 2,
	    orange: 3,
	    red: 4,
	    yes: 4
	};
	
	exports.default = {
	    isMarker: function isMarker(layer) {
	        return layer instanceof _leaflet2.default.Marker;
	    },
	    notMarker: function notMarker(layer) {
	        return !!layer.getBounds;
	    },
	    isPolygon: function isPolygon(layer) {
	        return layer instanceof _leaflet2.default.Polygon || layer instanceof _leaflet2.default.Rectangle;
	    },
	    isLine: function isLine(layer) {
	        return layer instanceof _leaflet2.default.Polyline;
	    },
	    getFeatureRendererDependency: function getFeatureRendererDependency(feature) {
	        return 'FeatureRenderer/' + (feature.properties && feature.properties.type);
	    }
	};
	function getFeature(layer, newGeometry) {
	    return layer.feature ? _leaflet2.default.Util.extend({}, layer.feature, { geometry: newGeometry }) : asFeature(newGeometry);
	}
	
	function asFeature(geojson) {
	    if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
	        return geojson;
	    }
	
	    return {
	        type: 'Feature',
	        properties: {},
	        geometry: geojson
	    };
	}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isLayerSet = isLayerSet;
	exports.isLogicalLayer = isLogicalLayer;
	exports.isLayerDataSource = isLayerDataSource;
	exports.loopLogicalLayerIds = loopLogicalLayerIds;
	exports.loopLogicalLayers = loopLogicalLayers;
	exports.findLogicalLayer = findLogicalLayer;
	exports.findLogicalLayerInSets = findLogicalLayerInSets;
	exports.findAndSortLogicalLayers = findAndSortLogicalLayers;
	exports.findLogicalLayersWithoutZIndex = findLogicalLayersWithoutZIndex;
	exports.findAndSortLayerDataSource = findAndSortLayerDataSource;
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLayerSet(layer) {
	    return layer.type === _ClassNames2.default.LayerSet;
	} /**
	   * Created by Carsten Bühler
	   * User: c.buehler on 04.10.2016
	   * Copyright: xdot GmbH 2015
	   */
	
	function isLogicalLayer(layer) {
	    return layer.type === _ClassNames2.default.LogicalLayer;
	}
	
	function isLayerDataSource(layer) {
	    return layer.type === _ClassNames2.default.LayerDataSource;
	}
	
	function loopLogicalLayerIds(layerSet, list) {
	    layerSet.children.forEach(function (child) {
	        if (isLogicalLayer(child)) {
	            list.push(child.uuid);
	        } else if (isLayerSet(child)) {
	            list = loopLogicalLayerIds(child, list);
	        }
	    });
	    return list;
	}
	
	function loopLogicalLayers(layerSet, list) {
	    layerSet.children.forEach(function (child) {
	        if (isLogicalLayer(child)) {
	            list.push(child);
	        } else if (isLayerSet(child)) {
	            list = loopLogicalLayers(child, list);
	        }
	    });
	    return list;
	}
	
	function findLogicalLayer(layerSet, id) {
	    if (!isLayerSet(layerSet)) {
	        return undefined;
	    }
	    for (var _iterator = layerSet.children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	        } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	        }
	
	        var child = _ref;
	
	        if (isLogicalLayer(child) && child.id === id) {
	            return child;
	        }
	        if (isLayerSet(child)) {
	            var found = findLogicalLayer(child, id);
	            if (found !== undefined) {
	                return found;
	            }
	        }
	    }
	    return undefined;
	}
	
	function findLogicalLayerInSets(layerSets, id) {
	    for (var _iterator2 = layerSets, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i2++];
	        } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref2 = _i2.value;
	        }
	
	        var ls = _ref2;
	
	        var ll = findLogicalLayer(ls, id);
	        if (ll !== undefined) {
	            return ll;
	        }
	    }
	    return undefined;
	}
	
	function treeVisit(element, visitor) {
	    var visit = function visit(e) {
	        if (visitor(e) !== false && Array.isArray(e.children)) {
	            e.children.forEach(visit);
	        }
	    };
	    visit(element);
	}
	
	function filterElements(element, filter) {
	    var result = [];
	    element && (Array.isArray(element) ? element : [element]).forEach(function (element) {
	        return treeVisit(element, function (e) {
	            return filter(e) && result.push(e) || true;
	        });
	    });
	
	    return result;
	}
	
	function findAndSortLogicalLayers(element, logicalLayersPks) {
	    return filterElements(element, function (e) {
	        return isLogicalLayer(e) && (!logicalLayersPks || logicalLayersPks[e.uuid]);
	    }).sort(function (a, b) {
	        return a.zIndex > b.zIndex ? 1 : a.zIndex < b.zIndex ? -1 : 0;
	    });
	}
	
	function findLogicalLayersWithoutZIndex(element) {
	    return filterElements(element, function (e) {
	        return isLogicalLayer(e) && (!e.zIndex || e.zIndex > 0 && e.zIndex === Number.MAX_VALUE);
	    });
	}
	
	function findAndSortLayerDataSource(element, layerUuids) {
	    element = Array.isArray(element) ? element : [element];
	
	    //find all LogicalLayer and sort it by zIndex
	    var logicalLayer = findAndSortLogicalLayers(element, layerUuids);
	
	    //collect all layerDataSources from logicalLayers
	    var layerDataSources = [].concat.apply([], logicalLayer.map(function (ll) {
	        return ll.children.filter(isLayerDataSource);
	    }));
	
	    //collect all layerDataSources directly from element logicalLayers
	    return layerDataSources.concat(element.filter(isLayerDataSource).filter(function (e) {
	        return !layerUuids || layerUuids[e.uuid];
	    }));
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _keymirror = __webpack_require__(12);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _keymirror2.default)({
	    GeoFeature: null,
	    LogicalLayer: null,
	    LayerDataSource: null,
	    LayerSet: null,
	    MapConfig: null,
	    SituationMap: null
	}); /**
	     * Created by Carsten Bühler
	     * User: c.buehler on 14.06.2016
	     * Copyright: xdot GmbH 2015
	     */

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _geoUtils = __webpack_require__(14);
	
	var _DefaultFeatureRenderer = __webpack_require__(16);
	
	var _featureUtil = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler on 24.10.2016.
	 */
	
	var LoadingIcon = _leaflet2.default.Icon.extend({
	    options: {
	        iconUrl: '/map-portlet/assets/marker-icon-red.png',
	        popupAnchor: [0, -50],
	        iconSize: [25, 41],
	        iconAnchor: [12, 41]
	    }
	});
	
	exports.default = {
	
	    /**
	     Attention!
	     This methods replacing the given layer with a new created.
	     This only works if no handlers or other reverences are wired to the layer.
	      selfReplacingLoadingMarker(feature, options, rendererLoadingPromise) {
	        const bounds = getBoundsFromGeometry(feature);
	        return new LoadingMarker(bounds.getCenter(), feature, options, rendererLoadingPromise).setIcon(new LoadingIcon());
	    },     */
	
	    loadingMarker: function loadingMarker(feature) {
	        var bounds = (0, _geoUtils.getBoundsFromGeometry)(feature);
	        return _leaflet2.default.marker(bounds.getCenter()).setIcon(new LoadingIcon());
	    },
	    renderCluster: function renderCluster(cluster) {
	
	        var children = cluster.getAllChildMarkers();
	        var clusterOverallState = void 0;
	        for (var _iterator = children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var featureLayer = _ref;
	
	            var overallState = featureLayer.feature.properties.overallState;
	            if (!clusterOverallState && overallState) {
	                clusterOverallState = overallState;
	            }
	            if (overallState && _featureUtil.stateToValueMap[clusterOverallState] < _featureUtil.stateToValueMap[overallState]) {
	                clusterOverallState = overallState;
	            }
	
	            if (overallState === 'red') {
	                break;
	            }
	        }
	
	        var childCount = cluster.getChildCount();
	
	        return new _leaflet2.default.DivIcon({
	            html: '<div><span>' + childCount + '</span></div>',
	            className: 'marker-cluster marker-cluster-small ' + clusterOverallState,
	            iconSize: new _leaflet2.default.Point(40, 40)
	        });
	    },
	    createFeatureLayer: function createFeatureLayer(feature) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var returnPromiseOnMissing = arguments[2];
	
	        var renderer = new _DefaultFeatureRenderer.DefaultFeatureRenderer();
	        var layer = renderer.createFeatureLayer(feature, options);
	        layer.feature = feature;
	        return layer;
	    }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.transformGeometryToFeatures = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Hibbeler on 11.02.2016.
	                                                                                                                                                                                                                                                                   */
	
	
	exports.getFeatureId = getFeatureId;
	exports.toLatLng = toLatLng;
	exports.getBoundsFromGeometries = getBoundsFromGeometries;
	exports.getBoundsFromGeometry = getBoundsFromGeometry;
	exports.getBBoxFromGeometry = getBBoxFromGeometry;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function getFeatureId(f) {
	    //id alone is only valid for one modelClassName aka. type!
	    return f.properties.type + f.properties.id;
	}
	
	function toLatLng(o) {
	    if (o) {
	        if (o.lat) {
	            return o;
	        }
	        if (o.latitude) {
	            return { lat: o.latitude, lng: o.longitude };
	        }
	        console.warn('unsupported lat lng format: ', o);
	    }
	}
	
	function getBoundsFromGeometries(geometries) {
	    var bbox = new L.latLngBounds();
	
	    geometries.forEach(function (geometry) {
	        bbox.extend(getBoundsFromGeometry(geometry));
	    });
	
	    return bbox;
	}
	
	function getBoundsFromGeometry(geometry) {
	    var bbox = getBBoxFromGeometry(geometry);
	    if (bbox) {
	        var southWest = L.latLng(bbox[1], bbox[0]),
	            northEast = L.latLng(bbox[3], bbox[2]);
	
	        return L.latLngBounds(southWest, northEast);
	    }
	}
	
	function getBBoxFromGeometry(geometry) {
	    var coords = void 0,
	        bbox = void 0;
	    if (!geometry.hasOwnProperty('type')) return;
	    coords = _getCoordinatesDump(geometry);
	    bbox = [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY];
	    bbox = coords.reduce(function (prev, coord) {
	        return [Math.min(coord[0], prev[0]), Math.min(coord[1], prev[1]), Math.max(coord[0], prev[2]), Math.max(coord[1], prev[3])];
	    }, bbox);
	
	    if (bbox && bbox[0] < Number.POSITIVE_INFINITY && bbox[1] < Number.POSITIVE_INFINITY && bbox[2] > Number.NEGATIVE_INFINITY && bbox[3] > Number.NEGATIVE_INFINITY) {
	        return bbox;
	    }
	
	    return null;
	}
	
	function _getCoordinatesDump(gj) {
	    var coords = void 0;
	    if (gj.type === 'Point') {
	        coords = [gj.coordinates];
	    } else if (gj.type === 'LineString' || gj.type === 'MultiPoint') {
	        coords = gj.coordinates;
	    } else if (gj.type === 'Polygon' || gj.type === 'MultiLineString') {
	        coords = gj.coordinates.reduce(function (dump, part) {
	            return dump.concat(part);
	        }, []);
	    } else if (gj.type === 'MultiPolygon') {
	        coords = gj.coordinates.reduce(function (dump, poly) {
	            return dump.concat(poly.reduce(function (points, part) {
	                return points.concat(part);
	            }, []));
	        }, []);
	    } else if (gj.type === 'Feature') {
	        coords = _getCoordinatesDump(gj.geometry);
	    } else if (gj.type === 'GeometryCollection') {
	        coords = gj.geometries.reduce(function (dump, g) {
	            return dump.concat(_getCoordinatesDump(g));
	        }, []);
	    } else if (gj.type === 'FeatureCollection') {
	        coords = gj.features.reduce(function (dump, f) {
	            return dump.concat(_getCoordinatesDump(f));
	        }, []);
	    }
	    return coords;
	}
	
	var transformGeometryToFeatures = exports.transformGeometryToFeatures = function transformGeometryToFeatures(dataItem) {
	    var item = _liferayWidgetsReactWeb.DataUtil.asItem(dataItem);
	    if (item && item.geometry && item.geometry.features) {
	        return item.geometry.features.map(function (feature) {
	            return _extends({}, item, {
	                // className: dataItem.className,
	                className: feature.properties.type,
	                geometry: {
	                    coordinates: feature.geometry.coordinates,
	                    properties: feature.properties,
	                    type: feature.geometry.type
	                }
	            });
	        });
	    }
	    return [dataItem];
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DefaultFeatureRenderer = exports.HIGHLIGHT_DEFAULT_POLYGON = exports.DEFAULT_POLYGON = exports.HIGHLIGHT_DEFAULT_LINE = exports.DEFAULT_LINE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Bühler on 24.10.2016.
	                                                                                                                                                                                                                                                                   */
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _featureUtil = __webpack_require__(8);
	
	var _featureUtil2 = _interopRequireDefault(_featureUtil);
	
	var _icons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var stateColors = {
	    unknown: '#676a6c',
	    green: '#79e14b',
	    yellow: '#ffe700',
	    orange: '#ffad00',
	    red: '#f00000'
	};
	
	var DEFAULT_LINE = exports.DEFAULT_LINE = {
	    weight: 6,
	    opacity: 1,
	    dashArray: '20, 8',
	    dashStyle: {
	        color: '#676a6c'
	    }
	};
	
	var HIGHLIGHT_DEFAULT_LINE = exports.HIGHLIGHT_DEFAULT_LINE = _extends({}, DEFAULT_LINE, {
	    weight: 10
	});
	
	var DEFAULT_POLYGON = exports.DEFAULT_POLYGON = _extends({}, DEFAULT_LINE, {
	    weight: 5
	});
	
	var HIGHLIGHT_DEFAULT_POLYGON = exports.HIGHLIGHT_DEFAULT_POLYGON = _extends({}, DEFAULT_LINE, {
	    weight: 8,
	    fillOpacity: 0.4
	});
	
	var RedIcon = _leaflet2.default.Icon.extend({
	    options: {
	        iconUrl: '/map-portlet/assets/marker-icon-red.png',
	        popupAnchor: [0, -50],
	        iconSize: [25, 41],
	        iconAnchor: [12, 41]
	    }
	});
	
	var DefaultFeatureRenderer = exports.DefaultFeatureRenderer = function () {
	    function DefaultFeatureRenderer() {
	        _classCallCheck(this, DefaultFeatureRenderer);
	
	        this.icon = new _leaflet2.default.Icon.Default();
	        this.highlightIcon = new RedIcon();
	        this.line = DEFAULT_LINE;
	        this.highlightLine = HIGHLIGHT_DEFAULT_LINE;
	        this.polygon = DEFAULT_POLYGON;
	        this.highlightPolygon = HIGHLIGHT_DEFAULT_POLYGON;
	    }
	
	    DefaultFeatureRenderer.prototype.createFeatureLayer = function createFeatureLayer(feature, options) {
	        var highlight = options.highlight,
	            collapsed = options.collapsed;
	
	
	        var layer = void 0;
	
	        if (collapsed) {
	            layer = this.createCollapsedLayer(feature, options);
	        } else {
	            layer = this.createLayer(feature, options);
	        }
	
	        if (_featureUtil2.default.isMarker(layer)) {
	            this.styleMarker(layer, feature, highlight);
	        } else {
	            this.styleGeometry(layer, feature, highlight);
	        }
	
	        return layer;
	    };
	
	    DefaultFeatureRenderer.prototype.createLayer = function createLayer(feature, options) {
	        return _leaflet2.default.GeoJSON.geometryToLayer(feature, { bubblingMouseEvents: true, markersInheritOptions: true });
	    };
	
	    DefaultFeatureRenderer.prototype.createCollapsedLayer = function createCollapsedLayer(feature, options) {
	        var layer = _leaflet2.default.GeoJSON.geometryToLayer(feature, { bubblingMouseEvents: true, markersInheritOptions: true });
	        return _leaflet2.default.marker(layer.getBounds().getCenter(), { bubblingMouseEvents: true, markersInheritOptions: true });
	    };
	
	    DefaultFeatureRenderer.prototype.styleMarker = function styleMarker(layer, feature, highlight) {
	        var _feature$properties = feature.properties,
	            type = _feature$properties.type,
	            overallState = _feature$properties.overallState,
	            typeKey = _feature$properties.typeKey,
	            gaugingStationTypeKey = _feature$properties.gaugingStationTypeKey;
	
	
	        if (overallState) {
	            overallState = typeof overallState === 'string' ? overallState : overallState.state.stateKey;
	        }
	
	        var icon = (0, _icons.boIcon)(type, typeKey || gaugingStationTypeKey, highlight, overallState);
	
	        if (highlight) {
	            this._highlightMarker(layer, icon || this.highlightIcon);
	        } else {
	            this._renderMarker(layer, icon || this.icon);
	        }
	    };
	
	    DefaultFeatureRenderer.prototype.styleGeometry = function styleGeometry(layer, feature, highlight) {
	        var overallState = feature.properties.overallState;
	
	        var color = '#3388ff';
	
	        if (overallState) {
	            overallState = typeof overallState === 'string' ? overallState : overallState.state.stateKey;
	            color = stateColors[overallState];
	        }
	
	        var style = this.line;
	        if (_featureUtil2.default.isPolygon(layer, feature)) {
	            style = highlight ? this.highlightPolygon : this.polygon;
	        } else if (_featureUtil2.default.isLine(layer, feature)) {
	            style = highlight ? this.highlightLine : this.line;
	        }
	        layer.setStyle(_extends({}, style, {
	            color: color,
	            fillColor: color
	        }));
	    };
	
	    DefaultFeatureRenderer.prototype._renderMarker = function _renderMarker(layer, icon) {
	        layer.setZIndexOffset(0);
	        layer.setIcon(icon);
	    };
	
	    DefaultFeatureRenderer.prototype._highlightMarker = function _highlightMarker(layer, highlightIcon) {
	        layer.setZIndexOffset(1000);
	        layer.setIcon(highlightIcon);
	    };
	
	    return DefaultFeatureRenderer;
	}();
	
	exports.default = DefaultFeatureRenderer;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * User: n.gorte
	 * Date: 12.04.2019
	 * Time: 12:38
	 */
	'use strict';
	
	exports.__esModule = true;
	var FliwasCanvasRenderer = exports.FliwasCanvasRenderer = L.Canvas.extend({
	    onAdd: function onAdd(map) {
	        L.Renderer.prototype.onAdd.call(this, map);
	        // add this renderer so the map can quickly reference it
	        this._map._registerCanvasRenderer(this);
	
	        this._draw();
	    },
	    onRemove: function onRemove(map) {
	        L.Renderer.prototype.onRemove.call(this);
	        this.off('update', this._updatePaths, this);
	        map._unregisterCanvasRenderer(this);
	    },
	
	
	    _dispatchEvent: function _dispatchEvent(e) {
	        switch (e.type) {
	            case 'mousemove':
	                this._onMouseMove(e);
	                break;
	            case 'click':
	                this._onClick(e);
	                break;
	        }
	    },
	
	    // Canvas obviously doesn't have mouse events for individual drawn objects,
	    // so we emulate that by calculating what's under the mouse on mousemove/click manually
	    _onClick: function _onClick(e) {
	        var point = this._map.mouseEventToLayerPoint(e);
	        var layer = void 0,
	            clickedLayer = void 0;
	
	        for (var order = this._drawFirst; order; order = order.next) {
	            layer = order.layer;
	            if (layer.options.interactive && layer._containsPoint(point)) {
	                if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) {
	                    clickedLayer = layer;
	                }
	            }
	        }
	        if (clickedLayer) {
	            L.DomEvent.fakeStop(e);
	            this._fireEvent([clickedLayer], e);
	        } else {
	            // layer wasn't found, send to map to find if other canvas layers can handle event
	            // https://inovum-dev.de/jira/browse/FLIWASEN-932
	            this._map._forwardCanvasEvent(this, e);
	        }
	    },
	
	
	    _handleMouseOut: function _handleMouseOut(e) {
	        var layer = this._hoveredLayer;
	        if (layer) {
	            // if we're leaving the layer, fire mouseout
	            L.DomUtil.removeClass(this._container, 'leaflet-interactive');
	            this._fireEvent([layer], e, 'mouseout');
	            this._hoveredLayer = null;
	            this._mouseHoverThrottled = false;
	            // fix for https://github.com/elmarquis/Leaflet.GestureHandling/issues/44
	            // enabling map interactions after mouseout
	            this._map.gestureHandling._handleMouseOver();
	        }
	    },
	
	    _handleMouseHover: function _handleMouseHover(e, point) {
	        var _this = this;
	
	        if (this._mouseHoverThrottled) {
	            return;
	        }
	        var layer = void 0,
	            candidateHoveredLayer = void 0;
	
	        for (var order = this._drawFirst; order; order = order.next) {
	            layer = order.layer;
	            if (layer.options.interactive && layer._containsPoint(point)) {
	                candidateHoveredLayer = layer;
	            }
	        }
	
	        if (candidateHoveredLayer !== this._hoveredLayer) {
	            this._handleMouseOut(e);
	
	            if (candidateHoveredLayer) {
	                L.DomUtil.addClass(this._container, 'leaflet-interactive'); // change cursor
	                this._fireEvent([candidateHoveredLayer], e, 'mouseover');
	                this._hoveredLayer = candidateHoveredLayer;
	            }
	        }
	
	        // if no layer was found, forward it to the next canvas renderer if it exists
	        if (!candidateHoveredLayer) {
	            this._map._forwardCanvasEvent(this, e);
	        }
	
	        if (this._hoveredLayer) {
	            this._fireEvent([this._hoveredLayer], e);
	        }
	
	        this._mouseHoverThrottled = true;
	        setTimeout(function () {
	            _this._mouseHoverThrottled = false;
	        }, 32);
	    },
	
	    _updatePoly: function _updatePoly(layer, closed) {
	        if (!this._drawing) {
	            return;
	        }
	
	        var i,
	            j,
	            len2,
	            p,
	            parts = layer._parts,
	            len = parts.length,
	            ctx = this._ctx;
	
	        if (!len) {
	            return;
	        }
	
	        ctx.beginPath();
	        for (i = 0; i < len; i++) {
	            for (j = 0, len2 = parts[i].length; j < len2; j++) {
	                p = parts[i][j];
	                ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
	            }
	            if (closed) {
	                ctx.closePath();
	            }
	        }
	        this._fillStroke(ctx, layer);
	
	        if (layer.options._dashArray && layer.options.dashStyle) {
	            //ctx.beginPath();
	            for (i = 0; i < len; i++) {
	                for (j = 0, len2 = parts[i].length; j < len2; j++) {
	                    p = parts[i][j];
	                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
	                }
	                if (closed) {
	                    ctx.closePath();
	                }
	            }
	            this._fillDashes(ctx, layer);
	        }
	    },
	
	    _fillStroke: function _fillStroke(ctx, layer) {
	        var options = layer.options;
	
	        if (options.fill) {
	            ctx.globalAlpha = options.fillOpacity;
	            ctx.fillStyle = options.fillColor || options.color;
	            ctx.fill(options.fillRule || 'evenodd');
	        }
	
	        if (options.stroke && options.weight !== 0) {
	            if (ctx.setLineDash) {
	                if (!options.dashStyle) {
	                    ctx.setLineDash(layer.options && layer.options._dashArray || []);
	                } else {
	                    ctx.setLineDash([]);
	                }
	            }
	            ctx.globalAlpha = options.opacity;
	            ctx.lineWidth = options.weight;
	            ctx.strokeStyle = options.color;
	            ctx.lineCap = options.lineCap;
	            ctx.lineJoin = options.lineJoin;
	            ctx.stroke();
	        }
	    },
	
	    _fillDashes: function _fillDashes(ctx, layer) {
	        var options = layer.options;
	        var dashStyle = options.dashStyle;
	
	
	        if (options.stroke && options.weight !== 0) {
	            ctx.setLineDash([].concat(options._dashArray).reverse());
	            ctx.globalAlpha = dashStyle.opacity || options.opacity;
	            ctx.lineWidth = dashStyle.weight || options.weight;
	            ctx.strokeStyle = dashStyle.color || options.color;
	            ctx.lineCap = options.lineCap;
	            ctx.lineJoin = options.lineJoin;
	            ctx.stroke();
	        }
	    }
	});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 05.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Map = __webpack_require__(21);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _GeometryInputPlugin = __webpack_require__(65);
	
	var _GeometryInputPlugin2 = _interopRequireDefault(_GeometryInputPlugin);
	
	var _SearchPlugin = __webpack_require__(67);
	
	var _SearchPlugin2 = _interopRequireDefault(_SearchPlugin);
	
	var _CoordinatesSearchPlugin = __webpack_require__(73);
	
	var _CoordinatesSearchPlugin2 = _interopRequireDefault(_CoordinatesSearchPlugin);
	
	var _LayerChooserPlugin = __webpack_require__(74);
	
	var _LayerChooserPlugin2 = _interopRequireDefault(_LayerChooserPlugin);
	
	var _LayerInfoPlugin = __webpack_require__(76);
	
	var _LayerInfoPlugin2 = _interopRequireDefault(_LayerInfoPlugin);
	
	var _DrawerPlugin = __webpack_require__(90);
	
	var _DrawerPlugin2 = _interopRequireDefault(_DrawerPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeometryEditControl = function GeometryEditControl(props) {
	    var geometry = props.geometry,
	        _props$plugins = props.plugins,
	        plugins = _props$plugins === undefined ? [] : _props$plugins,
	        type = props.type,
	        handleGeometryChange = props.handleGeometryChange,
	        _props$allowMultipleG = props.allowMultipleGeometries,
	        allowMultipleGeometries = _props$allowMultipleG === undefined ? false : _props$allowMultipleG;
	
	
	    var newPlugins = [_SearchPlugin2.default, _CoordinatesSearchPlugin2.default].concat(plugins, [_LayerChooserPlugin2.default, _LayerInfoPlugin2.default, 'map/plugins/SituationMapPlugin', allowMultipleGeometries ? _DrawerPlugin2.default : _GeometryInputPlugin2.default]);
	
	    var geoEditProps = allowMultipleGeometries ? {
	        drawerGeoJSON: geometry,
	        drawerPluginTextLabel: false,
	        drawerPluginColorPicker: false,
	        onDrawerChange: handleGeometryChange
	    } : {
	        geometry: geometry,
	        type: type,
	        onGeometryChange: handleGeometryChange
	    };
	
	    return _react2.default.createElement(_Map2.default, _extends({
	        className: 'leaflet-draw-horizontal'
	    }, props, {
	        defaultFallbackMapConfigType: 'static',
	        plugins: newPlugins
	    }, geoEditProps));
	};
	
	GeometryEditControl.propTypes = _extends({}, _Map2.default.propTypes, {
	
	    geometry: _propTypes2.default.object,
	    type: _propTypes2.default.string,
	    handleGeometryChange: _propTypes2.default.func,
	    allowMultipleGeos: _propTypes2.default.bool
	});
	
	exports.default = GeometryEditControl;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler on 07.02.2016.
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _MapConfigPlugin = __webpack_require__(22);
	
	var _MapConfigPlugin2 = _interopRequireDefault(_MapConfigPlugin);
	
	var _LeafletLayerManagerPlugin = __webpack_require__(23);
	
	var _LeafletLayerManagerPlugin2 = _interopRequireDefault(_LeafletLayerManagerPlugin);
	
	var _DefaultPosition = __webpack_require__(41);
	
	var _DefaultPosition2 = _interopRequireDefault(_DefaultPosition);
	
	var _MapScalePlugin = __webpack_require__(42);
	
	var _MapScalePlugin2 = _interopRequireDefault(_MapScalePlugin);
	
	var _SelectionDisplayPlugin = __webpack_require__(43);
	
	var _SelectionDisplayPlugin2 = _interopRequireDefault(_SelectionDisplayPlugin);
	
	var _StoreFactory = __webpack_require__(44);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _leafletGestureHandling = __webpack_require__(52);
	
	__webpack_require__(53);
	
	__webpack_require__(57);
	
	__webpack_require__(59);
	
	var _FliwasCanvasRenderer = __webpack_require__(17);
	
	__webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Leaflet = _leaflet2.default; //this is a hack because we use a global Leaflet
	/*
	FLIWASEN-932
	Canvas layers don't propagate events to layers below in the layer stack. Even after removing
	the layer leaflet keeps the empty canvas in the layer pane.
	We extend the map to keep track of all added canvas layers by zIndex and forward events to
	layers positioned below.
	Check FliwasCanvasRenders _onClick and _handleMouseOver to see how events are forwarded
	 */
	_leaflet2.default.Map.include({
	    // object that stores arrays of canvas renderers by zIndex
	    _canvasRenderers: {},
	    _registerCanvasRenderer: function _registerCanvasRenderer(layer) {
	        var zIndex = layer.options.zIndex;
	        if (this._canvasRenderers[zIndex]) {
	            this._canvasRenderers[zIndex].push(layer);
	        } else {
	            this._canvasRenderers[zIndex] = [layer];
	        }
	    },
	
	    _unregisterCanvasRenderer: function _unregisterCanvasRenderer(layer) {
	        var zIndex = layer.options.zIndex;
	        if (this._canvasRenderers[zIndex]) {
	            this._canvasRenderers[zIndex] = this._canvasRenderers[zIndex].filter(function (r) {
	                return r !== layer;
	            });
	            if (this._canvasRenderers[zIndex].length === 0) {
	                delete this._canvasRenderers[zIndex];
	            }
	        }
	    },
	
	    _forwardCanvasEvent: function _forwardCanvasEvent(layer, e) {
	        var latLng = this.mouseEventToLatLng(e);
	        /*
	        Projects a geographical coordinate LatLng according to the projection of the map's CRS,
	        then scales it according to zoom and the CRS's transformation.
	        The result is pixel coordinate relative to the CRS origin which gets divided by tile size.
	         */
	        var tileCoord = this.project(latLng, this.getZoom()).floor().unscaleBy(_leaflet2.default.point(256, 256)).floor();
	        tileCoord.z = this.getZoom();
	
	        // 1000: fliwas object layers
	        var zIndex = layer.options.zIndex || 1000;
	        var nextZIndex = -1;
	        Object.keys(this._canvasRenderers).forEach(function (key) {
	            if (key < zIndex && key > nextZIndex) {
	                nextZIndex = key;
	            }
	        });
	        var forwardRenderers = this._canvasRenderers[nextZIndex];
	
	        if (forwardRenderers) {
	            // forward to the renderer *below* the renderer the originally received event
	            forwardRenderers.filter(function (r) {
	                if (r._bounds) {
	                    return r._bounds.contains(latLng);
	                }
	                return r._tileCoord.equals(tileCoord);
	            }).forEach(function (r) {
	                r._dispatchEvent && r._dispatchEvent(e);
	            });
	        }
	    }
	});
	
	_leaflet2.default.Map.addInitHook('addHandler', 'gestureHandling', _leafletGestureHandling.GestureHandling);
	
	//Bugfix FLIWAS-1052
	_leaflet2.default.Path.addInitHook(function () {
	    this._onClick = this._fireMouseEvent;
	});
	
	var isOverflown = function isOverflown(element) {
	    return element.scrollHeight > element.clientHeight;
	};
	var isFullscreen = function isFullscreen() {
	    return document.isFullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.body.classList.contains('map-fullscreen');
	};
	
	var MapConfigStore = (0, _StoreFactory.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext);
	
	var Map = function (_PluginComponent) {
	    _inherits(Map, _PluginComponent);
	
	    function Map(props) {
	        _classCallCheck(this, Map);
	
	        var _this = _possibleConstructorReturn(this, _PluginComponent.call(this, props, props.plugins));
	
	        var mapKey = props.mapKey || _liferayWidgetsReactWeb.UidUtil.generateId('map');
	
	        _this.state = _extends({}, _this.state, {
	            mapKey: mapKey
	        });
	
	        // not using state to prevent plugin updates and re-render
	        _this.overflow = false;
	        _this.scrollOverlay = null;
	        _this.isFullscreen = null;
	
	        _this.initDefaultPlugins();
	        _this.onResize = _this.onResize.bind(_this);
	        return _this;
	    }
	
	    Map.prototype.initDefaultPlugins = function initDefaultPlugins() {
	        var _this2 = this;
	
	        console.log('Map initDefaultPlugins()');
	        this.defaultPluginDefaultPosition = this.asPlugin(_DefaultPosition2.default);
	        this.defaultPluginMapConfigPlugin = this.asPlugin(_MapConfigPlugin2.default);
	        this.defaultPluginLeafletLayerManagerPlugin = this.asPlugin(_LeafletLayerManagerPlugin2.default);
	        this.defaultPluginMapScalePlugin = this.asPlugin(_MapScalePlugin2.default);
	        this.defaultPluginSelectionDisplayPlugin = this.asPlugin(_SelectionDisplayPlugin2.default);
	        Object.keys(this).filter(function (k) {
	            return k.indexOf('defaultPlugin') === 0 && (_this2[k].staticPlugin && !_this2[k].staticPlugin || _this2[k].constructor && !_this2[k].constructor.staticPlugin);
	        }).forEach(function (p) {
	            return console.error('Default plugin is not static', p);
	        });
	    };
	
	    Map.prototype.onPluginsChanged = function onPluginsChanged(newPlugins) {
	        _PluginComponent.prototype.onPluginsChanged.call(this, newPlugins);
	        this.initDefaultPlugins();
	    };
	
	    Map.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.map) {
	            this.map.off();
	            this.map.remove();
	        }
	        _PluginComponent.prototype.componentWillUnmount.call(this);
	    };
	
	    Map.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	        var mapKey = nextProps.mapKey || this.state.mapKey || _liferayWidgetsReactWeb.UidUtil.generateId('map');
	        if (mapKey !== this.state.mapKey) {
	            this.setState({
	                mapKey: mapKey
	            });
	        }
	
	        _PluginComponent.prototype.UNSAFE_componentWillReceiveProps.call(this, nextProps);
	    };
	
	    Map.prototype.plugins = function plugins() {
	        return [this.defaultPluginDefaultPosition, this.defaultPluginMapConfigPlugin].concat(_PluginComponent.prototype.plugins.call(this), [this.defaultPluginLeafletLayerManagerPlugin, this.defaultPluginMapScalePlugin, this.defaultPluginSelectionDisplayPlugin]);
	    };
	
	    //React update is finished. Init or update the map
	
	
	    Map.prototype.initWithPlugins = function initWithPlugins(o) {
	        var _this3 = this;
	
	        console.log('Init map! options: ', o, ' plugins: ', this.plugins());
	        o.maxZoom = o.maxZoom || 18;
	        this.map = Leaflet.map(this.state.mapKey, _extends({}, o, {
	            maxZoom: 18,
	            preferCanvas: true,
	            renderer: new _FliwasCanvasRenderer.FliwasCanvasRenderer(),
	            dragging: !_leaflet2.default.Browser.mobile,
	            tap: !_leaflet2.default.Browser.mobile,
	            gestureHandling: false,
	            gestureHandlingText: {
	                touch: 'Verschieben der Karte mit zwei Fingern',
	                scroll: 'Verwenden Sie Strg + Scrollen zum Zoomen der Karte',
	                scrollMac: 'Verwenden Sie \u2318 + Scrollen zum Zoomen der Karte'
	            }
	        }));
	        this.map.whenReady(function () {
	            return _this3.map.gestureHandling._handleMouseOver();
	        });
	
	        // access with map.toast
	        _leaflet2.default.control.toast({
	            timeout: 3000,
	            position: 'bottomcenter',
	            closable: true,
	            dismissable: true
	        }).addTo(this.map);
	
	        this.map.attributionControl.setPrefix('&copy; Leaflet');
	        this.map.attributionControl.addAttribution('&copy; 2024 <a href="https://maps.omniscale.com/en/" target="_blank">maps.omniscale.com</a>, Kartendaten: <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> - (Lizenz ODbL)');
	        this.map.sideBars = []; // store all sidebars here to close them if another ones opens
	        this.map.blockingControlActive = false; // flag to prevent certain actions while a blocking control is active
	
	        this.isFullscreen = isFullscreen();
	        Array.prototype.forEach.call(document.getElementsByClassName('modal-body'), function (elem) {
	            if (elem.contains(_this3.map._container)) {
	                _this3.modal = elem;
	            }
	        });
	
	        this.map.on('resize', this.onResize);
	
	        this.updateMap(this.map, o);
	        if (false) {
	            o = Object.freeze(o);
	        }
	        this.callPluginsInit(this.map, o);
	    };
	
	    Map.prototype.reinitWithPlugins = function reinitWithPlugins(o) {
	        console.log('Reinit map! options: ', o, ' plugins: ', this.plugins());
	        if (this.map) {
	            this.map.remove();
	        }
	
	        this.initWithPlugins(o);
	    };
	
	    Map.prototype.updateWithPlugins = function updateWithPlugins(o) {
	        this.updateMap(this.map, o);
	        this.callPluginsUpdate(this.map, o);
	    };
	
	    Map.prototype.updateMap = function updateMap(map, o) {
	        if (o && o.boundRequest && !o.boundRequest.handled) {
	            var bounds = o.boundRequest.bounds;
	
	            if (bounds && bounds.getNorthEast().equals(bounds.getSouthWest())) {
	                if (!map.getZoom()) {
	                    map.setZoom(10);
	                }
	                map.panTo(o.boundRequest.bounds.getCenter(), o.boundRequest.options);
	            } else {
	                if (bounds) {
	                    map.fitBounds(o.boundRequest.bounds, o.boundRequest.options);
	                }
	            }
	            o.boundRequest.cb();
	            o.boundRequest.handled = true;
	        }
	
	        this.onResize();
	    };
	
	    Map.prototype.onResize = function onResize() {
	        this.isFullscreen = isFullscreen();
	        this.overflow = isOverflown(this.modal || document.body);
	        if (this.overflow && !this.isFullscreen) {
	            this.map && this.map.gestureHandling.enable();
	        } else {
	            this.map && this.map.gestureHandling.disable();
	        }
	    };
	
	    Map.prototype.render = function render() {
	        var _this4 = this;
	
	        return _react2.default.createElement(
	            'div',
	            {
	                ref: function ref(div) {
	                    return _this4.container = div;
	                },
	                id: this.state.mapKey,
	                style: _extends({
	                    height: '350px',
	                    width: '100%'
	                }, this.props.style),
	                className: this.props.className
	            },
	            this.state.loadPlugins && _react2.default.createElement(
	                'span',
	                null,
	                'Plugins werden geladen'
	            )
	        );
	    };
	
	    return Map;
	}(_liferayWidgetsReactWeb.PluginComponent);
	
	function MapConfigWrapper(props) {
	    var _props$plugins = props.plugins,
	        plugins = _props$plugins === undefined ? [] : _props$plugins,
	        _props$defaultFallbac = props.defaultFallbackMapConfigType,
	        defaultFallbackMapConfigType = _props$defaultFallbac === undefined ? 'default' : _props$defaultFallbac,
	        dataMapConfig = props.mapConfig || (defaultFallbackMapConfigType === 'default' ? MapConfigStore.getDefaultMapConfig() : MapConfigStore.getFallbackMapConfig()),
	        mapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(dataMapConfig),
	        mapConfigPlugins = mapConfig && mapConfig.plugins || [];
	
	    return _react2.default.createElement(
	        _liferayWidgetsReactWeb.FlagComponent,
	        { item: mapConfig },
	        _react2.default.createElement(Map, _extends({}, props, {
	            mapConfig: dataMapConfig,
	            plugins: mapConfigPlugins.concat(plugins)
	        }))
	    );
	}
	
	Map.contextTypes = {
	    contextId: _propTypes2.default.string
	};
	
	Map.propTypes = _extends({}, _liferayWidgetsReactWeb.PluginComponent.propTypes, {
	    mapKey: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    selectedItems: _propTypes2.default.array,
	    disabledItems: _propTypes2.default.array
	});
	
	MapConfigWrapper.propTypes = {
	    plugins: _propTypes2.default.array,
	    defaultFallbackMapConfigType: _propTypes2.default.oneOf(['default', 'static']),
	    mapConfig: _propTypes2.default.object
	};
	
	exports.default = MapConfigWrapper;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 16.12.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MapConfigPlugin = function () {
	    function MapConfigPlugin(props) {
	        _classCallCheck(this, MapConfigPlugin);
	
	        this.boundRequestHandled = false;
	        this.boundRequestCb = this.boundRequestCb.bind(this);
	    }
	
	    MapConfigPlugin.prototype.init = function init(map) {
	        console.log('MapConfigPlugin init()', map);
	        this.map = map;
	    };
	
	    MapConfigPlugin.prototype.initOptions = function initOptions(o) {
	        console.log('MapConfigPlugin initOptions()');
	        var mapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(o.mapConfig);
	        if (mapConfig) {
	            var bb = mapConfig.boundingBox;
	            if (bb && bb.latitudeMax && bb.longitudeMax) {
	                var southWest = _leaflet2.default.latLng(bb.latitudeMin, bb.longitudeMin),
	                    northEast = _leaflet2.default.latLng(bb.latitudeMax, bb.longitudeMax);
	
	                o.boundRequest = {
	                    bounds: _leaflet2.default.latLngBounds(southWest, northEast),
	                    options: { animate: false },
	                    cb: this.boundRequestCb
	                };
	            }
	        }
	        return this.options(o);
	    };
	
	    MapConfigPlugin.prototype.options = function options(o) {
	        var mapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(o.mapConfig);
	
	        if (mapConfig) {
	            o = _extends({}, o, {
	                layerDescriptions: (o.layerDescriptions || []).concat(mapConfig.children || []),
	                baseLayerDescriptions: (o.baseLayerDescriptions || []).concat(mapConfig.baseLayer || []),
	                defaultBaseLayerId: mapConfig.defaultBaseLayerId
	            });
	        }
	
	        return o;
	    };
	
	    MapConfigPlugin.prototype.boundRequestCb = function boundRequestCb() {
	        this.boundRequestHandled = true;
	    };
	
	    return MapConfigPlugin;
	}();
	
	exports.default = MapConfigPlugin;
	
	
	MapConfigPlugin.staticPlugin = true;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 16.12.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _LayerFactory = __webpack_require__(24);
	
	var _LayerFactory2 = _interopRequireDefault(_LayerFactory);
	
	var _mapConfigUtil = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LeafletLayerManagerPlugin = function () {
	    function LeafletLayerManagerPlugin(props) {
	        _classCallCheck(this, LeafletLayerManagerPlugin);
	
	        console.log('LeafletLayerManager constructor()', props);
	        this.layers = {};
	    }
	
	    LeafletLayerManagerPlugin.prototype.init = function init(map, o) {
	        console.log('LeafletLayerManager init()', { map: map, o: o });
	        this.map = map;
	        this.o = o;
	        this.updateLayers(o);
	    };
	
	    LeafletLayerManagerPlugin.prototype.initOptions = function initOptions(o) {
	        return this.options(o);
	    };
	
	    LeafletLayerManagerPlugin.prototype.options = function options(o) {
	        var _this = this;
	
	        Object.keys(this.layers).forEach(function (layerKey) {
	            //Todo shallowEquals options?
	            var l = _this.layers[layerKey];
	            //if (l.controller && l.controller.update && !shallowEqual(l.controller.options, o)) {
	            if (l.controller && l.controller.options) {
	                l.controller.options(o);
	            }
	        });
	    };
	
	    LeafletLayerManagerPlugin.prototype.remove = function remove() {
	        console.log('LeafletLayerManager remove()');
	        this._removeLayerByIds(Object.keys(this.layers));
	    };
	
	    LeafletLayerManagerPlugin.prototype.update = function update(map, o) {
	        var _this2 = this;
	
	        console.log('LeafletLayerManager update()', { map: map, o: o });
	        this.o = o;
	        this.map = map;
	
	        this.updateLayers(o);
	
	        Object.keys(this.layers).forEach(function (layerKey) {
	            //Todo shallowEquals options?
	            var l = _this2.layers[layerKey];
	            //if (l.controller && l.controller.update && !shallowEqual(l.controller.options, o)) {
	            if (l.controller && l.controller.update) {
	                l.controller.update(map, o);
	            }
	        });
	    };
	
	    /**
	     *
	     * @param layerDescriptions
	     * @param activeUuids - null means all active
	     * @param baseLayerDescriptions
	     * @param baseLayerId
	     * @param defaultBaseLayerId
	     */
	
	
	    LeafletLayerManagerPlugin.prototype.updateLayers = function updateLayers(_ref) {
	        var _this3 = this;
	
	        var _ref$layerDescription = _ref.layerDescriptions,
	            layerDescriptions = _ref$layerDescription === undefined ? [] : _ref$layerDescription,
	            _ref$activeUuids = _ref.activeUuids,
	            activeUuids = _ref$activeUuids === undefined ? null : _ref$activeUuids,
	            _ref$baseLayerDescrip = _ref.baseLayerDescriptions,
	            baseLayerDescriptions = _ref$baseLayerDescrip === undefined ? [] : _ref$baseLayerDescrip,
	            baseLayerId = _ref.baseLayerId,
	            defaultBaseLayerId = _ref.defaultBaseLayerId;
	
	        var layerDataSources = (0, _mapConfigUtil.findAndSortLayerDataSource)(layerDescriptions, activeUuids);
	        var baseLayers = [];
	        layerDataSources = layerDataSources && layerDataSources.map(function (lds) {
	            var copy = _extends({}, lds);
	            var logicalLayer = lds.logicalLayerId && (0, _mapConfigUtil.findLogicalLayerInSets)(layerDescriptions, lds.logicalLayerId);
	            if (logicalLayer) {
	                copy.zIndex = logicalLayer.zIndex;
	            }
	            return copy;
	        });
	
	        baseLayerId = baseLayerId || defaultBaseLayerId;
	        if (baseLayerId) {
	            var idx = baseLayerDescriptions.findIndex(function (logicLayer) {
	                return logicLayer.id === baseLayerId;
	            });
	            if (idx >= 0) {
	                baseLayers = (0, _mapConfigUtil.findAndSortLayerDataSource)(baseLayerDescriptions[idx]);
	            } else {
	                console.warn('BaseLayer id: ' + baseLayerId + ' not found', baseLayerDescriptions);
	            }
	        }
	
	        if (baseLayers.length === 0 && baseLayerDescriptions.length > 0) {
	            baseLayers = (0, _mapConfigUtil.findAndSortLayerDataSource)(baseLayerDescriptions[0]);
	        }
	
	        layerDataSources = baseLayers.concat(layerDataSources);
	
	        var toAdd = layerDataSources.filter(function (lds) {
	            return !_this3.layers[lds.id];
	        });
	
	        var toRemove = Object.keys(layerDataSources.reduce(function (pv, cv) {
	            delete pv[cv.id];
	            return pv;
	        }, _extends({}, this.layers)));
	
	        if (toRemove.length + toAdd.length > 0) {
	            console.info('Layer changed! remove: ', toRemove, 'add', toAdd);
	            this._removeLayerByIds(toRemove);
	
	            toAdd.forEach(function (lds) {
	                try {
	                    var config = lds.config;
	                    config = typeof config === 'string' ? JSON.parse(config) : _extends({}, config);
	                    var layer = (0, _LayerFactory2.default)(_this3.map, _this3.o, lds, config, config.plugin, _this3.context);
	                    layer && (_this3.layers[lds.id] = layer);
	                } catch (e) {
	                    console.error('Error Adding Layer ', lds, 'to map', e);
	                }
	            });
	        }
	    };
	
	    LeafletLayerManagerPlugin.prototype._removeLayerByIds = function _removeLayerByIds(layerIds) {
	        var _this4 = this;
	
	        layerIds.forEach(function (id) {
	            var layer = _this4.layers[id];
	            if (layer) {
	                layer.clearLayers && layer.clearLayers();
	                if (layer.controller && layer.controller.remove) {
	                    layer.controller.remove(_this4.map);
	                }
	                _this4.map.removeLayer(layer.getInternalLayer && layer.getInternalLayer() || layer);
	                layer.off && layer.off();
	            } else {
	                console.error('Try remove Layer ' + id + ' from layers', _this4.layers);
	            }
	
	            delete _this4.layers[id];
	        });
	    };
	
	    return LeafletLayerManagerPlugin;
	}();
	
	exports.default = LeafletLayerManagerPlugin;
	
	
	LeafletLayerManagerPlugin.staticPlugin = true;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * User: c.buehler on 06.10.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	//require('external/leaflet-plugin-google');
	
	exports.default = layerFactory;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _FliwasRainRadarLayer = __webpack_require__(25);
	
	var _FliwasDataLayer = __webpack_require__(28);
	
	var _FliwasDataLayer2 = _interopRequireDefault(_FliwasDataLayer);
	
	var _RemoteVectorLayer = __webpack_require__(32);
	
	var _RemoteVectorLayer2 = _interopRequireDefault(_RemoteVectorLayer);
	
	var _FeatureManager = __webpack_require__(13);
	
	var _FeatureManager2 = _interopRequireDefault(_FeatureManager);
	
	var _CartoLayer = __webpack_require__(39);
	
	var _CartoLayer2 = _interopRequireDefault(_CartoLayer);
	
	var _FliwasCanvasTileRenderer = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingLayer = function () {
	    function LoadingLayer() {
	        var _this = this;
	
	        _classCallCheck(this, LoadingLayer);
	
	        this.delegateCalls = [];
	        ['on', 'off', 'setZIndex', 'clearLayers', 'onRemove', 'onAdd', 'eachLayer', 'removeFrom', 'update'].forEach(function (fn) {
	            return _this[fn] = _this.delegateFktn(fn).bind(_this);
	        });
	        this.getFeatureLayer = function (id, classname) {
	            return _this.delegate && _this.delegate.getFeatureLayer(id, classname) || null;
	        };
	    }
	
	    //return config in loading state, currently only for zIndex
	
	
	    LoadingLayer.prototype.setInternalLayer = function setInternalLayer(instance) {
	        var _this2 = this;
	
	        this.delegate = instance;
	        this.delegate.id = this.id;
	        this.delegate.logicalLayerId = this.logicalLayerId;
	        this.delegate.typeKey = this.typeKey;
	        this.delegate.controller = this.delegate.controller || this.delegateController || this.delegate.delegateController;
	        this.delegateCalls.forEach(function (_ref) {
	            var fn = _ref.fn,
	                args = _ref.args;
	            return _this2.callOnDelegate(fn, args);
	        });
	        this.delegateCalls = [];
	    };
	
	    LoadingLayer.prototype.getInternalLayer = function getInternalLayer() {
	        var delegate = this.delegate;
	        while (delegate != null && delegate.delegate) {
	            delegate = delegate.delegate;
	        }
	        return delegate;
	    };
	
	    LoadingLayer.prototype.delegateFktn = function delegateFktn(fn) {
	        var _this3 = this;
	
	        return function () {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            if (_this3.delegate && _this3.delegate[fn]) {
	                _this3.delegate[fn].apply(_this3.delegate, args);
	            } else {
	                _this3.delegateCalls.push({ fn: fn, args: args });
	            }
	        };
	    };
	
	    LoadingLayer.prototype.callOnDelegate = function callOnDelegate(fn, args) {
	        var f = this.delegate[fn];
	        f && f.apply(this.delegate, args);
	    };
	
	    _createClass(LoadingLayer, [{
	        key: 'options',
	        get: function get() {
	            return this.delegate && this.delegate.options || this.config;
	        }
	    }, {
	        key: 'controller',
	        get: function get() {
	            return this.delegate && this.delegate.controller;
	        },
	        set: function set(c) {
	            if (this.delegate) {
	                this.delegate.controller = c;
	            } else {
	                this.delegateController = c;
	            }
	        }
	    }]);
	
	    return LoadingLayer;
	}();
	
	function layerFactory(map, mapOptions, layer, config, plugin, context) {
	    plugin = typeof plugin === 'string' && _liferayWidgetsReactWeb.amdRequire.defined(plugin) ? (0, _liferayWidgetsReactWeb.amdRequire)(plugin) : plugin;
	
	    var lf = getLayerFactoryFunction(layer.typeKey);
	
	    if (!lf) {
	        return;
	    }
	
	    if (false) {
	        layer = Object.freeze(layer);
	        config = Object.freeze(config);
	    }
	
	    //for plugins merge config
	    if (typeof plugin === 'string') {
	        lf = function lf(map, layer, config, plugin, context) {
	            var inst = new LoadingLayer();
	            inst.config = config;
	            (0, _liferayWidgetsReactWeb.amdRequire)([config.plugin], function (plugin) {
	                inst.setInternalLayer(layerFactory(map, mapOptions, layer, config, plugin, context));
	            });
	            return inst;
	        };
	    } else if (plugin) {
	        var l = plugin[config.definition];
	        layer = _extends({}, layer, l);
	        config = _extends({}, config, l.config);
	        layer.config = config;
	    }
	
	    var controller = typeof layer.controller === 'function' ? new layer.controller() : layer.controller;
	    if (controller) {
	        config = controller.layerConfig(config);
	    }
	    var inst = lf(map, layer, config, plugin, context);
	
	    if (inst) {
	        if (__DEBUG__ && !layer.id) {
	            debugger;
	        }
	        inst.id = layer.id;
	        inst.logicalLayerId = layer.logicalLayerId;
	        inst.typeKey = layer.typeKey;
	    }
	
	    if (inst && controller && controller.init) {
	        initController(controller, mapOptions, inst, map, config, context);
	    }
	
	    return inst;
	}
	
	function initController(controller, mapOptions, inst, map, layerConfig, context) {
	    if (controller && controller.init) {
	        controller.init(map, mapOptions, inst, layerConfig, context);
	    }
	    inst.controller = controller;
	}
	
	function createCartoLeafletLayer(cartodb, config, map, layer) {
	    var cartoLayer = new _CartoLayer2.default(cartodb, config.client.username, config.client.apiKey);
	    var leafletLayer = cartoLayer.createLayer(config, layer);
	    leafletLayer.addTo(map);
	    return leafletLayer;
	}
	
	var cartodb = void 0;
	
	function getLayerFactoryFunction(typeKey) {
	
	    switch (typeKey) {
	
	        case 'cartodb':
	            {
	                return function (map, l, config) {
	                    /*
	                        Example for a JSON object with the layer data
	                         {
	                            "client": {
	                                "apiKey": "MY_API_KEY",
	                                "username": "MY_USER_NAME"
	                            },
	                            "layers": [
	                                {
	                                    "sql": "SELECT * FROM bw_fliwas_ezg_agg03_2018_02_10",
	                                    "style": "#bw_fliwas_ezg_agg03_2018_02_10{ polygon-fill: #FFFFFF; polygon-opacity: 0; line-color: #000000; line-width: 2.5; line-opacity: 1;}"
	                                }
	                            ]
	                        }*/
	
	                    if (cartodb) {
	                        return createCartoLeafletLayer(cartodb, config, map, l);
	                    } else {
	                        var inst = new LoadingLayer();
	                        (0, _liferayWidgetsReactWeb.amdRequire)(['cartodb'], function (c) {
	                            cartodb = c;
	                            var leafletLayer = createCartoLeafletLayer(cartodb, config, map, l);
	                            inst.setInternalLayer(leafletLayer);
	                            return inst;
	                        });
	                        return inst;
	                    }
	                };
	            }
	        case 'wms':
	            {
	                return function (map, l, config) {
	                    var legend = config.legend,
	                        infoText = config.infoText,
	                        rest = _objectWithoutProperties(config, ['legend', 'infoText']);
	
	                    var wmsConfig = _extends({}, rest);
	                    if (config.crs) {
	                        var crsCode = config.crs;
	                        wmsConfig.crs = _leaflet2.default.CRS[crsCode];
	                    }
	
	                    return _leaflet2.default.tileLayer.wms(config.url, wmsConfig).addTo(map).setZIndex(l.zIndex || config.zIndex || 0);
	                };
	            }
	        case 'gme':
	            {
	                return function (map, l, config) {
	                    return _leaflet2.default.tileLayer.wms(config.url, config).addTo(map).setZIndex(l.zIndex || config.zIndex || 0);
	                };
	            }
	
	        case 'leaflet-tile-layer':
	            {
	                return function (map, l, config) {
	                    return _leaflet2.default.tileLayer(config.url, config).addTo(map).setZIndex(l.zIndex || config.zIndex || 0);
	                };
	            }
	        case 'geojson':
	            {
	                return function (map, l, config) {
	                    return _leaflet2.default.geoJson(l.data, _extends({}, config, {
	                        //setZindex does not work on the geojson layer, only on individual paths inside the layer
	                        zIndex: l.zIndex || config.zIndex || 0
	                    })).addTo(map).setZIndex(l.zIndex || config.zIndex || 0);
	                };
	            }
	
	        case 'radar-image-layer':
	            {
	                return function (map, l, config) {
	                    var url = config.url,
	                        options = config.options;
	
	                    return new _FliwasRainRadarLayer.FliwasRainRadarLayer(url, options).addTo(map).setZIndex(l.zIndex || config.zIndex || 0);
	                };
	            }
	
	        case 'remote-data-layer':
	            {
	                return function (map, l, config) {
	                    if (config.servicePath) {
	                        /* Old service Style */
	                        console.error('Old remote-data-layer config found! ', l, config);
	                    }
	                    return new _FliwasDataLayer2.default({
	                        cluster: config.cluster || true,
	                        clusterOptions: _extends({
	                            animate: true,
	                            animateAddingMarkers: true,
	                            iconCreateFunction: _FeatureManager2.default.renderCluster,
	                            disableClusteringAtZoom: 10,
	                            maxClusterRadius: 50, //we use more clusters than the default
	                            spiderfyOnMaxZoom: false,
	                            zoomToBoundsOnClick: true,
	                            showCoverageOnHover: false,
	                            zIndex: l.zIndex || config.zIndex || 0
	                        }, config.clusterOptions)
	                    }).addTo(map).setZIndex(l.zIndex || config.zIndex || 0);
	                };
	            }
	
	        case 'remote-vector-layer':
	            {
	                return function (map, l, config) {
	                    var url = window.location.origin + config.servicePath + encodeURIComponent(JSON.stringify(config.filter));
	                    var vectorTilesLayer = new _RemoteVectorLayer2.default(url, _extends({
	                        rendererFactory: function rendererFactory(tileCoord, tileSize, opts) {
	                            return new _FliwasCanvasTileRenderer.FliwasCanvasTile(tileCoord, tileSize, opts);
	                        },
	                        interactive: true
	                    }, config));
	                    vectorTilesLayer.config = config;
	                    map.addLayer(vectorTilesLayer.setZIndex(l.zIndex || config.zIndex || 0));
	                    return vectorTilesLayer;
	                };
	            }
	
	        case 'kml':
	            {
	                /*
	                 if (layer.title == 'Wetterwarnungen') {
	                 console.log('Found DWD-KML-Layer. Request by Proxy.', config.url, '/dwdLayerProxy');
	                 config.url = location.origin + '/dwd-portlet/dwdLayerProxy';
	                 }
	                 */
	
	                if (!_leaflet2.default.KML) {
	                    //TODO  Check current implementation logic
	                    console.error('\'leaflet-plugin-kml\' not loaded! Check current implementation logic');
	                    return undefined;
	                    //amdRequire([ 'leaflet-plugin-kml' ], () => (map, l, config) => new L.KML(config.url, { async: true }).addTo(map).setZIndex(config.zIndex || 0));
	                } else {
	                    return function (map, l, config) {
	                        return new _leaflet2.default.KML(config.url, { async: true }).addTo(map).setZIndex(l.zIndex || config.zIndex || 0);
	                    };
	                }
	            }
	
	        case 'markerList':
	            {
	                return function (map, l, config) {
	                    var markers = l.features.map(function (feature) {
	                        return _leaflet2.default.marker([feature.lat, feature.lng], feature.options).setZIndexOffset(config.zIndex || 0);
	                    });
	
	                    return _leaflet2.default.featureGroup(markers).addTo(map);
	                };
	            }
	
	        default:
	            console.warn('No Layer of typeKey', typeKey);
	            break;
	    }
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: n.gorte
	 * Date: 10.04.2019
	 * Time: 10:40
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.FliwasRainRadarLayer = undefined;
	
	var _lwrClient = __webpack_require__(26);
	
	var _datefns = __webpack_require__(27);
	
	var _datefns2 = _interopRequireDefault(_datefns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIVE_MINUTE_MILLIS = 1000 * 60 * 5;
	
	L.Control.Legend = L.Control.extend({
	    onAdd: function onAdd(map) {
	        this.container = L.DomUtil.create('div', 'leaflet-bar map-legend');
	        this.container.style.backgroundColor = 'white';
	        this.container.style.padding = '5px 10px';
	
	        this.timeDisplay = L.DomUtil.create('span');
	        this.timeDisplay.innerHTML = 'Radardaten vom: ---';
	        this.container.appendChild(this.timeDisplay);
	        return this.container;
	    },
	    setContentString: function setContentString(text) {
	        this.timeDisplay.innerHTML = text;
	    },
	    error: function error(_error) {
	        if (_error) {
	            this.container.style.border = '2px solid rgba(255,0,0,0.5)';
	        } else {
	            this.container.style.border = '2px solid rgba(0,0,0,0.2)';
	        }
	    }
	});
	
	L.Control.legend = function (opts) {
	    return new L.Control.Legend(opts);
	};
	
	var FliwasRainRadarLayer = exports.FliwasRainRadarLayer = L.TileLayer.extend({
	
	    initialize: function initialize(url, options) {
	        var _this = this;
	
	        // (String, LatLngBounds, Object)
	        this.timeFormat = 'dd.MM.yy HH:mm';
	        this.etag = '';
	        this.fetchDate = this.fetchDate.bind(this);
	
	        this.url = this._createRequestUrl(url);
	        L.TileLayer.prototype.initialize.call(this, this.url, options);
	
	        var position = options.legendPosition || 'bottomcenter';
	        this.legend = L.Control.legend({ position: position });
	
	        this.fetchDate(this.getTileUrl({ x: 0, y: 0, z: 0, r: '' }));
	
	        //check every 5 minutes
	        this.intervalID = setInterval(function () {
	            _this.fetchDate(_this.getTileUrl({ x: 0, y: 0, z: 0, r: '' }));
	            _this.setUrl(_this.url, false);
	        }, options.refreshIntervall || FIVE_MINUTE_MILLIS);
	    },
	
	    addTo: function addTo(map) {
	        map.addControl(this.legend);
	        map.addLayer(this);
	        this.map = map;
	        return this;
	    },
	    onRemove: function onRemove() {
	        clearInterval(this.intervalID);
	        this.legend.remove();
	        L.TileLayer.prototype.onRemove.call(this, this.map);
	    },
	    _createRequestUrl: function _createRequestUrl(url) {
	        return _lwrClient.Client.getServerUrl() + url;
	    },
	    fetchDate: function fetchDate(url) {
	        var _this2 = this;
	
	        fetch(url).then(function (res) {
	            var etag = res.headers.get('ETag');
	            _this2.etag = etag || _this2.etag;
	            _this2.legend.error(false);
	            _this2.legend.setContentString('Radardaten vom: ' + (_this2.etag ? _this2.etag : _datefns2.default.format(new Date(), _this2.timeFormat)));
	        }).catch(function (e) {
	            console.error('RAIN RADAR', e);
	            _this2.legend.error(true);
	            _this2.legend.setContentString('Radardaten konnten nicht geladen werden!');
	        });
	    }
	});

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_26__;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_27__;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //TODO Needed?
	
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(29);
	
	__webpack_require__(30);
	
	__webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODO Needed?
	
	var FliwasDataLayer = _leaflet2.default.FeatureGroup.extend({
	
	    options: {
	        cluster: true,
	        markerOptions: {},
	        clusterOptions: {},
	        bubblingMouseEvents: true,
	        markersInheritOptions: true
	    },
	
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _leaflet2.default.FeatureGroup.prototype.initialize.call(this, null, options);
	        this._clusterGroup = _leaflet2.default.markerClusterGroup(_extends({}, this.options.clusterOptions, { bubblingMouseEvents: true }));
	        this._layerGroup = _leaflet2.default.featureGroup({ bubblingMouseEvents: true });
	    },
	
	    shouldCluster: function shouldCluster(layer) {
	        return this.options.cluster && !layer.preventCluster;
	    },
	
	    addLayers: function addLayers(layers) {
	        var _this = this;
	
	        var a = [],
	            aC = [];
	
	        layers.forEach(function (l) {
	            l.addEventParent(_this);
	            _this._layers[_this.getLayerId(l)] = l;
	            (_this.shouldCluster(l) ? aC : a).push(l);
	        });
	
	        if (this._map) {
	            aC.length === 1 ? this._clusterGroup.addLayer(aC[0]) : this._clusterGroup.addLayers(aC);
	            a.forEach(function (l) {
	                return _this._layerGroup.addLayer(l);
	            });
	        }
	
	        return this.fire('layeradd', { layers: layers });
	    },
	
	    addLayer: function addLayer(layer) {
	        if (this.hasLayer(layer)) {
	            return this;
	        }
	
	        layer.addEventParent(this);
	        this._layers[this.getLayerId(layer)] = layer;
	
	        if (this._map) {
	            (this.shouldCluster(layer) ? this._clusterGroup : this._layerGroup).addLayer(layer);
	        }
	
	        return this.fire('layeradd', { layer: layer });
	    },
	
	    removeLayers: function removeLayers(layers) {
	        var _this2 = this;
	
	        var r = [],
	            rC = [];
	
	        layers.forEach(function (l) {
	            l.removeEventParent(_this2);
	            delete _this2._layers[_this2.getLayerId(l)];
	            (_this2._layerGroup.hasLayer(l) ? r : rC).push(l);
	        });
	
	        if (this._map) {
	            this._clusterGroup.removeLayers(rC);
	            r.forEach(function (l) {
	                return _this2._layerGroup.removeLayer(l);
	            });
	        }
	
	        return this.fire('layerremove', { layers: layers });
	    },
	
	    removeLayer: function removeLayer(layer) {
	        if (!this.hasLayer(layer)) {
	            return this;
	        }
	
	        layer.removeEventParent(this);
	        delete this._layers[this.getLayerId(layer)];
	
	        if (this._map) {
	            if (this._layerGroup.hasLayer(layer)) {
	                this._layerGroup.removeLayer(layer);
	            } else {
	                this._clusterGroup.removeLayer(layer);
	            }
	        }
	        return this.fire('layerremove', { layer: layer });
	    },
	
	    onAdd: function onAdd(map) {
	        var _this3 = this;
	
	        var a = [],
	            aC = [];
	        this._map = map;
	        this._layerGroup.addTo(map);
	        this._clusterGroup.addTo(map);
	
	        this.getLayers().forEach(function (l) {
	            return (_this3.shouldCluster(l) ? aC : a).push(l);
	        });
	
	        this._clusterGroup.addLayers(aC);
	        a.forEach(function (l) {
	            return _this3._layerGroup.addLayer(l);
	        });
	    },
	
	    onRemove: function onRemove(map) {
	        var _this4 = this;
	
	        var r = [],
	            rC = [];
	        this._map = null;
	        map.removeLayer(this._layerGroup);
	        map.removeLayer(this._clusterGroup);
	
	        this.getLayers().forEach(function (l) {
	            return (_this4._layerGroup.hasLayer(l) ? r : rC).push(l);
	        });
	
	        this._clusterGroup.removeLayers(rC);
	        r.forEach(function (l) {
	            return _this4._layerGroup.removeLayer(l);
	        });
	    },
	
	    getBounds: function getBounds() {
	        return new _leaflet2.default.LatLngBounds().extend(this._clusterGroup.getBounds()).extend(this._layerGroup.getBounds());
	    }
	
	});
	
	exports.default = FliwasDataLayer;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_29__;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_30__;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_31__;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Nikolai Gorte on 28.08.2018.
	                                                                                                                                                                                                                                                                   */
	
	__webpack_require__(33);
	
	var _Symbolizer = __webpack_require__(34);
	
	var _Symbolizer2 = __webpack_require__(36);
	
	var _Symbolizer3 = __webpack_require__(38);
	
	var vectorTileLayerStyles = {
	    default: {
	        weight: 2,
	        radius: 4,
	        fillColor: '#9bc2c4',
	        fillOpacity: 0.4,
	        fill: true
	    }
	};
	
	var RemoteVectorLayer = L.VectorGrid.Protobuf.extend({
	
	    initialize: function initialize(url, options) {
	        var onClick = options.onClick,
	            onMouseOver = options.onMouseOver;
	
	        L.VectorGrid.Protobuf.prototype.initialize.call(this, url, _extends({
	            getFeatureId: function getFeatureId(feat) {
	                return feat.properties.type + '_' + feat.properties.id;
	            },
	
	            vectorTileLayerStyles: {
	                default: _extends({}, vectorTileLayerStyles.default, options.style)
	            }
	        }, options));
	
	        this.on('click', onClick);
	        //this.on('mouseover', onMouseOver);
	    },
	
	    _createLayer: function _createLayer(feat, pxPerExtent, layerStyle) {
	        var layer;
	        switch (feat.type) {
	            case 1:
	                layer = new _Symbolizer.PointSymbolizer(feat, pxPerExtent);
	                break;
	            case 2:
	                layer = new _Symbolizer2.LineSymbolizer(feat, pxPerExtent);
	                break;
	            case 3:
	                layer = new _Symbolizer3.FillSymbolizer(feat, pxPerExtent);
	                break;
	        }
	
	        if (this.options.interactive) {
	            layer.addEventParent(this);
	        }
	
	        return layer;
	    }
	});
	
	exports.default = RemoteVectorLayer;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	function __$strToBlobUri(str, mime, isBinary) {try {return window.URL.createObjectURL(new Blob([Uint8Array.from(str.split('').map(function(c) {return c.charCodeAt(0)}))], {type: mime}));} catch (e) {return "data:" + mime + (isBinary ? ";base64," : ",") + str;}}
	L.SVG.Tile = L.SVG.extend({
	
		initialize: function (tileCoord, tileSize, options) {
			L.SVG.prototype.initialize.call(this, options);
			this._tileCoord = tileCoord;
			this._size = tileSize;
	
			this._initContainer();
			this._container.setAttribute('width', this._size.x);
			this._container.setAttribute('height', this._size.y);
			this._container.setAttribute('viewBox', [0, 0, this._size.x, this._size.y].join(' '));
	
			this._layers = {};
		},
	
		getCoord: function() {
			return this._tileCoord;
		},
	
		getContainer: function() {
			return this._container;
		},
	
		onAdd: L.Util.falseFn,
	
		addTo: function(map) {
			this._map = map;
			if (this.options.interactive) {
				for (var i in this._layers) {
					var layer = this._layers[i];
					// By default, Leaflet tiles do not have pointer events.
					layer._path.style.pointerEvents = 'auto';
					this._map._targets[L.stamp(layer._path)] = layer;
				}
			}
		},
	
		removeFrom: function (map) {
			if (this.options.interactive) {
				for (var i in this._layers) {
					var layer = this._layers[i];
					delete this._map._targets[L.stamp(layer._path)];
				}
			}
			delete this._map;
		},
	
		_initContainer: function() {
			L.SVG.prototype._initContainer.call(this);
			var rect =  L.SVG.create('rect');
		},
	
		/// TODO: Modify _initPath to include an extra parameter, a group name
		/// to order symbolizers by z-index
	
		_addPath: function (layer) {
			this._rootGroup.appendChild(layer._path);
			this._layers[L.stamp(layer)] = layer;
		},
	
		_updateIcon: function (layer) {
			var path = layer._path = L.SVG.create('image'),
			    icon = layer.options.icon,
			    options = icon.options,
			    size = L.point(options.iconSize),
			    anchor = options.iconAnchor ||
			        	 size && size.divideBy(2, true),
			    p = layer._point.subtract(anchor);
			path.setAttribute('x', p.x);
			path.setAttribute('y', p.y);
			path.setAttribute('width', size.x + 'px');
			path.setAttribute('height', size.y + 'px');
			path.setAttribute('href', options.iconUrl);
		}
	});
	
	
	L.svg.tile = function(tileCoord, tileSize, opts){
		return new L.SVG.Tile(tileCoord, tileSize, opts);
	};
	
	// 🍂class Symbolizer
	// 🍂inherits Class
	// The abstract Symbolizer class is mostly equivalent in concept to a `L.Path` - it's an interface for
	// polylines, polygons and circles. But instead of representing leaflet Layers,
	// it represents things that have to be drawn inside a vector tile.
	
	// A vector tile *data layer* might have zero, one, or more *symbolizer definitions*
	// A vector tile *feature* might have zero, one, or more *symbolizers*.
	// The actual symbolizers applied will depend on filters and the symbolizer functions.
	
	var Symbolizer = L.Class.extend({
		// 🍂method initialize(feature: GeoJSON, pxPerExtent: Number)
		// Initializes a new Line Symbolizer given a GeoJSON feature and the
		// pixel-to-coordinate-units ratio. Internal use only.
	
		// 🍂method render(renderer, style)
		// Renders this symbolizer in the given tiled renderer, with the given
		// `L.Path` options.  Internal use only.
		render: function(renderer, style) {
			this._renderer = renderer;
			this.options = style;
			renderer._initPath(this);
			renderer._updateStyle(this);
		},
	
		// 🍂method render(renderer, style)
		// Updates the `L.Path` options used to style this symbolizer, and re-renders it.
		// Internal use only.
		updateStyle: function(renderer, style) {
			this.options = style;
			renderer._updateStyle(this);
		},
	
		_getPixelBounds: function() {
			var parts = this._parts;
			var bounds = L.bounds([]);
			for (var i = 0; i < parts.length; i++) {
				var part = parts[i];
				for (var j = 0; j < part.length; j++) {
					bounds.extend(part[j]);
				}
			}
	
			var w = this._clickTolerance(),
			    p = new L.Point(w, w);
	
			bounds.min._subtract(p);
			bounds.max._add(p);
	
			return bounds;
		},
		_clickTolerance: L.Path.prototype._clickTolerance,
	});
	
	// Contains mixins which are common to the Line Symbolizer and the Fill Symbolizer.
	
	var PolyBase = {
		_makeFeatureParts: function(feat, pxPerExtent) {
			var rings = feat.geometry;
			var coord;
	
			this._parts = [];
			for (var i = 0; i < rings.length; i++) {
				var ring = rings[i];
				var part = [];
				for (var j = 0; j < ring.length; j++) {
					coord = ring[j];
					// Protobuf vector tiles return {x: , y:}
					// Geojson-vt returns [,]
					part.push(L.point(coord).scaleBy(pxPerExtent));
				}
				this._parts.push(part);
			}
		},
	
		makeInteractive: function() {
			this._pxBounds = this._getPixelBounds();
		}
	};
	
	// 🍂class PointSymbolizer
	// 🍂inherits CircleMarker
	// A symbolizer for points.
	
	var PointSymbolizer = L.CircleMarker.extend({
		includes: Symbolizer.prototype,
	
		statics: {
			iconCache: {}
		},
	
		initialize: function(feature, pxPerExtent) {
			this.properties = feature.properties;
			this._makeFeatureParts(feature, pxPerExtent);
		},
	
		render: function(renderer, style) {
			Symbolizer.prototype.render.call(this, renderer, style);
			this._radius = style.radius || L.CircleMarker.prototype.options.radius;
			this._updatePath();
		},
	
		_makeFeatureParts: function(feat, pxPerExtent) {
			var coord = feat.geometry[0];
			if (typeof coord[0] === 'object' && 'x' in coord[0]) {
				// Protobuf vector tiles return [{x: , y:}]
				this._point = L.point(coord[0]).scaleBy(pxPerExtent);
				this._empty = L.Util.falseFn;
			} else {
				// Geojson-vt returns [,]
				this._point = L.point(coord).scaleBy(pxPerExtent);
				this._empty = L.Util.falseFn;
			}
		},
	
		makeInteractive: function() {
			this._updateBounds();
		},
	
		updateStyle: function(renderer, style) {
			this._radius = style.radius || this._radius;
			this._updateBounds();
			return Symbolizer.prototype.updateStyle.call(this, renderer, style);
		},
	
		_updateBounds: function() {
			var icon = this.options.icon;
			if (icon) {
				var size = L.point(icon.options.iconSize),
				    anchor = icon.options.iconAnchor ||
				             size && size.divideBy(2, true),
				    p = this._point.subtract(anchor);
				this._pxBounds = new L.Bounds(p, p.add(icon.options.iconSize));
			} else {
				L.CircleMarker.prototype._updateBounds.call(this);
			}
		},
	
		_updatePath: function() {
			if (this.options.icon) {
				this._renderer._updateIcon(this);
			} else {
				L.CircleMarker.prototype._updatePath.call(this);
			}
		},
	
		_getImage: function () {
			if (this.options.icon) {
				var url = this.options.icon.options.iconUrl,
				    img = PointSymbolizer.iconCache[url];
				if (!img) {
					var icon = this.options.icon;
					img = PointSymbolizer.iconCache[url] = icon.createIcon();
				}
				return img;
			} else {
				return null;
			}
	
		},
	
		_containsPoint: function(p) {
			var icon = this.options.icon;
			if (icon) {
				return this._pxBounds.contains(p);
			} else {
				return L.CircleMarker.prototype._containsPoint.call(this, p);
			}
		}
	});
	
	// 🍂class LineSymbolizer
	// 🍂inherits Polyline
	// A symbolizer for lines. Can be applied to line and polygon features.
	
	var LineSymbolizer = L.Polyline.extend({
		includes: [Symbolizer.prototype, PolyBase],
	
		initialize: function(feature, pxPerExtent) {
			this.properties = feature.properties;
			this._makeFeatureParts(feature, pxPerExtent);
		},
	
		render: function(renderer, style) {
			style.fill = false;
			Symbolizer.prototype.render.call(this, renderer, style);
			this._updatePath();
		},
	
		updateStyle: function(renderer, style) {
			style.fill = false;
			Symbolizer.prototype.updateStyle.call(this, renderer, style);
		},
	});
	
	// 🍂class FillSymbolizer
	// 🍂inherits Polyline
	// A symbolizer for filled areas. Applies only to polygon features.
	
	var FillSymbolizer = L.Polygon.extend({
		includes: [Symbolizer.prototype, PolyBase],
	
		initialize: function(feature, pxPerExtent) {
			this.properties = feature.properties;
			this._makeFeatureParts(feature, pxPerExtent);
		},
	
		render: function(renderer, style) {
			Symbolizer.prototype.render.call(this, renderer, style);
			this._updatePath();
		}
	});
	
	/* 🍂class VectorGrid
	 * 🍂inherits GridLayer
	 *
	 * A `VectorGrid` is a generic, abstract class for displaying tiled vector data.
	 * it provides facilities for symbolizing and rendering the data in the vector
	 * tiles, but lacks the functionality to fetch the vector tiles from wherever
	 * they are.
	 *
	 * Extends Leaflet's `L.GridLayer`.
	 */
	
	L.VectorGrid = L.GridLayer.extend({
	
		options: {
			// 🍂option rendererFactory = L.svg.tile
			// A factory method which will be used to instantiate the per-tile renderers.
			rendererFactory: L.svg.tile,
	
			// 🍂option vectorTileLayerStyles: Object = {}
			// A data structure holding initial symbolizer definitions for the vector features.
			vectorTileLayerStyles: {},
	
			// 🍂option interactive: Boolean = false
			// Whether this `VectorGrid` fires `Interactive Layer` events.
			interactive: false,
	
			// 🍂option getFeatureId: Function = undefined
			// A function that, given a vector feature, returns an unique identifier for it, e.g.
			// `function(feat) { return feat.properties.uniqueIdField; }`.
			// Must be defined for `setFeatureStyle` to work.
		},
	
		initialize: function(options) {
			L.setOptions(this, options);
			L.GridLayer.prototype.initialize.apply(this, arguments);
			if (this.options.getFeatureId) {
				this._vectorTiles = {};
				this._overriddenStyles = {};
				this.on('tileunload', function(e) {
					var key = this._tileCoordsToKey(e.coords),
					    tile = this._vectorTiles[key];
	
					if (tile && this._map) {
						tile.removeFrom(this._map);
					}
					delete this._vectorTiles[key];
				}, this);
			}
			this._dataLayerNames = {};
		},
	
		createTile: function(coords, done) {
			var storeFeatures = this.options.getFeatureId;
	
			var tileSize = this.getTileSize();
			var renderer = this.options.rendererFactory(coords, tileSize, this.options);
	
			var vectorTilePromise = this._getVectorTilePromise(coords);
	
			if (storeFeatures) {
				this._vectorTiles[this._tileCoordsToKey(coords)] = renderer;
				renderer._features = {};
			}
	
			vectorTilePromise.then( function renderTile(vectorTile) {
				for (var layerName in vectorTile.layers) {
					this._dataLayerNames[layerName] = true;
					var layer = vectorTile.layers[layerName];
	
					var pxPerExtent = this.getTileSize().divideBy(layer.extent);
	
					var layerStyle = this.options.vectorTileLayerStyles[ layerName ] ||
					L.Path.prototype.options;
	
					for (var i = 0; i < layer.features.length; i++) {
						var feat = layer.features[i];
						var id;
	
						var styleOptions = layerStyle;
						if (storeFeatures) {
							id = this.options.getFeatureId(feat);
							var styleOverride = this._overriddenStyles[id];
							if (styleOverride) {
								if (styleOverride[layerName]) {
									styleOptions = styleOverride[layerName];
								} else {
									styleOptions = styleOverride;
								}
							}
						}
	
						if (styleOptions instanceof Function) {
							styleOptions = styleOptions(feat.properties, coords.z);
						}
	
						if (!(styleOptions instanceof Array)) {
							styleOptions = [styleOptions];
						}
	
						if (!styleOptions.length) {
							continue;
						}
	
						var featureLayer = this._createLayer(feat, pxPerExtent);
	
						for (var j = 0; j < styleOptions.length; j++) {
							var style = L.extend({}, L.Path.prototype.options, styleOptions[j]);
							featureLayer.render(renderer, style);
							renderer._addPath(featureLayer);
						}
	
						if (this.options.interactive) {
							featureLayer.makeInteractive();
						}
	
						if (storeFeatures) {
							renderer._features[id] = {
								layerName: layerName,
								feature: featureLayer
							};
						}
					}
	
				}
				if (this._map != null) {
					renderer.addTo(this._map);
				}
				L.Util.requestAnimFrame(done.bind(coords, null, null));
			}.bind(this));
	
			return renderer.getContainer();
		},
	
		// 🍂method setFeatureStyle(id: Number, layerStyle: L.Path Options): this
		// Given the unique ID for a vector features (as per the `getFeatureId` option),
		// re-symbolizes that feature across all tiles it appears in.
		setFeatureStyle: function(id, layerStyle) {
			this._overriddenStyles[id] = layerStyle;
	
			for (var tileKey in this._vectorTiles) {
				var tile = this._vectorTiles[tileKey];
				var features = tile._features;
				var data = features[id];
				if (data) {
					var feat = data.feature;
	
					var styleOptions = layerStyle;
					if (layerStyle[data.layerName]) {
						styleOptions = layerStyle[data.layerName];
					}
	
					this._updateStyles(feat, tile, styleOptions);
				}
			}
			return this;
		},
	
		// 🍂method setFeatureStyle(id: Number): this
		// Reverts the effects of a previous `setFeatureStyle` call.
		resetFeatureStyle: function(id) {
			delete this._overriddenStyles[id];
	
			for (var tileKey in this._vectorTiles) {
				var tile = this._vectorTiles[tileKey];
				var features = tile._features;
				var data = features[id];
				if (data) {
					var feat = data.feature;
					var styleOptions = this.options.vectorTileLayerStyles[ data.layerName ] ||
					L.Path.prototype.options;
					this._updateStyles(feat, tile, styleOptions);
				}
			}
			return this;
		},
	
		// 🍂method getDataLayerNames(): Array
		// Returns an array of strings, with all the known names of data layers in
		// the vector tiles displayed. Useful for introspection.
		getDataLayerNames: function() {
			return Object.keys(this._dataLayerNames);
		},
	
		_updateStyles: function(feat, renderer, styleOptions) {
			styleOptions = (styleOptions instanceof Function) ?
				styleOptions(feat.properties, renderer.getCoord().z) :
				styleOptions;
	
			if (!(styleOptions instanceof Array)) {
				styleOptions = [styleOptions];
			}
	
			for (var j = 0; j < styleOptions.length; j++) {
				var style = L.extend({}, L.Path.prototype.options, styleOptions[j]);
				feat.updateStyle(renderer, style);
			}
		},
	
		_createLayer: function(feat, pxPerExtent, layerStyle) {
			var layer;
			switch (feat.type) {
			case 1:
				layer = new PointSymbolizer(feat, pxPerExtent);
				break;
			case 2:
				layer = new LineSymbolizer(feat, pxPerExtent);
				break;
			case 3:
				layer = new FillSymbolizer(feat, pxPerExtent);
				break;
			}
	
			if (this.options.interactive) {
				layer.addEventParent(this);
			}
	
			return layer;
		},
	});
	
	/*
	 * 🍂section Extension methods
	 *
	 * Classes inheriting from `VectorGrid` **must** define the `_getVectorTilePromise` private method.
	 *
	 * 🍂method getVectorTilePromise(coords: Object): Promise
	 * Given a `coords` object in the form of `{x: Number, y: Number, z: Number}`,
	 * this function must return a `Promise` for a vector tile.
	 *
	 */
	L.vectorGrid = function (options) {
		return new L.VectorGrid(options);
	};
	
	var read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? (nBytes - 1) : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & ((1 << (-nBits)) - 1);
	  s >>= (-nBits);
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1);
	  e >>= (-nBits);
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	};
	
	var write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
	  var i = isLE ? 0 : (nBytes - 1);
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};
	
	var index$1 = {
		read: read,
		write: write
	};
	
	var index = Pbf;
	
	var ieee754 = index$1;
	
	function Pbf(buf) {
	    this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
	    this.pos = 0;
	    this.type = 0;
	    this.length = this.buf.length;
	}
	
	Pbf.Varint  = 0; // varint: int32, int64, uint32, uint64, sint32, sint64, bool, enum
	Pbf.Fixed64 = 1; // 64-bit: double, fixed64, sfixed64
	Pbf.Bytes   = 2; // length-delimited: string, bytes, embedded messages, packed repeated fields
	Pbf.Fixed32 = 5; // 32-bit: float, fixed32, sfixed32
	
	var SHIFT_LEFT_32 = (1 << 16) * (1 << 16);
	var SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;
	
	Pbf.prototype = {
	
	    destroy: function() {
	        this.buf = null;
	    },
	
	    // === READING =================================================================
	
	    readFields: function(readField, result, end) {
	        var this$1 = this;
	
	        end = end || this.length;
	
	        while (this.pos < end) {
	            var val = this$1.readVarint(),
	                tag = val >> 3,
	                startPos = this$1.pos;
	
	            this$1.type = val & 0x7;
	            readField(tag, result, this$1);
	
	            if (this$1.pos === startPos) { this$1.skip(val); }
	        }
	        return result;
	    },
	
	    readMessage: function(readField, result) {
	        return this.readFields(readField, result, this.readVarint() + this.pos);
	    },
	
	    readFixed32: function() {
	        var val = readUInt32(this.buf, this.pos);
	        this.pos += 4;
	        return val;
	    },
	
	    readSFixed32: function() {
	        var val = readInt32(this.buf, this.pos);
	        this.pos += 4;
	        return val;
	    },
	
	    // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
	
	    readFixed64: function() {
	        var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
	        this.pos += 8;
	        return val;
	    },
	
	    readSFixed64: function() {
	        var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
	        this.pos += 8;
	        return val;
	    },
	
	    readFloat: function() {
	        var val = ieee754.read(this.buf, this.pos, true, 23, 4);
	        this.pos += 4;
	        return val;
	    },
	
	    readDouble: function() {
	        var val = ieee754.read(this.buf, this.pos, true, 52, 8);
	        this.pos += 8;
	        return val;
	    },
	
	    readVarint: function(isSigned) {
	        var buf = this.buf,
	            val, b;
	
	        b = buf[this.pos++]; val  =  b & 0x7f;        if (b < 0x80) { return val; }
	        b = buf[this.pos++]; val |= (b & 0x7f) << 7;  if (b < 0x80) { return val; }
	        b = buf[this.pos++]; val |= (b & 0x7f) << 14; if (b < 0x80) { return val; }
	        b = buf[this.pos++]; val |= (b & 0x7f) << 21; if (b < 0x80) { return val; }
	        b = buf[this.pos];   val |= (b & 0x0f) << 28;
	
	        return readVarintRemainder(val, isSigned, this);
	    },
	
	    readVarint64: function() { // for compatibility with v2.0.1
	        return this.readVarint(true);
	    },
	
	    readSVarint: function() {
	        var num = this.readVarint();
	        return num % 2 === 1 ? (num + 1) / -2 : num / 2; // zigzag encoding
	    },
	
	    readBoolean: function() {
	        return Boolean(this.readVarint());
	    },
	
	    readString: function() {
	        var end = this.readVarint() + this.pos,
	            str = readUtf8(this.buf, this.pos, end);
	        this.pos = end;
	        return str;
	    },
	
	    readBytes: function() {
	        var end = this.readVarint() + this.pos,
	            buffer = this.buf.subarray(this.pos, end);
	        this.pos = end;
	        return buffer;
	    },
	
	    // verbose for performance reasons; doesn't affect gzipped size
	
	    readPackedVarint: function(arr, isSigned) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readVarint(isSigned)); }
	        return arr;
	    },
	    readPackedSVarint: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readSVarint()); }
	        return arr;
	    },
	    readPackedBoolean: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readBoolean()); }
	        return arr;
	    },
	    readPackedFloat: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readFloat()); }
	        return arr;
	    },
	    readPackedDouble: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readDouble()); }
	        return arr;
	    },
	    readPackedFixed32: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readFixed32()); }
	        return arr;
	    },
	    readPackedSFixed32: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readSFixed32()); }
	        return arr;
	    },
	    readPackedFixed64: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readFixed64()); }
	        return arr;
	    },
	    readPackedSFixed64: function(arr) {
	        var this$1 = this;
	
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this$1.readSFixed64()); }
	        return arr;
	    },
	
	    skip: function(val) {
	        var type = val & 0x7;
	        if (type === Pbf.Varint) { while (this.buf[this.pos++] > 0x7f) {} }
	        else if (type === Pbf.Bytes) { this.pos = this.readVarint() + this.pos; }
	        else if (type === Pbf.Fixed32) { this.pos += 4; }
	        else if (type === Pbf.Fixed64) { this.pos += 8; }
	        else { throw new Error('Unimplemented type: ' + type); }
	    },
	
	    // === WRITING =================================================================
	
	    writeTag: function(tag, type) {
	        this.writeVarint((tag << 3) | type);
	    },
	
	    realloc: function(min) {
	        var length = this.length || 16;
	
	        while (length < this.pos + min) { length *= 2; }
	
	        if (length !== this.length) {
	            var buf = new Uint8Array(length);
	            buf.set(this.buf);
	            this.buf = buf;
	            this.length = length;
	        }
	    },
	
	    finish: function() {
	        this.length = this.pos;
	        this.pos = 0;
	        return this.buf.subarray(0, this.length);
	    },
	
	    writeFixed32: function(val) {
	        this.realloc(4);
	        writeInt32(this.buf, val, this.pos);
	        this.pos += 4;
	    },
	
	    writeSFixed32: function(val) {
	        this.realloc(4);
	        writeInt32(this.buf, val, this.pos);
	        this.pos += 4;
	    },
	
	    writeFixed64: function(val) {
	        this.realloc(8);
	        writeInt32(this.buf, val & -1, this.pos);
	        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
	        this.pos += 8;
	    },
	
	    writeSFixed64: function(val) {
	        this.realloc(8);
	        writeInt32(this.buf, val & -1, this.pos);
	        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
	        this.pos += 8;
	    },
	
	    writeVarint: function(val) {
	        val = +val || 0;
	
	        if (val > 0xfffffff || val < 0) {
	            writeBigVarint(val, this);
	            return;
	        }
	
	        this.realloc(4);
	
	        this.buf[this.pos++] =           val & 0x7f  | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) { return; }
	        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) { return; }
	        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) { return; }
	        this.buf[this.pos++] =   (val >>> 7) & 0x7f;
	    },
	
	    writeSVarint: function(val) {
	        this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
	    },
	
	    writeBoolean: function(val) {
	        this.writeVarint(Boolean(val));
	    },
	
	    writeString: function(str) {
	        str = String(str);
	        this.realloc(str.length * 4);
	
	        this.pos++; // reserve 1 byte for short string length
	
	        var startPos = this.pos;
	        // write the string directly to the buffer and see how much was written
	        this.pos = writeUtf8(this.buf, str, this.pos);
	        var len = this.pos - startPos;
	
	        if (len >= 0x80) { makeRoomForExtraLength(startPos, len, this); }
	
	        // finally, write the message length in the reserved place and restore the position
	        this.pos = startPos - 1;
	        this.writeVarint(len);
	        this.pos += len;
	    },
	
	    writeFloat: function(val) {
	        this.realloc(4);
	        ieee754.write(this.buf, val, this.pos, true, 23, 4);
	        this.pos += 4;
	    },
	
	    writeDouble: function(val) {
	        this.realloc(8);
	        ieee754.write(this.buf, val, this.pos, true, 52, 8);
	        this.pos += 8;
	    },
	
	    writeBytes: function(buffer) {
	        var this$1 = this;
	
	        var len = buffer.length;
	        this.writeVarint(len);
	        this.realloc(len);
	        for (var i = 0; i < len; i++) { this$1.buf[this$1.pos++] = buffer[i]; }
	    },
	
	    writeRawMessage: function(fn, obj) {
	        this.pos++; // reserve 1 byte for short message length
	
	        // write the message directly to the buffer and see how much was written
	        var startPos = this.pos;
	        fn(obj, this);
	        var len = this.pos - startPos;
	
	        if (len >= 0x80) { makeRoomForExtraLength(startPos, len, this); }
	
	        // finally, write the message length in the reserved place and restore the position
	        this.pos = startPos - 1;
	        this.writeVarint(len);
	        this.pos += len;
	    },
	
	    writeMessage: function(tag, fn, obj) {
	        this.writeTag(tag, Pbf.Bytes);
	        this.writeRawMessage(fn, obj);
	    },
	
	    writePackedVarint:   function(tag, arr) { this.writeMessage(tag, writePackedVarint, arr);   },
	    writePackedSVarint:  function(tag, arr) { this.writeMessage(tag, writePackedSVarint, arr);  },
	    writePackedBoolean:  function(tag, arr) { this.writeMessage(tag, writePackedBoolean, arr);  },
	    writePackedFloat:    function(tag, arr) { this.writeMessage(tag, writePackedFloat, arr);    },
	    writePackedDouble:   function(tag, arr) { this.writeMessage(tag, writePackedDouble, arr);   },
	    writePackedFixed32:  function(tag, arr) { this.writeMessage(tag, writePackedFixed32, arr);  },
	    writePackedSFixed32: function(tag, arr) { this.writeMessage(tag, writePackedSFixed32, arr); },
	    writePackedFixed64:  function(tag, arr) { this.writeMessage(tag, writePackedFixed64, arr);  },
	    writePackedSFixed64: function(tag, arr) { this.writeMessage(tag, writePackedSFixed64, arr); },
	
	    writeBytesField: function(tag, buffer) {
	        this.writeTag(tag, Pbf.Bytes);
	        this.writeBytes(buffer);
	    },
	    writeFixed32Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed32);
	        this.writeFixed32(val);
	    },
	    writeSFixed32Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed32);
	        this.writeSFixed32(val);
	    },
	    writeFixed64Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed64);
	        this.writeFixed64(val);
	    },
	    writeSFixed64Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed64);
	        this.writeSFixed64(val);
	    },
	    writeVarintField: function(tag, val) {
	        this.writeTag(tag, Pbf.Varint);
	        this.writeVarint(val);
	    },
	    writeSVarintField: function(tag, val) {
	        this.writeTag(tag, Pbf.Varint);
	        this.writeSVarint(val);
	    },
	    writeStringField: function(tag, str) {
	        this.writeTag(tag, Pbf.Bytes);
	        this.writeString(str);
	    },
	    writeFloatField: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed32);
	        this.writeFloat(val);
	    },
	    writeDoubleField: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed64);
	        this.writeDouble(val);
	    },
	    writeBooleanField: function(tag, val) {
	        this.writeVarintField(tag, Boolean(val));
	    }
	};
	
	function readVarintRemainder(l, s, p) {
	    var buf = p.buf,
	        h, b;
	
	    b = buf[p.pos++]; h  = (b & 0x70) >> 4;  if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 3;  if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 10; if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 17; if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 24; if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x01) << 31; if (b < 0x80) { return toNum(l, h, s); }
	
	    throw new Error('Expected varint not more than 10 bytes');
	}
	
	function readPackedEnd(pbf) {
	    return pbf.type === Pbf.Bytes ?
	        pbf.readVarint() + pbf.pos : pbf.pos + 1;
	}
	
	function toNum(low, high, isSigned) {
	    if (isSigned) {
	        return high * 0x100000000 + (low >>> 0);
	    }
	
	    return ((high >>> 0) * 0x100000000) + (low >>> 0);
	}
	
	function writeBigVarint(val, pbf) {
	    var low, high;
	
	    if (val >= 0) {
	        low  = (val % 0x100000000) | 0;
	        high = (val / 0x100000000) | 0;
	    } else {
	        low  = ~(-val % 0x100000000);
	        high = ~(-val / 0x100000000);
	
	        if (low ^ 0xffffffff) {
	            low = (low + 1) | 0;
	        } else {
	            low = 0;
	            high = (high + 1) | 0;
	        }
	    }
	
	    if (val >= 0x10000000000000000 || val < -0x10000000000000000) {
	        throw new Error('Given varint doesn\'t fit into 10 bytes');
	    }
	
	    pbf.realloc(10);
	
	    writeBigVarintLow(low, high, pbf);
	    writeBigVarintHigh(high, pbf);
	}
	
	function writeBigVarintLow(low, high, pbf) {
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos]   = low & 0x7f;
	}
	
	function writeBigVarintHigh(high, pbf) {
	    var lsb = (high & 0x07) << 4;
	
	    pbf.buf[pbf.pos++] |= lsb         | ((high >>>= 3) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f;
	}
	
	function makeRoomForExtraLength(startPos, len, pbf) {
	    var extraLen =
	        len <= 0x3fff ? 1 :
	        len <= 0x1fffff ? 2 :
	        len <= 0xfffffff ? 3 : Math.ceil(Math.log(len) / (Math.LN2 * 7));
	
	    // if 1 byte isn't enough for encoding message length, shift the data to the right
	    pbf.realloc(extraLen);
	    for (var i = pbf.pos - 1; i >= startPos; i--) { pbf.buf[i + extraLen] = pbf.buf[i]; }
	}
	
	function writePackedVarint(arr, pbf)   { for (var i = 0; i < arr.length; i++) { pbf.writeVarint(arr[i]); }   }
	function writePackedSVarint(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeSVarint(arr[i]); }  }
	function writePackedFloat(arr, pbf)    { for (var i = 0; i < arr.length; i++) { pbf.writeFloat(arr[i]); }    }
	function writePackedDouble(arr, pbf)   { for (var i = 0; i < arr.length; i++) { pbf.writeDouble(arr[i]); }   }
	function writePackedBoolean(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeBoolean(arr[i]); }  }
	function writePackedFixed32(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeFixed32(arr[i]); }  }
	function writePackedSFixed32(arr, pbf) { for (var i = 0; i < arr.length; i++) { pbf.writeSFixed32(arr[i]); } }
	function writePackedFixed64(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeFixed64(arr[i]); }  }
	function writePackedSFixed64(arr, pbf) { for (var i = 0; i < arr.length; i++) { pbf.writeSFixed64(arr[i]); } }
	
	// Buffer code below from https://github.com/feross/buffer, MIT-licensed
	
	function readUInt32(buf, pos) {
	    return ((buf[pos]) |
	        (buf[pos + 1] << 8) |
	        (buf[pos + 2] << 16)) +
	        (buf[pos + 3] * 0x1000000);
	}
	
	function writeInt32(buf, val, pos) {
	    buf[pos] = val;
	    buf[pos + 1] = (val >>> 8);
	    buf[pos + 2] = (val >>> 16);
	    buf[pos + 3] = (val >>> 24);
	}
	
	function readInt32(buf, pos) {
	    return ((buf[pos]) |
	        (buf[pos + 1] << 8) |
	        (buf[pos + 2] << 16)) +
	        (buf[pos + 3] << 24);
	}
	
	function readUtf8(buf, pos, end) {
	    var str = '';
	    var i = pos;
	
	    while (i < end) {
	        var b0 = buf[i];
	        var c = null; // codepoint
	        var bytesPerSequence =
	            b0 > 0xEF ? 4 :
	            b0 > 0xDF ? 3 :
	            b0 > 0xBF ? 2 : 1;
	
	        if (i + bytesPerSequence > end) { break; }
	
	        var b1, b2, b3;
	
	        if (bytesPerSequence === 1) {
	            if (b0 < 0x80) {
	                c = b0;
	            }
	        } else if (bytesPerSequence === 2) {
	            b1 = buf[i + 1];
	            if ((b1 & 0xC0) === 0x80) {
	                c = (b0 & 0x1F) << 0x6 | (b1 & 0x3F);
	                if (c <= 0x7F) {
	                    c = null;
	                }
	            }
	        } else if (bytesPerSequence === 3) {
	            b1 = buf[i + 1];
	            b2 = buf[i + 2];
	            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80) {
	                c = (b0 & 0xF) << 0xC | (b1 & 0x3F) << 0x6 | (b2 & 0x3F);
	                if (c <= 0x7FF || (c >= 0xD800 && c <= 0xDFFF)) {
	                    c = null;
	                }
	            }
	        } else if (bytesPerSequence === 4) {
	            b1 = buf[i + 1];
	            b2 = buf[i + 2];
	            b3 = buf[i + 3];
	            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
	                c = (b0 & 0xF) << 0x12 | (b1 & 0x3F) << 0xC | (b2 & 0x3F) << 0x6 | (b3 & 0x3F);
	                if (c <= 0xFFFF || c >= 0x110000) {
	                    c = null;
	                }
	            }
	        }
	
	        if (c === null) {
	            c = 0xFFFD;
	            bytesPerSequence = 1;
	
	        } else if (c > 0xFFFF) {
	            c -= 0x10000;
	            str += String.fromCharCode(c >>> 10 & 0x3FF | 0xD800);
	            c = 0xDC00 | c & 0x3FF;
	        }
	
	        str += String.fromCharCode(c);
	        i += bytesPerSequence;
	    }
	
	    return str;
	}
	
	function writeUtf8(buf, str, pos) {
	    for (var i = 0, c, lead; i < str.length; i++) {
	        c = str.charCodeAt(i); // code point
	
	        if (c > 0xD7FF && c < 0xE000) {
	            if (lead) {
	                if (c < 0xDC00) {
	                    buf[pos++] = 0xEF;
	                    buf[pos++] = 0xBF;
	                    buf[pos++] = 0xBD;
	                    lead = c;
	                    continue;
	                } else {
	                    c = lead - 0xD800 << 10 | c - 0xDC00 | 0x10000;
	                    lead = null;
	                }
	            } else {
	                if (c > 0xDBFF || (i + 1 === str.length)) {
	                    buf[pos++] = 0xEF;
	                    buf[pos++] = 0xBF;
	                    buf[pos++] = 0xBD;
	                } else {
	                    lead = c;
	                }
	                continue;
	            }
	        } else if (lead) {
	            buf[pos++] = 0xEF;
	            buf[pos++] = 0xBF;
	            buf[pos++] = 0xBD;
	            lead = null;
	        }
	
	        if (c < 0x80) {
	            buf[pos++] = c;
	        } else {
	            if (c < 0x800) {
	                buf[pos++] = c >> 0x6 | 0xC0;
	            } else {
	                if (c < 0x10000) {
	                    buf[pos++] = c >> 0xC | 0xE0;
	                } else {
	                    buf[pos++] = c >> 0x12 | 0xF0;
	                    buf[pos++] = c >> 0xC & 0x3F | 0x80;
	                }
	                buf[pos++] = c >> 0x6 & 0x3F | 0x80;
	            }
	            buf[pos++] = c & 0x3F | 0x80;
	        }
	    }
	    return pos;
	}
	
	var index$5 = Point$1;
	
	function Point$1(x, y) {
	    this.x = x;
	    this.y = y;
	}
	
	Point$1.prototype = {
	    clone: function() { return new Point$1(this.x, this.y); },
	
	    add:     function(p) { return this.clone()._add(p);     },
	    sub:     function(p) { return this.clone()._sub(p);     },
	    mult:    function(k) { return this.clone()._mult(k);    },
	    div:     function(k) { return this.clone()._div(k);     },
	    rotate:  function(a) { return this.clone()._rotate(a);  },
	    matMult: function(m) { return this.clone()._matMult(m); },
	    unit:    function() { return this.clone()._unit(); },
	    perp:    function() { return this.clone()._perp(); },
	    round:   function() { return this.clone()._round(); },
	
	    mag: function() {
	        return Math.sqrt(this.x * this.x + this.y * this.y);
	    },
	
	    equals: function(p) {
	        return this.x === p.x &&
	               this.y === p.y;
	    },
	
	    dist: function(p) {
	        return Math.sqrt(this.distSqr(p));
	    },
	
	    distSqr: function(p) {
	        var dx = p.x - this.x,
	            dy = p.y - this.y;
	        return dx * dx + dy * dy;
	    },
	
	    angle: function() {
	        return Math.atan2(this.y, this.x);
	    },
	
	    angleTo: function(b) {
	        return Math.atan2(this.y - b.y, this.x - b.x);
	    },
	
	    angleWith: function(b) {
	        return this.angleWithSep(b.x, b.y);
	    },
	
	    // Find the angle of the two vectors, solving the formula for the cross product a x b = |a||b|sin(θ) for θ.
	    angleWithSep: function(x, y) {
	        return Math.atan2(
	            this.x * y - this.y * x,
	            this.x * x + this.y * y);
	    },
	
	    _matMult: function(m) {
	        var x = m[0] * this.x + m[1] * this.y,
	            y = m[2] * this.x + m[3] * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _add: function(p) {
	        this.x += p.x;
	        this.y += p.y;
	        return this;
	    },
	
	    _sub: function(p) {
	        this.x -= p.x;
	        this.y -= p.y;
	        return this;
	    },
	
	    _mult: function(k) {
	        this.x *= k;
	        this.y *= k;
	        return this;
	    },
	
	    _div: function(k) {
	        this.x /= k;
	        this.y /= k;
	        return this;
	    },
	
	    _unit: function() {
	        this._div(this.mag());
	        return this;
	    },
	
	    _perp: function() {
	        var y = this.y;
	        this.y = this.x;
	        this.x = -y;
	        return this;
	    },
	
	    _rotate: function(angle) {
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle),
	            x = cos * this.x - sin * this.y,
	            y = sin * this.x + cos * this.y;
	        this.x = x;
	        this.y = y;
	        return this;
	    },
	
	    _round: function() {
	        this.x = Math.round(this.x);
	        this.y = Math.round(this.y);
	        return this;
	    }
	};
	
	// constructs Point from an array if necessary
	Point$1.convert = function (a) {
	    if (a instanceof Point$1) {
	        return a;
	    }
	    if (Array.isArray(a)) {
	        return new Point$1(a[0], a[1]);
	    }
	    return a;
	};
	
	var Point = index$5;
	
	var vectortilefeature = VectorTileFeature$2;
	
	function VectorTileFeature$2(pbf, end, extent, keys, values) {
	    // Public
	    this.properties = {};
	    this.extent = extent;
	    this.type = 0;
	
	    // Private
	    this._pbf = pbf;
	    this._geometry = -1;
	    this._keys = keys;
	    this._values = values;
	
	    pbf.readFields(readFeature, this, end);
	}
	
	function readFeature(tag, feature, pbf) {
	    if (tag == 1) { feature.id = pbf.readVarint(); }
	    else if (tag == 2) { readTag(pbf, feature); }
	    else if (tag == 3) { feature.type = pbf.readVarint(); }
	    else if (tag == 4) { feature._geometry = pbf.pos; }
	}
	
	function readTag(pbf, feature) {
	    var end = pbf.readVarint() + pbf.pos;
	
	    while (pbf.pos < end) {
	        var key = feature._keys[pbf.readVarint()],
	            value = feature._values[pbf.readVarint()];
	        feature.properties[key] = value;
	    }
	}
	
	VectorTileFeature$2.types = ['Unknown', 'Point', 'LineString', 'Polygon'];
	
	VectorTileFeature$2.prototype.loadGeometry = function() {
	    var pbf = this._pbf;
	    pbf.pos = this._geometry;
	
	    var end = pbf.readVarint() + pbf.pos,
	        cmd = 1,
	        length = 0,
	        x = 0,
	        y = 0,
	        lines = [],
	        line;
	
	    while (pbf.pos < end) {
	        if (!length) {
	            var cmdLen = pbf.readVarint();
	            cmd = cmdLen & 0x7;
	            length = cmdLen >> 3;
	        }
	
	        length--;
	
	        if (cmd === 1 || cmd === 2) {
	            x += pbf.readSVarint();
	            y += pbf.readSVarint();
	
	            if (cmd === 1) { // moveTo
	                if (line) { lines.push(line); }
	                line = [];
	            }
	
	            line.push(new Point(x, y));
	
	        } else if (cmd === 7) {
	
	            // Workaround for https://github.com/mapbox/mapnik-vector-tile/issues/90
	            if (line) {
	                line.push(line[0].clone()); // closePolygon
	            }
	
	        } else {
	            throw new Error('unknown command ' + cmd);
	        }
	    }
	
	    if (line) { lines.push(line); }
	
	    return lines;
	};
	
	VectorTileFeature$2.prototype.bbox = function() {
	    var pbf = this._pbf;
	    pbf.pos = this._geometry;
	
	    var end = pbf.readVarint() + pbf.pos,
	        cmd = 1,
	        length = 0,
	        x = 0,
	        y = 0,
	        x1 = Infinity,
	        x2 = -Infinity,
	        y1 = Infinity,
	        y2 = -Infinity;
	
	    while (pbf.pos < end) {
	        if (!length) {
	            var cmdLen = pbf.readVarint();
	            cmd = cmdLen & 0x7;
	            length = cmdLen >> 3;
	        }
	
	        length--;
	
	        if (cmd === 1 || cmd === 2) {
	            x += pbf.readSVarint();
	            y += pbf.readSVarint();
	            if (x < x1) { x1 = x; }
	            if (x > x2) { x2 = x; }
	            if (y < y1) { y1 = y; }
	            if (y > y2) { y2 = y; }
	
	        } else if (cmd !== 7) {
	            throw new Error('unknown command ' + cmd);
	        }
	    }
	
	    return [x1, y1, x2, y2];
	};
	
	VectorTileFeature$2.prototype.toGeoJSON = function(x, y, z) {
	    var size = this.extent * Math.pow(2, z),
	        x0 = this.extent * x,
	        y0 = this.extent * y,
	        coords = this.loadGeometry(),
	        type = VectorTileFeature$2.types[this.type],
	        i, j;
	
	    function project(line) {
	        for (var j = 0; j < line.length; j++) {
	            var p = line[j], y2 = 180 - (p.y + y0) * 360 / size;
	            line[j] = [
	                (p.x + x0) * 360 / size - 180,
	                360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90
	            ];
	        }
	    }
	
	    switch (this.type) {
	    case 1:
	        var points = [];
	        for (i = 0; i < coords.length; i++) {
	            points[i] = coords[i][0];
	        }
	        coords = points;
	        project(coords);
	        break;
	
	    case 2:
	        for (i = 0; i < coords.length; i++) {
	            project(coords[i]);
	        }
	        break;
	
	    case 3:
	        coords = classifyRings(coords);
	        for (i = 0; i < coords.length; i++) {
	            for (j = 0; j < coords[i].length; j++) {
	                project(coords[i][j]);
	            }
	        }
	        break;
	    }
	
	    if (coords.length === 1) {
	        coords = coords[0];
	    } else {
	        type = 'Multi' + type;
	    }
	
	    var result = {
	        type: "Feature",
	        geometry: {
	            type: type,
	            coordinates: coords
	        },
	        properties: this.properties
	    };
	
	    if ('id' in this) {
	        result.id = this.id;
	    }
	
	    return result;
	};
	
	// classifies an array of rings into polygons with outer rings and holes
	
	function classifyRings(rings) {
	    var len = rings.length;
	
	    if (len <= 1) { return [rings]; }
	
	    var polygons = [],
	        polygon,
	        ccw;
	
	    for (var i = 0; i < len; i++) {
	        var area = signedArea(rings[i]);
	        if (area === 0) { continue; }
	
	        if (ccw === undefined) { ccw = area < 0; }
	
	        if (ccw === area < 0) {
	            if (polygon) { polygons.push(polygon); }
	            polygon = [rings[i]];
	
	        } else {
	            polygon.push(rings[i]);
	        }
	    }
	    if (polygon) { polygons.push(polygon); }
	
	    return polygons;
	}
	
	function signedArea(ring) {
	    var sum = 0;
	    for (var i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {
	        p1 = ring[i];
	        p2 = ring[j];
	        sum += (p2.x - p1.x) * (p1.y + p2.y);
	    }
	    return sum;
	}
	
	var VectorTileFeature$1 = vectortilefeature;
	
	var vectortilelayer = VectorTileLayer$2;
	
	function VectorTileLayer$2(pbf, end) {
	    // Public
	    this.version = 1;
	    this.name = null;
	    this.extent = 4096;
	    this.length = 0;
	
	    // Private
	    this._pbf = pbf;
	    this._keys = [];
	    this._values = [];
	    this._features = [];
	
	    pbf.readFields(readLayer, this, end);
	
	    this.length = this._features.length;
	}
	
	function readLayer(tag, layer, pbf) {
	    if (tag === 15) { layer.version = pbf.readVarint(); }
	    else if (tag === 1) { layer.name = pbf.readString(); }
	    else if (tag === 5) { layer.extent = pbf.readVarint(); }
	    else if (tag === 2) { layer._features.push(pbf.pos); }
	    else if (tag === 3) { layer._keys.push(pbf.readString()); }
	    else if (tag === 4) { layer._values.push(readValueMessage(pbf)); }
	}
	
	function readValueMessage(pbf) {
	    var value = null,
	        end = pbf.readVarint() + pbf.pos;
	
	    while (pbf.pos < end) {
	        var tag = pbf.readVarint() >> 3;
	
	        value = tag === 1 ? pbf.readString() :
	            tag === 2 ? pbf.readFloat() :
	            tag === 3 ? pbf.readDouble() :
	            tag === 4 ? pbf.readVarint64() :
	            tag === 5 ? pbf.readVarint() :
	            tag === 6 ? pbf.readSVarint() :
	            tag === 7 ? pbf.readBoolean() : null;
	    }
	
	    return value;
	}
	
	// return feature `i` from this layer as a `VectorTileFeature`
	VectorTileLayer$2.prototype.feature = function(i) {
	    if (i < 0 || i >= this._features.length) { throw new Error('feature index out of bounds'); }
	
	    this._pbf.pos = this._features[i];
	
	    var end = this._pbf.readVarint() + this._pbf.pos;
	    return new VectorTileFeature$1(this._pbf, end, this.extent, this._keys, this._values);
	};
	
	var VectorTileLayer$1 = vectortilelayer;
	
	var vectortile = VectorTile$1;
	
	function VectorTile$1(pbf, end) {
	    this.layers = pbf.readFields(readTile, {}, end);
	}
	
	function readTile(tag, layers, pbf) {
	    if (tag === 3) {
	        var layer = new VectorTileLayer$1(pbf, pbf.readVarint() + pbf.pos);
	        if (layer.length) { layers[layer.name] = layer; }
	    }
	}
	
	var VectorTile = vectortile;
	
	/*
	 * 🍂class VectorGrid.Protobuf
	 * 🍂extends VectorGrid
	 *
	 * A `VectorGrid` for vector tiles fetched from the internet.
	 * Tiles are supposed to be protobufs (AKA "protobuffer" or "Protocol Buffers"),
	 * containing data which complies with the
	 * [MapBox Vector Tile Specification](https://github.com/mapbox/vector-tile-spec/tree/master/2.1).
	 *
	 * This is the format used by:
	 * - Mapbox Vector Tiles
	 * - Mapzen Vector Tiles
	 * - ESRI Vector Tiles
	 * - [OpenMapTiles hosted Vector Tiles](https://openmaptiles.com/hosting/)
	 *
	 * 🍂example
	 *
	 * You must initialize a `VectorGrid.Protobuf` with a URL template, just like in
	 * `L.TileLayer`s. The difference is that the template must point to vector tiles
	 * (usually `.pbf` or `.mvt`) instead of raster (`.png` or `.jpg`) tiles, and that
	 * you should define the styling for all the features.
	 *
	 * <br><br>
	 *
	 * For OpenMapTiles, with a key from [https://openmaptiles.org/docs/host/use-cdn/](https://openmaptiles.org/docs/host/use-cdn/),
	 * initialization looks like this:
	 *
	 * ```
	 * L.vectorGrid.protobuf("https://free-{s}.tilehosting.com/data/v3/{z}/{x}/{y}.pbf.pict?key={key}", {
	 * 	vectorTileLayerStyles: { ... },
	 * 	subdomains: "0123",
	 * 	key: 'abcdefghi01234567890',
	 * 	maxNativeZoom: 14
	 * }).addTo(map);
	 * ```
	 *
	 * And for Mapbox vector tiles, it looks like this:
	 *
	 * ```
	 * L.vectorGrid.protobuf("https://{s}.tiles.mapbox.com/v4/mapbox.mapbox-streets-v6/{z}/{x}/{y}.vector.pbf?access_token={token}", {
	 * 	vectorTileLayerStyles: { ... },
	 * 	subdomains: "abcd",
	 * 	token: "pk.abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRTS.TUVWXTZ0123456789abcde"
	 * }).addTo(map);
	 * ```
	 */
	L.VectorGrid.Protobuf = L.VectorGrid.extend({
	
		options: {
			// 🍂section
			// As with `L.TileLayer`, the URL template might contain a reference to
			// any option (see the example above and note the `{key}` or `token` in the URL
			// template, and the corresponding option).
			//
			// 🍂option subdomains: String = 'abc'
			// Akin to the `subdomains` option for `L.TileLayer`.
			subdomains: 'abc',	// Like L.TileLayer
			//
			// 🍂option fetchOptions: Object = {}
			// options passed to `fetch`, e.g. {credentials: 'same-origin'} to send cookie for the current domain
			fetchOptions: {}
		},
	
		initialize: function(url, options) {
			// Inherits options from geojson-vt!
	// 		this._slicer = geojsonvt(geojson, options);
			this._url = url;
			L.VectorGrid.prototype.initialize.call(this, options);
		},
	
		// 🍂method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		setUrl: function(url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		},
	
		_getSubdomain: L.TileLayer.prototype._getSubdomain,
	
		_getVectorTilePromise: function(coords) {
			var data = {
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: coords.z
	// 			z: this._getZoomForUrl()	/// TODO: Maybe replicate TileLayer's maxNativeZoom
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) { // Should this option be available in Leaflet.VectorGrid?
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			var tileUrl = L.Util.template(this._url, L.extend(data, this.options));
	
			return fetch(tileUrl, this.options.fetchOptions).then(function(response){
	
				if (!response.ok) {
					return {layers:[]};
				}
	
				return response.blob().then( function (blob) {
	// 				console.log(blob);
	
					var reader = new FileReader();
					return new Promise(function(resolve){
						reader.addEventListener("loadend", function() {
							// reader.result contains the contents of blob as a typed array
	
							// blob.type === 'application/x-protobuf'
							var pbf = new index( reader.result );
	// 						console.log(pbf);
							return resolve(new VectorTile( pbf ));
	
						});
						reader.readAsArrayBuffer(blob);
					});
				});
			}).then(function(json){
	
	// 			console.log('Vector tile:', json.layers);
	// 			console.log('Vector tile water:', json.layers.water);	// Instance of VectorTileLayer
	
				// Normalize feature getters into actual instanced features
				for (var layerName in json.layers) {
					var feats = [];
	
					for (var i=0; i<json.layers[layerName].length; i++) {
						var feat = json.layers[layerName].feature(i);
						feat.geometry = feat.loadGeometry();
						feats.push(feat);
					}
	
					json.layers[layerName].features = feats;
				}
	
				return json;
			});
		}
	});
	
	
	// 🍂factory L.vectorGrid.protobuf(url: String, options)
	// Instantiates a new protobuf VectorGrid with the given URL template and options
	L.vectorGrid.protobuf = function (url, options) {
		return new L.VectorGrid.Protobuf(url, options);
	};
	
	var workerCode = __$strToBlobUri("'use strict';\n\nvar simplify_1 = simplify$1;\n\n// calculate simplification data using optimized Douglas-Peucker algorithm\n\nfunction simplify$1(points, tolerance) {\n\n    var sqTolerance = tolerance * tolerance,\n        len = points.length,\n        first = 0,\n        last = len - 1,\n        stack = [],\n        i, maxSqDist, sqDist, index;\n\n    // always retain the endpoints (1 is the max value)\n    points[first][2] = 1;\n    points[last][2] = 1;\n\n    // avoid recursion by using a stack\n    while (last) {\n\n        maxSqDist = 0;\n\n        for (i = first + 1; i < last; i++) {\n            sqDist = getSqSegDist(points[i], points[first], points[last]);\n\n            if (sqDist > maxSqDist) {\n                index = i;\n                maxSqDist = sqDist;\n            }\n        }\n\n        if (maxSqDist > sqTolerance) {\n            points[index][2] = maxSqDist; // save the point importance in squared pixels as a z coordinate\n            stack.push(first);\n            stack.push(index);\n            first = index;\n\n        } else {\n            last = stack.pop();\n            first = stack.pop();\n        }\n    }\n}\n\n// square distance from a point to a segment\nfunction getSqSegDist(p, a, b) {\n\n    var x = a[0], y = a[1],\n        bx = b[0], by = b[1],\n        px = p[0], py = p[1],\n        dx = bx - x,\n        dy = by - y;\n\n    if (dx !== 0 || dy !== 0) {\n\n        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);\n\n        if (t > 1) {\n            x = bx;\n            y = by;\n\n        } else if (t > 0) {\n            x += dx * t;\n            y += dy * t;\n        }\n    }\n\n    dx = px - x;\n    dy = py - y;\n\n    return dx * dx + dy * dy;\n}\n\nvar convert_1 = convert$1;\n\nvar simplify = simplify_1;\n\n// converts GeoJSON feature into an intermediate projected JSON vector format with simplification data\n\nfunction convert$1(data, tolerance) {\n    var features = [];\n\n    if (data.type === 'FeatureCollection') {\n        for (var i = 0; i < data.features.length; i++) {\n            convertFeature(features, data.features[i], tolerance);\n        }\n    } else if (data.type === 'Feature') {\n        convertFeature(features, data, tolerance);\n\n    } else {\n        // single geometry or a geometry collection\n        convertFeature(features, {geometry: data}, tolerance);\n    }\n    return features;\n}\n\nfunction convertFeature(features, feature, tolerance) {\n    if (feature.geometry === null) {\n        // ignore features with null geometry\n        return;\n    }\n\n    var geom = feature.geometry,\n        type = geom.type,\n        coords = geom.coordinates,\n        tags = feature.properties,\n        i, j, rings, projectedRing;\n\n    if (type === 'Point') {\n        features.push(create(tags, 1, [projectPoint(coords)]));\n\n    } else if (type === 'MultiPoint') {\n        features.push(create(tags, 1, project(coords)));\n\n    } else if (type === 'LineString') {\n        features.push(create(tags, 2, [project(coords, tolerance)]));\n\n    } else if (type === 'MultiLineString' || type === 'Polygon') {\n        rings = [];\n        for (i = 0; i < coords.length; i++) {\n            projectedRing = project(coords[i], tolerance);\n            if (type === 'Polygon') { projectedRing.outer = (i === 0); }\n            rings.push(projectedRing);\n        }\n        features.push(create(tags, type === 'Polygon' ? 3 : 2, rings));\n\n    } else if (type === 'MultiPolygon') {\n        rings = [];\n        for (i = 0; i < coords.length; i++) {\n            for (j = 0; j < coords[i].length; j++) {\n                projectedRing = project(coords[i][j], tolerance);\n                projectedRing.outer = (j === 0);\n                rings.push(projectedRing);\n            }\n        }\n        features.push(create(tags, 3, rings));\n\n    } else if (type === 'GeometryCollection') {\n        for (i = 0; i < geom.geometries.length; i++) {\n            convertFeature(features, {\n                geometry: geom.geometries[i],\n                properties: tags\n            }, tolerance);\n        }\n\n    } else {\n        throw new Error('Input data is not a valid GeoJSON object.');\n    }\n}\n\nfunction create(tags, type, geometry) {\n    var feature = {\n        geometry: geometry,\n        type: type,\n        tags: tags || null,\n        min: [2, 1], // initial bbox values;\n        max: [-1, 0]  // note that coords are usually in [0..1] range\n    };\n    calcBBox(feature);\n    return feature;\n}\n\nfunction project(lonlats, tolerance) {\n    var projected = [];\n    for (var i = 0; i < lonlats.length; i++) {\n        projected.push(projectPoint(lonlats[i]));\n    }\n    if (tolerance) {\n        simplify(projected, tolerance);\n        calcSize(projected);\n    }\n    return projected;\n}\n\nfunction projectPoint(p) {\n    var sin = Math.sin(p[1] * Math.PI / 180),\n        x = (p[0] / 360 + 0.5),\n        y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);\n\n    y = y < 0 ? 0 :\n        y > 1 ? 1 : y;\n\n    return [x, y, 0];\n}\n\n// calculate area and length of the poly\nfunction calcSize(points) {\n    var area = 0,\n        dist = 0;\n\n    for (var i = 0, a, b; i < points.length - 1; i++) {\n        a = b || points[i];\n        b = points[i + 1];\n\n        area += a[0] * b[1] - b[0] * a[1];\n\n        // use Manhattan distance instead of Euclidian one to avoid expensive square root computation\n        dist += Math.abs(b[0] - a[0]) + Math.abs(b[1] - a[1]);\n    }\n    points.area = Math.abs(area / 2);\n    points.dist = dist;\n}\n\n// calculate the feature bounding box for faster clipping later\nfunction calcBBox(feature) {\n    var geometry = feature.geometry,\n        min = feature.min,\n        max = feature.max;\n\n    if (feature.type === 1) { calcRingBBox(min, max, geometry); }\n    else { for (var i = 0; i < geometry.length; i++) { calcRingBBox(min, max, geometry[i]); } }\n\n    return feature;\n}\n\nfunction calcRingBBox(min, max, points) {\n    for (var i = 0, p; i < points.length; i++) {\n        p = points[i];\n        min[0] = Math.min(p[0], min[0]);\n        max[0] = Math.max(p[0], max[0]);\n        min[1] = Math.min(p[1], min[1]);\n        max[1] = Math.max(p[1], max[1]);\n    }\n}\n\nvar tile = transformTile;\nvar point = transformPoint;\n\n// Transforms the coordinates of each feature in the given tile from\n// mercator-projected space into (extent x extent) tile space.\nfunction transformTile(tile, extent) {\n    if (tile.transformed) { return tile; }\n\n    var z2 = tile.z2,\n        tx = tile.x,\n        ty = tile.y,\n        i, j, k;\n\n    for (i = 0; i < tile.features.length; i++) {\n        var feature = tile.features[i],\n            geom = feature.geometry,\n            type = feature.type;\n\n        if (type === 1) {\n            for (j = 0; j < geom.length; j++) { geom[j] = transformPoint(geom[j], extent, z2, tx, ty); }\n\n        } else {\n            for (j = 0; j < geom.length; j++) {\n                var ring = geom[j];\n                for (k = 0; k < ring.length; k++) { ring[k] = transformPoint(ring[k], extent, z2, tx, ty); }\n            }\n        }\n    }\n\n    tile.transformed = true;\n\n    return tile;\n}\n\nfunction transformPoint(p, extent, z2, tx, ty) {\n    var x = Math.round(extent * (p[0] * z2 - tx)),\n        y = Math.round(extent * (p[1] * z2 - ty));\n    return [x, y];\n}\n\nvar transform$1 = {\n	tile: tile,\n	point: point\n};\n\nvar clip_1 = clip$1;\n\n/* clip features between two axis-parallel lines:\n *     |        |\n *  ___|___     |     /\n * /   |   \____|____/\n *     |        |\n */\n\nfunction clip$1(features, scale, k1, k2, axis, intersect, minAll, maxAll) {\n\n    k1 /= scale;\n    k2 /= scale;\n\n    if (minAll >= k1 && maxAll <= k2) { return features; } // trivial accept\n    else if (minAll > k2 || maxAll < k1) { return null; } // trivial reject\n\n    var clipped = [];\n\n    for (var i = 0; i < features.length; i++) {\n\n        var feature = features[i],\n            geometry = feature.geometry,\n            type = feature.type,\n            min, max;\n\n        min = feature.min[axis];\n        max = feature.max[axis];\n\n        if (min >= k1 && max <= k2) { // trivial accept\n            clipped.push(feature);\n            continue;\n        } else if (min > k2 || max < k1) { continue; } // trivial reject\n\n        var slices = type === 1 ?\n                clipPoints(geometry, k1, k2, axis) :\n                clipGeometry(geometry, k1, k2, axis, intersect, type === 3);\n\n        if (slices.length) {\n            // if a feature got clipped, it will likely get clipped on the next zoom level as well,\n            // so there's no need to recalculate bboxes\n            clipped.push({\n                geometry: slices,\n                type: type,\n                tags: features[i].tags || null,\n                min: feature.min,\n                max: feature.max\n            });\n        }\n    }\n\n    return clipped.length ? clipped : null;\n}\n\nfunction clipPoints(geometry, k1, k2, axis) {\n    var slice = [];\n\n    for (var i = 0; i < geometry.length; i++) {\n        var a = geometry[i],\n            ak = a[axis];\n\n        if (ak >= k1 && ak <= k2) { slice.push(a); }\n    }\n    return slice;\n}\n\nfunction clipGeometry(geometry, k1, k2, axis, intersect, closed) {\n\n    var slices = [];\n\n    for (var i = 0; i < geometry.length; i++) {\n\n        var ak = 0,\n            bk = 0,\n            b = null,\n            points = geometry[i],\n            area = points.area,\n            dist = points.dist,\n            outer = points.outer,\n            len = points.length,\n            a, j, last;\n\n        var slice = [];\n\n        for (j = 0; j < len - 1; j++) {\n            a = b || points[j];\n            b = points[j + 1];\n            ak = bk || a[axis];\n            bk = b[axis];\n\n            if (ak < k1) {\n\n                if ((bk > k2)) { // ---|-----|-->\n                    slice.push(intersect(a, b, k1), intersect(a, b, k2));\n                    if (!closed) { slice = newSlice(slices, slice, area, dist, outer); }\n\n                } else if (bk >= k1) { slice.push(intersect(a, b, k1)); } // ---|-->  |\n\n            } else if (ak > k2) {\n\n                if ((bk < k1)) { // <--|-----|---\n                    slice.push(intersect(a, b, k2), intersect(a, b, k1));\n                    if (!closed) { slice = newSlice(slices, slice, area, dist, outer); }\n\n                } else if (bk <= k2) { slice.push(intersect(a, b, k2)); } // |  <--|---\n\n            } else {\n\n                slice.push(a);\n\n                if (bk < k1) { // <--|---  |\n                    slice.push(intersect(a, b, k1));\n                    if (!closed) { slice = newSlice(slices, slice, area, dist, outer); }\n\n                } else if (bk > k2) { // |  ---|-->\n                    slice.push(intersect(a, b, k2));\n                    if (!closed) { slice = newSlice(slices, slice, area, dist, outer); }\n                }\n                // | --> |\n            }\n        }\n\n        // add the last point\n        a = points[len - 1];\n        ak = a[axis];\n        if (ak >= k1 && ak <= k2) { slice.push(a); }\n\n        // close the polygon if its endpoints are not the same after clipping\n\n        last = slice[slice.length - 1];\n        if (closed && last && (slice[0][0] !== last[0] || slice[0][1] !== last[1])) { slice.push(slice[0]); }\n\n        // add the final slice\n        newSlice(slices, slice, area, dist, outer);\n    }\n\n    return slices;\n}\n\nfunction newSlice(slices, slice, area, dist, outer) {\n    if (slice.length) {\n        // we don't recalculate the area/length of the unclipped geometry because the case where it goes\n        // below the visibility threshold as a result of clipping is rare, so we avoid doing unnecessary work\n        slice.area = area;\n        slice.dist = dist;\n        if (outer !== undefined) { slice.outer = outer; }\n\n        slices.push(slice);\n    }\n    return [];\n}\n\nvar clip$2 = clip_1;\n\nvar wrap_1 = wrap$1;\n\nfunction wrap$1(features, buffer, intersectX) {\n    var merged = features,\n        left  = clip$2(features, 1, -1 - buffer, buffer,     0, intersectX, -1, 2), // left world copy\n        right = clip$2(features, 1,  1 - buffer, 2 + buffer, 0, intersectX, -1, 2); // right world copy\n\n    if (left || right) {\n        merged = clip$2(features, 1, -buffer, 1 + buffer, 0, intersectX, -1, 2); // center world copy\n\n        if (left) { merged = shiftFeatureCoords(left, 1).concat(merged); } // merge left into center\n        if (right) { merged = merged.concat(shiftFeatureCoords(right, -1)); } // merge right into center\n    }\n\n    return merged;\n}\n\nfunction shiftFeatureCoords(features, offset) {\n    var newFeatures = [];\n\n    for (var i = 0; i < features.length; i++) {\n        var feature = features[i],\n            type = feature.type;\n\n        var newGeometry;\n\n        if (type === 1) {\n            newGeometry = shiftCoords(feature.geometry, offset);\n        } else {\n            newGeometry = [];\n            for (var j = 0; j < feature.geometry.length; j++) {\n                newGeometry.push(shiftCoords(feature.geometry[j], offset));\n            }\n        }\n\n        newFeatures.push({\n            geometry: newGeometry,\n            type: type,\n            tags: feature.tags,\n            min: [feature.min[0] + offset, feature.min[1]],\n            max: [feature.max[0] + offset, feature.max[1]]\n        });\n    }\n\n    return newFeatures;\n}\n\nfunction shiftCoords(points, offset) {\n    var newPoints = [];\n    newPoints.area = points.area;\n    newPoints.dist = points.dist;\n\n    for (var i = 0; i < points.length; i++) {\n        newPoints.push([points[i][0] + offset, points[i][1], points[i][2]]);\n    }\n    return newPoints;\n}\n\nvar tile$1 = createTile$1;\n\nfunction createTile$1(features, z2, tx, ty, tolerance, noSimplify) {\n    var tile = {\n        features: [],\n        numPoints: 0,\n        numSimplified: 0,\n        numFeatures: 0,\n        source: null,\n        x: tx,\n        y: ty,\n        z2: z2,\n        transformed: false,\n        min: [2, 1],\n        max: [-1, 0]\n    };\n    for (var i = 0; i < features.length; i++) {\n        tile.numFeatures++;\n        addFeature(tile, features[i], tolerance, noSimplify);\n\n        var min = features[i].min,\n            max = features[i].max;\n\n        if (min[0] < tile.min[0]) { tile.min[0] = min[0]; }\n        if (min[1] < tile.min[1]) { tile.min[1] = min[1]; }\n        if (max[0] > tile.max[0]) { tile.max[0] = max[0]; }\n        if (max[1] > tile.max[1]) { tile.max[1] = max[1]; }\n    }\n    return tile;\n}\n\nfunction addFeature(tile, feature, tolerance, noSimplify) {\n\n    var geom = feature.geometry,\n        type = feature.type,\n        simplified = [],\n        sqTolerance = tolerance * tolerance,\n        i, j, ring, p;\n\n    if (type === 1) {\n        for (i = 0; i < geom.length; i++) {\n            simplified.push(geom[i]);\n            tile.numPoints++;\n            tile.numSimplified++;\n        }\n\n    } else {\n\n        // simplify and transform projected coordinates for tile geometry\n        for (i = 0; i < geom.length; i++) {\n            ring = geom[i];\n\n            // filter out tiny polylines & polygons\n            if (!noSimplify && ((type === 2 && ring.dist < tolerance) ||\n                                (type === 3 && ring.area < sqTolerance))) {\n                tile.numPoints += ring.length;\n                continue;\n            }\n\n            var simplifiedRing = [];\n\n            for (j = 0; j < ring.length; j++) {\n                p = ring[j];\n                // keep points with importance > tolerance\n                if (noSimplify || p[2] > sqTolerance) {\n                    simplifiedRing.push(p);\n                    tile.numSimplified++;\n                }\n                tile.numPoints++;\n            }\n\n            if (type === 3) { rewind(simplifiedRing, ring.outer); }\n\n            simplified.push(simplifiedRing);\n        }\n    }\n\n    if (simplified.length) {\n        tile.features.push({\n            geometry: simplified,\n            type: type,\n            tags: feature.tags || null\n        });\n    }\n}\n\nfunction rewind(ring, clockwise) {\n    var area = signedArea(ring);\n    if (area < 0 === clockwise) { ring.reverse(); }\n}\n\nfunction signedArea(ring) {\n    var sum = 0;\n    for (var i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {\n        p1 = ring[i];\n        p2 = ring[j];\n        sum += (p2[0] - p1[0]) * (p1[1] + p2[1]);\n    }\n    return sum;\n}\n\nvar index = geojsonvt;\n\nvar convert = convert_1;\nvar transform = transform$1;\nvar clip = clip_1;\nvar wrap = wrap_1;\nvar createTile = tile$1;     // final simplified tile generation\n\n\nfunction geojsonvt(data, options) {\n    return new GeoJSONVT(data, options);\n}\n\nfunction GeoJSONVT(data, options) {\n    options = this.options = extend(Object.create(this.options), options);\n\n    var debug = options.debug;\n\n    if (debug) { console.time('preprocess data'); }\n\n    var z2 = 1 << options.maxZoom, // 2^z\n        features = convert(data, options.tolerance / (z2 * options.extent));\n\n    this.tiles = {};\n    this.tileCoords = [];\n\n    if (debug) {\n        console.timeEnd('preprocess data');\n        console.log('index: maxZoom: %d, maxPoints: %d', options.indexMaxZoom, options.indexMaxPoints);\n        console.time('generate tiles');\n        this.stats = {};\n        this.total = 0;\n    }\n\n    features = wrap(features, options.buffer / options.extent, intersectX);\n\n    // start slicing from the top tile down\n    if (features.length) { this.splitTile(features, 0, 0, 0); }\n\n    if (debug) {\n        if (features.length) { console.log('features: %d, points: %d', this.tiles[0].numFeatures, this.tiles[0].numPoints); }\n        console.timeEnd('generate tiles');\n        console.log('tiles generated:', this.total, JSON.stringify(this.stats));\n    }\n}\n\nGeoJSONVT.prototype.options = {\n    maxZoom: 14,            // max zoom to preserve detail on\n    indexMaxZoom: 5,        // max zoom in the tile index\n    indexMaxPoints: 100000, // max number of points per tile in the tile index\n    solidChildren: false,   // whether to tile solid square tiles further\n    tolerance: 3,           // simplification tolerance (higher means simpler)\n    extent: 4096,           // tile extent\n    buffer: 64,             // tile buffer on each side\n    debug: 0                // logging level (0, 1 or 2)\n};\n\nGeoJSONVT.prototype.splitTile = function (features, z, x, y, cz, cx, cy) {\n    var this$1 = this;\n\n\n    var stack = [features, z, x, y],\n        options = this.options,\n        debug = options.debug,\n        solid = null;\n\n    // avoid recursion by using a processing queue\n    while (stack.length) {\n        y = stack.pop();\n        x = stack.pop();\n        z = stack.pop();\n        features = stack.pop();\n\n        var z2 = 1 << z,\n            id = toID(z, x, y),\n            tile = this$1.tiles[id],\n            tileTolerance = z === options.maxZoom ? 0 : options.tolerance / (z2 * options.extent);\n\n        if (!tile) {\n            if (debug > 1) { console.time('creation'); }\n\n            tile = this$1.tiles[id] = createTile(features, z2, x, y, tileTolerance, z === options.maxZoom);\n            this$1.tileCoords.push({z: z, x: x, y: y});\n\n            if (debug) {\n                if (debug > 1) {\n                    console.log('tile z%d-%d-%d (features: %d, points: %d, simplified: %d)',\n                        z, x, y, tile.numFeatures, tile.numPoints, tile.numSimplified);\n                    console.timeEnd('creation');\n                }\n                var key = 'z' + z;\n                this$1.stats[key] = (this$1.stats[key] || 0) + 1;\n                this$1.total++;\n            }\n        }\n\n        // save reference to original geometry in tile so that we can drill down later if we stop now\n        tile.source = features;\n\n        // if it's the first-pass tiling\n        if (!cz) {\n            // stop tiling if we reached max zoom, or if the tile is too simple\n            if (z === options.indexMaxZoom || tile.numPoints <= options.indexMaxPoints) { continue; }\n\n        // if a drilldown to a specific tile\n        } else {\n            // stop tiling if we reached base zoom or our target tile zoom\n            if (z === options.maxZoom || z === cz) { continue; }\n\n            // stop tiling if it's not an ancestor of the target tile\n            var m = 1 << (cz - z);\n            if (x !== Math.floor(cx / m) || y !== Math.floor(cy / m)) { continue; }\n        }\n\n        // stop tiling if the tile is solid clipped square\n        if (!options.solidChildren && isClippedSquare(tile, options.extent, options.buffer)) {\n            if (cz) { solid = z; } // and remember the zoom if we're drilling down\n            continue;\n        }\n\n        // if we slice further down, no need to keep source geometry\n        tile.source = null;\n\n        if (debug > 1) { console.time('clipping'); }\n\n        // values we'll use for clipping\n        var k1 = 0.5 * options.buffer / options.extent,\n            k2 = 0.5 - k1,\n            k3 = 0.5 + k1,\n            k4 = 1 + k1,\n            tl, bl, tr, br, left, right;\n\n        tl = bl = tr = br = null;\n\n        left  = clip(features, z2, x - k1, x + k3, 0, intersectX, tile.min[0], tile.max[0]);\n        right = clip(features, z2, x + k2, x + k4, 0, intersectX, tile.min[0], tile.max[0]);\n\n        if (left) {\n            tl = clip(left, z2, y - k1, y + k3, 1, intersectY, tile.min[1], tile.max[1]);\n            bl = clip(left, z2, y + k2, y + k4, 1, intersectY, tile.min[1], tile.max[1]);\n        }\n\n        if (right) {\n            tr = clip(right, z2, y - k1, y + k3, 1, intersectY, tile.min[1], tile.max[1]);\n            br = clip(right, z2, y + k2, y + k4, 1, intersectY, tile.min[1], tile.max[1]);\n        }\n\n        if (debug > 1) { console.timeEnd('clipping'); }\n\n        if (tl) { stack.push(tl, z + 1, x * 2,     y * 2); }\n        if (bl) { stack.push(bl, z + 1, x * 2,     y * 2 + 1); }\n        if (tr) { stack.push(tr, z + 1, x * 2 + 1, y * 2); }\n        if (br) { stack.push(br, z + 1, x * 2 + 1, y * 2 + 1); }\n    }\n\n    return solid;\n};\n\nGeoJSONVT.prototype.getTile = function (z, x, y) {\n    var this$1 = this;\n\n    var options = this.options,\n        extent = options.extent,\n        debug = options.debug;\n\n    var z2 = 1 << z;\n    x = ((x % z2) + z2) % z2; // wrap tile x coordinate\n\n    var id = toID(z, x, y);\n    if (this.tiles[id]) { return transform.tile(this.tiles[id], extent); }\n\n    if (debug > 1) { console.log('drilling down to z%d-%d-%d', z, x, y); }\n\n    var z0 = z,\n        x0 = x,\n        y0 = y,\n        parent;\n\n    while (!parent && z0 > 0) {\n        z0--;\n        x0 = Math.floor(x0 / 2);\n        y0 = Math.floor(y0 / 2);\n        parent = this$1.tiles[toID(z0, x0, y0)];\n    }\n\n    if (!parent || !parent.source) { return null; }\n\n    // if we found a parent tile containing the original geometry, we can drill down from it\n    if (debug > 1) { console.log('found parent tile z%d-%d-%d', z0, x0, y0); }\n\n    // it parent tile is a solid clipped square, return it instead since it's identical\n    if (isClippedSquare(parent, extent, options.buffer)) { return transform.tile(parent, extent); }\n\n    if (debug > 1) { console.time('drilling down'); }\n    var solid = this.splitTile(parent.source, z0, x0, y0, z, x, y);\n    if (debug > 1) { console.timeEnd('drilling down'); }\n\n    // one of the parent tiles was a solid clipped square\n    if (solid !== null) {\n        var m = 1 << (z - solid);\n        id = toID(solid, Math.floor(x / m), Math.floor(y / m));\n    }\n\n    return this.tiles[id] ? transform.tile(this.tiles[id], extent) : null;\n};\n\nfunction toID(z, x, y) {\n    return (((1 << z) * y + x) * 32) + z;\n}\n\nfunction intersectX(a, b, x) {\n    return [x, (x - a[0]) * (b[1] - a[1]) / (b[0] - a[0]) + a[1], 1];\n}\nfunction intersectY(a, b, y) {\n    return [(y - a[1]) * (b[0] - a[0]) / (b[1] - a[1]) + a[0], y, 1];\n}\n\nfunction extend(dest, src) {\n    for (var i in src) { dest[i] = src[i]; }\n    return dest;\n}\n\n// checks whether a tile is a whole-area fill after clipping; if it is, there's no sense slicing it further\nfunction isClippedSquare(tile, extent, buffer) {\n\n    var features = tile.source;\n    if (features.length !== 1) { return false; }\n\n    var feature = features[0];\n    if (feature.type !== 3 || feature.geometry.length > 1) { return false; }\n\n    var len = feature.geometry[0].length;\n    if (len !== 5) { return false; }\n\n    for (var i = 0; i < len; i++) {\n        var p = transform.point(feature.geometry[0][i], extent, tile.z2, tile.x, tile.y);\n        if ((p[0] !== -buffer && p[0] !== extent + buffer) ||\n            (p[1] !== -buffer && p[1] !== extent + buffer)) { return false; }\n    }\n\n    return true;\n}\n\nvar identity = function(x) {\n  return x;\n};\n\nvar transform$3 = function(topology) {\n  if ((transform = topology.transform) == null) { return identity; }\n  var transform,\n      x0,\n      y0,\n      kx = transform.scale[0],\n      ky = transform.scale[1],\n      dx = transform.translate[0],\n      dy = transform.translate[1];\n  return function(point, i) {\n    if (!i) { x0 = y0 = 0; }\n    point[0] = (x0 += point[0]) * kx + dx;\n    point[1] = (y0 += point[1]) * ky + dy;\n    return point;\n  };\n};\n\nvar bbox = function(topology) {\n  var bbox = topology.bbox;\n\n  function bboxPoint(p0) {\n    p1[0] = p0[0], p1[1] = p0[1], t(p1);\n    if (p1[0] < x0) { x0 = p1[0]; }\n    if (p1[0] > x1) { x1 = p1[0]; }\n    if (p1[1] < y0) { y0 = p1[1]; }\n    if (p1[1] > y1) { y1 = p1[1]; }\n  }\n\n  function bboxGeometry(o) {\n    switch (o.type) {\n      case \"GeometryCollection\": o.geometries.forEach(bboxGeometry); break;\n      case \"Point\": bboxPoint(o.coordinates); break;\n      case \"MultiPoint\": o.coordinates.forEach(bboxPoint); break;\n    }\n  }\n\n  if (!bbox) {\n    var t = transform$3(topology), p0, p1 = new Array(2), name,\n        x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;\n\n    topology.arcs.forEach(function(arc) {\n      var i = -1, n = arc.length;\n      while (++i < n) {\n        p0 = arc[i], p1[0] = p0[0], p1[1] = p0[1], t(p1, i);\n        if (p1[0] < x0) { x0 = p1[0]; }\n        if (p1[0] > x1) { x1 = p1[0]; }\n        if (p1[1] < y0) { y0 = p1[1]; }\n        if (p1[1] > y1) { y1 = p1[1]; }\n      }\n    });\n\n    for (name in topology.objects) {\n      bboxGeometry(topology.objects[name]);\n    }\n\n    bbox = topology.bbox = [x0, y0, x1, y1];\n  }\n\n  return bbox;\n};\n\nvar reverse = function(array, n) {\n  var t, j = array.length, i = j - n;\n  while (i < --j) { t = array[i], array[i++] = array[j], array[j] = t; }\n};\n\nvar feature = function(topology, o) {\n  return o.type === \"GeometryCollection\"\n      ? {type: \"FeatureCollection\", features: o.geometries.map(function(o) { return feature$1(topology, o); })}\n      : feature$1(topology, o);\n};\n\nfunction feature$1(topology, o) {\n  var id = o.id,\n      bbox = o.bbox,\n      properties = o.properties == null ? {} : o.properties,\n      geometry = object(topology, o);\n  return id == null && bbox == null ? {type: \"Feature\", properties: properties, geometry: geometry}\n      : bbox == null ? {type: \"Feature\", id: id, properties: properties, geometry: geometry}\n      : {type: \"Feature\", id: id, bbox: bbox, properties: properties, geometry: geometry};\n}\n\nfunction object(topology, o) {\n  var transformPoint = transform$3(topology),\n      arcs = topology.arcs;\n\n  function arc(i, points) {\n    if (points.length) { points.pop(); }\n    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {\n      points.push(transformPoint(a[k].slice(), k));\n    }\n    if (i < 0) { reverse(points, n); }\n  }\n\n  function point(p) {\n    return transformPoint(p.slice());\n  }\n\n  function line(arcs) {\n    var points = [];\n    for (var i = 0, n = arcs.length; i < n; ++i) { arc(arcs[i], points); }\n    if (points.length < 2) { points.push(points[0].slice()); }\n    return points;\n  }\n\n  function ring(arcs) {\n    var points = line(arcs);\n    while (points.length < 4) { points.push(points[0].slice()); }\n    return points;\n  }\n\n  function polygon(arcs) {\n    return arcs.map(ring);\n  }\n\n  function geometry(o) {\n    var type = o.type, coordinates;\n    switch (type) {\n      case \"GeometryCollection\": return {type: type, geometries: o.geometries.map(geometry)};\n      case \"Point\": coordinates = point(o.coordinates); break;\n      case \"MultiPoint\": coordinates = o.coordinates.map(point); break;\n      case \"LineString\": coordinates = line(o.arcs); break;\n      case \"MultiLineString\": coordinates = o.arcs.map(line); break;\n      case \"Polygon\": coordinates = polygon(o.arcs); break;\n      case \"MultiPolygon\": coordinates = o.arcs.map(polygon); break;\n      default: return null;\n    }\n    return {type: type, coordinates: coordinates};\n  }\n\n  return geometry(o);\n}\n\nvar stitch = function(topology, arcs) {\n  var stitchedArcs = {},\n      fragmentByStart = {},\n      fragmentByEnd = {},\n      fragments = [],\n      emptyIndex = -1;\n\n  // Stitch empty arcs first, since they may be subsumed by other arcs.\n  arcs.forEach(function(i, j) {\n    var arc = topology.arcs[i < 0 ? ~i : i], t;\n    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {\n      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;\n    }\n  });\n\n  arcs.forEach(function(i) {\n    var e = ends(i),\n        start = e[0],\n        end = e[1],\n        f, g;\n\n    if (f = fragmentByEnd[start]) {\n      delete fragmentByEnd[f.end];\n      f.push(i);\n      f.end = end;\n      if (g = fragmentByStart[end]) {\n        delete fragmentByStart[g.start];\n        var fg = g === f ? f : f.concat(g);\n        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;\n      } else {\n        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;\n      }\n    } else if (f = fragmentByStart[end]) {\n      delete fragmentByStart[f.start];\n      f.unshift(i);\n      f.start = start;\n      if (g = fragmentByEnd[start]) {\n        delete fragmentByEnd[g.end];\n        var gf = g === f ? f : g.concat(f);\n        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;\n      } else {\n        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;\n      }\n    } else {\n      f = [i];\n      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;\n    }\n  });\n\n  function ends(i) {\n    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;\n    if (topology.transform) { p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; }); }\n    else { p1 = arc[arc.length - 1]; }\n    return i < 0 ? [p1, p0] : [p0, p1];\n  }\n\n  function flush(fragmentByEnd, fragmentByStart) {\n    for (var k in fragmentByEnd) {\n      var f = fragmentByEnd[k];\n      delete fragmentByStart[f.start];\n      delete f.start;\n      delete f.end;\n      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });\n      fragments.push(f);\n    }\n  }\n\n  flush(fragmentByEnd, fragmentByStart);\n  flush(fragmentByStart, fragmentByEnd);\n  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) { fragments.push([i]); } });\n\n  return fragments;\n};\n\nfunction extractArcs(topology, object$$1, filter) {\n  var arcs = [],\n      geomsByArc = [],\n      geom;\n\n  function extract0(i) {\n    var j = i < 0 ? ~i : i;\n    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});\n  }\n\n  function extract1(arcs) {\n    arcs.forEach(extract0);\n  }\n\n  function extract2(arcs) {\n    arcs.forEach(extract1);\n  }\n\n  function extract3(arcs) {\n    arcs.forEach(extract2);\n  }\n\n  function geometry(o) {\n    switch (geom = o, o.type) {\n      case \"GeometryCollection\": o.geometries.forEach(geometry); break;\n      case \"LineString\": extract1(o.arcs); break;\n      case \"MultiLineString\": case \"Polygon\": extract2(o.arcs); break;\n      case \"MultiPolygon\": extract3(o.arcs); break;\n    }\n  }\n\n  geometry(object$$1);\n\n  geomsByArc.forEach(filter == null\n      ? function(geoms) { arcs.push(geoms[0].i); }\n      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) { arcs.push(geoms[0].i); } });\n\n  return arcs;\n}\n\nfunction planarRingArea(ring) {\n  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;\n  while (++i < n) { a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0]; }\n  return Math.abs(area); // Note: doubled area!\n}\n\nvar bisect = function(a, x) {\n  var lo = 0, hi = a.length;\n  while (lo < hi) {\n    var mid = lo + hi >>> 1;\n    if (a[mid] < x) { lo = mid + 1; }\n    else { hi = mid; }\n  }\n  return lo;\n};\n\nvar slicers = {};\nvar options;\n\nonmessage = function (e) {\n	if (e.data[0] === 'slice') {\n		// Given a blob of GeoJSON and some topojson/geojson-vt options, do the slicing.\n		var geojson = e.data[1];\n		options     = e.data[2];\n\n		if (geojson.type && geojson.type === 'Topology') {\n			for (var layerName in geojson.objects) {\n				slicers[layerName] = index(\n					feature(geojson, geojson.objects[layerName])\n				, options);\n			}\n		} else {\n			slicers[options.vectorTileLayerName] = index(geojson, options);\n		}\n\n	} else if (e.data[0] === 'get') {\n		// Gets the vector tile for the given coordinates, sends it back as a message\n		var coords = e.data[1];\n\n		var tileLayers = {};\n		for (var layerName in slicers) {\n			var slicedTileLayer = slicers[layerName].getTile(coords.z, coords.x, coords.y);\n\n			if (slicedTileLayer) {\n				var vectorTileLayer = {\n					features: [],\n					extent: options.extent,\n					name: options.vectorTileLayerName,\n					length: slicedTileLayer.features.length\n				};\n\n				for (var i in slicedTileLayer.features) {\n					var feat = {\n						geometry: slicedTileLayer.features[i].geometry,\n						properties: slicedTileLayer.features[i].tags,\n						type: slicedTileLayer.features[i].type	// 1 = point, 2 = line, 3 = polygon\n					};\n					vectorTileLayer.features.push(feat);\n				}\n				tileLayers[layerName] = vectorTileLayer;\n			}\n		}\n		postMessage({ layers: tileLayers, coords: coords });\n	}\n};\n//# sourceMap" + "pingURL=slicerWebWorker.js.worker.map\n", "text/plain; charset=us-ascii", false);
	
	// The geojson/topojson is sliced into tiles via a web worker.
	// This import statement depends on rollup-file-as-blob, so that the
	// variable 'workerCode' is a blob URL.
	
	/*
	 * 🍂class VectorGrid.Slicer
	 * 🍂extends VectorGrid
	 *
	 * A `VectorGrid` for slicing up big GeoJSON or TopoJSON documents in vector
	 * tiles, leveraging [`geojson-vt`](https://github.com/mapbox/geojson-vt).
	 *
	 * 🍂example
	 *
	 * ```
	 * var geoJsonDocument = {
	 * 	type: 'FeatureCollection',
	 * 	features: [ ... ]
	 * };
	 *
	 * L.vectorGrid.slicer(geoJsonDocument, {
	 * 	vectorTileLayerStyles: {
	 * 		sliced: { ... }
	 * 	}
	 * }).addTo(map);
	 *
	 * ```
	 *
	 * `VectorGrid.Slicer` can also handle [TopoJSON](https://github.com/mbostock/topojson) transparently:
	 * ```js
	 * var layer = L.vectorGrid.slicer(topojson, options);
	 * ```
	 *
	 * The TopoJSON format [implicitly groups features into "objects"](https://github.com/mbostock/topojson-specification/blob/master/README.md#215-objects).
	 * These will be transformed into vector tile layer names when styling (the
	 * `vectorTileLayerName` option is ignored when using TopoJSON).
	 *
	 */
	
	L.VectorGrid.Slicer = L.VectorGrid.extend({
	
		options: {
			// 🍂section
			// Additionally to these options, `VectorGrid.Slicer` can take in any
			// of the [`geojson-vt` options](https://github.com/mapbox/geojson-vt#options).
	
			// 🍂option vectorTileLayerName: String = 'sliced'
			// Vector tiles contain a set of *data layers*, and those data layers
			// contain features. Thus, the slicer creates one data layer, with
			// the name given in this option. This is important for symbolizing the data.
			vectorTileLayerName: 'sliced',
	
			extent: 4096,	// Default for geojson-vt
			maxZoom: 14  	// Default for geojson-vt
		},
	
		initialize: function(geojson, options) {
			L.VectorGrid.prototype.initialize.call(this, options);
	
			// Create a shallow copy of this.options, excluding things that might
			// be functions - we only care about topojson/geojsonvt options
			var options = {};
			for (var i in this.options) {
				if (i !== 'rendererFactory' &&
					i !== 'vectorTileLayerStyles' &&
					typeof (this.options[i]) !== 'function'
				) {
					options[i] = this.options[i];
				}
			}
	
	// 		this._worker = new Worker(window.URL.createObjectURL(new Blob([workerCode])));
			this._worker = new Worker(workerCode);
	
			// Send initial data to worker.
			this._worker.postMessage(['slice', geojson, options]);
	
		},
	
	
		_getVectorTilePromise: function(coords) {
	
			var _this = this;
	
			var p = new Promise( function waitForWorker(res) {
				_this._worker.addEventListener('message', function recv(m) {
					if (m.data.coords &&
					    m.data.coords.x === coords.x &&
					    m.data.coords.y === coords.y &&
					    m.data.coords.z === coords.z ) {
	
						res(m.data);
						_this._worker.removeEventListener('message', recv);
					}
				});
			});
	
			this._worker.postMessage(['get', coords]);
	
			return p;
		},
	
	});
	
	
	L.vectorGrid.slicer = function (geojson, options) {
		return new L.VectorGrid.Slicer(geojson, options);
	};
	
	L.Canvas.Tile = L.Canvas.extend({
	
		initialize: function (tileCoord, tileSize, options) {
			L.Canvas.prototype.initialize.call(this, options);
			this._tileCoord = tileCoord;
			this._size = tileSize;
	
			this._initContainer();
			this._container.setAttribute('width', this._size.x);
			this._container.setAttribute('height', this._size.y);
			this._layers = {};
			this._drawnLayers = {};
			this._drawing = true;
	
			if (options.interactive) {
				// By default, Leaflet tiles do not have pointer events
				this._container.style.pointerEvents = 'auto';
			}
		},
	
		getCoord: function() {
			return this._tileCoord;
		},
	
		getContainer: function() {
			return this._container;
		},
	
		getOffset: function() {
			return this._tileCoord.scaleBy(this._size).subtract(this._map.getPixelOrigin());
		},
	
		onAdd: L.Util.falseFn,
	
		addTo: function(map) {
			this._map = map;
		},
	
		removeFrom: function (map) {
			delete this._map;
		},
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e).subtract(this.getOffset()), layer, clickedLayer;
	
			for (var id in this._layers) {
				layer = this._layers[id];
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				L.DomEvent.fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e).subtract(this.getOffset());
			this._handleMouseHover(e, point);
		},
	
		/// TODO: Modify _initPath to include an extra parameter, a group name
		/// to order symbolizers by z-index
	
		_updateIcon: function (layer) {
			if (!this._drawing) { return; }
	
			var icon = layer.options.icon,
			    options = icon.options,
			    size = L.point(options.iconSize),
			    anchor = options.iconAnchor ||
			        	 size && size.divideBy(2, true),
			    p = layer._point.subtract(anchor),
			    ctx = this._ctx,
			    img = layer._getImage();
	
			if (img.complete) {
				ctx.drawImage(img, p.x, p.y, size.x, size.y);
			} else {
				L.DomEvent.on(img, 'load', function() {
					ctx.drawImage(img, p.x, p.y, size.x, size.y);
				});
			}
	
			this._drawnLayers[layer._leaflet_id] = layer;
		}
	});
	
	
	L.canvas.tile = function(tileCoord, tileSize, opts){
		return new L.Canvas.Tile(tileCoord, tileSize, opts);
	};
	
	// Aux file to bundle everything together
	//# sourceMappingURL=Leaflet.VectorGrid.js.map


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PointSymbolizer = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Symbolizer = __webpack_require__(35);
	
	// 🍂class PointSymbolizer
	// 🍂inherits CircleMarker
	// A symbolizer for points.
	
	var PointSymbolizer = L.CircleMarker.extend({
	    includes: _Symbolizer.Symbolizer.prototype,
	
	    statics: {
	        iconCache: {}
	    },
	
	    initialize: function initialize(feature, pxPerExtent) {
	        this.properties = feature.properties;
	        this._makeFeatureParts(feature, pxPerExtent);
	    },
	
	    render: function render(renderer, style) {
	        _Symbolizer.Symbolizer.prototype.render.call(this, renderer, style);
	        this._radius = style.radius || L.CircleMarker.prototype.options.radius;
	        this._updatePath();
	    },
	
	    _makeFeatureParts: function _makeFeatureParts(feat, pxPerExtent) {
	        var coord = feat.geometry[0];
	        if (_typeof(coord[0]) === 'object' && 'x' in coord[0]) {
	            // Protobuf vector tiles return [{x: , y:}]
	            this._point = L.point(coord[0]).scaleBy(pxPerExtent);
	            this._empty = L.Util.falseFn;
	        } else {
	            // Geojson-vt returns [,]
	            this._point = L.point(coord).scaleBy(pxPerExtent);
	            this._empty = L.Util.falseFn;
	        }
	    },
	
	    /*getLatLng() {
	        console.error(this);
	        return this._renderer._map.layerPointToLatLng(this._point);
	    },*/
	
	    makeInteractive: function makeInteractive() {
	        this._updateBounds();
	    },
	
	    updateStyle: function updateStyle(renderer, style) {
	        this._radius = style.radius || this._radius;
	        this._updateBounds();
	        return _Symbolizer.Symbolizer.prototype.updateStyle.call(this, renderer, style);
	    },
	
	    _updateBounds: function _updateBounds() {
	        var icon = this.options.icon;
	        if (icon) {
	            var size = L.point(icon.options.iconSize),
	                anchor = icon.options.iconAnchor || size && size.divideBy(2, true),
	                p = this._point.subtract(anchor);
	            this._pxBounds = new L.Bounds(p, p.add(icon.options.iconSize));
	        } else {
	            L.CircleMarker.prototype._updateBounds.call(this);
	        }
	    },
	
	    _updatePath: function _updatePath() {
	        if (this.options.icon) {
	            this._renderer._updateIcon(this);
	        } else {
	            L.CircleMarker.prototype._updatePath.call(this);
	        }
	    },
	
	    _getImage: function _getImage() {
	        if (this.options.icon) {
	            var url = this.options.icon.options.iconUrl,
	                img = PointSymbolizer.iconCache[url];
	            if (!img) {
	                var icon = this.options.icon;
	                img = PointSymbolizer.iconCache[url] = icon.createIcon();
	            }
	            return img;
	        } else {
	            return null;
	        }
	    },
	
	    _containsPoint: function _containsPoint(p) {
	        var icon = this.options.icon;
	        if (icon) {
	            return this._pxBounds.contains(p);
	        } else {
	            return L.CircleMarker.prototype._containsPoint.call(this, p);
	        }
	    }
	});
	
	PointSymbolizer.getLatLng = null;
	exports.PointSymbolizer = PointSymbolizer;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	// 🍂class Symbolizer
	// 🍂inherits Class
	// The abstract Symbolizer class is mostly equivalent in concept to a `L.Path` - it's an interface for
	// polylines, polygons and circles. But instead of representing leaflet Layers,
	// it represents things that have to be drawn inside a vector tile.
	
	// A vector tile *data layer* might have zero, one, or more *symbolizer definitions*
	// A vector tile *feature* might have zero, one, or more *symbolizers*.
	// The actual symbolizers applied will depend on filters and the symbolizer functions.
	
	var Symbolizer = exports.Symbolizer = L.Class.extend({
		// 🍂method initialize(feature: GeoJSON, pxPerExtent: Number)
		// Initializes a new Line Symbolizer given a GeoJSON feature and the
		// pixel-to-coordinate-units ratio. Internal use only.
	
		// 🍂method render(renderer, style)
		// Renders this symbolizer in the given tiled renderer, with the given
		// `L.Path` options.  Internal use only.
		render: function render(renderer, style) {
			this._renderer = renderer;
			this.options = style;
			renderer._initPath(this);
			renderer._updateStyle(this);
		},
	
		// 🍂method render(renderer, style)
		// Updates the `L.Path` options used to style this symbolizer, and re-renders it.
		// Internal use only.
		updateStyle: function updateStyle(renderer, style) {
			this.options = style;
			renderer._updateStyle(this);
		},
	
		_getPixelBounds: function _getPixelBounds() {
			var parts = this._parts;
			var bounds = L.bounds([]);
			for (var i = 0; i < parts.length; i++) {
				var part = parts[i];
				for (var j = 0; j < part.length; j++) {
					bounds.extend(part[j]);
				}
			}
	
			var w = this._clickTolerance(),
			    p = new L.Point(w, w);
	
			bounds.min._subtract(p);
			bounds.max._add(p);
	
			return bounds;
		},
		_clickTolerance: L.Path.prototype._clickTolerance
	});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LineSymbolizer = undefined;
	
	var _Symbolizer = __webpack_require__(35);
	
	var _SymbolizerPolyBase = __webpack_require__(37);
	
	// 🍂class LineSymbolizer
	// 🍂inherits Polyline
	// A symbolizer for lines. Can be applied to line and polygon features.
	
	var LineSymbolizer = exports.LineSymbolizer = L.Polyline.extend({
		includes: [_Symbolizer.Symbolizer.prototype, _SymbolizerPolyBase.PolyBase],
	
		initialize: function initialize(feature, pxPerExtent) {
			this.properties = feature.properties;
			this._makeFeatureParts(feature, pxPerExtent);
		},
	
		render: function render(renderer, style) {
			style.fill = false;
			_Symbolizer.Symbolizer.prototype.render.call(this, renderer, style);
			this._updatePath();
		},
	
		updateStyle: function updateStyle(renderer, style) {
			style.fill = false;
			_Symbolizer.Symbolizer.prototype.updateStyle.call(this, renderer, style);
		}
	});

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	// Contains mixins which are common to the Line Symbolizer and the Fill Symbolizer.
	
	var PolyBase = exports.PolyBase = {
		_makeFeatureParts: function _makeFeatureParts(feat, pxPerExtent) {
			var rings = feat.geometry;
			var coord;
	
			this._parts = [];
			for (var i = 0; i < rings.length; i++) {
				var ring = rings[i];
				var part = [];
				for (var j = 0; j < ring.length; j++) {
					coord = ring[j];
					// Protobuf vector tiles return {x: , y:}
					// Geojson-vt returns [,]
					part.push(L.point(coord).scaleBy(pxPerExtent));
				}
				this._parts.push(part);
			}
		},
	
		makeInteractive: function makeInteractive() {
			this._pxBounds = this._getPixelBounds();
		}
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FillSymbolizer = undefined;
	
	var _Symbolizer = __webpack_require__(35);
	
	var _SymbolizerPolyBase = __webpack_require__(37);
	
	// 🍂class FillSymbolizer
	// 🍂inherits Polyline
	// A symbolizer for filled areas. Applies only to polygon features.
	
	var FillSymbolizer = exports.FillSymbolizer = L.Polygon.extend({
		includes: [_Symbolizer.Symbolizer.prototype, _SymbolizerPolyBase.PolyBase],
	
		initialize: function initialize(feature, pxPerExtent) {
			this.properties = feature.properties;
			this._makeFeatureParts(feature, pxPerExtent);
		},
	
		render: function render(renderer, style) {
			_Symbolizer.Symbolizer.prototype.render.call(this, renderer, style);
			this._updatePath();
		}
	});

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Use to display layers from carto backend
	 * Requires carto user info to create client: API key and username
	 *
	 *
	 *
	 * @param username Username of the carto account to be used
	 * @param apiKey API-Key for the related account
	 */
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CartoLayer = function () {
	    function CartoLayer(carto, username, apiKey) {
	        _classCallCheck(this, CartoLayer);
	
	        this.carto = carto;
	        this.client = new this.carto.Client({
	            apiKey: apiKey,
	            username: username
	        });
	    }
	
	    /**
	     * Create a carto layer and with given query and style and return leaflet-layer
	     * @param config JSON containing the data for the layers.
	     * @param layer layer definition
	     * Requires: Layer array, containing sql and style params in an object
	     * {
	     *   "client": {
	     *       "apiKey": "MY_API_KEY",
	     *       "username": "MY_USERNAME"
	     *   },
	     *   "layers": [
	     *       {
	     *           "sql": "SELECT * FROM bw_fliwas_ezg_agg03_2018_02_10",
	     *           "style": "#bw_fliwas_ezg_agg03_2018_02_10{ polygon-fill: #FFFFFF; polygon-opacity: 0; line-color: #000000; line-width: 2.5; line-opacity: 1;}"
	     *       }
	     *   ]
	     * }
	     * @returns {LeafletLayer}
	     */
	
	
	    CartoLayer.prototype.createLayer = function createLayer(config, layer) {
	        var _this = this;
	
	        config.layers && config.layers.forEach(function (layer) {
	
	            var source = new _this.carto.source.SQL(layer.sql);
	            var style = new _this.carto.style.CartoCSS(layer.style);
	            /*            const defaultKeys = layer.defaultKeys;
	                        const columnNames = this.getColumnNames(layer.html).filter( (element, index) => defaultKeys.indexOf(element) === -1 );
	                        const parsedAndDefaultColumnNames = defaultKeys.concat(columnNames);*/
	            var cartoLayer = new _this.carto.layer.Layer(source, style);
	            //cartoLayer.on('featureClicked', (e) => this.openPopUp(e, map, layer.html, parsedAndDefaultColumnNames));
	
	            _this.client.addLayer(cartoLayer);
	        });
	
	        var defaultAttribution = '&copy; CARTO';
	        var leafletLayer = this.client.getLeafletLayer({
	            attribution: layer.attribution || defaultAttribution
	        });
	        leafletLayer.setZIndex(layer.zIndex || config.zIndex || 0);
	        return leafletLayer;
	    };
	
	    /**
	     * Open a static popup on the map.
	     * @param featureEvent Clickevent
	     * @param map Map element to open the popup on
	     * @param html HTML string for popup
	     * @param columnNames names of DB Cols
	     */
	
	
	    CartoLayer.prototype.openPopUp = function openPopUp(featureEvent, map, html, columnNames) {
	        var popup = L.popup();
	        var content = html;
	
	        columnNames.forEach(function (name) {
	            var featureProperty = featureEvent.data[name];
	            content = content.replace('{{' + name + '}}', featureProperty || '');
	        });
	
	        content = content.replace('<a href="#close" class="cartodb-popup-close-button close">x</a>', '');
	        popup.setContent(content);
	
	        popup.setLatLng(featureEvent.latLng);
	        if (!popup.isOpen()) {
	            popup.openOn(map);
	        }
	    };
	
	    CartoLayer.prototype.getColumnNames = function getColumnNames(html) {
	        var results = [];
	
	        var res = html.split('{{');
	        res.map(function (current, index) {
	            index !== 0 && results.push(current.slice(0, current.indexOf('}}')));
	        });
	
	        return results;
	    };
	
	    return CartoLayer;
	}();
	
	exports.default = CartoLayer;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FliwasCanvasTile = undefined;
	
	var _FliwasCanvasRenderer = __webpack_require__(17);
	
	var FliwasCanvasTile = exports.FliwasCanvasTile = _FliwasCanvasRenderer.FliwasCanvasRenderer.extend({
	
	    initialize: function initialize(tileCoord, tileSize, options) {
	        // using FliwasCanvasRenderer here, to get canvas layer event propagation
	        // FLIWASEN-932 Details-Renderer von flächenhaften FLIWAS-Objekten öffnet sich nicht
	        _FliwasCanvasRenderer.FliwasCanvasRenderer.prototype.initialize.call(this, options);
	        this._tileCoord = tileCoord;
	        this._size = tileSize;
	
	        this._initContainer();
	        this._container.setAttribute('width', this._size.x);
	        this._container.setAttribute('height', this._size.y);
	        this._layers = {};
	        this._drawnLayers = {};
	        this._drawing = true;
	
	        if (options.interactive) {
	            // By default, Leaflet tiles do not have pointer events
	            this._container.style.pointerEvents = 'auto';
	        }
	    },
	
	    getCoord: function getCoord() {
	        return this._tileCoord;
	    },
	
	    getContainer: function getContainer() {
	        return this._container;
	    },
	
	    getOffset: function getOffset() {
	        return this._tileCoord.scaleBy(this._size).subtract(this._map.getPixelOrigin());
	    },
	
	    //onAdd: L.Util.falseFn,
	    onAdd: L.Util.falseFn,
	
	    addTo: function addTo(map) {
	        this._map = map;
	        // add this renderer so the map can quickly reference it
	        this._map._registerCanvasRenderer(this);
	    },
	
	    removeFrom: function removeFrom(map) {
	        map._unregisterCanvasRenderer(this);
	        delete this._map;
	    },
	
	    _onClick: function _onClick(e) {
	        var point = this._map.mouseEventToLayerPoint && this._map.mouseEventToLayerPoint(e).subtract(this.getOffset());
	        var layer = void 0,
	            clickedLayer = void 0;
	
	        for (var id in this._layers) {
	            layer = this._layers[id];
	            if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
	                clickedLayer = layer;
	            }
	        }
	        if (clickedLayer) {
	            L.DomEvent.fakeStop(e);
	            this._fireEvent([clickedLayer], e);
	        } else {
	            // layer wasn't found, send to map to find if other canvas layers can handle event
	            // https://inovum-dev.de/jira/browse/FLIWASEN-932
	            this._map._forwardCanvasEvent(this, e);
	        }
	    },
	
	    _onMouseMove: function _onMouseMove(e) {
	        if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) {
	            return;
	        }
	
	        var point = this._map.mouseEventToLayerPoint(e).subtract(this.getOffset());
	        this._handleMouseHover(e, point);
	    },
	
	    /// TODO: Modify _initPath to include an extra parameter, a group name
	    /// to order symbolizers by z-index
	
	    _updateIcon: function _updateIcon(layer) {
	        if (!this._drawing) {
	            return;
	        }
	
	        var icon = layer.options.icon,
	            options = icon.options,
	            size = L.point(options.iconSize),
	            anchor = options.iconAnchor || size && size.divideBy(2, true),
	            p = layer._point.subtract(anchor),
	            ctx = this._ctx,
	            img = layer._getImage();
	
	        if (img.complete) {
	            ctx.drawImage(img, p.x, p.y, size.x, size.y);
	        } else {
	            L.DomEvent.on(img, 'load', function () {
	                ctx.drawImage(img, p.x, p.y, size.x, size.y);
	            });
	        }
	
	        this._drawnLayers[layer._leaflet_id] = layer;
	    }
	}); /**
	     * User: nikolaigorte * Date: 09.03.23 * Time: 11:56 */

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler on 08.02.2016.
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var southWest = _leaflet2.default.latLng(47.2703, 5.8667),
	    northEast = _leaflet2.default.latLng(55.0585, 15.0419),
	    defaultBounds = _leaflet2.default.latLngBounds(southWest, northEast),
	    defaultOptions = { animate: false };
	
	var DefaultPosition = function () {
	    function DefaultPosition(props) {
	        _classCallCheck(this, DefaultPosition);
	
	        this.boundRequestHandled = false;
	        this.boundRequestCb = this.boundRequestCb.bind(this);
	    }
	
	    DefaultPosition.prototype.initOptions = function initOptions(o) {
	        o.boundRequest = {
	            bounds: defaultBounds,
	            options: defaultOptions,
	            cb: this.boundRequestCb
	        };
	        return o;
	    };
	
	    DefaultPosition.prototype.boundRequestCb = function boundRequestCb() {
	        this.boundRequestHandled = true;
	    };
	
	    return DefaultPosition;
	}();
	
	exports.default = DefaultPosition;
	
	
	DefaultPosition.staticPlugin = true;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MapScalePlugin = function () {
	    function MapScalePlugin() {
	        _classCallCheck(this, MapScalePlugin);
	    }
	
	    MapScalePlugin.prototype.init = function init(map, o) {
	        map.addControl(_leaflet2.default.control.scale({
	            imperial: false,
	            position: 'bottomright'
	        }));
	    };
	
	    return MapScalePlugin;
	}();
	
	exports.default = MapScalePlugin;
	
	
	MapScalePlugin.staticPlugin = true;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by n.gorte on 16.08.2017.
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectionDisplayPlugin = function () {
	    function SelectionDisplayPlugin(props) {
	        _classCallCheck(this, SelectionDisplayPlugin);
	
	        this.boundRequestHandled = false;
	        this.boundRequestCb = this.boundRequestCb.bind(this);
	    }
	
	    SelectionDisplayPlugin.prototype.initOptions = function initOptions(o) {
	        return this.options(o);
	    };
	
	    SelectionDisplayPlugin.prototype.init = function init(map, o, reEvaluate) {
	        this.map = map;
	    };
	
	    SelectionDisplayPlugin.prototype.compareSelectedLayers = function compareSelectedLayers(a, b) {
	        return a.feature.properties.id === b.feature.properties.id;
	    };
	
	    SelectionDisplayPlugin.prototype.options = function options(o) {
	        if (o && o.selectedLayers && !(0, _liferayWidgetsReactWeb.equalArray)(o.selectedLayers, this.selectedLayers, this.compareSelectedLayers) || o.selectedLayers && !this.boundRequestHandled) {
	            console.log('SelectionDisplayPlugin options()', o);
	            this.boundRequestHandled = false;
	            var currentBounds = this.map.getBounds();
	            var l = new _leaflet2.default.featureGroup(o.selectedLayers);
	            if (!currentBounds.contains(l.getBounds())) {
	                o.boundRequest = {
	                    bounds: l.getBounds(),
	                    options: { animate: false, padding: [50, 50] },
	                    cb: this.boundRequestCb
	                };
	            } else {
	                this.boundRequestCb();
	            }
	        }
	        return o;
	    };
	
	    SelectionDisplayPlugin.prototype.update = function update(map, o) {
	        if (o && o.selectedLayers && !(0, _liferayWidgetsReactWeb.equalArray)(o.selectedLayers, this.selectedLayers, this.compareSelectedLayers)) {
	            this.selectedLayers = o.selectedLayers;
	        }
	    };
	
	    SelectionDisplayPlugin.prototype.remove = function remove() {
	        this.map = null;
	    };
	
	    SelectionDisplayPlugin.prototype.boundRequestCb = function boundRequestCb() {
	        this.boundRequestHandled = true;
	    };
	
	    return SelectionDisplayPlugin;
	}();
	
	exports.default = SelectionDisplayPlugin;
	
	
	SelectionDisplayPlugin.staticPlugin = true;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getGeoJsonStore = getGeoJsonStore;
	exports.getMapConfigStore = getMapConfigStore;
	exports.getLogicalLayerStore = getLogicalLayerStore;
	exports.getLayerDataSourceStore = getLayerDataSourceStore;
	
	var _LogicalLayerStore = __webpack_require__(45);
	
	var _LogicalLayerStore2 = _interopRequireDefault(_LogicalLayerStore);
	
	var _LayerDataSourceStore = __webpack_require__(47);
	
	var _LayerDataSourceStore2 = _interopRequireDefault(_LayerDataSourceStore);
	
	var _MapConfigStore = __webpack_require__(49);
	
	var _MapConfigStore2 = _interopRequireDefault(_MapConfigStore);
	
	var _GeoJsonStore = __webpack_require__(51);
	
	var _GeoJsonStore2 = _interopRequireDefault(_GeoJsonStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Hibbeler on 07.02.2016.
	 */
	
	var geoJsonStoreInstance = void 0;
	
	function getGeoJsonStore(AppContext) {
	    return geoJsonStoreInstance || (geoJsonStoreInstance = AppContext.createStore(_GeoJsonStore2.default));
	}
	
	var mapConfigStoreInstance = void 0;
	
	function getMapConfigStore(AppContext) {
	    return mapConfigStoreInstance || (mapConfigStoreInstance = AppContext.createStore(_MapConfigStore2.default));
	}
	
	var logicalLayerStoreInstance = void 0;
	
	function getLogicalLayerStore(AppContext) {
	    return logicalLayerStoreInstance || (logicalLayerStoreInstance = AppContext.createStore(_LogicalLayerStore2.default));
	}
	
	var layerDataSourceStoreInstance = void 0;
	
	function getLayerDataSourceStore(AppContext) {
	    return layerDataSourceStoreInstance || (layerDataSourceStoreInstance = AppContext.createStore(_LayerDataSourceStore2.default));
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	var _LogicalLayerWebApi = __webpack_require__(46);
	
	var _LogicalLayerWebApi2 = _interopRequireDefault(_LogicalLayerWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 08.06.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var LogicalLayerStore = function (_ClassRemoteDataStore) {
	    _inherits(LogicalLayerStore, _ClassRemoteDataStore);
	
	    function LogicalLayerStore(Dispatcher) {
	        _classCallCheck(this, LogicalLayerStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _ClassNames2.default.LogicalLayer, _LogicalLayerWebApi2.default.listGroupLogicalLayers, _LogicalLayerWebApi2.default.get));
	    }
	
	    LogicalLayerStore.refresh = function refresh(existing, newRemote) {
	
	        return this.updateQuery(this.invalidateData(existing), {
	            start: 0,
	            end: existing._end
	        });
	    };
	
	    LogicalLayerStore.prototype.websocketModelUpdate = function websocketModelUpdate(remote, wsUpdate) {
	        if (wsUpdate.eventType !== 'POST' && wsUpdate.eventType !== 'PUT' && wsUpdate.eventType !== 'PATCH' && wsUpdate.eventType !== 'PATCH-MERGE' && wsUpdate.eventType !== 'DELETE') {
	            if (!Array.isArray(wsUpdate) && !wsUpdate.metric) {
	                console.warn('Unknown update type: ', wsUpdate);
	            }
	        }
	        var newRemote = void 0;
	
	        _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote).filter(function (d) {
	            return d.className === wsUpdate.className || d.className === wsUpdate.attachedClassName;
	        }).forEach(function (d) {
	            if ((0, _liferayWidgetsReactWeb.isList)(d)) {
	                console.debug('Update', wsUpdate, '==> invalidate list', d);
	                d = LogicalLayerStore.refresh(d);
	            } else if (d.item.id === wsUpdate.classPK) {
	                console.debug('Update', wsUpdate, '==> invalidate corresponding item', d);
	                if (wsUpdate.op === 'POST') {
	                    console.error('Model-Update->', wsUpdate, ' for existing object', wsUpdate, d);
	                } else if (wsUpdate.op === 'DELETE') {
	                    d = _liferayWidgetsReactWeb.RemoteDataStore.updateFlag(d, {
	                        _deleted: true,
	                        _error: null,
	                        _loading: false,
	                        _invalid: false
	                    });
	                } else {
	                    d = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(d);
	                }
	            } else if (d.item.id === wsUpdate.attachedClassPK) {
	                console.debug('Update', wsUpdate, '==> invalidate item (attached)', d);
	                d = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(d);
	            }
	
	            newRemote = newRemote || (newRemote = _extends({}, remote));
	            newRemote[d.name] = d;
	        });
	
	        _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote).filter(function (d) {
	            return (0, _liferayWidgetsReactWeb.isAttachedList)(d, wsUpdate);
	        }).forEach(function (d) {
	            console.debug('Update', wsUpdate, '==> invalidate item (attached List)', d);
	            d = LogicalLayerStore.refresh(d);
	
	            newRemote = newRemote || (newRemote = _extends({}, remote));
	            newRemote[d.name] = d;
	        });
	
	        return newRemote || remote;
	    };
	
	    return LogicalLayerStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = LogicalLayerStore;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(26);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _ClassNames2.default.LogicalLayer; /**
	                                                    * Copyright 2016 xdot GmbH
	                                                    * Author: Marius Runde
	                                                    * Date: 01.06.2016
	                                                    *
	                                                    */
	
	var logicalLayerService = function logicalLayerService(m, o) {
	    return _lwrClient.Client.invoke('/map.logicallayer/' + m, o);
	};
	var logicalLayerServiceWithContext = function logicalLayerServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/map.logicallayer/' + m, o, c);
	};
	
	var api = {
	    listGroupLogicalLayers: function listGroupLogicalLayers(query) {
	        return logicalLayerServiceWithContext('list-by-group-scope.3', {
	            start: query.start,
	            end: query.end
	        }, {});
	    },
	    listViewableLogicalLayersByGroupScope: function listViewableLogicalLayersByGroupScope() {
	        return logicalLayerServiceWithContext('list-viewable-by-group-scope.1', {});
	    },
	    get: function get(logicalLayer) {
	        return logicalLayerService('get.1', {
	            id: logicalLayer.id
	        });
	    },
	    addLogicalLayer: function addLogicalLayer(logicalLayer) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(logicalLayerServiceWithContext('add.1', {}, {
	            title: logicalLayer.title,
	            description: logicalLayer.description
	        }), {
	            className: className,
	            eventType: 'POST'
	        });
	    },
	    updateLogicLayer: function updateLogicLayer(logicalLayer) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(logicalLayerServiceWithContext('update.2', {
	            id: logicalLayer.id
	        }, {
	            title: logicalLayer.title,
	            description: logicalLayer.description
	        }), {
	            className: className,
	            classPK: logicalLayer.id,
	            eventType: 'PUT'
	        });
	    },
	    deleteLogicalLayer: function deleteLogicalLayer(logicalLayer) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(logicalLayerServiceWithContext('delete.2', {
	            id: logicalLayer.id
	        }, {}), {
	            className: className,
	            classPK: logicalLayer.id,
	            eventType: 'DELETE'
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('LogicalLayerWebApi', api);
	
	exports.default = api;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	var _LayerDataSourceWebApi = __webpack_require__(48);
	
	var _LayerDataSourceWebApi2 = _interopRequireDefault(_LayerDataSourceWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 08.06.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var LayerDataSourceStore = function (_ClassRemoteDataStore) {
	    _inherits(LayerDataSourceStore, _ClassRemoteDataStore);
	
	    function LayerDataSourceStore(Dispatcher) {
	        _classCallCheck(this, LayerDataSourceStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _ClassNames2.default.LayerDataSource, _LayerDataSourceWebApi2.default.listLayerDataSourcesByLogicalLayerId, null));
	    }
	
	    /*reduce(state, action){
	        
	        let availableLayers = state.availableLayers || {};
	        
	        switch(action.type) {
	            case ActionTypes.LIST_BY_MAPCONFIG:
	                switch (action.meta.asyncState) {
	                    case AsyncState.REQUESTED:
	                        return {
	                            ...state,
	                            'availableLayers': {
	                                ...availableLayers,
	                                [action.payload.mapConfigId]: []
	                            }
	                        };
	                     case AsyncState.SUCCESS:
	                        return {
	                            ...state,
	                            'availableLayers': {
	                                ...availableLayers,
	                                [action.payload.mapConfigId]: action.payload.item
	                            }
	                        };
	                        break;
	                     case AsyncState.ERROR:
	                        
	                        break;
	                    //no default
	                }
	            default:
	                return super.reduce(state, action);
	        }
	        return state;
	    }*/
	
	
	    return LayerDataSourceStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = LayerDataSourceStore;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(26);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _ClassNames2.default.LayerDataSource;
	
	//const layerDataSourceService = (m, o) => Client.invoke('/map.layerdatasource/' + m, o);
	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 01.06.2016
	 *
	 */
	
	var layerDataSourceServiceWithContext = function layerDataSourceServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/map.layerdatasource/' + m, o, c);
	};
	
	var api = {
	    listAll: function listAll(query) {
	        return layerDataSourceServiceWithContext('list-all.1', {}, {});
	    },
	    listByMapConfig: function listByMapConfig(query) {
	        return layerDataSourceServiceWithContext('list-by-map-config.2', {
	            mapConfigId: query.mapConfigId
	        }, {});
	    },
	    listLayerDataSourcesByLogicalLayerId: function listLayerDataSourcesByLogicalLayerId(query) {
	        return layerDataSourceServiceWithContext('list-by-logical-layer-id.4', {
	            layerId: query.byId,
	            start: query.start,
	            end: query.end
	        }, {});
	    },
	    addLayerDataSource: function addLayerDataSource(layerDataSource) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(layerDataSourceServiceWithContext('add.1', {}, {
	            title: layerDataSource.title,
	            typeKey: layerDataSource.typeKey,
	            logicalLayerId: layerDataSource.logicalLayerId,
	            config: layerDataSource.config
	        }), {
	            className: className,
	            eventType: 'POST'
	        });
	    },
	    updateLayerDataSource: function updateLayerDataSource(layerDataSource) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(layerDataSourceServiceWithContext('update.2', {
	            id: layerDataSource.id
	        }, {
	            title: layerDataSource.title,
	            typeKey: layerDataSource.typeKey,
	            logicalLayerId: layerDataSource.logicalLayerId,
	            config: layerDataSource.config
	        }), {
	            className: className,
	            classPK: layerDataSource.id,
	            eventType: 'PUT'
	        });
	    },
	    deleteLayerDataSource: function deleteLayerDataSource(layerDataSource) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(layerDataSourceServiceWithContext('delete.2', {
	            id: layerDataSource.id
	        }, {}), {
	            className: className,
	            classPK: layerDataSource.id,
	            eventType: 'DELETE'
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('LayerDataSourceWebApi', api);
	
	exports.default = api;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	var _MapConfigWebApi = __webpack_require__(50);
	
	var _MapConfigWebApi2 = _interopRequireDefault(_MapConfigWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Marius Runde
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 13.05.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var MapConfigStore = function (_ClassRemoteDataStore) {
	    _inherits(MapConfigStore, _ClassRemoteDataStore);
	
	    function MapConfigStore(Dispatcher) {
	        _classCallCheck(this, MapConfigStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _ClassNames2.default.MapConfig, _MapConfigWebApi2.default.allListGroupMapConfigs /* good idea to use the "all" api? */, _MapConfigWebApi2.default.get));
	    }
	
	    MapConfigStore.prototype.getDefaultMapConfig = function getDefaultMapConfig() {
	        return this.getRemoteData('GroupDefaultMapConfig');
	    };
	
	    MapConfigStore.prototype.getFallbackMapConfig = function getFallbackMapConfig() {
	        return {
	            'boundingBox': {
	                'latitudeMax': 49.872070099704835,
	                'latitudeMin': 47.31508638552833,
	                'longitudeMax': 11.09619140625,
	                'longitudeMin': 7.14111328125
	            },
	            'plugins': ['map/plugins/DefaultPosition', 'map/plugins/MapConfigPlugin', 'map/plugins/FliwasOrganizationDefaultPositionPlugin'],
	            'description': '',
	            'title': 'Fallback MapConfig',
	            'uuid': 'fallback_default_mapconfig',
	            'defaultBaseLayerId': -1,
	            'baseLayer': [{
	                'description': 'OSM-StaticLayer',
	                'title': 'OSM-StaticLayer',
	                'type': 'LogicalLayer',
	                'uuid': 'lubworg_gb_t1a_t2',
	                'children': [{
	                    'logicalLayerId': -1,
	                    'typeKey': 'leaflet-tile-layer',
	                    'id': -1,
	                    'title': 'OSM-StaticLayer',
	                    'type': 'LayerDataSource',
	                    'config': '{  "url": "https://maps.omniscale.net/v2/fliwas-e278fbd2/style.default/{z}/{x}/{y}.png" }'
	                }],
	                'id': -1,
	                'zIndex': -1
	            }],
	            'children': [],
	            'id': -1
	        };
	    };
	
	    return MapConfigStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = MapConfigStore;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(26);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _ClassNames2.default.MapConfig; /**
	                                                 * Copyright 2016 xdot GmbH
	                                                 * Author: Marius Runde
	                                                 * Date: 01.06.2016
	                                                 *
	                                                 */
	
	var mapConfigService = function mapConfigService(m, o) {
	    return _lwrClient.Client.invoke('/map.mapconfig/' + m, o);
	};
	var mapConfigServiceWithContext = function mapConfigServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/map.mapconfig/' + m, o, c);
	};
	
	var api = {
	    allListViewableMapConfigs: function allListViewableMapConfigs() {
	        return mapConfigServiceWithContext('list-viewable-by-group-scope.1', {});
	    },
	    allListGroupMapConfigs: function allListGroupMapConfigs() {
	        return mapConfigServiceWithContext('list-all-by-group-scope.1', {});
	    },
	    get: function get(query) {
	        return mapConfigService('get.1', {
	            id: query.id
	        });
	    },
	    itemDefaultGrouped: function itemDefaultGrouped(query) {
	        return mapConfigService('get-default-map-config-by-group-id.1', {
	            groupId: query.groupId
	        });
	    },
	    addMapConfig: function addMapConfig(mapConfig) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(mapConfigServiceWithContext('add.1', {}, {
	            mapConfig: mapConfig
	        }), {
	            className: className,
	            eventType: 'POST'
	        });
	    },
	    setDefaultMapConfig: function setDefaultMapConfig(data) {
	        return mapConfigService('set-default-map-config.2', {
	            mapConfigId: data.mapConfigId,
	            groupId: data.groupId
	        });
	    },
	    resetDefaultMapConfig: function resetDefaultMapConfig(data) {
	        return mapConfigService('reset-default-map-config.1', {
	            groupId: data.groupId
	        });
	    },
	    updateMapConfig: function updateMapConfig(mapConfig) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(mapConfigServiceWithContext('update.2', {
	            id: mapConfig.id
	        }, {
	            mapConfig: mapConfig
	        }), {
	            className: className,
	            classPK: mapConfig.id,
	            eventType: 'PUT'
	        });
	    },
	    deleteMapConfig: function deleteMapConfig(mapConfig) {
	        return _liferayWidgetsReactWeb.ApiUtil.apiCall(mapConfigService('delete.2', {
	            id: mapConfig.id
	        }, {
	            mapConfig: mapConfig
	        }), {
	            className: className,
	            classPK: mapConfig.id,
	            eventType: 'DELETE'
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('MapConfigWebApi', api);
	
	exports.default = api;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _geoUtils = __webpack_require__(14);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 05.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var GeoJsonStore = function (_RemoteDataStore) {
	    _inherits(GeoJsonStore, _RemoteDataStore);
	
	    function GeoJsonStore(dispatcher) {
	        _classCallCheck(this, GeoJsonStore);
	
	        return _possibleConstructorReturn(this, _RemoteDataStore.call(this, dispatcher));
	    }
	
	    GeoJsonStore.prototype.reduce = function reduce(state, action) {
	        var name = void 0,
	            className = void 0;
	
	        switch (action.type) {
	            case _liferayWidgetsReactWeb.ActionTypesCommon.DATA_ITEM_INIT:
	                var _action$meta = action.meta;
	                name = _action$meta.name;
	                className = _action$meta.className;
	
	                if ('GeoJson' === className) {
	                    state = this.initItem(state, name, _extends({}, action.payload, {
	                        className: className
	                    }), this.defaultItemData);
	                    //   let data = RemoteDataStore.getData(state.remote, action.meta.name);
	                    //   data = RemoteDataStore.updateQuery(data, { changedSince: new Date().getTime() });
	                    //   return  this.doSetRemoteState(state, RemoteDataStore.setData(state.remote, data));
	                }
	                break;
	            case _liferayWidgetsReactWeb.ActionTypesCommon.DATA_REMOVE:
	                var _action$meta2 = action.meta;
	                name = _action$meta2.name;
	                className = _action$meta2.className;
	
	                if ('GeoJson' === className) {
	                    return this.removeRemoteData(state, name);
	                }
	                break;
	            case _liferayWidgetsReactWeb.ActionTypesCommon.DATA_UPDATE_MESSAGE:
	                var remote = this.websocketModelUpdate(state.remote, action.payload);
	                if (state.remote !== remote) {
	                    state = this.doSetRemoteState(state, remote);
	                }
	                break;
	        }
	
	        if (action.meta && 'GeoJson' === action.meta.className) {
	            //      action.meta.className = null;
	            state = _RemoteDataStore.prototype.reduce.call(this, state, action);
	        }
	
	        return state;
	    };
	
	    GeoJsonStore.prototype.asyncSuccess = function asyncSuccess(data, newItem) {
	        if (newItem.properties.changedSince > 0) {
	            newItem.features = this.updateFeature(data.item.features, newItem.features);
	        }
	        var newData = _liferayWidgetsReactWeb.RemoteDataStore.updateItem(data, newItem);
	        newData.query = _extends({}, newData.query, {
	            changedSince: newItem.properties.queryTime
	        });
	        return newData;
	    };
	
	    GeoJsonStore.prototype.updateFeature = function updateFeature(oldFeatures, changedFeatures) {
	        var newFeatures = oldFeatures;
	        if (changedFeatures && changedFeatures.length > 0) {
	            var _newFeatures;
	
	            var toAdd = [];
	            var changedFeatureMap = changedFeatures.reduce(function (acc, feature) {
	                if (oldFeatures.findIndex(function (of) {
	                    return of.properties.id === feature.properties.id;
	                }) < 0) {
	                    toAdd.push(feature);
	                } else {
	                    acc[(0, _geoUtils.getFeatureId)(feature)] = feature;
	                }
	                return acc;
	            }, {});
	            newFeatures = oldFeatures.map(function (of, i) {
	                var id = (0, _geoUtils.getFeatureId)(of);
	                return changedFeatureMap[id] || of;
	            });
	            (_newFeatures = newFeatures).push.apply(_newFeatures, toAdd);
	        }
	        return newFeatures;
	    };
	
	    GeoJsonStore.prototype.getDataClassNames = function getDataClassNames(d) {
	        var classes = {};
	        if (d.item && d.item.features) {
	            d.item.features.forEach(function (feature) {
	                return classes[feature.properties.type] = true;
	            });
	        }
	        if (d.query && d.query.classNames) {
	            d.query.classNames.forEach(function (nc) {
	                return classes[nc] = true;
	            });
	        }
	        return Object.keys(classes);
	    };
	
	    GeoJsonStore.prototype.websocketModelUpdate = function websocketModelUpdate(remote, wsUpdate) {
	        var _this2 = this;
	
	        var newRemote = void 0;
	
	        if (wsUpdate.eventType === 'POST' || wsUpdate.eventType === 'PUT' || wsUpdate.eventType === 'PATCH' || wsUpdate.eventType === 'PATCH-MERGE' || wsUpdate.eventType === 'DELETE' || wsUpdate.eventType === 'DELETE') {
	            var className = wsUpdate.type;
	
	            var attachedClassName = void 0;
	            if (wsUpdate.metadata) {
	                attachedClassName = wsUpdate.metadata.attachedClassName;
	            }
	
	            _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote).filter(function (d) {
	                var cn = _this2.getDataClassNames(d);
	                return cn.indexOf(className) >= 0 || cn.indexOf(attachedClassName) >= 0;
	            }).forEach(function (d) {
	                var o = d;
	                d = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(o);
	                if (o !== d) {
	                    newRemote = newRemote || (newRemote = _extends({}, remote));
	                    newRemote[o.name] = d;
	                }
	            });
	        } else if (!Array.isArray(wsUpdate) && !wsUpdate.metric) {
	            console.warn('Unknown update type: ', wsUpdate);
	        }
	
	        if (this.extendedWebsocketModelUpdate) {
	            newRemote = this.extendedWebsocketModelUpdate(newRemote || remote, wsUpdate);
	        }
	
	        return newRemote || remote;
	    };
	
	    //wihtout backup
	
	
	    GeoJsonStore.invalidateData = function invalidateData(existing) {
	        if (existing._invalid) {
	            return existing;
	        }
	        return _extends({}, existing, {
	            _invalid: true
	        });
	    };
	
	    return GeoJsonStore;
	}(_liferayWidgetsReactWeb.RemoteDataStore);
	
	exports.default = GeoJsonStore;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	!function(a,t){ true?t(exports):"function"==typeof define&&define.amd?define("leafletGestureHandling",["exports"],t):t(a.leafletGestureHandling={})}(this,function(a){"use strict";var o={ar:{touch:"استخدم إصبعين لتحريك الخريطة",scroll:"‏استخدم ctrl + scroll لتصغير/تكبير الخريطة",scrollMac:"يمكنك استخدام ⌘ + التمرير لتكبير/تصغير الخريطة"},bg:{touch:"Използвайте два пръста, за да преместите картата",scroll:"Задръжте бутона Ctrl натиснат, докато превъртате, за да промените мащаба на картата",scrollMac:"Задръжте бутона ⌘ натиснат, докато превъртате, за да промените мащаба на картата"},bn:{touch:"মানচিত্রটিকে সরাতে দুটি আঙ্গুল ব্যবহার করুন",scroll:"ম্যাপ জুম করতে ctrl + scroll ব্যবহার করুন",scrollMac:"ম্যাপে জুম করতে ⌘ বোতাম টিপে স্ক্রল করুন"},ca:{touch:"Fes servir dos dits per moure el mapa",scroll:"Prem la tecla Control mentre et desplaces per apropar i allunyar el mapa",scrollMac:"Prem la tecla ⌘ mentre et desplaces per apropar i allunyar el mapa"},cs:{touch:"K posunutí mapy použijte dva prsty",scroll:"Velikost zobrazení mapy změňte podržením klávesy Ctrl a posouváním kolečka myši",scrollMac:"Velikost zobrazení mapy změníte podržením klávesy ⌘ a posunutím kolečka myši / touchpadu"},da:{touch:"Brug to fingre til at flytte kortet",scroll:"Brug ctrl + rullefunktionen til at zoome ind og ud på kortet",scrollMac:"Brug ⌘ + rullefunktionen til at zoome ind og ud på kortet"},de:{touch:"Verschieben der Karte mit zwei Fingern",scroll:"Verwende Strg+Scrollen zum Zoomen der Karte",scrollMac:"⌘"},el:{touch:"Χρησιμοποιήστε δύο δάχτυλα για μετακίνηση στον χάρτη",scroll:"Χρησιμοποιήστε το πλήκτρο Ctrl και κύλιση, για να μεγεθύνετε τον χάρτη",scrollMac:"Χρησιμοποιήστε το πλήκτρο ⌘ + κύλιση για εστίαση στον χάρτη"},en:{touch:"Use two fingers to move the map",scroll:"Use ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},"en-AU":{touch:"Use two fingers to move the map",scroll:"Use ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},"en-GB":{touch:"Use two fingers to move the map",scroll:"Use ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},es:{touch:"Para mover el mapa, utiliza dos dedos",scroll:"Mantén pulsada la tecla Ctrl mientras te desplazas para acercar o alejar el mapa",scrollMac:"Mantén pulsada la tecla ⌘ mientras te desplazas para acercar o alejar el mapa"},eu:{touch:"Erabili bi hatz mapa mugitzeko",scroll:"Mapan zooma aplikatzeko, sakatu Ktrl eta egin gora edo behera",scrollMac:"Eduki sakatuta ⌘ eta egin gora eta behera mapa handitu eta txikitzeko"},fa:{touch:"برای حرکت دادن نقشه از دو انگشت استفاده کنید.",scroll:"‏برای بزرگ‌نمایی نقشه از ctrl + scroll استفاده کنید",scrollMac:"برای بزرگ‌نمایی نقشه، از ⌘ + پیمایش استفاده کنید."},fi:{touch:"Siirrä karttaa kahdella sormella.",scroll:"Zoomaa karttaa painamalla Ctrl-painiketta ja vierittämällä.",scrollMac:"Zoomaa karttaa pitämällä painike ⌘ painettuna ja vierittämällä."},fil:{touch:"Gumamit ng dalawang daliri upang iusog ang mapa",scroll:"Gamitin ang ctrl + scroll upang i-zoom ang mapa",scrollMac:"Gamitin ang ⌘ + scroll upang i-zoom ang mapa"},fr:{touch:"Utilisez deux doigts pour déplacer la carte",scroll:"Vous pouvez zoomer sur la carte à l'aide de CTRL+Molette de défilement",scrollMac:"Vous pouvez zoomer sur la carte à l'aide de ⌘+Molette de défilement"},gl:{touch:"Utiliza dous dedos para mover o mapa",scroll:"Preme Ctrl mentres te desprazas para ampliar o mapa",scrollMac:"Preme ⌘ e desprázate para ampliar o mapa"},gu:{touch:"નકશો ખસેડવા બે આંગળીઓનો ઉપયોગ કરો",scroll:"નકશાને ઝૂમ કરવા માટે ctrl + સ્ક્રોલનો ઉપયોગ કરો",scrollMac:"નકશાને ઝૂમ કરવા ⌘ + સ્ક્રોલનો ઉપયોગ કરો"},hi:{touch:"मैप एक जगह से दूसरी जगह ले जाने के लिए दो उंगलियों का इस्तेमाल करें",scroll:"मैप को ज़ूम करने के लिए ctrl + स्क्रोल का उपयोग करें",scrollMac:"मैप को ज़ूम करने के लिए ⌘ + स्क्रोल का उपयोग करें"},hr:{touch:"Pomičite kartu pomoću dva prsta",scroll:"Upotrijebite Ctrl i klizač miša da biste zumirali kartu",scrollMac:"Upotrijebite gumb ⌘ dok se pomičete za zumiranje karte"},hu:{touch:"Két ujjal mozgassa a térképet",scroll:"A térkép a ctrl + görgetés használatával nagyítható",scrollMac:"A térkép a ⌘ + görgetés használatával nagyítható"},id:{touch:"Gunakan dua jari untuk menggerakkan peta",scroll:"Gunakan ctrl + scroll untuk memperbesar atau memperkecil peta",scrollMac:"Gunakan ⌘ + scroll untuk memperbesar atau memperkecil peta"},it:{touch:"Utilizza due dita per spostare la mappa",scroll:"Utilizza CTRL + scorrimento per eseguire lo zoom della mappa",scrollMac:"Utilizza ⌘ + scorrimento per eseguire lo zoom della mappa"},iw:{touch:"הזז את המפה באמצעות שתי אצבעות",scroll:"‏אפשר לשנות את מרחק התצוגה במפה באמצעות מקש ctrl וגלילה",scrollMac:"אפשר לשנות את מרחק התצוגה במפה באמצעות מקש ⌘ וגלילה"},ja:{touch:"地図を移動させるには指 2 本で操作します",scroll:"地図をズームするには、Ctrl キーを押しながらスクロールしてください",scrollMac:"地図をズームするには、⌘ キーを押しながらスクロールしてください"},kn:{touch:"Use two fingers to move the map",scroll:"Use Ctrl + scroll to zoom the map",scrollMac:"Use ⌘ + scroll to zoom the map"},ko:{touch:"지도를 움직이려면 두 손가락을 사용하세요.",scroll:"지도를 확대/축소하려면 Ctrl을 누른 채 스크롤하세요.",scrollMac:"지도를 확대하려면 ⌘ + 스크롤 사용"},lt:{touch:"Perkelkite žemėlapį dviem pirštais",scroll:"Slinkite nuspaudę klavišą „Ctrl“, kad pakeistumėte žemėlapio mastelį",scrollMac:"Paspauskite klavišą ⌘ ir slinkite, kad priartintumėte žemėlapį"},lv:{touch:"Lai pārvietotu karti, bīdiet to ar diviem pirkstiem",scroll:"Kartes tālummaiņai izmantojiet ctrl + ritināšanu",scrollMac:"Lai veiktu kartes tālummaiņu, izmantojiet ⌘ + ritināšanu"},ml:{touch:"മാപ്പ് നീക്കാൻ രണ്ട് വിരലുകൾ ഉപയോഗിക്കുക",scroll:"കൺട്രോൾ + സ്‌ക്രോൾ ഉപയോഗിച്ച് ‌മാപ്പ് ‌സൂം ചെയ്യുക",scrollMac:"⌘ + സ്‌ക്രോൾ ഉപയോഗിച്ച് ‌മാപ്പ് ‌സൂം ചെയ്യുക"},mr:{touch:"नकाशा हलविण्यासाठी दोन बोटे वापरा",scroll:"नकाशा झूम करण्यासाठी ctrl + scroll वापरा",scrollMac:"नकाशावर झूम करण्यासाठी ⌘ + स्क्रोल वापरा"},nl:{touch:"Gebruik twee vingers om de kaart te verplaatsen",scroll:"Gebruik Ctrl + scrollen om in- en uit te zoomen op de kaart",scrollMac:"Gebruik ⌘ + scrollen om in en uit te zoomen op de kaart"},no:{touch:"Bruk to fingre for å flytte kartet",scroll:"Hold ctrl-tasten inne og rull for å zoome på kartet",scrollMac:"Hold inne ⌘-tasten og rull for å zoome på kartet"},pl:{touch:"Przesuń mapę dwoma palcami",scroll:"Naciśnij CTRL i przewiń, by przybliżyć mapę",scrollMac:"Naciśnij ⌘ i przewiń, by przybliżyć mapę"},pt:{touch:"Use dois dedos para mover o mapa",scroll:"Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",scrollMac:"Use ⌘ e role a tela simultaneamente para aplicar zoom no mapa"},"pt-BR":{touch:"Use dois dedos para mover o mapa",scroll:"Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",scrollMac:"Use ⌘ e role a tela simultaneamente para aplicar zoom no mapa"},"pt-PT":{touch:"Utilize dois dedos para mover o mapa",scroll:"Utilizar ctrl + deslocar para aumentar/diminuir zoom do mapa",scrollMac:"Utilize ⌘ + deslocar para aumentar/diminuir o zoom do mapa"},ro:{touch:"Folosiți două degete pentru a deplasa harta",scroll:"Apăsați tasta ctrl și derulați simultan pentru a mări harta",scrollMac:"Folosiți ⌘ și derulați pentru a mări/micșora harta"},ru:{touch:"Чтобы переместить карту, проведите по ней двумя пальцами",scroll:"Чтобы изменить масштаб, прокручивайте карту, удерживая клавишу Ctrl.",scrollMac:"Чтобы изменить масштаб, нажмите ⌘ + прокрутка"},sk:{touch:"Mapu môžete posunúť dvoma prstami",scroll:"Ak chcete priblížiť mapu, stlačte kláves ctrl a posúvajte",scrollMac:"Ak chcete priblížiť mapu, stlačte kláves ⌘ a posúvajte kolieskom myši"},sl:{touch:"Premaknite zemljevid z dvema prstoma",scroll:"Zemljevid povečate tako, da držite tipko Ctrl in vrtite kolesce na miški",scrollMac:"Uporabite ⌘ + funkcijo pomika, da povečate ali pomanjšate zemljevid"},sr:{touch:"Мапу померајте помоћу два прста",scroll:"Притисните ctrl тастер док померате да бисте зумирали мапу",scrollMac:"Притисните тастер ⌘ док померате да бисте зумирали мапу"},sv:{touch:"Använd två fingrar för att flytta kartan",scroll:"Använd ctrl + rulla för att zooma kartan",scrollMac:"Använd ⌘ + rulla för att zooma på kartan"},ta:{touch:"மேப்பை நகர்த்த இரண்டு விரல்களைப் பயன்படுத்தவும்",scroll:"மேப்பை பெரிதாக்கி/சிறிதாக்கிப் பார்க்க, ctrl பட்டனைப் பிடித்தபடி, மேலே/கீழே ஸ்க்ரால் செய்யவும்",scrollMac:"மேப்பை பெரிதாக்கி/சிறிதாக்கிப் பார்க்க, ⌘ பட்டனைப் பிடித்தபடி, மேலே/கீழே ஸ்க்ரால் செய்யவும்"},te:{touch:"మ్యాప్‌ని తరలించడం కోసం రెండు వేళ్లను ఉపయోగించండి",scroll:"మ్యాప్‌ని జూమ్ చేయడానికి ctrl బటన్‌ను నొక్కి ఉంచి, స్క్రోల్ చేయండి",scrollMac:"మ్యాప్ జూమ్ చేయాలంటే ⌘ + స్క్రోల్ ఉపయోగించండి"},th:{touch:"ใช้ 2 นิ้วเพื่อเลื่อนแผนที่",scroll:"กด Ctrl ค้างไว้ แล้วเลื่อนหน้าจอเพื่อซูมแผนที่",scrollMac:"กด ⌘ แล้วเลื่อนหน้าจอเพื่อซูมแผนที่"},tl:{touch:"Gumamit ng dalawang daliri upang iusog ang mapa",scroll:"Gamitin ang ctrl + scroll upang i-zoom ang mapa",scrollMac:"Gamitin ang ⌘ + scroll upang i-zoom ang mapa"},tr:{touch:"Haritada gezinmek için iki parmağınızı kullanın",scroll:"Haritayı yakınlaştırmak için ctrl + kaydırma kombinasyonunu kullanın",scrollMac:"Haritayı yakınlaştırmak için ⌘ tuşuna basıp ekranı kaydırın"},uk:{touch:"Переміщуйте карту двома пальцями",scroll:"Щоб змінювати масштаб карти, прокручуйте коліщатко миші, утримуючи клавішу Ctrl",scrollMac:"Щоб змінити масштаб карти, використовуйте ⌘ + прокручування"},vi:{touch:"Sử dụng hai ngón tay để di chuyển bản đồ",scroll:"Sử dụng ctrl + cuộn để thu phóng bản đồ",scrollMac:"Sử dụng ⌘ + cuộn để thu phóng bản đồ"},"zh-CN":{touch:"使用双指移动地图",scroll:"按住 Ctrl 并滚动鼠标滚轮才可缩放地图",scrollMac:"按住 ⌘ 并滚动鼠标滚轮才可缩放地图"},"zh-TW":{touch:"同時以兩指移動地圖",scroll:"按住 ctrl 鍵加上捲動滑鼠可以縮放地圖",scrollMac:"按 ⌘ 加上滾動捲軸可以縮放地圖"}};L.Map.mergeOptions({gestureHandlingOptions:{text:{},duration:1e3}});var t=!1,e=L.Handler.extend({addHooks:function(){this._handleTouch=this._handleTouch.bind(this),this._setupPluginOptions(),this._setLanguageContent(),this._disableInteractions(),this._map._container.addEventListener("touchstart",this._handleTouch),this._map._container.addEventListener("touchmove",this._handleTouch),this._map._container.addEventListener("touchend",this._handleTouch),this._map._container.addEventListener("touchcancel",this._handleTouch),this._map._container.addEventListener("click",this._handleTouch),L.DomEvent.on(this._map._container,"wheel",this._handleScroll,this),L.DomEvent.on(this._map,"mouseover",this._handleMouseOver,this),L.DomEvent.on(this._map,"mouseout",this._handleMouseOut,this),L.DomEvent.on(this._map,"movestart",this._handleDragging,this),L.DomEvent.on(this._map,"move",this._handleDragging,this),L.DomEvent.on(this._map,"moveend",this._handleDragging,this)},removeHooks:function(){this._enableInteractions(),this._map._container.removeEventListener("touchstart",this._handleTouch),this._map._container.removeEventListener("touchmove",this._handleTouch),this._map._container.removeEventListener("touchend",this._handleTouch),this._map._container.removeEventListener("touchcancel",this._handleTouch),this._map._container.removeEventListener("click",this._handleTouch),L.DomEvent.off(this._map._container,"wheel",this._handleScroll,this),L.DomEvent.off(this._map,"mouseover",this._handleMouseOver,this),L.DomEvent.off(this._map,"mouseout",this._handleMouseOut,this),L.DomEvent.off(this._map,"movestart",this._handleDragging,this),L.DomEvent.off(this._map,"move",this._handleDragging,this),L.DomEvent.off(this._map,"moveend",this._handleDragging,this)},_handleDragging:function(a){"movestart"==a.type||"move"==a.type?t=!0:"moveend"==a.type&&(t=!1)},_disableInteractions:function(){this._map.dragging.disable(),this._map.scrollWheelZoom.disable(),this._map.tap&&this._map.tap.disable()},_enableInteractions:function(){this._map.dragging.enable(),this._map.scrollWheelZoom.enable(),this._map.tap&&this._map.tap.enable()},_setupPluginOptions:function(){this._map.options.gestureHandlingText&&(this._map.options.gestureHandlingOptions.text=this._map.options.gestureHandlingText)},_setLanguageContent:function(){var a;if(this._map.options.gestureHandlingOptions&&this._map.options.gestureHandlingOptions.text&&this._map.options.gestureHandlingOptions.text.touch&&this._map.options.gestureHandlingOptions.text.scroll&&this._map.options.gestureHandlingOptions.text.scrollMac)a=this._map.options.gestureHandlingOptions.text;else{var t=this._getUserLanguage();t||(t="en"),o[t]&&(a=o[t]),a||-1===t.indexOf("-")||(t=t.split("-")[0],a=o[t]),a||(a=o[t="en"])}var e=!1;0<=navigator.platform.toUpperCase().indexOf("MAC")&&(e=!0);var l=a.scroll;e&&(l=a.scrollMac),this._map._container.setAttribute("data-gesture-handling-touch-content",a.touch),this._map._container.setAttribute("data-gesture-handling-scroll-content",l)},_getUserLanguage:function(){return navigator.languages?navigator.languages[0]:navigator.language||navigator.userLanguage},_handleTouch:function(a){for(var t=["leaflet-control-minimap","leaflet-interactive","leaflet-popup-content","leaflet-popup-content-wrapper","leaflet-popup-close-button","leaflet-control-zoom-in","leaflet-control-zoom-out"],e=!1,l=0;l<t.length;l++)L.DomUtil.hasClass(a.target,t[l])&&(e=!0);e?L.DomUtil.hasClass(a.target,"leaflet-interactive")&&"touchmove"===a.type&&1===a.touches.length?(L.DomUtil.addClass(this._map._container,"leaflet-gesture-handling-touch-warning"),this._disableInteractions()):L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-touch-warning"):"touchmove"===a.type||"touchstart"===a.type?1===a.touches.length?(L.DomUtil.addClass(this._map._container,"leaflet-gesture-handling-touch-warning"),this._disableInteractions()):(a.preventDefault(),this._enableInteractions(),L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-touch-warning")):L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-touch-warning")},_isScrolling:!1,_handleScroll:function(a){a.metaKey||a.ctrlKey?(a.preventDefault(),L.DomUtil.removeClass(this._map._container,"leaflet-gesture-handling-scroll-warning"),this._map.scrollWheelZoom.enable()):(L.DomUtil.addClass(this._map._container,"leaflet-gesture-handling-scroll-warning"),this._map.scrollWheelZoom.disable(),clearTimeout(this._isScrolling),this._isScrolling=setTimeout(function(){for(var a=document.getElementsByClassName("leaflet-gesture-handling-scroll-warning"),t=0;t<a.length;t++)L.DomUtil.removeClass(a[t],"leaflet-gesture-handling-scroll-warning")},this._map.options.gestureHandlingOptions.duration))},_handleMouseOver:function(a){this._enableInteractions()},_handleMouseOut:function(a){t||this._disableInteractions()}});L.Map.addInitHook("addHandler","gestureHandling",e),a.GestureHandling=e,a.default=e,Object.defineProperty(a,"__esModule",{value:!0})});
	//# sourceMappingURL=leaflet-gesture-handling.min.js.map


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(54);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./map.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./map.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:991px){.leaflet-control-zoom-in,.leaflet-control-zoom-out{display:none!important}}.leaflet-draw-toolbar a{background-image:linear-gradient(transparent,transparent),url(\"data:image/svg+xml;base64,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\")!important}.bolder-heading{font-weight:700}.bold-heading{font-weight:500}", ""]);
	
	// exports


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(58);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!./leaflet-gesture-handling.css", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!./leaflet-gesture-handling.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes leaflet-gestures-fadein{0%{opacity:0}to{opacity:1}}.leaflet-container:after{animation:leaflet-gestures-fadein .8s backwards;color:#fff;font-family:Roboto,Arial,sans-serif;font-size:22px;-ms-flex-pack:center;justify-content:center;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:15px;position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);z-index:461;pointer-events:none}.leaflet-gesture-handling-scroll-warning:after,.leaflet-gesture-handling-touch-warning:after{animation:leaflet-gestures-fadein .8s forwards}.leaflet-gesture-handling-touch-warning:after{content:attr(data-gesture-handling-touch-content)}.leaflet-gesture-handling-scroll-warning:after{content:attr(data-gesture-handling-scroll-content)}", ""]);
	
	// exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: n.gorte
	 * Date: 11.04.2019
	 * Time: 10:28
	 */
	'use strict';
	
	__webpack_require__(60);
	
	/**
	 * Extends leaflet control positions with 'bottomcenter', 'topcenter', 'leftcenter', 'rightcenter'
	 */
	L.Map.include({
	    _initControlPos: function _initControlPos() {
	        var corners = this._controlCorners = {};
	        var l = 'leaflet-';
	        var container = this._controlContainer = L.DomUtil.create('div', l + 'control-container', this._container);
	
	        var createCorner = function createCorner(vSide, hSide) {
	            var className = l + vSide + ' ' + l + hSide;
	            return corners[vSide + hSide] = L.DomUtil.create('div', className, container);
	        };
	
	        createCorner('top', 'left');
	        createCorner('top', 'right');
	        createCorner('top', 'center');
	        createCorner('bottom', 'left');
	        createCorner('bottom', 'right');
	        createCorner('bottom', 'center');
	        createCorner('left', 'center');
	        createCorner('right', 'center');
	    }
	});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(61);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./leaflet-control-positions.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./leaflet-control-positions.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-layers{border:0}.leaflet-bottom.leaflet-center,.leaflet-top.leaflet-center{position:absolute;left:50%;margin-right:-50%;transform:translate(-50%)}.leaflet-touch .leaflet-bar.leaflet-control-custom,.leaflet-touch .leaflet-bar a{width:34px;height:34px;line-height:34px;background-color:#3ba9ea;color:#fff;font-size:20px;cursor:pointer;text-align:center;border-radius:0;align-items:center;padding:0;border:none}.leaflet-touch .leaflet-bar.leaflet-control-custom.active,.leaflet-touch .leaflet-bar a.active{background-color:#326487}@media (hover:hover){.leaflet-touch .leaflet-bar.leaflet-control-custom:hover,.leaflet-touch .leaflet-bar a:hover{background-color:#326487}}.leaflet-top.leaflet-left{flex-direction:row;display:flex;flex-wrap:wrap;right:50px}.leaflet-left.leaflet-center,.leaflet-right.leaflet-center{position:absolute;top:50%;transform:translateY(-50%)}.map-fullscreen.modal-open .modal{z-index:100000!important}.leaflet-draw{z-index:802}.leaflet-draw-horizontal .leaflet-draw{display:flex;flex-direction:row;align-items:center;flex-wrap:wrap}.leaflet-draw-horizontal .leaflet-draw .leaflet-draw-section .leaflet-draw-toolbar{display:flex;flex-direction:row;align-items:center;margin-top:0}.leaflet-draw-horizontal .leaflet-draw .leaflet-draw-section .leaflet-draw-toolbar a{background-size:300px 34px}.leaflet-draw-horizontal .leaflet-draw .leaflet-draw-section .leaflet-draw-toolbar .leaflet-draw-toolbar-button-enabled{background-color:#326487}.leaflet-draw-horizontal .leaflet-draw .leaflet-draw-section:first-child .leaflet-draw-toolbar{margin-right:12px}.leaflet-draw-horizontal .leaflet-draw-actions{top:36px!important}", ""]);
	
	// exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * User: nikolaigorte * Date: 22.03.23 * Time: 15:22 */
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.Toast = _leaflet2.default.Control.extend({
	    options: {
	        position: 'bottomcenter',
	        timeout: 3000,
	        closable: true,
	        dismissable: true,
	        className: '',
	        marginLeft: null,
	        marginRight: null
	    },
	    onAdd: function onAdd(map) {
	        this._notifications = [];
	
	        this._container = _leaflet2.default.DomUtil.create('div', 'leaflet-control-notifications ' + this.options.className);
	
	        if (this.options.marginLeft) {
	            this._container.style.marginLeft = this.options.marginLeft;
	        }
	        if (this.options.marginRight) {
	            this._container.style.marginRight = this.options.marginRight;
	        }
	
	        _leaflet2.default.DomEvent.disableScrollPropagation(this._container);
	        _leaflet2.default.DomEvent.disableClickPropagation(this._container);
	        _leaflet2.default.DomEvent.on(this._container, 'contextmenu', _leaflet2.default.DomEvent.stopPropagation);
	
	        map._container.insertBefore(this._container, map._container.firstChild);
	        map.toast = this;
	        return this._container;
	    },
	
	    onRemove: function onRemove(map) {
	        map.toast = null;
	    },
	    info: function info(title, message, options) {
	        this._add('info', title, message, _extends({ icon: 'fa fa-info-circle' }, options));
	    },
	    warning: function warning(title, message, options) {
	        this._add('warning', title, message, _extends({ icon: 'fa fa-exclamation-triangle' }, options));
	    },
	    success: function success(title, message, options) {
	        this._add('success', title, message, _extends({ icon: 'fa fa-check-circle' }, options));
	    },
	    alert: function alert(title, message, options) {
	        this._add('alert', title, message, _extends({ icon: 'fa fa-exclamation-circle' }, options));
	    },
	    custom: function custom(title, message, options) {
	        this._add('custom', title, message, _extends({ icon: 'fa fa-cog' }, options));
	    },
	    clear: function clear() {
	        this._notifications.forEach(this._remove);
	        this._notifications = [];
	    },
	    _add: function _add(severity, title, message, options) {
	        var _this = this;
	
	        var className = options.className,
	            icon = options.icon,
	            timeout = options.timeout,
	            closable = options.closable,
	            dismissable = options.dismissable;
	
	        var container = _leaflet2.default.DomUtil.create('div', 'leaflet-toast ' + severity, this._container);
	        var _closable = typeof closable !== 'undefined' ? closable : this.options.closable;
	        var _dismissable = typeof dismissable !== 'undefined' ? dismissable : this.options.dismissable;
	        var iconSpanUtil = void 0,
	            iconUtil = void 0,
	            contentUtil = void 0,
	            titleUtil = void 0,
	            messageUtil = void 0;
	
	        if (icon) {
	            iconSpanUtil = _leaflet2.default.DomUtil.create('div', 'leaflet-toast-icon', container);
	            iconUtil = _leaflet2.default.DomUtil.create('i', icon, iconSpanUtil);
	        }
	        contentUtil = _leaflet2.default.DomUtil.create('div', 'leaflet-toast-content', container);
	        titleUtil = _leaflet2.default.DomUtil.create('div', 'leaflet-toast-title', contentUtil);
	        messageUtil = _leaflet2.default.DomUtil.create('div', 'leaflet-toast-message', contentUtil);
	        if (_dismissable) {
	            _leaflet2.default.DomUtil.addClass(container, 'dismissable');
	            _leaflet2.default.DomEvent.addListener(container, 'click', _leaflet2.default.DomEvent.stop);
	            _leaflet2.default.DomEvent.addListener(container, 'click', function () {
	                return _this._remove(container);
	            });
	            _leaflet2.default.DomEvent.disableClickPropagation(container);
	        }
	
	        if (_closable) {
	            var closeBtnUtil = _leaflet2.default.DomUtil.create('span', 'leaflet-toast-close-button', container);
	            closeBtnUtil.innerHTML = '&times;';
	            _leaflet2.default.DomEvent.addListener(closeBtnUtil, 'click', _leaflet2.default.DomEvent.stop);
	            _leaflet2.default.DomEvent.addListener(closeBtnUtil, 'click', function () {
	                return _this._remove(container);
	            });
	            _leaflet2.default.DomEvent.disableClickPropagation(closeBtnUtil);
	        }
	
	        if (className) {
	            _leaflet2.default.DomUtil.addClass(container, className);
	        }
	        if (title) {
	            titleUtil.innerHTML = title;
	        }
	        if (message) {
	            messageUtil.innerHTML = message;
	        }
	        setTimeout(function () {
	            container.style.opacity = '1';
	        });
	        setTimeout(function () {
	            _this._remove(container);
	        }, timeout || this.options.timeout);
	
	        this._notifications.push(container);
	
	        return container;
	    },
	    _remove: function _remove(container) {
	        var index = this._notifications.indexOf(container);
	        this._notifications.splice(index, 1);
	        container.style.opacity = '0';
	        setTimeout(function () {
	            _leaflet2.default.DomUtil.remove(container);
	        }, 300);
	    }
	});
	
	_leaflet2.default.control.toast = function (options) {
	    return new _leaflet2.default.Control.Toast(options);
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(64);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./toast-plugin.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./toast-plugin.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-toast{width:300px;min-height:50px;padding:10px;margin:0 0 1rem;box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12);border-radius:5px;transition:opacity .3s ease;display:table;opacity:0}.leaflet-toast.dismissable{cursor:pointer}.leaflet-toast.alert>.leaflet-toast-close-button,.leaflet-toast.alert>.leaflet-toast-icon>i{color:#8a0714}.leaflet-toast.info>.leaflet-toast-close-button,.leaflet-toast.info>.leaflet-toast-icon>i{color:#3786aa}.leaflet-toast.success>.leaflet-toast-close-button,.leaflet-toast.success>.leaflet-toast-icon>i{color:#308333}.leaflet-toast.warning>.leaflet-toast-close-button,.leaflet-toast.warning>.leaflet-toast-icon>i{color:#c56702}.leaflet-toast.custom>.leaflet-toast-close-button,.leaflet-toast.custom>.leaflet-toast-icon>i{color:#a2a2a2}.leaflet-toast.alert{background-color:rgba(199,66,67,.95);color:#f3f3f3;border:solid #8a0714;border-width:0 0 0 4px}.leaflet-toast.info{background-color:rgba(61,171,198,.95);color:#f3f3f3;border:solid #3786aa;border-width:0 0 0 4px}.leaflet-toast.success{background-color:rgba(74,162,85,.95);color:#f3f3f3;border:solid #308333;border-width:0 0 0 4px}.leaflet-toast.warning{background-color:rgba(237,154,71,.95);color:#f3f3f3;border:solid #c56702;border-width:0 0 0 4px}.leaflet-toast.custom{background-color:hsla(0,0%,89%,.95);color:#494949;border:solid #a2a2a2;border-width:0 0 0 4px}.leaflet-toast-content{display:table-cell;vertical-align:middle}.leaflet-toast-message,.leaflet-toast-title{margin-left:10px}.leaflet-toast>.leaflet-toast-content>.leaflet-toast-title{font-weight:800}.leaflet-toast-close-button{margin-left:15px;color:#fff;font-weight:700;font-size:20px;line-height:20px;cursor:pointer;transition:.3s;float:right}.leaflet-toast-close-button:hover{font-size:22px;color:red}.leaflet-toast-icon{display:table-cell;vertical-align:middle;font-size:22pt;width:30px}.modern>.leaflet-toast{border-radius:2px;color:#333}.modern>.leaflet-toast.alert{background-color:hsla(0,0%,100%,.95);border:solid #cc2738;border-width:0 0 0 4px}.modern>.leaflet-toast.success{background-color:hsla(0,0%,100%,.95);border:solid #32da3f;border-width:0 0 0 4px}.modern>.leaflet-toast.warning{background-color:hsla(0,0%,100%,.95);border:solid #febe14;border-width:0 0 0 4px}.modern>.leaflet-toast.info{background-color:hsla(0,0%,100%,.95);border:solid #1a76e5;border-width:0 0 0 4px}.modern>.leaflet-toast.custom{background-color:hsla(0,0%,100%,.95);border:solid #5e5e5e;border-width:0 0 0 4px}.modern>.leaflet-toast.alert>.leaflet-toast-icon>i{color:#cc2738}.modern>.leaflet-toast.info>.leaflet-toast-icon>i{color:#1a76e5}.modern>.leaflet-toast.success>.leaflet-toast-icon>i{color:#32da3f}.modern>.leaflet-toast.warning>.leaflet-toast-icon>i{color:#febe14}.modern>.leaflet-toast.custom>.leaflet-toast-icon>i{color:#5e5e5e}.modern>.leaflet-toast .leaflet-toast-content .leaflet-toast-message,.modern>.leaflet-toast>.leaflet-toast-close-button{color:#767676}", ""]);
	
	// exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 05.07.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _translateLeafletDrawer = __webpack_require__(66);
	
	var _translateLeafletDrawer2 = _interopRequireDefault(_translateLeafletDrawer);
	
	var _FeatureManager = __webpack_require__(13);
	
	var _FeatureManager2 = _interopRequireDefault(_FeatureManager);
	
	var _geoUtils = __webpack_require__(14);
	
	var _ = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GeometryInputPlugin = function () {
	    function GeometryInputPlugin(props) {
	        _classCallCheck(this, GeometryInputPlugin);
	
	        if (props.onGeometryChange) {
	            this.onGeometryChange = props.onGeometryChange.bind(this);
	        } else {
	            console.error('Required properties onGeometryChange are undefined!');
	        }
	        this.drawLayer = new _leaflet2.default.FeatureGroup();
	        this.boundRequestHandled = false;
	        this.applyChanges = this.applyChanges.bind(this);
	        this.block = this.block.bind(this);
	        this.unBlock = this.unBlock.bind(this);
	    }
	
	    GeometryInputPlugin.prototype.initOptions = function initOptions(o) {
	        var _this = this;
	
	        if (o.geometry && !this.boundRequestHandled) {
	            o.boundRequest = {
	                bounds: (0, _geoUtils.getBoundsFromGeometry)(o.geometry),
	                options: { animate: false },
	                cb: function cb() {
	                    return _this.boundRequestHandled = true;
	                }
	            };
	        }
	        return o;
	    };
	
	    GeometryInputPlugin.prototype.init = function init(map, o) {
	        var _this2 = this;
	
	        (0, _liferayWidgetsReactWeb.amdRequire)(['leaflet-draw', 'css!leaflet-draw-css'], function () {
	            (0, _translateLeafletDrawer2.default)();
	            _this2.map = map;
	            map.options.drawControl = true;
	            map.addLayer(_this2.drawLayer);
	            var control = new _leaflet2.default.Control.Draw({
	                draw: _extends({}, o.drawOptions, {
	                    rectangle: Liferay.Browser.isMobile() ? false : o.drawOptions.rectangle,
	                    marker: o.drawOptions.marker !== undefined ? o.drawOptions.marker : { icon: (0, _.boIcon)(o.type) }
	                }),
	                edit: {
	                    featureGroup: _this2.drawLayer
	                }
	            });
	            map.drawControl = control;
	            map.addControl(control).on(_leaflet2.default.Draw.Event.CREATED, _this2.handleCreated.bind(_this2)).on(_leaflet2.default.Draw.Event.EDITSTOP, _this2.applyChanges).on(_leaflet2.default.Draw.Event.DELETED, _this2.applyChanges);
	
	            map.on(_leaflet2.default.Draw.Event.DRAWSTART, _this2.block);
	            map.on(_leaflet2.default.Draw.Event.EDITSTART, _this2.block);
	            map.on(_leaflet2.default.Draw.Event.DELETESTART, _this2.block);
	
	            _leaflet2.default.DomUtil.toFront(control.getContainer());
	
	            _this2.setGeometry(o);
	        });
	    };
	
	    GeometryInputPlugin.prototype.remove = function remove() {
	        this.map = null;
	        this.drawLayer = null;
	    };
	
	    GeometryInputPlugin.prototype.setGeometry = function setGeometry(_ref) {
	        var _this3 = this;
	
	        var geometry = _ref.geometry,
	            type = _ref.type;
	
	        this.drawLayer.eachLayer(function (layer) {
	            return layer.editing && layer.editing.disable();
	        }).clearLayers();
	        if (geometry) {
	            var feature = { geometry: geometry, type: 'Feature', properties: { type: type } };
	            var layer = _FeatureManager2.default.createFeatureLayer(feature, {}, true);
	            if (layer.then) {
	                var loadingLayer = _FeatureManager2.default.loadingMarker(feature);
	                layer.then(function (renderer) {
	                    _this3.drawLayer.removeLayer(loadingLayer);
	                    _this3.drawLayer.addLayer(renderer.createFeatureLayer(feature, {}));
	                });
	                layer = loadingLayer;
	            }
	            this.drawLayer.addLayer(layer);
	        }
	        this.geometry = geometry;
	    };
	
	    GeometryInputPlugin.prototype.getGeometry = function getGeometry() {
	        return this.drawLayer.getLayers().length > 0 ? this.drawLayer.getLayers()[0].toGeoJSON().geometry : null;
	    };
	
	    GeometryInputPlugin.prototype.update = function update(map, o) {
	        if (o.geometry !== this.geometry) {
	            this.setGeometry(o);
	        }
	    };
	
	    GeometryInputPlugin.prototype.block = function block() {
	        this.map.blockingControlActive = true;
	    };
	
	    GeometryInputPlugin.prototype.unBlock = function unBlock() {
	        var _this4 = this;
	
	        /*
	        hacky but Leaflet Draw ensures closing click for rectangle creation is
	        propagated to map which triggers our LayerInfo plugin.
	        https://github.com/Leaflet/Leaflet.draw/blob/develop/src/draw/handler/Draw.Rectangle.js#L52
	        This ensures LayerInfo stays closed while drawing
	         */
	
	        setTimeout(function () {
	            _this4.map.blockingControlActive = false;
	        }, 300);
	    };
	
	    GeometryInputPlugin.prototype.applyChanges = function applyChanges(e) {
	        this.onGeometryChange(this.getGeometry());
	        this.unBlock();
	    };
	
	    GeometryInputPlugin.prototype.handleCreated = function handleCreated(e) {
	        this.onGeometryChange(e.layer.toGeoJSON().geometry);
	        this.unBlock();
	    };
	
	    return GeometryInputPlugin;
	}();
	
	exports.default = GeometryInputPlugin;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**!
	                                                                                                                                                                                                                                                                   * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                   * Date: 13.10.2016
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   */
	
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    if (_leaflet2.default.drawLocal && _leaflet2.default.drawLocal.isTranslated) {
	        return;
	    }
	
	    _leaflet2.default.drawLocal = _extends({}, _leaflet2.default.drawLocal, {
	        isTranslated: true,
	        draw: {
	            toolbar: {
	                actions: {
	                    title: 'Zeichnen abbrechen',
	                    text: 'Abbrechen'
	                },
	                finish: {
	                    title: 'Zeichnen abschließen',
	                    text: 'Abschließen'
	                },
	                undo: {
	                    title: 'Letzten gezeichneten Punkt löschen',
	                    text: 'Letzten Punkt löschen'
	                },
	                buttons: {
	                    polyline: 'Polylinie zeichnen',
	                    polygon: 'Polygon zeichnen',
	                    rectangle: 'Rechteck zeichnen',
	                    circle: 'Kreis zeichnen',
	                    marker: 'Marker zeichnen',
	                    circlemarker: 'Kreismarker zeichnen'
	                }
	            },
	            handlers: {
	                circle: {
	                    tooltip: {
	                        start: 'Klicken und ziehen, um einen Kreis zu zeichnen.'
	                    },
	                    radius: 'Radius'
	                },
	                circlemarker: {
	                    tooltip: {
	                        start: 'Klicken, um einen Kreismarker zu zeichnen.'
	                    }
	                },
	                marker: {
	                    tooltip: {
	                        start: 'Auf die Karte klicken, um einen Marker zu zeichnen.'
	                    }
	                },
	                polygon: {
	                    tooltip: {
	                        start: 'Klicken zum Zeichnen eines Polygons.',
	                        cont: 'Klicken zum Zeichnen eines Polygons.',
	                        end: 'Auf ersten Punkt klicken, um Polygon abzuschließen.'
	                    }
	                },
	                polyline: {
	                    error: '<strong>Fehler:</strong> Kanten dürfen sich nicht überschneiden!',
	                    tooltip: {
	                        start: 'Klicken zum Zeichnen einer Polylinie.',
	                        cont: 'Klicken zum Zeichnen einer Polylinie.',
	                        end: 'Auf letzten Punkt klicken, um Polylinie abzuschließen.'
	                    }
	                },
	                rectangle: {
	                    tooltip: {
	                        start: 'Klicken und ziehen, um ein Rechteck zu zeichnen.'
	                    }
	                },
	                simpleshape: {
	                    tooltip: {
	                        end: 'Maus loslassen, um Zeichnen zu beenden.'
	                    }
	                }
	            }
	        },
	        edit: {
	            toolbar: {
	                actions: {
	                    save: {
	                        title: 'Änderungen speichern.',
	                        text: 'Speichern'
	                    },
	                    cancel: {
	                        title: 'Zeichnen abbrechen und alle Änderungen verwerfen.',
	                        text: 'Abbrechen'
	                    },
	                    clearAll: {
	                        title: 'Alle Zeichnungen löschen.',
	                        text: 'Alle löschen'
	                    }
	                },
	                buttons: {
	                    edit: 'Layer bearbeiten.',
	                    editDisabled: 'Keine Layer zum Bearbeiten.',
	                    remove: 'Layer löschen.',
	                    removeDisabled: 'Keine Layer zum Löschen.'
	                }
	            },
	            handlers: {
	                edit: {
	                    tooltip: {
	                        text: 'Zum Editieren, Layer verschieben.',
	                        subtext: 'Auf Abbrechen klicken, um Änderungen rückgängig zu machen.'
	                    }
	                },
	                remove: {
	                    tooltip: {
	                        text: 'Zum Löschen auf einen Layer klicken.'
	                    }
	                }
	            }
	        }
	    });
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: n.gorte
	 * Date: 28.06.2022
	 * Time: 14:19
	 */
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 05.09.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	__webpack_require__(69);
	
	var _SearchBox = __webpack_require__(71);
	
	var _SearchBoxAutocomplete = __webpack_require__(72);
	
	var _lwrClient = __webpack_require__(26);
	
	var _mapConfigUtil = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SUGGEST_URL = 'https://geo.lupo-cloud.de/bkg_osgts_adv/suggest?count=5&filter=typ:ort OR typ:strasse&query=';
	var GEOSEARCH_URL = 'https://geo.lupo-cloud.de/bkg_osgts_adv/geosearch/?srsName=EPSG:4326&format=json&count=1&filter=';
	var searchGeoFeatures = function searchGeoFeatures(query, classNames, gaugingStationTypeKeys) {
	    return _lwrClient.Client.invoke('/geo.geofeature/search-geo-features.6', {
	        classNames: classNames,
	        gaugingStationTypeKeys: gaugingStationTypeKeys,
	        limit: 5,
	        searchTerm: query,
	        groupId: _lwrClient.Client.getScopeGroupId()
	    });
	};
	
	var SearchPlugin = function () {
	    function SearchPlugin(props, config) {
	        _classCallCheck(this, SearchPlugin);
	
	        this.config = config;
	        this.props = props;
	
	        this.suggestions = {
	            type: 'suggestions',
	            items: [],
	            error: null
	        };
	
	        this.fliwasObjects = {
	            type: 'fliwas',
	            items: [],
	            error: null
	        };
	
	        this.selectedPlace = {
	            type: 'place',
	            item: null,
	            error: null
	        };
	
	        this.query = '';
	
	        this.onInputChange = this.onInputChange.bind(this);
	        this.resetItems = this.resetItems.bind(this);
	        this.onInputFocus = this.onInputFocus.bind(this);
	        this.renderAutoComplete = this.renderAutoComplete.bind(this);
	        this.onFliwasObjectClick = this.onFliwasObjectClick.bind(this);
	        this.onSuggestionClick = this.onSuggestionClick.bind(this);
	        this.onResize = this.onResize.bind(this);
	        this.search = (0, _liferayWidgetsReactWeb.debounce)(this.search, 300);
	        this.onClose = this.onClose.bind(this);
	    }
	
	    SearchPlugin.prototype.init = function init(map, o, reEvaluate) {
	        this._reEvaluate = reEvaluate;
	        this._map = map;
	        this._options = o;
	
	        this.placeMarker = _leaflet2.default.marker().bindPopup();
	        this.searchControl = new _SearchBox.SearchBox();
	        map.addControl(this.searchControl);
	        this.searchControl.onInput('input', this.onInputChange);
	        this.searchControl.onInput('focus', this.onInputChange);
	        this.searchControl.onClear('click', this.resetItems);
	
	        this._map.on('resize', this.onResize);
	        this.onResize();
	    };
	
	    SearchPlugin.prototype.update = function update(map, o) {
	        if (!(0, _liferayWidgetsReactWeb.deepEqual)(this._options.activeUuids, o.activeUuids)) {
	            this.search(this.query);
	        }
	        this._options = o;
	    };
	
	    SearchPlugin.prototype.remove = function remove() {
	        this._map.off();
	        this.placeMarker && this.placeMarker.remove();
	        if (this.searchControl) {
	            this.searchControl.remove();
	        }
	        this._map = null;
	    };
	
	    SearchPlugin.prototype.onResize = function onResize() {
	        if (this._map.getSize().x >= 600) {
	            this.searchControl.show();
	        }
	    };
	
	    SearchPlugin.prototype.onInputChange = function onInputChange(e) {
	        var value = e.target.value;
	        this.query = value;
	        this.search(value);
	    };
	
	    SearchPlugin.prototype.onInputFocus = function onInputFocus() {
	        if (this.fliwasObjects.items.length > 0) {
	            this.renderAutoComplete();
	        }
	    };
	
	    SearchPlugin.prototype.resetItems = function resetItems() {
	        this.placeMarker && this.placeMarker.remove();
	        this.query = '';
	        this.suggestions = {
	            type: 'suggestions',
	            items: [],
	            error: null
	        };
	        this.fliwasObjects = {
	            type: 'fliwas',
	            items: [],
	            error: null
	        };
	        _reactDom2.default.unmountComponentAtNode(this.searchControl._autocompleteWrapper);
	    };
	
	    SearchPlugin.prototype.search = function search(query) {
	        var _options = this._options,
	            activeUuids = _options.activeUuids,
	            layerDescriptions = _options.layerDescriptions;
	
	        var layerDescriptionsFlat = layerDescriptions && layerDescriptions.map(function (ld) {
	            return (0, _mapConfigUtil.loopLogicalLayers)(ld, []);
	        }).flat();
	
	        var options = layerDescriptionsFlat && layerDescriptionsFlat.filter(function (l) {
	            return activeUuids[l.uuid];
	        }).reduce(function (acc, layerDescription) {
	            try {
	                var configString = layerDescription.children && layerDescription.children[0].config;
	                var configJson = layerDescription.config || JSON.parse(configString);
	                if (configJson.className) {
	                    if (!acc.classNames.includes(configJson.className)) {
	                        acc.classNames.push(configJson.className);
	                    }
	                    if (configJson.className === 'GaugingStation' && configJson.typeKey) {
	                        acc.gaugingStationTypeKeys.push(configJson.typeKey);
	                    }
	                }
	            } catch (e) {
	                console.error('Failed to parse config of: ', layerDescription, e);
	            }
	            return acc;
	        }, {
	            classNames: [],
	            gaugingStationTypeKeys: []
	        });
	
	        if (query.length > 2) {
	            this.getSuggestions(query);
	            this.getFliwasObjects(query, [].concat(options.classNames), options.gaugingStationTypeKeys);
	        }
	    };
	
	    SearchPlugin.prototype.getFliwasObjects = function getFliwasObjects(query, classNames, gaugingStationTypeKeys) {
	        var _this = this;
	
	        if (!classNames.length > 0) {
	            this.fliwasObjects = _extends({}, this.fliwasObjects, {
	                items: []
	            });
	            return;
	        }
	        searchGeoFeatures(query, classNames, gaugingStationTypeKeys).then(function (json) {
	            _this.fliwasObjects = _extends({}, _this.fliwasObjects, {
	                items: json,
	                error: null
	            });
	        }).catch(function (error) {
	            _this.fliwasObjects = _extends({}, _this.fliwasObjects, {
	                items: [],
	                error: error
	            });
	        }).finally(this.renderAutoComplete);
	    };
	
	    SearchPlugin.prototype.getSuggestions = function getSuggestions(query) {
	        var _this2 = this;
	
	        var suggestUrl = encodeURI(SUGGEST_URL + query);
	        fetch(suggestUrl).then(function (response) {
	            return response.json();
	        }).then(function (json) {
	            _this2.suggestions = _extends({}, _this2.suggestions, {
	                items: json,
	                error: null
	            });
	        }).catch(function (error) {
	            _this2.suggestions = _extends({}, _this2.suggestions, {
	                items: [],
	                error: error
	            });
	        }).finally(this.renderAutoComplete);
	    };
	
	    SearchPlugin.prototype.getPlace = function getPlace(suggestion) {
	        var _this3 = this;
	
	        var queryString = suggestion.suggestion.replace(' ', '+');
	        var geosearchUrl = encodeURI(GEOSEARCH_URL + 'typ:' + suggestion.type + '&query=' + queryString);
	        fetch(geosearchUrl).then(function (response) {
	            return response.json();
	        }).then(function (json) {
	            _this3.selectedPlace = _extends({}, _this3.selectedPlace, {
	                item: json.features[0],
	                error: null
	            });
	            _this3.setPlaceMarker(json.features[0]);
	        }).catch(function (error) {
	            _this3.selectedPlace = _extends({}, _this3.selectedPlace, {
	                item: null,
	                error: error
	            });
	        });
	    };
	
	    SearchPlugin.prototype.onClose = function onClose() {
	        this.resetItems();
	        _reactDom2.default.unmountComponentAtNode(this.searchControl._autocompleteWrapper);
	    };
	
	    SearchPlugin.prototype.onSuggestionClick = function onSuggestionClick(suggestion) {
	        this.searchControl.setValue(suggestion.suggestion);
	        this.getPlace(suggestion);
	        this.onClose();
	    };
	
	    SearchPlugin.prototype.onFliwasObjectClick = function onFliwasObjectClick(fliwasObject) {
	        var properties = fliwasObject.properties,
	            geometry = fliwasObject.geometry;
	        var id = properties.id,
	            type = properties.type;
	        var coordinates = geometry.coordinates,
	            geometryType = geometry.type;
	
	        if (geometryType !== 'Point') {
	            var latLngs = _leaflet2.default.geoJSON(geometry).getBounds();
	            this._map.fitBounds(latLngs);
	        } else {
	            var latLng = _leaflet2.default.latLng(coordinates[1], coordinates[0]);
	            this._map.setView(latLng, 14);
	        }
	
	        // global selection not required FLIWASEN-980 Auswahl von Objekten wird auf alle Karten übertragen
	        //RemoteDataActions.pageSelected(type, { id });
	        this.onClose();
	    };
	
	    SearchPlugin.prototype.setPlaceMarker = function setPlaceMarker(feature) {
	        var geometry = feature.geometry;
	        var coordinates = geometry.coordinates;
	
	        var latLng = _leaflet2.default.latLng(coordinates[1], coordinates[0]);
	
	        this.placeMarker.setLatLng(latLng);
	        if (!this._map.hasLayer(this.placeMarker)) {
	            this.placeMarker.addTo(this._map);
	        }
	
	        this.placeMarker.setPopupContent(feature.properties.text);
	        this.placeMarker.openPopup();
	        this._map.setView(latLng, 13);
	    };
	
	    SearchPlugin.prototype.renderAutoComplete = function renderAutoComplete() {
	        _reactDom2.default.render(_react2.default.createElement(_SearchBoxAutocomplete.SearchBoxAutocomplete, {
	            suggestions: this.suggestions,
	            fliwasObjects: this.fliwasObjects,
	            onSuggestionClick: this.onSuggestionClick,
	            onFliwasObjectClick: this.onFliwasObjectClick,
	            activeUuids: this._options.activeUuids,
	            onClose: this.onClose
	        }), this.searchControl._autocompleteWrapper);
	    };
	
	    return SearchPlugin;
	}();
	
	exports.default = SearchPlugin;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_68__;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(70);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./search-plugin.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./search-plugin.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-searchbox-container{z-index:801;height:fit-content}.leaflet-searchbox-wrapper{display:flex;justify-content:right;height:34px}.leaflet-searchbox-wrapper .leaflet-searchbox{background-color:#fff;outline:none;transition-duration:.2s;font-size:17px;transition-delay:.1s;z-index:702;padding:0 8px;border-width:1px}.leaflet-searchbox-wrapper .leaflet-searchbox.leaflet-searchbox-left{border-right:none}.leaflet-searchbox-wrapper .leaflet-searchbox.leaflet-searchbox-right{border-left:none}.leaflet-searchbox-wrapper .clear-button{display:none}.leaflet-searchbox-wrapper .clear-button.active{display:block;position:absolute;font-size:20px;top:7px;right:7px;z-index:800;cursor:pointer}.leaflet-searchbox-wrapper .clear-button.active~.leaflet-searchbox{width:100%}.leaflet-searchbox-wrapper .leaflet-searchbox-button{background-color:#fff;outline:none;transition-duration:.2s;width:40px;transition-delay:0s;z-index:702}.leaflet-searchbox-wrapper .leaflet-searchbox-button:hover{cursor:pointer}.leaflet-searchbox-wrapper .leaflet-searchbox-button.leaflet-searchbox-button-right{border-left:none}.leaflet-searchbox-wrapper .leaflet-searchbox-button.leaflet-searchbox-button-left{border-right:none}.leaflet-searchbox-container .leaflet-searchbox-autocomplete{outline:none;transition-duration:.2s}.leaflet-searchbox-wrapper .leaflet-searchbox-button i{font-size:130%}.leaflet-searchbox-container .leaflet-searchbox-icon{width:69%;height:auto}.leaflet-searchbox-container .leaflet-searchbox-autocomplete{position:absolute;top:20px;width:100%;list-style-type:none;margin:0;padding:20px 0 0;background-color:#fff;border-top:none;z-index:701}.leaflet-searchbox-container .leaflet-searchbox-autocomplete:empty{display:none}.leaflet-searchbox-autocomplete .leaflet-searchbox-autocomplete-item{background-color:#fff;outline:none;transition-duration:.2s;width:100%;border:none;z-index:701;font-size:14px;padding:3px 10px;cursor:pointer;color:#676a6c}.leaflet-searchbox-autocomplete .leaflet-searchbox-autocomplete-item:hover{background-color:#f3f3f3}.leaflet-searchbox-autocomplete .leaflet-searchbox-autocomplete-fliwas-item{display:flex;align-items:center}.leaflet-searchbox-autocomplete .leaflet-searchbox-autocomplete-fliwas-item img{width:28px;height:28px;margin-right:10px;object-fit:contain;flex-shrink:0}.leaflet-searchbox-autocomplete .leaflet-searchbox-autocomplete-fliwas-item span{overflow:hidden}.leaflet-searchbox-autocomplete .leaflet-searchbox-autocomplete-label{font-size:12px;font-weight:700;color:#676a6c;margin-top:8px}.collapsed .leaflet-searchbox{width:0!important;padding:0;transition-delay:0s;border-left:none;border-right:none}.collapsed .leaflet-searchbox-button{transition-delay:.2s;border:1px solid rgba(0,0,0,.3)}.collapsed .leaflet-searchbox-autocomplete{display:none}.leaflet-searchbox-wrapper.open .leaflet-searchbox,.leaflet-searchbox-wrapper.open .leaflet-searchbox-button{border-bottom-left-radius:0;border-bottom-right-radius:0}", ""]);
	
	// exports


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * User: n.gorte
	 * Date: 28.06.2022
	 * Time: 15:26
	 */
	
	var SearchBox = exports.SearchBox = L.Control.extend({
	    options: {
	        position: 'topleft',
	        expand: 'right',
	        collapsed: true,
	        icon: 'fa fa-search',
	        title: 'Suchen',
	        placeholder: ''
	    },
	    onHideHandlers: [],
	
	    addTo: function addTo(map) {
	        this.remove();
	        this._map = map;
	
	        var container = this._container = this.onAdd(map),
	            pos = this.getPosition(),
	            corner = map._controlCorners[pos];
	
	        L.DomUtil.addClass(container, 'leaflet-control');
	
	        if (pos.indexOf('bottom') !== -1) {
	            corner.insertBefore(container, corner.firstChild);
	        } else {
	            corner.appendChild(container);
	        }
	
	        this._map.on('unload', this.remove, this);
	
	        return this;
	    },
	
	    onAdd: function onAdd(map) {
	        this._container = L.DomUtil.create('div', 'leaflet-searchbox-container');
	        this._searchboxWrapper = L.DomUtil.create('div', 'leaflet-searchbox-wrapper', this._container);
	        this._autocompleteWrapper = L.DomUtil.create('div', 'leaflet-searchbox-autocomplete-wrapper', this._container);
	
	        this._createButton();
	        this._createInput();
	        this._createClearButton();
	
	        this._collapsed = this.options.collapsed;
	        if (this.options.collapsed) {
	            this.hide();
	        }
	
	        L.DomEvent.disableClickPropagation(this._container);
	
	        L.DomEvent.on(this._button, 'click', this._onClick, this);
	        L.DomEvent.on(this._clearButton, 'click', this.clear, this);
	        return this._container;
	    },
	    onRemove: function onRemove(map) {
	        L.DomEvent.off(this._button);
	        L.DomEvent.off(this._input);
	        L.DomEvent.off(this._clearButton);
	        L.DomEvent.off(this._container);
	        this.onHideHandlers = [];
	    },
	    getValue: function getValue() {
	        return this._input.value;
	    },
	    setValue: function setValue(value) {
	        this._input.value = value;
	    },
	    hide: function hide() {
	        L.DomUtil.addClass(this._container, 'collapsed');
	        L.DomUtil.removeClass(this._button, 'active');
	        L.DomUtil.removeClass(this._clearButton, 'active');
	        this._input.blur();
	        this._button.blur();
	        this._collapsed = true;
	        this.onHideHandlers.forEach(function (handler) {
	            return handler();
	        });
	    },
	    show: function show() {
	        L.DomUtil.removeClass(this._container, 'collapsed');
	        L.DomUtil.addClass(this._button, 'active');
	        L.DomUtil.addClass(this._clearButton, 'active');
	        this._collapsed = false;
	        // this._input.focus();
	    },
	    toggle: function toggle() {
	        if (L.DomUtil.hasClass(this._container, 'collapsed')) {
	            this.show();
	        } else {
	            this.hide();
	        }
	    },
	    onHide: function onHide(handler) {
	        this.onHideHandlers.push(handler);
	    },
	    offHide: function offHide(handler) {
	        this.onHideHandlers = this.onHideHandlers.filter(function (item) {
	            return item !== handler;
	        });
	    },
	    isCollapsed: function isCollapsed() {
	        return L.DomUtil.hasClass(this._container, 'collapsed');
	    },
	    clearInput: function clearInput() {
	        this._input.value = '';
	    },
	
	
	    clear: function clear() {
	        this.clearInput();
	    },
	
	    onClear: function onClear(event, handler) {
	        L.DomEvent.on(this._clearButton, event, handler, this);
	    },
	    offClear: function offClear(event, handler) {
	        L.DomEvent.off(this._clearButton, event, handler, this);
	    },
	    onInput: function onInput(event, handler) {
	        L.DomEvent.on(this._input, event, handler, this);
	    },
	    offInput: function offInput(event, handler) {
	        L.DomEvent.off(this._input, event, handler, this);
	    },
	    onButton: function onButton(event, handler) {
	        var wrapper = this._buttonHandlerWrapper(handler);
	        L.DomEvent.on(this._button, event, wrapper, this);
	    },
	    offButton: function offButton(event, handler) {
	        var wrapper = this._buttonHandlerWrapper(handler);
	        L.DomEvent.off(this._button, event, wrapper, this);
	    },
	    _onClick: function _onClick() {
	        this.toggle();
	    },
	    _buttonHandlerWrapper: function _buttonHandlerWrapper(handler) {
	        return function () {
	            if (!this._collapsed) {
	                handler();
	            }
	        };
	    },
	    _createButton: function _createButton() {
	        var position = this.options.expand === 'left' ? 'right' : 'left';
	        this._button = L.DomUtil.create('div', 'leaflet-bar leaflet-control-custom leaflet-searchbox-button leaflet-searchbox-button-' + position, this._searchboxWrapper);
	        this._button.setAttribute('type', 'button');
	        this._button.setAttribute('role', 'button');
	        this._button.setAttribute('title', this.options.title);
	        this._icon = L.DomUtil.create('span', this.options.icon, this._button);
	    },
	    _createInput: function _createInput() {
	        var _this = this;
	
	        var position = this.options.expand === 'left' ? 'left' : 'right';
	        this._input = L.DomUtil.create('input', 'leaflet-searchbox leaflet-searchbox-' + position, this._searchboxWrapper);
	        this._input.setAttribute('type', 'text');
	        this._input.setAttribute('placeholder', this.options.placeholder);
	        this._input.setAttribute('enterkeyhint', 'done');
	        L.DomEvent.on(this._input, 'keyup', function (keyboardEvent) {
	            var key = keyboardEvent.code || keyboardEvent.keyCode;
	            if (key === 'Enter' || key === 13) {
	                _this._input.blur();
	            }
	        }, this);
	
	        if (this.options.expand === 'left') {
	            L.DomUtil.toBack(this._input);
	        }
	    },
	    _createClearButton: function _createClearButton() {
	        this._clearButton = L.DomUtil.create('i', 'clear-button fa fa-times', this._searchboxWrapper);
	    }
	});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SearchBoxAutocomplete = undefined;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _icons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoCompleteListSectionHeader = function AutoCompleteListSectionHeader(_ref) {
	    var item = _ref.item,
	        label = _ref.label,
	        noResultsText = _ref.noResultsText,
	        errorText = _ref.errorText;
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	            'li',
	            { className: 'leaflet-searchbox-autocomplete-item leaflet-searchbox-autocomplete-label' },
	            label
	        ),
	        !item.error && item.items.length === 0 && _react2.default.createElement(
	            'li',
	            { className: 'leaflet-searchbox-autocomplete-item' },
	            noResultsText
	        ),
	        item.error && _react2.default.createElement(
	            'li',
	            { className: 'leaflet-searchbox-autocomplete-item' },
	            errorText
	        )
	    );
	}; /**
	    * User: n.gorte
	    * Date: 29.06.2022
	    * Time: 11:49
	    */
	
	var SearchBoxAutocomplete = exports.SearchBoxAutocomplete = function SearchBoxAutocomplete(_ref2) {
	    var suggestions = _ref2.suggestions,
	        fliwasObjects = _ref2.fliwasObjects,
	        onSuggestionClick = _ref2.onSuggestionClick,
	        onFliwasObjectClick = _ref2.onFliwasObjectClick,
	        activeUuids = _ref2.activeUuids,
	        onClose = _ref2.onClose;
	
	
	    (0, _react.useEffect)(function () {
	        var onKeyDown = function onKeyDown(e) {
	            if (e.keyCode === 27) {
	                onClose();
	            }
	        };
	        window.addEventListener('keydown', onKeyDown);
	        return function () {
	            window.removeEventListener('keydown', onKeyDown);
	        };
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        var onKeyDown = function onKeyDown(e) {
	            if (e.keyCode === 13) {
	                onSuggestionClick(suggestions.items[0]);
	            }
	        };
	        window.addEventListener('keydown', onKeyDown);
	        return function () {
	            window.removeEventListener('keydown', onKeyDown);
	        };
	    }, [suggestions]);
	
	    return _react2.default.createElement(
	        'ul',
	        { className: 'leaflet-searchbox-autocomplete' },
	        _react2.default.createElement(AutoCompleteListSectionHeader, {
	            item: suggestions,
	            label: 'Orte',
	            errorText: 'Fehler bei der Anfrage',
	            noResultsText: 'Keine Ergebnisse'
	        }),
	        !suggestions.error && suggestions.items.length > 0 && suggestions.items.map(function (item) {
	            return _react2.default.createElement(
	                'li',
	                {
	                    key: item.suggestion,
	                    className: 'leaflet-searchbox-autocomplete-item',
	                    onClick: function onClick() {
	                        return onSuggestionClick(item);
	                    }
	                },
	                item.suggestion
	            );
	        }),
	        _react2.default.createElement(AutoCompleteListSectionHeader, {
	            item: suggestions,
	            label: 'FLIWAS-Objekte',
	            errorText: 'Fehler bei der Anfrage',
	            noResultsText: 'Keine Ergebnisse'
	        }),
	        activeUuids && Object.keys(activeUuids).length === 0 && _react2.default.createElement(
	            'li',
	            { className: 'leaflet-searchbox-autocomplete-item leaflet-searchbox-autocomplete-fliwas-item' },
	            _react2.default.createElement(
	                'span',
	                null,
	                'Keine FLIWAS-Objekt Layer aktiv'
	            )
	        ),
	        !fliwasObjects.error && fliwasObjects.items.length > 0 && fliwasObjects.items.map(function (item) {
	            var fliwasObjectIcon = (0, _icons.boIcon)(item.properties.type, item.properties.typeKey || item.properties.gaugingStationTypeKey);
	            var suffix = item.properties.type === 'GaugingStation' ? ' (' + item.properties.waters + ')' : '';
	            return _react2.default.createElement(
	                'li',
	                {
	                    key: item.properties.id,
	                    className: 'leaflet-searchbox-autocomplete-item leaflet-searchbox-autocomplete-fliwas-item',
	                    onClick: function onClick() {
	                        return onFliwasObjectClick(item);
	                    }
	                },
	                _react2.default.createElement('img', { src: fliwasObjectIcon.options.iconUrl }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    item.properties.title,
	                    suffix
	                )
	            );
	        })
	    );
	};
	
	SearchBoxAutocomplete.propTypes = {
	    suggestions: _propTypes2.default.object.isRequired,
	    fliwasObjects: _propTypes2.default.object.isRequired,
	    onSuggestionClick: _propTypes2.default.func.isRequired,
	    onFliwasObjectClick: _propTypes2.default.func.isRequired,
	    activeUuids: _propTypes2.default.object,
	    onClose: _propTypes2.default.func.isRequired
	};
	
	AutoCompleteListSectionHeader.propTypes = {
	    item: _propTypes2.default.object,
	    label: _propTypes2.default.string,
	    noResultsText: _propTypes2.default.string,
	    errorText: _propTypes2.default.string
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: n.gorte
	 * Date: 28.06.2022
	 * Time: 14:19
	 */
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 05.09.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(69);
	
	var _SearchBox = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CoordinatesSearchPlugin = function () {
	    function CoordinatesSearchPlugin(props, config) {
	        _classCallCheck(this, CoordinatesSearchPlugin);
	
	        this.config = config;
	        this.props = props;
	
	        this.onInputChange = this.onInputChange.bind(this);
	        this.search = this.search.bind(this);
	        this.setPlaceMarker = this.setPlaceMarker.bind(this);
	        this.onHide = this.onHide.bind(this);
	    }
	
	    CoordinatesSearchPlugin.prototype.init = function init(map, o, reEvaluate) {
	        this._reEvaluate = reEvaluate;
	        this._map = map;
	        this._options = o;
	
	        this.placeMarker = _leaflet2.default.marker().bindPopup();
	
	        this.searchControl = new _SearchBox.SearchBox({
	            title: 'Koordinatensuche',
	            placeholder: 'Lat, Lon Z.B. (48.1, 7.5)',
	            icon: 'icon icon-fliwas-search-crosshair'
	        });
	        map.addControl(this.searchControl);
	        this.searchControl.onInput('input', this.onInputChange);
	        this.searchControl.onInput('keydown', this.search);
	        this.searchControl.onHide(this.onHide);
	    };
	
	    CoordinatesSearchPlugin.prototype.update = function update(map, o) {
	        this._options = o;
	    };
	
	    CoordinatesSearchPlugin.prototype.remove = function remove() {
	        this._map.off();
	        this.placeMarker && this.placeMarker.remove();
	        if (this.searchControl) {
	            this.searchControl.remove();
	        }
	        this._map = null;
	    };
	
	    CoordinatesSearchPlugin.prototype.onInputChange = function onInputChange(e) {
	        var values = e.target.value;
	        values = values.split(',');
	        this.lat = values[0] !== '' && Number.parseFloat(values[0]);
	        this.lng = values[1] !== '' && Number.parseFloat(values[1]);
	    };
	
	    CoordinatesSearchPlugin.prototype.onHide = function onHide() {
	        this.placeMarker && this.placeMarker.remove();
	    };
	
	    CoordinatesSearchPlugin.prototype.search = function search(e) {
	        if (e.key === 'Enter') {
	            if (Number.isFinite(this.lat) && Number.isFinite(this.lng)) {
	                this.latLng = [this.lat, this.lng];
	                this.setPlaceMarker();
	                this._map.setView(this.latLng, 16);
	            } else {
	                alert('Ungültige Koordinateneingabe.');
	            }
	        }
	    };
	
	    CoordinatesSearchPlugin.prototype.setPlaceMarker = function setPlaceMarker() {
	        this.placeMarker.setLatLng(this.latLng);
	        if (!this._map.hasLayer(this.placeMarker)) {
	            this.placeMarker.addTo(this._map);
	        }
	
	        this.placeMarker.setPopupContent('Lat, Lon: ' + this.latLng.toString());
	        this.placeMarker.openPopup();
	    };
	
	    return CoordinatesSearchPlugin;
	}();
	
	exports.default = CoordinatesSearchPlugin;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 05.09.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _localConfigUtil = __webpack_require__(75);
	
	var _mapPortlet = __webpack_require__(6);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalConfigStore = (0, _liferayWidgetsReactWeb.getLocalConfigStore)(_liferayWidgetsReactWeb.AppContext);
	
	var LayerChooserPlugin = function () {
	    function LayerChooserPlugin(props, config) {
	        _classCallCheck(this, LayerChooserPlugin);
	
	        this.config = config;
	        this.props = props;
	        this.portletConfig = undefined;
	        this.updateTitle = this.updateTitle.bind(this);
	        this.onLayersChange = (0, _liferayWidgetsReactWeb.debounce)(this.onLayersChange.bind(this), 300);
	    }
	
	    LayerChooserPlugin.prototype.withCtx = function withCtx(s) {
	        return (this.context && this.context.contextId ? this.context.contextId : 'DEFAULT_') + s;
	    };
	
	    LayerChooserPlugin.prototype._getLocalStorageKeyWithMapConfig = function _getLocalStorageKeyWithMapConfig(key) {
	        if (this.context && this.context.contextId) {
	            var mapConf = this.context;
	            key += '_MAP_CONFIG_' + mapConf.contextId;
	        }
	        return key;
	    };
	
	    LayerChooserPlugin.prototype.initOptions = function initOptions(o) {
	        this.o = o;
	        this.ACTIVE_LAYER_UUIDS_KEY = this.withCtx('_ACTIVE_UUIDS');
	        // Portlet config overrides default behaviour. See FLIWASEN-45 https://inovum-dev.de/jira/browse/FLIWASEN-45
	        if (o && o.portletConfig && o.portletConfig.activeLayerUuids) {
	            this.portletConfig = o.portletConfig;
	            _liferayWidgetsReactWeb.ConfigActions.updateLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY), o.portletConfig.activeLayerUuids);
	        }
	
	        return this.options(o);
	    };
	
	    LayerChooserPlugin.prototype.init = function init(map, o, reEvaluate) {
	        var _this = this;
	
	        this.reEvaluate = reEvaluate;
	        this.map = map;
	        var sidebarContent = _leaflet2.default.DomUtil.create('div', '', map.getContainer());
	        var btn = _leaflet2.default.DomUtil.create('div', 'sidebar-btn left');
	        btn.setAttribute('role', 'button');
	        btn.setAttribute('title', 'Themen & Lagekarten');
	        this.btnContent = _leaflet2.default.DomUtil.create('div', 'sidebar-btn__content', btn);
	        this.sidebar = _leaflet2.default.control.sidebar(sidebarContent, { position: 'left', closeButton: false });
	
	        this.sidebar.on('show', this.updateTitle);
	        this.sidebar.on('hide', this.updateTitle);
	        this.updateTitle();
	
	        map.addControl(this.sidebar);
	        var content = this.sidebar.getContainer();
	        btn.onclick = function (e) {
	            _leaflet2.default.DomEvent.stopPropagation(e);
	            _leaflet2.default.DomEvent.preventDefault(e);
	            _this.sidebar.toggle();
	        };
	        content.parentNode.insertBefore(btn, content);
	    };
	
	    LayerChooserPlugin.prototype.options = function options(o) {
	
	        var defaultActiveUUids = this.config && this.config.initShowAllLayers ? null : [];
	
	        var localStorageOrDefault = (0, _localConfigUtil.getPropertiesFromLocalConfig)(LocalConfigStore.getLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY)), defaultActiveUUids);
	
	        if (o.portletConfig && this.portletConfig && !(0, _liferayWidgetsReactWeb.shallowEqual)(o.portletConfig.activeLayerUuids, this.portletConfig.activeLayerUuids)) {
	            this.portletConfig = o.portletConfig;
	            _liferayWidgetsReactWeb.ConfigActions.updateLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY), o.portletConfig.activeLayerUuids);
	            o = _extends({}, o, {
	                activeUuids: o.portletConfig.activeLayerUuids
	            });
	        } else if (!(0, _liferayWidgetsReactWeb.shallowEqual)(o.activeUuids, localStorageOrDefault)) {
	            if (o.activeUuids || localStorageOrDefault) {
	                console.debug('Extend activeUuids from options', o.activeUuids, ' with', { localStorageOrDefault: localStorageOrDefault });
	                o = _extends({}, o, {
	                    activeUuids: _extends({}, o.activeUuids, localStorageOrDefault)
	                });
	            }
	        }
	
	        return o;
	    };
	
	    LayerChooserPlugin.prototype.updateTitle = function updateTitle() {
	        var icon = this.sidebar.isVisible() ? 'right' : 'left';
	        this.btnContent.innerHTML = '<span class="sidebar-situationmap-name">' + 'Themen & Lagekarten' + '</span>' + '<span class="icon icon-fliwas-arrow-' + icon + ' left" title=""></span>';
	    };
	
	    LayerChooserPlugin.prototype.update = function update(map, o) {
	        var _this2 = this;
	
	        this.o = o;
	        _reactDom2.default.render(_react2.default.createElement(_mapPortlet.LayerChooserSidebar, {
	            layerDescriptions: o.layerDescriptions,
	            onClose: function onClose() {
	                return _this2.sidebar.hide();
	            },
	            context: this.context,
	            onLayersChange: this.onLayersChange,
	            activeLayerUuids: this.o.activeUuids,
	            reEvaluate: this.reEvaluate
	        }), this.sidebar.getContainer());
	    };
	
	    LayerChooserPlugin.prototype.remove = function remove() {
	        this.map = null;
	    };
	
	    LayerChooserPlugin.prototype.onLayersChange = function onLayersChange(activeUuids) {
	        _liferayWidgetsReactWeb.ConfigActions.updateLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY), activeUuids);
	        this.reEvaluate({ activeUuids: activeUuids });
	    };
	
	    return LayerChooserPlugin;
	}();
	
	exports.default = LayerChooserPlugin;
	
	
	LayerChooserPlugin.contextTypes = {
	    contextId: _propTypes2.default.string
	};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getPropertiesFromLocalConfig = getPropertiesFromLocalConfig;
	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 14.10.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	/**
	 * Highlighted Polygon Style
	 */
	
	function getPropertiesFromLocalConfig(localConfig) {
	  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return localConfig && localConfig.properties || defaultValue;
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 05.09.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _LayerInfoSidebar = __webpack_require__(77);
	
	var _LayerInfoSidebar2 = _interopRequireDefault(_LayerInfoSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//https://stackoverflow.com/questions/30703212/how-to-convert-radius-in-metres-to-pixels-in-mapbox-leaflet
	// used to define a buffer around the clicked point
	var getMetresPerPixel = function getMetresPerPixel(map) {
	    return 40075016.686 * Math.abs(Math.cos(map.getCenter().lat * Math.PI / 180)) / Math.pow(2, map.getZoom() + 8);
	};
	
	var LayerInfoPlugin = function () {
	    function LayerInfoPlugin(props, config) {
	        _classCallCheck(this, LayerInfoPlugin);
	
	        this.config = config;
	        this.props = props;
	
	        this._marker = _leaflet2.default.marker([0, 0], {
	            icon: _leaflet2.default.icon({
	                iconUrl: '/o/de.xdot.liferay.map.web/icons/pin.png',
	                popupAnchor: [0, -64],
	                iconSize: [28, 56],
	                iconAnchor: [14, 56]
	            })
	        });
	
	        this.onMapClick = this.onMapClick.bind(this);
	        this.updateTitle = this.updateTitle.bind(this);
	        this.onHide = this.onHide.bind(this);
	    }
	
	    LayerInfoPlugin.prototype.withCtx = function withCtx(s) {
	        return (this.context && this.context.contextId ? this.context.contextId : 'DEFAULT_') + s;
	    };
	
	    LayerInfoPlugin.prototype.initOptions = function initOptions(o) {
	        this.o = o;
	        return this.options(o);
	    };
	
	    LayerInfoPlugin.prototype.options = function options(o) {
	        return o;
	    };
	
	    LayerInfoPlugin.prototype.init = function init(map, o, reEvaluate) {
	        var _this = this;
	
	        this.reEvaluate = reEvaluate;
	        this._map = map;
	        var sidebarContent = _leaflet2.default.DomUtil.create('div', '', map.getContainer());
	        var btn = _leaflet2.default.DomUtil.create('div', 'sidebar-btn right');
	        btn.setAttribute('role', 'button');
	        btn.setAttribute('title', 'Themen & Lagekarten');
	        this.btnContent = _leaflet2.default.DomUtil.create('div', 'sidebar-btn__content', btn);
	        this.sidebar = _leaflet2.default.control.sidebar(sidebarContent, { position: 'right', closeButton: false });
	
	        this.sidebar.on('show', this.updateTitle);
	        this.sidebar.on('hide', this.onHide);
	        this.updateTitle();
	
	        map.addControl(this.sidebar);
	        var content = this.sidebar.getContainer();
	        btn.onclick = function (e) {
	            _leaflet2.default.DomEvent.stopPropagation(e);
	            _leaflet2.default.DomEvent.preventDefault(e);
	            _this.sidebar.toggle();
	        };
	        content.parentNode.insertBefore(btn, content);
	
	        this._map.on('click', this.onMapClick);
	    };
	
	    LayerInfoPlugin.prototype.updateTitle = function updateTitle() {
	        var icon = this.sidebar.isVisible() ? 'left' : 'right';
	        this.btnContent.innerHTML = '<span class="sidebar-situationmap-name">' + 'Objektinfo & Legende' + '</span>' + '<span class="icon icon-fliwas-arrow-' + icon + ' left" title=""></span>';
	    };
	
	    LayerInfoPlugin.prototype.onHide = function onHide() {
	        this.updateTitle();
	        this._marker.remove();
	    };
	
	    LayerInfoPlugin.prototype.update = function update(map, o) {
	        var _this2 = this;
	
	        this.o = o;
	        _reactDom2.default.render(_react2.default.createElement(_LayerInfoSidebar2.default, {
	            layerDescriptions: o.layerDescriptions,
	            onClose: function onClose() {
	                return _this2.sidebar.hide();
	            },
	            activeLayerUuids: this.o.activeUuids,
	            layers: this._map._layers,
	            latlng: this.latlng,
	            metresPerPixel: this.metresPerPixel
	        }), this.sidebar.getContainer());
	    };
	
	    LayerInfoPlugin.prototype.remove = function remove() {
	        this._map = null;
	    };
	
	    LayerInfoPlugin.prototype.onMapClick = function onMapClick(e) {
	        if (!this._map.blockingControlActive) {
	            var latlng = e.latlng;
	
	            this.latlng = latlng;
	            this.metresPerPixel = getMetresPerPixel(this._map);
	            this._marker.setLatLng(latlng);
	            this._marker.addTo(this._map);
	            this.sidebar.show();
	            this.reEvaluate({ latlng: latlng, metresPerPixel: this.metresPerPixel });
	        }
	    };
	
	    return LayerInfoPlugin;
	}();
	
	exports.default = LayerInfoPlugin;
	
	
	LayerInfoPlugin.contextTypes = {
	    contextId: _propTypes2.default.string
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                   * Date: 23.06.2016
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	__webpack_require__(79);
	
	__webpack_require__(81);
	
	var _LayerLegend = __webpack_require__(83);
	
	var _mapConfigUtil = __webpack_require__(10);
	
	var _ObjectInfoPreview = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getActiveLayerConfigs(layerConfigs, activeUuids) {
	    if (!layerConfigs || !activeUuids) {
	        return [];
	    }
	    return layerConfigs.reduce(function (acc, item) {
	        var isLayersSet = (0, _mapConfigUtil.isLayerSet)(item);
	        if (isLayersSet) {
	            acc = [].concat(acc, getActiveLayerConfigs(item.children, activeUuids));
	        } else if (!isLayersSet && activeUuids[item.uuid]) {
	            var typeKey = item.children && item.children[0] && item.children[0].typeKey;
	            acc.push(_extends({}, item, { typeKey: typeKey }));
	        }
	        return acc;
	    }, []);
	}
	
	function parseConfig(c) {
	    try {
	        return JSON.parse(c);
	    } catch (e) {
	        console.warn(e);
	        return undefined;
	    }
	}
	
	function getActiveLegends(layerConfigs, activeUuids) {
	    if (!layerConfigs || !activeUuids) {
	        return [];
	    }
	    return layerConfigs.reduce(function (acc, item) {
	        var isLayersSet = (0, _mapConfigUtil.isLayerSet)(item);
	        if (isLayersSet) {
	            var activeLayerSetLayers = getActiveLayerConfigs(item.children, activeUuids);
	            if (activeLayerSetLayers.length > 0 && item.config) {
	                var configJson = parseConfig(item.config);
	                if (configJson && configJson.legend && activeLayerSetLayers.length > 0) {
	                    acc.push({
	                        title: item.title,
	                        legend: configJson.legend,
	                        legendClass: configJson.legendClass || '',
	                        legendTitleSuffix: configJson.legendTitleSuffix || ''
	                    });
	                } else {
	                    acc = [].concat(acc, getActiveLegends(item.children, activeUuids));
	                }
	            } else {
	                acc = [].concat(acc, getActiveLegends(item.children, activeUuids));
	            }
	        } else if (!isLayersSet && activeUuids[item.uuid]) {
	            var configString = item.children && item.children[0] && item.children[0].config;
	            var _configJson = parseConfig(configString);
	            if (_configJson && _configJson.legend) {
	                acc.push({
	                    title: item.title,
	                    legend: _configJson.legend,
	                    legendClass: _configJson.legendClass || '',
	                    legendTitleSuffix: _configJson.legendTitleSuffix || ''
	                });
	            }
	        }
	        return acc;
	    }, []);
	}
	
	var LayerInfoSidebar = function LayerInfoSidebar(_ref) {
	    var layerDescriptions = _ref.layerDescriptions,
	        onClose = _ref.onClose,
	        activeLayerUuids = _ref.activeLayerUuids,
	        layers = _ref.layers,
	        latlng = _ref.latlng,
	        metresPerPixel = _ref.metresPerPixel;
	
	    var _useState = (0, _react.useState)('object-info'),
	        activeTab = _useState[0],
	        setActiveTab = _useState[1];
	
	    var activeLayerConfigs = layerDescriptions && getActiveLayerConfigs(layerDescriptions, activeLayerUuids);
	    var legends = layerDescriptions && getActiveLegends(layerDescriptions, activeLayerUuids);
	
	    (0, _react.useEffect)(function () {
	        setActiveTab('object-info');
	    }, [latlng]);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'layer-chooser' },
	        _react2.default.createElement(
	            _liferayWidgetsReactWeb.Header,
	            { onClose: onClose },
	            _react2.default.createElement(
	                'h3',
	                { className: 'm-0 leaflet-sidebar__title' },
	                'Objektinfo & Legende'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'layer-chooser__content' },
	            _react2.default.createElement(
	                _reactBootstrap.Tabs,
	                {
	                    activeKey: activeTab,
	                    onSelect: setActiveTab
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'object-info', title: 'Objektinfo' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'py-2' },
	                        _react2.default.createElement(_ObjectInfoPreview.ObjectInfoPreview, {
	                            layerConfigs: activeLayerConfigs,
	                            layers: layers,
	                            latlng: latlng,
	                            metresPerPixel: metresPerPixel
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'legend', title: 'Legende' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'py-2' },
	                        _react2.default.createElement(_LayerLegend.LayerLegend, {
	                            legends: legends,
	                            onClose: onClose
	                        })
	                    )
	                )
	            )
	        )
	    );
	};
	
	LayerInfoSidebar.propTypes = {
	    layerDescriptions: _propTypes2.default.array,
	    activeLayerUuids: _propTypes2.default.object,
	    onClose: _propTypes2.default.func,
	    layers: _propTypes2.default.object,
	    latlng: _propTypes2.default.object,
	    metresPerPixel: _propTypes2.default.number
	};
	
	exports.default = LayerInfoSidebar;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_78__;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(80);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./treelist.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./treelist.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".rc-tree{margin:0;padding:0;list-style:none}.rc-tree li a{height:30px}", ""]);
	
	// exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(82);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./layer-chooser.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./layer-chooser.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".layer-chooser .rc-tree .rc-tree-treenode{display:flex;flex-direction:row;align-items:center;height:27px}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-indent .rc-tree-indent-unit{width:32px}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-node-content-wrapper{white-space:normal;display:flex;flex-direction:row;align-items:center;justify-content:center;height:auto;line-height:1.75;padding:2px 0}.layer-chooser .rc-tree .rc-tree-treenode.rc-tree-treenode-switcher-close,.layer-chooser .rc-tree .rc-tree-treenode.rc-tree-treenode-switcher-open{background-color:#f3f3f4}.layer-chooser .rc-tree .rc-tree-treenode .badge{background-color:#326487;color:#fff;padding-bottom:0}.layer-chooser .rc-tree .rc-tree-treenode span.rc-tree-switcher{background-image:none;background-color:#3ba9ea;color:#fff;display:flex;align-items:center;justify-content:center;width:26px;height:26px;flex-shrink:0}.layer-chooser .rc-tree .rc-tree-treenode span.rc-tree-checkbox,.layer-chooser .rc-tree .rc-tree-treenode span.rc-tree-switcher-noop{display:none}.layer-chooser .rc-tree .rc-tree-treenode span.rc-tree-iconEle.rc-tree-icon__customize{width:1.2em;height:1.2em;line-height:1.2em;font-size:1.2em;color:#3ba9ea}.layer-chooser .rc-tree .rc-tree-treenode span.rc-tree-iconEle.rc-tree-icon__customize:has(span.invisible){width:0}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-title{display:flex}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-title .rc-tree-title__info-button{margin-left:0;margin-bottom:0;padding:0 8px;font-size:14px;border:0}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-title .rc-tree-title__info-button:hover{background-color:transparent;color:#3ba9ea}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-title .rc-tree-title__info-button:focus{box-shadow:none}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-title:has(.rc-tree-title__logical_layer) .rc-tree-title__info-button{height:16px}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-title .rc-tree-title__layerset{display:inline-block;max-width:250px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.layer-chooser .rc-tree .rc-tree-treenode .rc-tree-title .rc-tree-title__logical_layer{max-width:250px;line-height:120%}.layer-chooser .nav-tabs .nav-item.active,.layer-chooser .tab-content{background:#fff}.layer-chooser .tab-content{box-shadow:none;border:none;padding:0}.layer-chooser .nav-tabs>.nav-item{flex:1;display:flex;justify-content:center}.layer-chooser__info-popup{z-index:1051;max-width:400px!important}.layer-chooser__content{padding:0 16px}", ""]);
	
	// exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LayerLegend = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * User: n.gorte
	                                                                                                                                                                                                                                                                   * Date: 20.06.2022
	                                                                                                                                                                                                                                                                   * Time: 15:52
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayerLegend = exports.LayerLegend = function LayerLegend(_ref) {
	    var _ref$legends = _ref.legends,
	        legends = _ref$legends === undefined ? [] : _ref$legends,
	        onClose = _ref.onClose;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'fliwas-map-legend-container' },
	        _react2.default.createElement(
	            'ul',
	            { className: 'fliwas-map-legend' },
	            legends.length === 0 && _react2.default.createElement(
	                'li',
	                { className: 'fliwas-map-legend__section-item' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Keine Legenden gefunden'
	                )
	            ),
	            legends.map(function (item) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: item.title, className: 'fliwas-map-legend__section-item ' + item.legendClass },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'fliwas-map-legend__section-item-title' },
	                        item.title,
	                        ' ',
	                        item.legendTitleSuffix
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'list-group fliwas-map-legend__item-list' },
	                        item.legend.map(function (legendElem, i) {
	                            return _react2.default.createElement(LegendItem, _extends({
	                                key: legendElem.label + ' - ' + i }, legendElem));
	                        })
	                    )
	                );
	            })
	        )
	    );
	};
	
	LayerLegend.propTypes = {
	    legends: _propTypes2.default.array,
	    onClose: _propTypes2.default.func
	};
	
	var LegendItem = function LegendItem(_ref2) {
	    var label = _ref2.label,
	        icon = _ref2.icon;
	    var type = icon.type,
	        color = icon.color,
	        fillColor = icon.fillColor,
	        url = icon.url,
	        borderWidth = icon.borderWidth,
	        style = icon.style;
	
	    return _react2.default.createElement(
	        'li',
	        { className: 'fliwas-map-legend__item' },
	        url && Array.isArray(url) && url.map(function (u) {
	            return _react2.default.createElement('img', { style: style, key: u, src: u,
	                className: 'fliwas-map-legend__item__image' });
	        }),
	        url && !Array.isArray(url) && _react2.default.createElement('img', { style: style, src: url, className: 'fliwas-map-legend__item__image' }),
	        !url && _react2.default.createElement(LegendItemIcon, {
	            type: type,
	            style: style,
	            color: color,
	            fillColor: fillColor,
	            borderWidth: borderWidth
	        }),
	        _react2.default.createElement('span', {
	            className: 'fliwas-map-legend__item__label',
	            dangerouslySetInnerHTML: { __html: label }
	        })
	    );
	};
	
	LegendItem.propTypes = {
	    label: _propTypes2.default.string.isRequired,
	    icon: _propTypes2.default.shape({
	        type: _propTypes2.default.oneOf(['area', 'line', 'point', 'custom']),
	        url: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	        color: _propTypes2.default.string,
	        fillColor: _propTypes2.default.string,
	        borderWidth: _propTypes2.default.number
	    }).isRequired
	};
	
	var LegendItemIcon = function LegendItemIcon(_ref3) {
	    var type = _ref3.type,
	        color = _ref3.color,
	        fillColor = _ref3.fillColor,
	        borderWidth = _ref3.borderWidth,
	        style = _ref3.style;
	
	    var className = 'fliwas-map-legend__item__icon fliwas-map-legend__item__icon--' + type;
	
	    var _style = style ? style : {
	        borderColor: color || 'transparent',
	        backgroundColor: fillColor || 'transparent',
	        borderWidth: borderWidth || (color ? '1px' : '0px')
	    };
	
	    return _react2.default.createElement('div', { className: className, style: _style });
	};
	
	LegendItemIcon.propTypes = {
	    type: _propTypes2.default.oneOf(['area', 'line', 'point', 'custom']).isRequired,
	    color: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    fillColor: _propTypes2.default.string,
	    borderWidth: _propTypes2.default.number
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(85);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./legend.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./legend.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".fliwas-map-legend-container__title{font-size:14px;font-weight:700;color:#676a6c;margin-bottom:10px}.fliwas-map-legend,.fliwas-map-legend__item-list{padding-left:0;margin-bottom:0;list-style:none}.fliwas-map-legend{padding:0 16px}.fliwas-map-legend__section-item{margin-bottom:8px;font-size:12px;line-height:1.5}.fliwas-map-legend__section-item-title{font-weight:700}.fliwas-map-legend__item{display:flex;flex-direction:row;align-items:center;line-height:1;padding:4px 0}.fliwas-map-legend__item__image{width:22px;max-width:32px;margin-right:12px;max-height:32px;object-fit:contain}.fliwas-map-legend__item__icon{height:22px;width:22px;margin-right:12px;flex-shrink:0}.fliwas-map-legend__item__icon--point{border-radius:100%;border-width:2px;border-style:solid}.fliwas-map-legend__item__icon--line{height:2px;border-width:1px;border-style:solid}.fliwas-map-legend__item__icon--area{border-width:2px;border-style:solid}.rain-radar-legend .fliwas-map-legend__item{padding:10px 0 0}.rain-radar-legend .fliwas-map-legend__item~.fliwas-map-legend__item{padding:0}.rain-radar-legend .fliwas-map-legend__item .fliwas-map-legend__item__label{position:relative;top:-10px}", ""]);
	
	// exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ObjectInfoPreview = undefined;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(87);
	
	var _CartoObjectInfoItem = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User: n.gorte
	 * Date: 06.07.2022
	 * Time: 13:39
	 */
	
	var ObjectInfoPreview = exports.ObjectInfoPreview = function ObjectInfoPreview(_ref) {
	    var layerConfigs = _ref.layerConfigs,
	        layers = _ref.layers,
	        latlng = _ref.latlng,
	        metresPerPixel = _ref.metresPerPixel;
	
	    if (!layerConfigs || !layers || !latlng || !metresPerPixel) {
	        return null;
	    }
	    layerConfigs = layerConfigs.filter(function (item) {
	        return item.typeKey !== 'remote-data-layer' && item.typeKey !== 'remote-vector-layer';
	    });
	    return _react2.default.createElement(
	        'ul',
	        { className: 'list-group m-0' },
	        layerConfigs && layerConfigs.map(function (layerConfig) {
	            var layer = layers && Object.keys(layers).reduce(function (acc, key) {
	                var l = layers[key];
	                if (l.id === layerConfig.uuid || l.logicalLayerId === layerConfig.id) {
	                    acc = layers[key];
	                }
	                return acc;
	            }, null);
	            var ObjectInfoItem = layer && layer.controller && layer.controller.getObjectInfoItem && layer.controller.getObjectInfoItem();
	
	            if (ObjectInfoItem) {
	                return _react2.default.createElement(ObjectInfoItem, {
	                    key: layerConfig.id,
	                    layerConfig: layerConfig,
	                    layer: layer
	                });
	            }
	
	            if (layerConfig.typeKey === 'cartodb') {
	                return _react2.default.createElement(_CartoObjectInfoItem.CartoObjectInfoItem, {
	                    key: layerConfig.id,
	                    layerConfig: layerConfig,
	                    latlng: latlng,
	                    metresPerPixel: metresPerPixel
	                });
	            }
	            return _react2.default.createElement(
	                'li',
	                { className: 'list-group-item leaflet-object-info__item', key: layerConfig.id },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'leaflet-object-info__item__title mb-2' },
	                    layerConfig.title
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'leaflet-object-info__item__nodata' },
	                    'Keine weiteren Fachinformationen vorhanden.'
	                )
	            );
	        })
	    );
	};
	
	ObjectInfoPreview.propTypes = {
	    latlng: _propTypes2.default.object,
	    layerConfigs: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    layers: _propTypes2.default.object,
	    metresPerPixel: _propTypes2.default.number
	};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(88);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./object-info.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./object-info.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-object-info .leaflet-popup-content{margin:8px;max-height:450px;overflow:auto}.leaflet-object-info .leaflet-popup-close-button{color:#676a6c!important}.leaflet-object-info__item{padding:.5rem}.leaflet-object-info__item__title,.leaflet-object-info__item__topic{display:block;font-weight:700;font-size:12px;color:#676a6c}.leaflet-object-info__item__icon{margin-right:1rem;width:24px;height:24px;object-fit:contain}.leaflet-object-info__item__title{font-weight:400}.leaflet-object-info__item__error,.leaflet-object-info__item__nodata{display:block;margin:0}", ""]);
	
	// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CartoObjectInfoItem = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * User: n.gorte
	                                                                                                                                                                                                                                                                   * Date: 06.07.2022
	                                                                                                                                                                                                                                                                   * Time: 16:16
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COLLAPSE_THRESHOLD = 5;
	
	var sqlQuery = function sqlQuery(layers, latlng, metresPerPixel) {
	    var unionTable = layers.reduce(function (acc, layer, i) {
	        acc += '\n        ' + layer.sql + '\n        ' + (i < layers.length - 1 ? ' UNION ALL ' : '') + '\n    ';
	        return acc;
	    }, '');
	    var q = '\n        SELECT title, topic, url, icon,\n        values, ST_Distance(the_geom_webmercator, ST_Transform(ST_PointFromText(\'POINT(' + latlng.lng + ' ' + latlng.lat + ')\', 4326), 3857)) AS distance\n        FROM (' + unionTable + ') as t\n        WHERE ST_DWithin(t.the_geom_webmercator\n            , ST_Transform(ST_PointFromText(\'POINT(' + latlng.lng + ' ' + latlng.lat + ')\'\n            , 4326)\n            , 3857)\n            , ' + metresPerPixel * 10 + ')\n        ORDER BY distance\n    ';
	    return encodeURIComponent(q);
	};
	
	var fetchCartoFeatureInfo = function fetchCartoFeatureInfo(_ref) {
	    var client = _ref.client,
	        layers = _ref.layers,
	        latlng = _ref.latlng,
	        metresPerPixel = _ref.metresPerPixel;
	
	    return fetch('https://' + client.username + '.carto.com/api/v2/sql?q=' + sqlQuery(layers, latlng, metresPerPixel) + '&api_key=' + client.apiKey);
	};
	
	function reducer(state, action) {
	    switch (action.type) {
	        case 'SET_STATE':
	            return _extends({}, state, action.payload);
	        default:
	            return state;
	    }
	}
	
	var CartoObjectInfoItem = exports.CartoObjectInfoItem = function CartoObjectInfoItem(_ref2) {
	    var layerConfig = _ref2.layerConfig,
	        latlng = _ref2.latlng,
	        metresPerPixel = _ref2.metresPerPixel;
	
	    var config = JSON.parse(layerConfig.children[0].config);
	    var client = config.client,
	        layers = config.layers;
	
	    var _useReducer = (0, _react.useReducer)(reducer, {
	        feature: null,
	        values: null,
	        error: false,
	        count: 0,
	        collapsed: false
	    }),
	        state = _useReducer[0],
	        dispatch = _useReducer[1];
	
	    var feature = state.feature,
	        values = state.values,
	        error = state.error,
	        collapsed = state.collapsed,
	        count = state.count;
	
	
	    (0, _react.useEffect)(function () {
	        fetchCartoFeatureInfo({ client: client, layers: layers, latlng: latlng, metresPerPixel: metresPerPixel }).then(function (response) {
	            return response.json();
	        }).then(function (data) {
	            dispatch({
	                type: 'SET_STATE',
	                payload: {
	                    feature: data.rows[0],
	                    error: false
	                }
	            });
	        }).catch(function () {
	            dispatch({
	                type: 'SET_STATE',
	                payload: {
	                    feature: null,
	                    error: true
	                }
	            });
	        });
	    }, [latlng]);
	
	    (0, _react.useEffect)(function () {
	        if (feature) {
	            var _values = feature.values;
	
	            try {
	                if (_values && _values.length > 0) {
	                    var valuesJson = JSON.parse(_values);
	                    var _count = Object.keys(valuesJson).length;
	                    dispatch({
	                        type: 'SET_STATE',
	                        payload: {
	                            values: valuesJson,
	                            count: _count,
	                            collapsed: _count > COLLAPSE_THRESHOLD
	                        }
	                    });
	                } else {
	                    dispatch({
	                        type: 'SET_STATE',
	                        payload: {
	                            values: null,
	                            count: 0,
	                            collapsed: false
	                        }
	                    });
	                }
	            } catch (e) {
	                dispatch({
	                    type: 'SET_STATE',
	                    payload: {
	                        values: null,
	                        count: 0,
	                        error: true
	                    }
	                });
	            }
	        }
	    }, [feature]);
	
	    var toggleCollapse = function toggleCollapse() {
	        dispatch({ type: 'SET_STATE', payload: { collapsed: !collapsed } });
	    };
	
	    if (!error && !feature) {
	        return null;
	    }
	
	    return _react2.default.createElement(
	        'li',
	        { className: 'list-group-item leaflet-object-info__item' },
	        _react2.default.createElement(
	            'div',
	            { className: 'd-flex align-items-center mb-2' },
	            feature.icon && _react2.default.createElement('img', { src: feature.icon, className: 'leaflet-object-info__item__icon' }),
	            _react2.default.createElement(
	                'div',
	                null,
	                feature && feature.topic && feature.topic !== '' && _react2.default.createElement(
	                    'span',
	                    { className: 'leaflet-object-info__item__topic' },
	                    feature.topic
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'leaflet-object-info__item__title' },
	                    feature.title || layerConfig.title
	                )
	            )
	        ),
	        error && _react2.default.createElement(
	            'span',
	            { className: 'leaflet-object-info__item__error' },
	            'Daten konnten nicht geladen werden.'
	        ),
	        !error && !values && _react2.default.createElement(
	            'span',
	            { className: 'leaflet-object-info__item__nodata' },
	            'Keine weiteren Fachinformationen vorhanden.'
	        ),
	        !error && values && _react2.default.createElement(
	            _reactBootstrap.Table,
	            { striped: true, size: 'sm', borderless: true },
	            _react2.default.createElement(
	                'tbody',
	                null,
	                Object.keys(values).filter(function (v, i) {
	                    return collapsed ? i < COLLAPSE_THRESHOLD : true;
	                }).map(function (key) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: key },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            key
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            values[key]
	                        )
	                    );
	                }),
	                feature.url.length > 0 && _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'Url'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: feature.url, target: '_blank', rel: 'noopener noreferrer' },
	                            feature.url
	                        )
	                    )
	                )
	            )
	        ),
	        count > COLLAPSE_THRESHOLD && _react2.default.createElement(
	            'div',
	            { className: 'd-flex my-2 justify-content-end' },
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'link',
	                    onClick: toggleCollapse
	                },
	                collapsed ? 'Mehr ' : 'Weniger ',
	                _react2.default.createElement('span', { className: 'icon icon-fliwas-arrow-' + (collapsed ? 'down' : 'up') })
	            )
	        )
	    );
	};
	
	CartoObjectInfoItem.propTypes = {
	    layerConfig: _propTypes2.default.object,
	    latlng: _propTypes2.default.object,
	    metresPerPixel: _propTypes2.default.number
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 05.07.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _DrawerGeoJsonLayer = __webpack_require__(91);
	
	var _DrawerGeoJsonLayer2 = _interopRequireDefault(_DrawerGeoJsonLayer);
	
	var _translateLeafletDrawer = __webpack_require__(66);
	
	var _translateLeafletDrawer2 = _interopRequireDefault(_translateLeafletDrawer);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _TextLabelControl = __webpack_require__(93);
	
	var _ColorSelectControl = __webpack_require__(94);
	
	var _ColorPickerControl = __webpack_require__(95);
	
	var _TextLabelIcon = __webpack_require__(92);
	
	var _featureUtil = __webpack_require__(8);
	
	var _SvgMarkers = __webpack_require__(96);
	
	var _icons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	_leaflet2.default.LayerGroup.include({
	    toGeoJSON: function toGeoJSON(precision) {
	        var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	        if (type === 'MultiPoint') {
	            return this.toMultiPoint(precision);
	        }
	
	        var isGeometryCollection = type === 'GeometryCollection',
	            jsons = [];
	
	        this.eachLayer(function (layer) {
	            if (layer.toGeoJSON) {
	                var json = layer.toGeoJSON(precision);
	                if (layer.options.radius) {
	                    json.properties.radius = layer._mRadius;
	                }
	                if (isGeometryCollection) {
	                    jsons.push(json.geometry);
	                } else {
	                    var feature = (0, _featureUtil.asFeature)(json);
	                    // Squash nested feature collections
	                    if (feature.type === 'FeatureCollection') {
	                        jsons.push.apply(jsons, feature.features);
	                    } else {
	                        jsons.push(feature);
	                    }
	                }
	            }
	        });
	
	        if (isGeometryCollection) {
	            return (0, _featureUtil.getFeature)(this, {
	                geometries: jsons,
	                type: 'GeometryCollection'
	            });
	        }
	
	        return {
	            type: 'FeatureCollection',
	            features: jsons
	        };
	    }
	});
	
	var DrawerPlugin = function () {
	    function DrawerPlugin(props) {
	        _classCallCheck(this, DrawerPlugin);
	
	        console.log('Drawer constructor()');
	        this.openTextLabelModal = props.openTextLabelModal && props.openTextLabelModal.bind(this);
	        this.onDrawerChange = props.onDrawerChange && props.onDrawerChange.bind(this);
	
	        this.handleTextLabelClick = this.handleTextLabelClick.bind(this);
	        this.handleIconLabelClick = this.handleIconLabelClick.bind(this);
	        this.handleLayerClick = this.handleLayerClick.bind(this);
	        this.toggleColorPickerControl = this.toggleColorPickerControl.bind(this);
	        this.onToggleTextLabelControl = this.onToggleTextLabelControl.bind(this);
	        this.disableTextLabelControl = this.disableTextLabelControl.bind(this);
	        this.disableColorPickerControl = this.disableColorPickerControl.bind(this);
	        this.block = this.block.bind(this);
	        this.unblock = this.unblock.bind(this);
	
	        this.boundRequestHandled = false;
	        this.boundRequestCb = this.boundRequestCb.bind(this);
	
	        this.drawerColor = '#0000FF';
	
	        this.o = {};
	    }
	
	    DrawerPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        this.o = o;
	        (0, _liferayWidgetsReactWeb.amdRequire)(['FlexiColorPicker', 'leaflet-draw', 'css!leaflet-draw-css'], function () {
	            var _o = _this.o,
	                drawerGeoJSON = _o.drawerGeoJSON,
	                _o$drawOptions = _o.drawOptions,
	                drawOptions = _o$drawOptions === undefined ? {} : _o$drawOptions,
	                _o$drawerPluginTextLa = _o.drawerPluginTextLabel,
	                drawerPluginTextLabel = _o$drawerPluginTextLa === undefined ? true : _o$drawerPluginTextLa,
	                _o$drawerPluginColorP = _o.drawerPluginColorPicker,
	                drawerPluginColorPicker = _o$drawerPluginColorP === undefined ? true : _o$drawerPluginColorP;
	
	            (0, _translateLeafletDrawer2.default)();
	            _this.map = map;
	            map.options.drawControl = true;
	
	            var options = {
	                onEachFeature: function onEachFeature(feature, layer) {
	                    var onClick = _this.handleLayerClick;
	                    if (layer.drawerType === 'TextLabel') {
	                        onClick = _this.handleTextLabelClick;
	                    } else if (layer.drawerType === 'IconLabel') {
	                        onClick = _this.handleIconLabelClick;
	                    }
	                    layer.on('click', onClick);
	                }
	            };
	
	            _this.drawerGeoJsonLayer = new _DrawerGeoJsonLayer2.default(drawerGeoJSON, options).addTo(map);
	
	            _this.drawControl = new _leaflet2.default.Control.Draw({
	                draw: _extends({
	                    //circle: false,
	                    circlemarker: false
	                }, drawOptions),
	                edit: {
	                    featureGroup: _this.drawerGeoJsonLayer,
	                    edit: {
	                        selectedPathOptions: {
	                            maintainColor: true
	                        }
	                    }
	                }
	            });
	
	            map.addControl(_this.drawControl);
	
	            if (drawerPluginTextLabel) {
	                _this.textLabelControl = new _TextLabelControl.TextLabelControl({ onClick: _this.onToggleTextLabelControl });
	                map.addControl(_this.textLabelControl);
	            }
	
	            if (drawerPluginColorPicker) {
	                _this.colorPickerControl = new _ColorPickerControl.ColorPickerControl();
	                _this.colorSelectionControl = new _ColorSelectControl.ColorSelectControl({
	                    onClick: _this.toggleColorPickerControl,
	                    color: _this.drawerColor
	                });
	                map.addControl(_this.colorSelectionControl);
	            }
	            _this.updateDrawingOptions();
	
	            //map.on('click', this.handleClick.bind(this));
	            map.on('mousedown', _this.handleClick.bind(_this));
	            map.on('touchstart', _this.handleClick.bind(_this));
	
	            map.on(_leaflet2.default.Draw.Event.CREATED, _this.handleCreated.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.EDITED, _this.handleEdited.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.DELETED, _this.handleDeleted.bind(_this));
	
	            map.on(_leaflet2.default.Draw.Event.DRAWSTART, _this.handleDrawStart.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.DRAWSTOP, _this.handleDrawStop.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.EDITSTART, _this.handleEditStart.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.EDITSTOP, _this.handleEditStop.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.DELETESTART, _this.handleDeleteStart.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.DELETESTOP, _this.handleDeleteStop.bind(_this));
	        });
	    };
	
	    DrawerPlugin.prototype.initOptions = function initOptions(o) {
	        var drawerGeoJSON = o.drawerGeoJSON;
	        //todo use a  simple fast bound calc algo
	
	        var drawerGeoJsonLayer = new _DrawerGeoJsonLayer2.default(drawerGeoJSON);
	        var bounds = drawerGeoJsonLayer.getBounds();
	        if (bounds.isValid()) {
	            o.boundRequest = {
	                bounds: bounds,
	                options: { animate: false },
	                cb: this.boundRequestCb
	            };
	        }
	        return o;
	    };
	
	    DrawerPlugin.prototype.update = function update(map, o) {
	        var _ref = o || {},
	            drawerGeoJSON = _ref.drawerGeoJSON,
	            drawerTextLabel = _ref.drawerTextLabel;
	
	        if (drawerGeoJSON && this.drawerGeoJsonLayer && !this.editControlActive && !this.deleteControlActive) {
	            this.drawerGeoJsonLayer.clearLayers();
	            this.drawerGeoJsonLayer.addData(drawerGeoJSON);
	        }
	
	        if (drawerTextLabel && drawerTextLabel.edited) {
	            this.handleTextLabelEdited(drawerTextLabel);
	        }
	    };
	
	    DrawerPlugin.prototype.updateDrawingOptions = function updateDrawingOptions() {
	        if (this.colorSelectionControl) {
	            this.colorSelectionControl.setColor(this.drawerColor);
	        }
	
	        this.drawControl.setDrawingOptions({
	            polygon: {
	                shapeOptions: {
	                    color: this.drawerColor
	                }
	            },
	            polyline: {
	                shapeOptions: {
	                    color: this.drawerColor
	                }
	            },
	            rectangle: {
	                shapeOptions: {
	                    color: this.drawerColor
	                }
	            },
	            circle: {
	                shapeOptions: {
	                    color: this.drawerColor
	                }
	            },
	            // use ClassName marker based on ClassName(type) or default
	            marker: this.o.type ? { icon: (0, _icons.boIcon)(this.o.type) } : {
	                icon: _leaflet2.default.divIcon({
	                    html: (0, _SvgMarkers.svgMarkerIcon)(this.drawerColor),
	                    className: 'svg-icon',
	                    iconSize: [32, 52],
	                    iconAnchor: [16, 52]
	                })
	            }
	        });
	    };
	
	    DrawerPlugin.prototype.boundRequestCb = function boundRequestCb() {
	        this.boundRequestHandled = true;
	    };
	
	    DrawerPlugin.prototype.onToggleTextLabelControl = function onToggleTextLabelControl(active) {
	        if (active) {
	            this.colorPickerControl.disable();
	        }
	    };
	
	    DrawerPlugin.prototype.disableTextLabelControl = function disableTextLabelControl() {
	        this.textLabelControl && this.textLabelControl.isActive() && this.textLabelControl.disable();
	    };
	
	    DrawerPlugin.prototype.disableColorPickerControl = function disableColorPickerControl() {
	        this.colorPickerControl && this.colorPickerControl.isActive() && this.colorPickerControl.disable();
	    };
	
	    DrawerPlugin.prototype.toggleColorPickerControl = function toggleColorPickerControl(e) {
	        var _this2 = this;
	
	        if (this.colorPickerControl) {
	            this.disableTextLabelControl();
	            if (!this.colorPickerControl.isActive()) {
	                this.colorPickerControl.enable();
	                this.map.addControl(this.colorPickerControl);
	                var slider = this.colorPickerControl.getSliderElement();
	                var picker = this.colorPickerControl.getPickerElement();
	                // eslint-disable-next-line no-undef
	                ColorPicker(slider, picker, function (hex) {
	                    _this2.drawerColor = hex;
	                    _this2.updateDrawingOptions();
	                });
	            } else {
	                this.disableColorPickerControl();
	                this.map.removeControl(this.colorPickerControl);
	            }
	        }
	    };
	
	    DrawerPlugin.prototype.handleClick = function handleClick(e) {
	        if (this.textLabelControl && this.textLabelControl.isActive()) {
	            this.textLabelControl.disable();
	            this.openTextLabelModal(e.latlng, null);
	        }
	    };
	
	    DrawerPlugin.prototype.handleLayerClick = function handleLayerClick(e) {
	        if (this.colorPickerControl && this.colorPickerControl.isActive()) {
	            _leaflet2.default.DomEvent.stop(e);
	            var clickedLayer = e.target;
	            clickedLayer.options.color = this.drawerColor;
	            this.transformToGeoJSON();
	        }
	    };
	
	    DrawerPlugin.prototype.handleTextLabelClick = function handleTextLabelClick(e) {
	        if (this.colorPickerControl && this.colorPickerControl.isActive()) {
	            this.handleLayerClick(e);
	        } else if (!this.deleteControlActive) {
	            this.disableTextLabelControl();
	            this.openTextLabelModal(e.latlng, e.target);
	        }
	    };
	
	    DrawerPlugin.prototype.handleTextLabelEdited = function handleTextLabelEdited(drawerTextLabel) {
	        var _this3 = this;
	
	        var oldLayer = drawerTextLabel.oldLayer,
	            text = drawerTextLabel.text;
	
	        var color = this.drawerColor;
	
	        if (oldLayer) {
	            this.drawerGeoJsonLayer.getLayers().forEach(function (layer) {
	                if (layer.options.id === oldLayer.options.id) {
	                    _this3.drawerGeoJsonLayer.removeLayer(layer);
	                }
	            });
	
	            color = oldLayer.options.color;
	        }
	
	        var textLabelMarker = _leaflet2.default.marker(drawerTextLabel.coordinates, {
	            icon: (0, _TextLabelIcon.textLabelIcon)(_extends({}, drawerTextLabel, {
	                color: color
	            })),
	            color: color,
	            title: text,
	            editFormData: _extends({}, drawerTextLabel, {
	                color: color
	            })
	        });
	
	        _leaflet2.default.Util.stamp(textLabelMarker);
	
	        this.handleCreated({ layer: textLabelMarker });
	    };
	
	    DrawerPlugin.prototype.handleIconLabelClick = function handleIconLabelClick(e) {
	        if (this.colorPickerControl && this.colorPickerControl.isActive()) {
	            var marker = e.target;
	            var newIcon = _leaflet2.default.divIcon({
	                html: (0, _SvgMarkers.svgMarkerIcon)(this.drawerColor),
	                className: 'svg-icon',
	                iconSize: [32, 52],
	                iconAnchor: [16, 52]
	            });
	            marker.setIcon(newIcon);
	            this.transformToGeoJSON();
	        } else if (!this.deleteControlActive) {
	            this.disableColorPickerControl();
	            this.disableTextLabelControl();
	        }
	    };
	
	    DrawerPlugin.prototype.handleCreated = function handleCreated(e) {
	        var layer = e.layer;
	        layer.options.color = layer.options.color || this.drawerColor;
	        _leaflet2.default.Util.stamp(layer);
	        this.drawerGeoJsonLayer.addLayer(layer);
	        this.transformToGeoJSON();
	    };
	
	    DrawerPlugin.prototype.handleEdited = function handleEdited(e) {
	        this.transformToGeoJSON();
	    };
	
	    DrawerPlugin.prototype.handleDeleted = function handleDeleted(e) {
	        var _this4 = this;
	
	        e.layers.getLayers().forEach(function (layer) {
	            _this4.drawerGeoJsonLayer.removeLayer(layer);
	        });
	
	        this.transformToGeoJSON();
	    };
	
	    DrawerPlugin.prototype.block = function block() {
	        this.map.blockingControlActive = true;
	    };
	
	    DrawerPlugin.prototype.unblock = function unblock() {
	        var _this5 = this;
	
	        /*
	        hacky but Leaflet Draw ensures closing click for rectangle creation is
	        propagated to map which triggers our LayerInfo plugin.
	        https://github.com/Leaflet/Leaflet.draw/blob/develop/src/draw/handler/Draw.Rectangle.js#L52
	        This ensures LayerInfo stays closed while drawing
	         */
	
	        setTimeout(function () {
	            _this5.map.blockingControlActive = false;
	        }, 300);
	    };
	
	    DrawerPlugin.prototype.handleDrawStart = function handleDrawStart() {
	        this.drawControlActive = true;
	        this.block();
	        this.disableTextLabelControl();
	        // this.disableColorPickerControl();
	    };
	
	    DrawerPlugin.prototype.handleDrawStop = function handleDrawStop() {
	        this.drawControlActive = false;
	        this.unblock();
	    };
	
	    DrawerPlugin.prototype.handleEditStart = function handleEditStart() {
	        this.editControlActive = true;
	        this.block();
	        this.disableTextLabelControl();
	        this.disableColorPickerControl();
	    };
	
	    DrawerPlugin.prototype.handleEditStop = function handleEditStop() {
	        this.editControlActive = false;
	        this.unblock();
	    };
	
	    DrawerPlugin.prototype.handleDeleteStart = function handleDeleteStart() {
	        this.deleteControlActive = true;
	        this.block();
	        this.disableTextLabelControl();
	        this.disableColorPickerControl();
	    };
	
	    DrawerPlugin.prototype.handleDeleteStop = function handleDeleteStop() {
	        this.deleteControlActive = false;
	        this.unblock();
	    };
	
	    DrawerPlugin.prototype.transformToGeoJSON = function transformToGeoJSON() {
	        var geoJSON = this.drawerGeoJsonLayer.toGeoJSON();
	        for (var i = 0; i < geoJSON.features.length; i++) {
	            var feature = geoJSON.features[i];
	            var layer = this.drawerGeoJsonLayer.getLayers()[i];
	
	            feature.style = _extends({}, feature.style, {
	                color: layer.options.color
	            });
	
	            //Ensure that Icon has properties before setting it, otherwise it disappears from the map after placing the marker
	            var hasIconProperties = Boolean(layer.options.icon && Object.keys(layer.options.icon.options).length);
	            feature.properties = _extends({}, feature.properties, {
	                icon: hasIconProperties ? layer.options.icon.options : null,
	                id: _leaflet2.default.Util.stamp(layer),
	                title: layer.options.title,
	                editFormData: layer.options.editFormData,
	                // set Icon based on object type if initial icon is null
	                type: this.o.type
	            });
	        }
	
	        this.onDrawerChange(geoJSON);
	    };
	
	    return DrawerPlugin;
	}();
	
	exports.default = DrawerPlugin;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Hibbeler on 11.02.2016.
	                                                                                                                                                                                                                                                                   */
	/**
	 * modded version of https://github.com/perliedman/leaflet-realtime/blob/master/src/L.Realtime.js
	 * Copyright (c) 2014, Per Liedman (per@liedman.net)
	 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
	 */
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _TextLabelIcon = __webpack_require__(92);
	
	var _icons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DrawerGeoJsonLayer = _leaflet2.default.GeoJSON.extend({
	    addData: function addData(geojson) {
	        var features = _leaflet2.default.Util.isArray(geojson) ? geojson : geojson.features,
	            i = void 0,
	            len = void 0,
	            feature = void 0;
	
	        if (features) {
	            for (i = 0, len = features.length; i < len; i++) {
	                // only add this if geometry or geometries are set and not null
	                feature = features[i];
	                if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
	                    this.addData(feature);
	                }
	            }
	            return this;
	        }
	
	        var options = this.options;
	
	        if (options.filter && !options.filter(geojson)) {
	            return this;
	        }
	
	        var layer = this.geometryToLayer(geojson, options);
	        if (!layer) {
	            return this;
	        }
	        //FIXME
	        //layer.feature = L.GeoJSON.asFeature(geojson);
	
	        layer.defaultOptions = layer.options;
	        this.resetStyle(layer);
	
	        if (options.onEachFeature) {
	            options.onEachFeature(geojson, layer);
	        }
	
	        return this.addLayer(layer);
	    },
	    geometryToLayer: function geometryToLayer(geojson, options) {
	        var properties = geojson.properties,
	            style = geojson.style,
	            geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
	            coords = geometry ? geometry.coordinates : null,
	            coordsToLatLng = options && options.coordsToLatLng || _leaflet2.default.GeoJSON.coordsToLatLng;
	
	
	        if (geometry.type === 'Point') {
	            if (properties && properties.title && properties.icon) {
	                var latlng = coordsToLatLng(coords);
	                var textLabelMarker = _leaflet2.default.marker(latlng, _extends({
	                    icon: (0, _TextLabelIcon.textLabelIcon)(_extends({}, properties.editFormData || {}, style)),
	                    id: properties.id,
	                    title: properties.title,
	                    editFormData: properties.editFormData
	                }, style));
	
	                textLabelMarker.drawerType = 'TextLabel';
	                return textLabelMarker;
	            } else if (properties && properties.radius) {
	                return new _leaflet2.default.Circle(coordsToLatLng(coords), _extends({}, properties, style));
	            } else if (properties && properties.icon) {
	                var _latlng = coordsToLatLng(coords);
	                var icon = properties.icon.html ? _leaflet2.default.divIcon(_extends({}, properties.icon)) : _leaflet2.default.icon(_extends({}, properties.icon));
	                var iconLabelMarker = _leaflet2.default.marker(_latlng, {
	                    icon: icon,
	                    id: properties.id
	                });
	                iconLabelMarker.drawerType = 'IconLabel';
	                return iconLabelMarker;
	            } else if (properties && !properties.icon && properties.type) {
	                //  PlannedActions should use a className based icon
	                var _latlng2 = coordsToLatLng(coords);
	                var _icon = (0, _icons.boIcon)(properties.type);
	                var iconMarker = _leaflet2.default.marker(_latlng2, {
	                    icon: _icon,
	                    id: properties.id
	                });
	                iconMarker.drawerType = 'IconMarker';
	                return iconMarker;
	            }
	        } else {
	            var layer = _leaflet2.default.GeoJSON.geometryToLayer(geojson, _extends({}, options, geojson.style));
	
	            if (!(layer instanceof _leaflet2.default.Path)) {
	                throw new Error('Unexpected layer type ' + layer);
	            }
	
	            return layer;
	        }
	    },
	    getBounds: function getBounds() {
	        var bounds = new _leaflet2.default.LatLngBounds();
	
	        for (var id in this._layers) {
	            var layer = this._layers[id];
	            if (layer.getBounds) {
	                try {
	                    bounds.extend(layer.getBounds());
	                } catch (e) {
	                    /**
	                     * bounds of circle layer can't be calculated if layer is not on map
	                     * https://github.com/Leaflet/Leaflet/issues/4978
	                     */
	                    console.warn('Fail to get bounds for layer', layer, 'Using layer center instead');
	                    bounds.extend(layer.getLatLng());
	                }
	            } else {
	                bounds.extend(layer.getLatLng());
	            }
	        }
	        return bounds;
	    }
	});
	
	exports.default = DrawerGeoJsonLayer;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * User: n.gorte
	 * Date: 26.10.2020
	 * Time: 15:39
	 */
	
	var textLabelIcon = exports.textLabelIcon = function textLabelIcon(_ref) {
	    var bold = _ref.bold,
	        size = _ref.size,
	        whiteBackground = _ref.whiteBackground,
	        underline = _ref.underline,
	        text = _ref.text,
	        color = _ref.color;
	
	    var fontSize = size && parseInt(size);
	    var backgroundColor = whiteBackground ? 'white' : '';
	    var fontWeight = bold ? 800 : 400;
	    var textDecoration = underline ? 'underline' : 'none';
	
	    return L.divIcon({
	        className: 'situation-map-text-label',
	        html: '<span style="color:' + color + '; font-size: ' + fontSize + 'px; font-weight: ' + fontWeight + '; text-decoration: ' + textDecoration + '; background-color: ' + backgroundColor + '">\n                    ' + text + '\n               </span>'
	    });
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TextLabelControl = undefined;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextLabelControl = exports.TextLabelControl = _leaflet2.default.Control.extend({
	    options: {
	        position: 'topleft'
	    },
	
	    initialize: function initialize(options) {
	        _leaflet2.default.Util.setOptions(this, options);
	        this._active = options.active || false;
	
	        this._onClick = this._onClick.bind(this);
	    },
	    onAdd: function onAdd(map) {
	        var container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
	
	        container.innerHTML = 'T';
	
	        container.style.backgroundColor = 'white';
	        container.style.color = 'black';
	        container.style.cursor = 'pointer';
	        container.style.fontSize = '20px';
	        container.style.height = '34px';
	        container.style.textAlign = 'center';
	        container.style.width = '34px';
	        container.title = 'Text einfügen';
	
	        container.onclick = this._onClick;
	
	        return container;
	    },
	    onRemove: function onRemove(map) {
	        this._container.onclick = null;
	        this._container = null;
	    },
	    enable: function enable() {
	        this._active = true;
	        this._container.style.backgroundColor = 'blue';
	        this._container.style.color = 'white';
	    },
	    disable: function disable() {
	        this._active = false;
	        this._container.style.backgroundColor = 'white';
	        this._container.style.color = 'black';
	    },
	    isActive: function isActive() {
	        return this._active;
	    },
	    _onClick: function _onClick(e) {
	        if (e) {
	            e.stopPropagation();
	        }
	        this._active = !this._active;
	        if (this._active) {
	            this.enable();
	        } else {
	            this.disable();
	        }
	        this.options.onClick && this.options.onClick(this._active);
	    }
	}); /**
	     * User: n.gorte
	     * Date: 20.10.2020
	     * Time: 16:13
	     */

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ColorSelectControl = undefined;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColorSelectControl = exports.ColorSelectControl = _leaflet2.default.Control.extend({
	    options: {
	        position: 'bottomleft'
	    },
	
	    initialize: function initialize(options) {
	        _leaflet2.default.Util.setOptions(this, options);
	        this._onClick = this._onClick.bind(this);
	    },
	    onAdd: function onAdd(map) {
	        var container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
	        container.style.backgroundColor = this.options.color;
	        container.style.cursor = 'pointer';
	        container.style.height = '26px';
	        container.style.width = '26px';
	        container.title = 'Farb-Auswahl';
	        container.onclick = this._onClick;
	        return container;
	    },
	    onRemove: function onRemove(map) {
	        this._container.onclick = null;
	        this._container = null;
	    },
	    enable: function enable() {
	        this._active = true;
	    },
	    disable: function disable() {
	        this._active = false;
	    },
	    isActive: function isActive() {
	        return this._active;
	    },
	    setColor: function setColor(color) {
	        this._container.style.backgroundColor = color;
	    },
	    _onClick: function _onClick(e) {
	        if (e) {
	            _leaflet2.default.DomEvent.stop(e);
	        }
	        this._active = !this._active;
	        if (this._active) {
	            this.enable();
	        } else {
	            this.disable();
	        }
	        this.options.onClick && this.options.onClick(this._active);
	    }
	}); /**
	     * User: n.gorte
	     * Date: 20.10.2020
	     * Time: 16:13
	     */

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ColorPickerControl = undefined;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColorPickerControl = exports.ColorPickerControl = _leaflet2.default.Control.extend({
	    options: {
	        position: 'bottomleft'
	    },
	
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	            active: false
	        };
	
	        _leaflet2.default.Util.setOptions(this, options);
	        this._active = options.active;
	    },
	    onAdd: function onAdd(map) {
	        this._map = map;
	        var container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
	
	        container.style.cursor = 'pointer';
	        container.style.height = '100px';
	        container.style.width = '130px';
	
	        var slider = document.createElement('div');
	        slider.style.float = 'left';
	        slider.style.height = '100px';
	        slider.style.width = '26px';
	        this._slider = slider;
	
	        var picker = document.createElement('div');
	        picker.style.float = 'right';
	        picker.style.height = '100px';
	        picker.style.width = '100px';
	        this._picker = picker;
	
	        container.appendChild(slider);
	        container.appendChild(picker);
	
	        container.addEventListener('mouseover', function () {
	            map.dragging.disable();
	        });
	        container.addEventListener('mouseout', function () {
	            map.dragging.enable();
	        });
	
	        container.addEventListener('click', function (e) {
	            _leaflet2.default.DomEvent.stop(e);
	        });
	
	        return container;
	    },
	    enable: function enable() {
	        this._active = true;
	    },
	    disable: function disable() {
	        this._active = false;
	    },
	    isActive: function isActive() {
	        return this._active;
	    },
	    getSliderElement: function getSliderElement() {
	        return this._slider;
	    },
	    getPickerElement: function getPickerElement() {
	        return this._picker;
	    }
	}); /**
	     * User: n.gorte
	     * Date: 20.10.2020
	     * Time: 16:13
	     */

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * User: n.gorte
	 * Date: 21.10.2020
	 * Time: 12:34
	 */
	
	var svgText = function svgText(_ref) {
	    var text = _ref.text,
	        color = _ref.color,
	        fontWeight = _ref.fontWeight,
	        textDecoration = _ref.textDecoration,
	        fontSize = _ref.fontSize;
	
	    return '\n                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="150" height="30" fill="white">\n                        <text x="50%" y="50%" \n                        dominant-baseline="middle" \n                        text-anchor="middle" \n                        fill="' + color + '" \n                        font-size="' + (fontSize || 12) + '" \n                        font-weight="' + fontWeight + '"\n                        text-decoration="' + textDecoration + '"\n                        >\n                            ' + text + '\n                        </text>\n                    </svg>\n            ';
	};
	
	var svgMarkers = exports.svgMarkers = function svgMarkers(_ref2) {
	    var text = _ref2.text,
	        color = _ref2.color,
	        fontWeight = _ref2.fontWeight,
	        textDecoration = _ref2.textDecoration,
	        fontSize = _ref2.fontSize;
	
	    return 'data:image/svg+xml,' + encodeURIComponent(svgText({ text: text, color: color, fontWeight: fontWeight, textDecoration: textDecoration, fontSize: fontSize }));
	};
	
	var svgMarkerIcon = exports.svgMarkerIcon = function svgMarkerIcon() {
	    var fill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#7A8BE7';
	    return '\n    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" \n   width="32.574287"\n   height="50.542145"\n    >   \n    <g transform="matrix(0.09285714,0,0,0.09285714,-0.69642859,-0.71500113)">\n        <g>\n            <path d="m 182.9,551.7 c 0,0.1 0.19999,0.3 0.19999,0.3 C 183.09999,552 358.3,283 358.3,194.6 358.3,64.5 269.5,7.900009 182.9,7.700012 96.3,7.9 7.5,64.5 7.5,194.6 7.5,283 182.8,552 182.8,552 c 0,0 0.1,-0.3 0.1,-0.3 z M 122.2,187.2 c 0,-33.6 27.2,-60.80001 60.8,-60.80001 33.6,0 60.8,27.2 60.8,60.80001 0,33.6 -27.3,60.8 -60.9,60.8 -33.5,0 -60.7,-27.2 -60.7,-60.8 z" stroke="none" fill="' + fill + '" fill-rule="nonzero" />\n        </g>\n    </g>\n    </svg>\n';
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 05.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GeometryEditControl = __webpack_require__(18);
	
	var _GeometryEditControl2 = _interopRequireDefault(_GeometryEditControl);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeometryInput = function (_React$Component) {
	    _inherits(GeometryInput, _React$Component);
	
	    function GeometryInput() {
	        _classCallCheck(this, GeometryInput);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    GeometryInput.prototype.render = function render() {
	        var _props = this.props,
	            hideLabel = _props.hideLabel,
	            InputElement = _props.InputElement,
	            geometry = _props.geometry,
	            formData = _props.formData,
	            featureProperties = _props.featureProperties,
	            _props$nameGeometry = _props.nameGeometry,
	            nameGeometry = _props$nameGeometry === undefined ? 'geometry' : _props$nameGeometry,
	            type = _props.type,
	            required = _props.required,
	            otherProps = _objectWithoutProperties(_props, ['hideLabel', 'InputElement', 'geometry', 'formData', 'featureProperties', 'nameGeometry', 'type', 'required']);
	
	        var g = geometry || formData && formData.geometry;
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            !hideLabel && _react2.default.createElement(
	                _reactBootstrap.FormLabel,
	                null,
	                'Position ',
	                required && _react2.default.createElement(
	                    'span',
	                    { className: 'required-symbol' },
	                    ' *'
	                )
	            ),
	            _react2.default.createElement(_GeometryEditControl2.default, _extends({
	                style: { height: 500 }
	            }, otherProps, {
	                handleGeometryChange: this.props.handleGeometryChange,
	                type: type,
	                geometry: g,
	                featureProperties: featureProperties
	            })),
	            InputElement && !required && _react2.default.createElement(InputElement, {
	                name: nameGeometry,
	                type: 'hidden',
	                value: g,
	                validations: {
	                    notNull: function notNull(geometry) {
	                        return !!geometry;
	                    }
	                }
	            }),
	            InputElement && required && _react2.default.createElement(InputElement, {
	                name: nameGeometry,
	                type: 'hidden',
	                value: g,
	                validations: {
	                    notNull: function notNull(geometry) {
	                        return !!geometry;
	                    }
	                },
	                required: true })
	        );
	    };
	
	    return GeometryInput;
	}(_react2.default.Component);
	
	GeometryInput.propTypes = {
	    defaultPosition: _propTypes2.default.object,
	    formData: _propTypes2.default.object,
	    featureProperties: _propTypes2.default.object,
	    required: _propTypes2.default.bool,
	    nameGeometry: _propTypes2.default.string,
	    geometry: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	    type: _propTypes2.default.string,
	    handleGeometryChange: _propTypes2.default.func.isRequired,
	    hideLabel: _propTypes2.default.bool,
	    InputElement: _propTypes2.default.func
	};
	
	exports.default = GeometryInput;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Carsten Hibbeler
	 * Date: 09.02.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Map = __webpack_require__(21);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Leaflet = L; //this is a hack because we use a global Leaflet
	
	var LocationInput = function (_React$Component) {
	    _inherits(LocationInput, _React$Component);
	
	    function LocationInput(props) {
	        _classCallCheck(this, LocationInput);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.mapPlugin = {
	            init: _this.onMapInit.bind(_this)
	        };
	        return _this;
	    }
	
	    LocationInput.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	        console.log('Update PositionMap', nextProps);
	
	        if (!this.marker) {
	            console.log('initMarker', nextProps);
	            this.initMarker(nextProps);
	        } else {
	            var _props = this.props,
	                position = _props.position,
	                markerOptions = _props.markerOptions;
	
	            if (!(0, _liferayWidgetsReactWeb.shallowEqual)(markerOptions, nextProps.markerOptions)) {
	                console.log('removeLayer', nextProps);
	                this.map.removeLayer(this.marker);
	                this.initMarker(nextProps);
	            } else if (!(0, _liferayWidgetsReactWeb.shallowEqual)(position, nextProps.position)) {
	                console.log('setLatLng', nextProps);
	                this.marker.setLatLng(nextProps.position);
	            }
	        }
	    };
	
	    LocationInput.prototype.onMapInit = function onMapInit(map) {
	        var _this2 = this;
	
	        this.map = map;
	        map && map.on('click', function (e) {
	            return _this2.onPositionChange(e.latlng);
	        });
	        this.initMarker(this.props);
	    };
	
	    LocationInput.prototype.onPositionChange = function onPositionChange(latLng) {
	        this.props.onPositionChange(latLng);
	    };
	
	    LocationInput.prototype.initMarker = function initMarker(props) {
	        var _this3 = this;
	
	        var position = props.position,
	            defaultPosition = props.defaultPosition,
	            p = position || defaultPosition;
	
	        if (p) {
	            this.marker = Leaflet.marker(p, _extends({}, props.markerOptions, {
	                draggable: true
	            })).addTo(this.map);
	            this.map.setView(p, this.props.zoom || 11);
	            this.marker && this.marker.on('dragend', function () {
	                return _this3.onPositionChange(_this3.marker.getLatLng());
	            });
	        }
	    };
	
	    LocationInput.prototype.render = function render() {
	        var _props2 = this.props,
	            InputElement = _props2.InputElement,
	            position = _props2.position,
	            _props2$nameLatitude = _props2.nameLatitude,
	            nameLatitude = _props2$nameLatitude === undefined ? 'latitude' : _props2$nameLatitude,
	            _props2$nameLongitude = _props2.nameLongitude,
	            nameLongitude = _props2$nameLongitude === undefined ? 'longitude' : _props2$nameLongitude,
	            _props2$plugins = _props2.plugins,
	            plugins = _props2$plugins === undefined ? [] : _props2$plugins,
	            otherProps = _objectWithoutProperties(_props2, ['InputElement', 'position', 'nameLatitude', 'nameLongitude', 'plugins']);
	
	        var latLng = position && Leaflet.latLng(position);
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(_Map2.default, _extends({}, otherProps, {
	                defaultFallbackMapConfigType: 'static',
	                plugins: plugins.concat(this.mapPlugin) })),
	            InputElement && _react2.default.createElement(InputElement, { name: nameLatitude, type: 'hidden', value: latLng && latLng.lat }),
	            InputElement && _react2.default.createElement(InputElement, { name: nameLongitude, type: 'hidden', value: latLng && latLng.lng }),
	            !InputElement && _react2.default.createElement('input', { name: nameLatitude, type: 'hidden', value: latLng && latLng.lat }),
	            !InputElement && _react2.default.createElement('input', { name: nameLongitude, type: 'hidden', value: latLng && latLng.lng })
	        );
	    };
	
	    return LocationInput;
	}(_react2.default.Component);
	
	LocationInput.propTypes = _extends({}, _Map2.default.propTypes, {
	    defaultPosition: _propTypes2.default.object,
	    markerOptions: _propTypes2.default.object,
	    position: _propTypes2.default.object,
	
	    onPositionChange: _propTypes2.default.func.isRequired, //without the input makes no sense
	
	    InputElement: _propTypes2.default.func,
	
	    nameLatitude: _propTypes2.default.string,
	    nameLongitude: _propTypes2.default.string,
	
	    center: _propTypes2.default.object,
	    zoom: _propTypes2.default.number
	});
	
	exports.default = LocationInput;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Tobias Wahl
	 * Date: 17.03.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapLinkListItem = function (_React$Component) {
	    _inherits(MapLinkListItem, _React$Component);
	
	    function MapLinkListItem(props) {
	        _classCallCheck(this, MapLinkListItem);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    MapLinkListItem.prototype.onClick = function onClick(e) {
	        this.props.onClick(this.props.item, e);
	    };
	
	    MapLinkListItem.prototype.render = function render() {
	        var _props = this.props,
	            item = _props.item,
	            active = _props.active,
	            disabled = _props.disabled;
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            { className: 'link-list-item ' + (active ? 'active' : ''),
	                disabled: disabled,
	                onClick: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { className: 'link-title' },
	                item.title + (item.groupName ? ' (' + item.groupName + ')' : '')
	            )
	        );
	    };
	
	    return MapLinkListItem;
	}(_react2.default.Component);
	
	MapLinkListItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = MapLinkListItem;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	__webpack_require__(79);
	
	__webpack_require__(81);
	
	var _LayerChooser = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayerChooserSidebar = function LayerChooserSidebar(_ref) {
	    var layerDescriptions = _ref.layerDescriptions,
	        onClose = _ref.onClose,
	        onLayersChange = _ref.onLayersChange,
	        context = _ref.context,
	        activeLayerUuids = _ref.activeLayerUuids,
	        reEvaluate = _ref.reEvaluate;
	
	
	    (0, _react.useEffect)(function () {
	        // force update after mount to render situationmap sidebar
	        // TODO combine layer chooser and situationmap plugin(?)
	        reEvaluate && reEvaluate();
	    }, []);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'layer-chooser' },
	        _react2.default.createElement(
	            _liferayWidgetsReactWeb.Header,
	            { onClose: onClose },
	            _react2.default.createElement(
	                'h3',
	                { className: 'm-0 leaflet-sidebar__title' },
	                'Themen & Lagekarten'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'layer-chooser__content' },
	            _react2.default.createElement(
	                _reactBootstrap.Tabs,
	                { defaultActiveKey: 'layers' },
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'layers', title: 'Themen' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'py-2' },
	                        _react2.default.createElement(_LayerChooser.LayerChooser, {
	                            layerDescriptions: layerDescriptions,
	                            onLayersChange: onLayersChange,
	                            mapId: context.contextId,
	                            activeLayerUuids: activeLayerUuids
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'situationmaps', title: 'Lagekarten' },
	                    _react2.default.createElement('div', { id: 'situation-map-chooser-container' + context.contextId, className: 'py-2' })
	                )
	            )
	        )
	    );
	}; /**
	    * Copyright 2016 xdot GmbH
	    *
	    * Author: Carsten Hibbeler
	    * Date: 23.06.2016
	    *
	    */
	
	LayerChooserSidebar.propTypes = {
	    layerDescriptions: _propTypes2.default.array,
	    context: _propTypes2.default.object,
	    activeLayerUuids: _propTypes2.default.object,
	    onClose: _propTypes2.default.func,
	    onLayersChange: _propTypes2.default.func,
	    reEvaluate: _propTypes2.default.func
	};
	
	exports.default = LayerChooserSidebar;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LayerChooser = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mapConfigUtil = __webpack_require__(10);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * User: n.gorte
	                                                                                                                                                                                                                              * Date: 11.07.2022
	                                                                                                                                                                                                                              * Time: 10:45
	                                                                                                                                                                                                                              */
	
	function getCount(layerSet) {
	    return layerSet.children.reduce(function (acc, child) {
	        return child.type === 'LayerSet' ? acc + getCount(child) : acc + 1;
	    }, 0);
	}
	
	function getActiveCount(layerSet, activeUuids) {
	    return layerSet.children.reduce(function (acc, child) {
	        if (child.type === 'LayerSet') {
	            return acc + getActiveCount(child, activeUuids);
	        } else if (activeUuids && Object.keys(activeUuids).includes(child.uuid)) {
	            return acc + 1;
	        }
	        return acc;
	    }, 0);
	}
	
	var CheckIcon = function CheckIcon(_ref) {
	    var checked = _ref.checked;
	    return _react2.default.createElement('span', { className: checked ? 'fa fa-check-square' : 'fa fa-square-o' });
	};
	
	var SwitcherIcon = function SwitcherIcon(_ref2) {
	    var expanded = _ref2.expanded,
	        isLeaf = _ref2.isLeaf;
	    return !isLeaf && _react2.default.createElement('span', { className: expanded ? 'icon icon-fliwas-arrow-down' : 'icon icon-fliwas-arrow-right' });
	};
	
	var LayerChooser = function LayerChooser(_ref3) {
	    var layerDescriptions = _ref3.layerDescriptions,
	        onLayersChange = _ref3.onLayersChange,
	        _ref3$activeLayerUuid = _ref3.activeLayerUuids,
	        activeLayerUuids = _ref3$activeLayerUuid === undefined ? {} : _ref3$activeLayerUuid,
	        mapId = _ref3.mapId;
	
	    var mapContainer = document.getElementById(mapId);
	    var overlayContainer = (0, _react.useRef)(mapContainer || document.body);
	    var popupTarget = (0, _react.useRef)(null);
	    var infoText = (0, _react.useRef)(null);
	
	    var _useState = (0, _react.useState)(false),
	        showInfo = _useState[0],
	        setShowInfo = _useState[1];
	
	    var onCheck = function onCheck(checkedKeys, _ref4) {
	        var checked = _ref4.checked,
	            node = _ref4.node;
	
	        if (checkedKeys) {
	            var parentNode = findParentNode(treeData, node.key);
	
	            if (parentNode && parentNode.isSingleChoice) {
	                var siblingKeys = parentNode.children.map(function (child) {
	                    return child.key;
	                }).filter(function (key) {
	                    return key !== node.key && checkedKeys.includes(key);
	                });
	
	                if (siblingKeys.length > 0) {
	                    checkedKeys = checkedKeys.filter(function (key) {
	                        return !siblingKeys.includes(key);
	                    });
	                }
	            }
	
	            var newActiveUuids = checkedKeys.filter(function (key) {
	                return !key.includes('LayerSet');
	            }).reduce(function (acc, key) {
	                acc[key] = true;
	                return acc;
	            }, {});
	
	            onLayersChange(newActiveUuids);
	        }
	    };
	
	    var renderLayerSet = function renderLayerSet(layerSet) {
	        var count = getCount(layerSet);
	        var activeCount = getActiveCount(layerSet, activeLayerUuids);
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'rc-tree-title__layerset' },
	                layerSet.title
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.Badge,
	                { className: 'ml-2' },
	                activeCount,
	                '/',
	                count
	            ),
	            layerSet.description.length > 0 && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'outline-primary',
	                    className: 'rc-tree-title__info-button',
	                    onClick: showInfoPopup(layerSet.description)
	                },
	                _react2.default.createElement('span', { className: 'icon icon-fliwas-info-o' })
	            )
	        );
	    };
	
	    var showInfoPopup = function showInfoPopup(text) {
	        return function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	            popupTarget.current = e.target;
	            infoText.current = text;
	            setShowInfo(!showInfo);
	        };
	    };
	
	    var renderLogicalLayer = function renderLogicalLayer(_ref5) {
	        var title = _ref5.title;
	        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var infoText = config.infoText;
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'span',
	                { className: 'rc-tree-title__logical_layer' },
	                title
	            ),
	            infoText && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'outline-primary',
	                    className: 'rc-tree-title__info-button',
	                    onClick: showInfoPopup(infoText)
	                },
	                _react2.default.createElement('span', { className: 'icon icon-fliwas-info-o' })
	            )
	        );
	    };
	
	    var getTreeData = function getTreeData(layers) {
	        return layers.map(function (item, i) {
	            var isLayersSet = (0, _mapConfigUtil.isLayerSet)(item);
	            var configJson = void 0;
	            try {
	                configJson = isLayersSet ? item.config && JSON.parse(item.config) : item.children && JSON.parse(item.children[0].config);
	            } catch (e) {
	                console.error('Failed to parse layer config', e, item);
	            }
	
	            var isLayerSetWithSingleChoice = configJson && configJson.isSingleChoice ? configJson.isSingleChoice : false;
	
	            return {
	                key: item.uuid,
	                uuid: item.uuid,
	                title: isLayersSet ? function () {
	                    return renderLayerSet(item);
	                } : renderLogicalLayer(item, configJson),
	                isLeaf: !isLayersSet,
	                children: isLayersSet ? getTreeData(item.children) : null,
	                isLayerSet: isLayersSet,
	                isSingleChoice: isLayerSetWithSingleChoice,
	                icon: isLayerSetWithSingleChoice ? _react2.default.createElement('span', { className: 'fa fa-square-o invisible' }) : null,
	                disableCheckbox: isLayerSetWithSingleChoice
	            };
	        });
	    };
	
	    var findParentNode = function findParentNode(treeData, childKey) {
	        for (var _iterator = treeData, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref6;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref6 = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref6 = _i.value;
	            }
	
	            var parent = _ref6;
	
	            if (parent.children && parent.children.some(function (child) {
	                return child.key === childKey;
	            })) {
	                return parent;
	            }
	            var foundInChild = findParentNode(parent.children || [], childKey);
	            if (foundInChild) return foundInChild;
	        }
	        return null;
	    };
	
	    var treeData = getTreeData(layerDescriptions);
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        layerDescriptions && layerDescriptions.length > 0 && _react2.default.createElement(
	            _liferayWidgetsReactWeb.AmdRequireComponent,
	            { dependencies: ['rc-tree', 'rcTreeCss'] },
	            function (rcTree) {
	                var Tree = rcTree['default'];
	
	                return _react2.default.createElement(Tree, {
	                    checkedKeys: Object.keys(activeLayerUuids),
	                    defaultExpandAll: false,
	                    autoExpandParent: true,
	                    draggable: false,
	                    showIcon: true,
	                    selectable: false,
	                    checkable: true,
	                    treeData: treeData,
	                    icon: CheckIcon,
	                    switcherIcon: SwitcherIcon,
	                    onCheck: onCheck
	                });
	            }
	        ),
	        _react2.default.createElement(
	            _reactBootstrap.Overlay,
	            {
	                container: overlayContainer.current,
	                target: popupTarget.current,
	                show: showInfo,
	                placement: 'bottom',
	                rootClose: true,
	                onHide: function onHide() {
	                    return setShowInfo(false);
	                }
	            },
	            function (_ref7) {
	                var placement = _ref7.placement,
	                    arrowProps = _ref7.arrowProps,
	                    _show = _ref7.show,
	                    popper = _ref7.popper,
	                    props = _objectWithoutProperties(_ref7, ['placement', 'arrowProps', 'show', 'popper']);
	
	                return _react2.default.createElement(
	                    'div',
	                    _extends({}, props, {
	                        className: 'layer-chooser__info-popup popover bs-popover-bottom'
	                    }),
	                    _react2.default.createElement('div', _extends({ className: 'arrow' }, arrowProps)),
	                    _react2.default.createElement('div', { className: 'popover-body', dangerouslySetInnerHTML: { __html: infoText.current } })
	                );
	            }
	        )
	    );
	};
	
	exports.LayerChooser = LayerChooser;
	LayerChooser.propTypes = {
	    layerDescriptions: _propTypes2.default.array,
	    activeLayerUuids: _propTypes2.default.object,
	    onLayersChange: _propTypes2.default.func,
	    mapId: _propTypes2.default.string
	};
	
	CheckIcon.propTypes = {
	    checked: _propTypes2.default.bool
	};
	
	SwitcherIcon.propTypes = {
	    expanded: _propTypes2.default.bool,
	    isLeaf: _propTypes2.default.bool
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _lwrClient = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Hibbeler on 11.02.2016.
	 */
	/**
	 * modded version of https://github.com/perliedman/leaflet-realtime/blob/master/src/L.Realtime.js
	 * Copyright (c) 2014, Per Liedman (per@liedman.net)
	 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
	 */
	var RemoteDataGeoJsonLayer = _leaflet2.default.GeoJSON.extend({
	
	    options: {
	        getFeatureId: function getFeatureId(f) {
	            //id is only valid for one modelClassName aka. type!
	            return f.properties.type + f.properties.id;
	        },
	
	        updateFeature: function updateFeature(f, oldLayer, newLayer) {
	            if (f.geometry.type === 'Point') {
	                oldLayer.setLatLng(newLayer.getLatLng());
	                return oldLayer;
	            } else {
	                return newLayer;
	            }
	        }
	    },
	
	    initialize: function initialize(servicePath, method, options) {
	        var _this = this;
	
	        _leaflet2.default.GeoJSON.prototype.initialize.call(this, undefined, options);
	
	        var serviceWithContext = function serviceWithContext(m, o, c) {
	            return _lwrClient.Client.invokeWithContext(servicePath + m, o, c);
	        };
	        this.request = function () {
	            if (options.data && options.context) {
	                serviceWithContext(method, options.data, options.context).then(_this._onNewData.bind(_this), function (e) {
	                    return console.error(e);
	                });
	            } else {
	                serviceWithContext(method, options).then(_this._onNewData.bind(_this), function (e) {
	                    return console.error(e);
	                });
	            }
	        };
	
	        this._features = {};
	        this._featureLayers = {};
	
	        this.update();
	    },
	
	    update: function update() {
	        this.request();
	        return this;
	    },
	
	    remove: function remove(geojson) {
	        var features = _leaflet2.default.Util.isArray(geojson) ? geojson : geojson.features ? geojson.features : [geojson],
	            exit = {},
	            i = void 0,
	            len = void 0,
	            fId = void 0;
	
	        for (i = 0, len = features.length; i < len; i++) {
	            fId = this.options.getFeatureId(features[i]);
	            this.removeLayer(this._featureLayers[fId]);
	            exit[fId] = this._features[fId];
	            delete this._features[fId];
	            delete this._featureLayers[fId];
	        }
	
	        _leaflet2.default.Evented.prototype.fire.call(this, 'update', {
	            features: this._features,
	            enter: {},
	            update: {},
	            exit: exit
	        });
	
	        return this;
	    },
	
	    getFeatureLayer: function getFeatureLayer(id, className) {
	        if (!className) {
	            console.error('Missing className');
	        }
	        return this._featureLayers[className + id];
	    },
	
	    getFeature: function getFeature(id, className) {
	        if (!className) {
	            console.error('Missing className');
	        }
	        return this._features[className + id];
	    },
	
	    _onNewData: function _onNewData(response) {
	        var oef = this.options.onEachFeature,
	            layersToRemove = [],
	            features = {},
	            enter = {},
	            update = {},
	            exit = {},
	            i = void 0;
	
	        this.options.onEachFeature = _leaflet2.default.bind(function onEachFeature(f, l) {
	
	            var fId = void 0,
	                oldLayer = void 0,
	                newLayer = void 0;
	
	            if (oef) {
	                oef(f, l);
	            }
	
	            fId = this.options.getFeatureId(f);
	            oldLayer = this._featureLayers[fId];
	
	            if (oldLayer) {
	                newLayer = this.options.updateFeature(f, oldLayer, l);
	                if (newLayer !== oldLayer) {
	                    this.removeLayer(oldLayer);
	                }
	                if (newLayer !== l) {
	                    layersToRemove.push(l);
	                }
	
	                l = newLayer;
	                update[fId] = f;
	            } else {
	                enter[fId] = f;
	            }
	
	            this._featureLayers[fId] = l;
	            this._features[fId] = features[fId] = f;
	        }, this);
	
	        this.addData(response);
	
	        exit = this._removeUnknown(features);
	
	        for (i = 0; i < layersToRemove.length; i++) {
	            this.removeLayer(layersToRemove[i]);
	        }
	
	        _leaflet2.default.Evented.prototype.fire.call(this, 'update', {
	            features: this._features,
	            enter: enter,
	            update: update,
	            exit: exit
	        });
	
	        this.options.onEachFeature = oef;
	    },
	
	    _removeUnknown: function _removeUnknown(known) {
	        var fId = void 0,
	            removed = {};
	        for (fId in this._featureLayers) {
	            if (!known[fId] && this._featureLayers.hasOwnProperty(fId)) {
	                this.removeLayer(this._featureLayers[fId]);
	                removed[fId] = this._features[fId];
	                delete this._featureLayers[fId];
	                delete this._features[fId];
	            }
	        }
	
	        return removed;
	    }
	
	});
	
	exports.default = RemoteDataGeoJsonLayer;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _geoUtils = __webpack_require__(14);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idx = function idx(id, className) {
	    if (!className) {
	        console.error('Missing className');
	    }
	    return className + id;
	}; /**
	    * Created by Carsten Hibbeler on 17.01.2019.
	    */
	
	
	var clone = function clone(s) {
	    var t = {};
	    for (var k in s) {
	        if (Object.prototype.hasOwnProperty.call(s, k)) {
	            t[k] = s[k];
	        }
	    }
	    return t;
	};
	
	var diff = function diff(oldFeaturesMap, newFeatures) {
	    var t0 = performance.now();
	    oldFeaturesMap = clone(oldFeaturesMap);
	    var diff = {
	        added: [],
	        removed: [],
	        changed: []
	    };
	    newFeatures.forEach(function (nF) {
	        var id = (0, _geoUtils.getFeatureId)(nF),
	            oF = oldFeaturesMap[id];
	        if (!oF) {
	            diff.added.push(nF);
	        } else {
	            if (!(0, _liferayWidgetsReactWeb.deepEqual)(nF, oF)) {
	                diff.changed.push(nF);
	            }
	            delete oldFeaturesMap[id];
	        }
	    });
	    for (var k in oldFeaturesMap) {
	        if (Object.prototype.hasOwnProperty.call(oldFeaturesMap, k)) {
	            diff.removed.push(oldFeaturesMap[k]);
	        }
	    }
	    var t1 = performance.now();
	    console.log("Diff took " + (t1 - t0) + " milliseconds.");
	    return diff;
	};
	
	var RemoteDataStoreGeoJsonLayer = _leaflet2.default.GeoJSON.extend({
	
	    options: {
	        updateFeature: function updateFeature(f, oldLayer, newLayer) {
	            throw new Error("deprecated");
	            if (f.geometry.type === 'Point') {
	                oldLayer.setLatLng(newLayer.getLatLng());
	                return oldLayer;
	            } else {
	                return newLayer;
	            }
	        }
	    },
	
	    initialize: function initialize(options) {
	        _leaflet2.default.GeoJSON.prototype.initialize.call(this, undefined, options);
	
	        this._features = {};
	        this._featureLayers = {};
	    },
	
	    getFeatureLayer: function getFeatureLayer(id, className) {
	        return this._featureLayers[idx(id, className)];
	    },
	
	    update: function update(featureCollection) {
	        var _this = this;
	
	        var oef = this.options.onEachFeature,
	            changes = diff(this._features, featureCollection.features);
	
	        if (changes.added.length + changes.changed.length + changes.removed.length === 0) {
	            return;
	        }
	
	        //Add
	        this.options.onEachFeature = function (f, l) {
	            var fId = (0, _geoUtils.getFeatureId)(f);
	
	            oef && oef(f, l);
	
	            if (_this._featureLayers[fId]) {
	                console.error("No existing layer expected");
	            }
	
	            _this._featureLayers[fId] = l;
	            _this._features[fId] = f;
	        };
	        this.addData(changes.added);
	
	        //Change
	        this.options.onEachFeature = function (f, l) {
	            var fId = (0, _geoUtils.getFeatureId)(f),
	                oldLayer = _this._featureLayers[fId];
	
	            oef && oef(f, l);
	
	            if (oldLayer) {
	                if (!_this.hasLayer(oldLayer)) {
	                    console.error("Missing layer: ", oldLayer);
	                }
	                _this.removeLayer(oldLayer);
	            } else {
	                console.error("No existing layer expected");
	            }
	
	            _this._featureLayers[fId] = l;
	            _this._features[fId] = f;
	        };
	        this.addData(changes.changed);
	
	        //Remove
	        changes.removed.forEach(function (f) {
	            var fId = (0, _geoUtils.getFeatureId)(f),
	                oldLayer = _this._featureLayers[fId];
	            if (!oldLayer) {
	                if (!_this.hasLayer(oldLayer)) {
	                    console.error("Missing layer: ", oldLayer);
	                }
	                console.error("Layer not found for ", f);
	            }
	            _this.removeLayer(oldLayer);
	            delete _this._featureLayers[fId];
	            delete _this._features[fId];
	        });
	
	        _leaflet2.default.Evented.prototype.fire.call(this, 'update', {
	            features: this._features,
	            enter: changes.added,
	            update: changes.removed,
	            exit: changes.changed
	        });
	
	        this.options.onEachFeature = oef;
	    },
	
	    _removeUnknown: function _removeUnknown(known) {
	        throw new Error("deprecated");
	        var removed = {};
	        for (var fId in this._featureLayers) {
	            if (!known[fId]) {
	                this.removeLayer(this._featureLayers[fId]);
	                removed[fId] = this._features[fId];
	                delete this._featureLayers[fId];
	                delete this._features[fId];
	            }
	        }
	        return removed;
	    }
	
	});
	
	exports.default = RemoteDataStoreGeoJsonLayer;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _LayerDataSourceWebApi = __webpack_require__(48);
	
	var _LayerDataSourceWebApi2 = _interopRequireDefault(_LayerDataSourceWebApi);
	
	var _MapConfigWebApi = __webpack_require__(50);
	
	var _MapConfigWebApi2 = _interopRequireDefault(_MapConfigWebApi);
	
	var _ActionTypes = __webpack_require__(105);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	exports.default = {
	    loadMapConfig: function loadMapConfig(uuid) {
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatchAsyncOperation(_ActionTypes2.default.LOAD_MAP_CONFIG_ASYNC, _MapConfigWebApi2.default.loadMapConfig, {}, {});
	    },
	    loadStaticLayers: function loadStaticLayers() {
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatchAsyncOperation(_ActionTypes2.default.REQUEST_STATIC_LAYERS, _LayerDataSourceWebApi2.default.loadLayers, {}, {});
	    },
	    saveDemoMapConfig: function saveDemoMapConfig() {
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatchAsyncOperation(_ActionTypes2.default.SAVE_MAP_CONFIG_ASYNC, _MapConfigWebApi2.default.saveDemoMapConfig, {}, {});
	    },
	    addLayer: function addLayer( /* object or array */layer) {
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	            type: _ActionTypes2.default.ADD_LAYER,
	            payload: layer
	        });
	    },
	    selectLayer: function selectLayer(layerId) {
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	            type: _ActionTypes2.default.SELECT_LAYER,
	            payload: layerId
	        });
	    },
	    deselectLayer: function deselectLayer(layerId) {
	        _liferayWidgetsReactWeb.AppContext.getDispatcher().dispatch({
	            type: _ActionTypes2.default.DESELECT_LAYER,
	            payload: layerId
	        });
	    }
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _keymirror = __webpack_require__(12);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _keymirror2.default)({
	    REQUEST_STATIC_LAYERS: null,
	    ADD_LAYER: null,
	    SELECT_LAYER: null,
	    DESELECT_LAYER: null,
	
	    MAP_CONFIGS_ASYNC: null,
	
	    ADD_LOGICAL_LAYER_ASYNC: null,
	    UPDATE_LOGICAL_LAYER_ASYNC: null
	}); /**
	     * Created by Carsten Bühler
	     * User: CBuehler on 22.10.2015
	     * Copyright: xdot GmbH 2015
	     */

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var api = 'GeoJsonWebApi'; /**
	                            * Created by Carsten Bühler
	                            * User: CBuehler on 23.09.2015
	                            * Copyright: xdot GmbH 2015
	                            */
	
	var itemApiMethod = 'getGeoJson';
	
	var pollingData = {};
	
	setInterval(function () {
	    var t = new Date().getTime();
	    Object.keys(pollingData).filter(function (name) {
	        return t - pollingData[name] > 1000;
	    }).forEach(function (name) {
	        pollingData[name] = t;
	        _liferayWidgetsReactWeb.RemoteDataActions.invalidate(name, "GeoJson");
	    });
	}, 1000 * 60);
	
	exports.default = {
	
	    geoJson: function geoJson(name, query) {
	        pollingData[name] = new Date().getTime();
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, "GeoJson", query, api + '.' + itemApiMethod);
	    }
	
	};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	L.Control.Sidebar = L.Control.extend({
	
	    includes: L.Evented.prototype || L.Mixin.Events,
	
	    options: {
	        closeButton: true,
	        position: 'left',
	        autoPan: true
	    },
	
	    initialize: function initialize(placeholder, options) {
	        L.setOptions(this, options);
	
	        // Find content container
	        var content = this._contentContainer = L.DomUtil.get(placeholder);
	
	        // Remove the content container from its original parent
	        content.parentNode.removeChild(content);
	
	        var l = 'leaflet-';
	
	        // Create sidebar container
	        var container = this._container = L.DomUtil.create('div', l + 'sidebar ' + this.options.position);
	
	        // Style and attach content container
	        L.DomUtil.addClass(content, l + 'control');
	        container.appendChild(content);
	
	        // Create close button and attach it if configured
	        if (this.options.closeButton) {
	            var close = this._closeButton = L.DomUtil.create('a', 'close', container);
	            close.innerHTML = '&times;';
	        }
	    },
	
	    addTo: function addTo(map) {
	        this._map = map;
	        var container = this._container;
	        var content = this._contentContainer;
	
	        // Attach event to close button
	        if (this.options.closeButton) {
	            var close = this._closeButton;
	            L.DomEvent.on(close, 'click', this.hide, this);
	        }
	
	        L.DomEvent.on(container, 'transitionend', this._handleTransitionEvent, this).on(container, 'webkitTransitionEnd', this._handleTransitionEvent, this);
	
	        // Attach sidebar container to controls container
	        var controlContainer = map._controlContainer;
	        controlContainer.insertBefore(container, controlContainer.firstChild);
	
	        // Make sure we don't drag the map when we interact with the content
	        var stop = L.DomEvent.stopPropagation;
	        L.DomEvent.disableClickPropagation(content);
	        L.DomEvent.on(content, 'contextmenu', stop).on(content, 'touchstart', stop).on(content, 'mousewheel', stop).on(content, 'wheel', stop).on(content, 'MozMousePixelScroll', stop);
	
	        this._map.sideBars = this._map.sideBars || [];
	        this._map.sideBars.push(this);
	        return this;
	    },
	
	    remove: function remove(map) {
	        var _this = this;
	
	        this.hide();
	
	        var container = this._container;
	        var content = this._contentContainer;
	
	        // Remove sidebar container from controls container
	        var controlContainer = map._controlContainer;
	        controlContainer.removeChild(container);
	
	        //disassociate the map object
	        this._map.sideBars = this._map.sideBars.filter(function (s) {
	            return s !== _this;
	        });
	        this._map = null;
	
	        // Unregister events to prevent memory leak
	        var stop = L.DomEvent.stopPropagation;
	        var fakeStop = L.DomEvent._fakeStop || stop;
	        L.DomEvent.off(content, 'contextmenu', stop).off(content, 'click', fakeStop).off(content, 'mousedown', stop).off(content, 'touchstart', stop).off(content, 'dblclick', fakeStop).off(content, 'mousewheel', stop).off(content, 'MozMousePixelScroll', stop);
	
	        L.DomEvent.off(container, 'transitionend', this._handleTransitionEvent, this).off(container, 'webkitTransitionEnd', this._handleTransitionEvent, this);
	
	        if (this._closeButton && this._close) {
	            var close = this._closeButton;
	
	            L.DomEvent.off(close, 'click', this.hide, this);
	        }
	
	        return this;
	    },
	
	    isVisible: function isVisible() {
	        return L.DomUtil.hasClass(this._container, 'visible');
	    },
	
	    show: function show() {
	        if (!this.isVisible()) {
	            //this._map.sideBars.filter(s => s !== this).forEach(s => s.hide());
	            L.DomUtil.addClass(this._container, 'visible');
	            if (this.options.autoPan) {
	                this._map.panBy([-this.getOffset() / 2, 0], {
	                    duration: 0.5
	                });
	            }
	            this.fire('show');
	        }
	    },
	
	    hide: function hide(e) {
	        if (this.isVisible()) {
	            L.DomUtil.removeClass(this._container, 'visible');
	            if (this.options.autoPan) {
	                this._map.panBy([this.getOffset() / 2, 0], {
	                    duration: 0.5
	                });
	            }
	            this.fire('hide');
	        }
	        if (e) {
	            L.DomEvent.stopPropagation(e);
	        }
	    },
	
	    toggle: function toggle() {
	        if (this.isVisible()) {
	            this.hide();
	        } else {
	            this.show();
	        }
	    },
	
	    getContainer: function getContainer() {
	        return this._contentContainer;
	    },
	
	    getCloseButton: function getCloseButton() {
	        return this._closeButton;
	    },
	
	    setContent: function setContent(content) {
	        this.getContainer().innerHTML = content;
	        return this;
	    },
	
	    getOffset: function getOffset() {
	        if (this.options.position === 'right') {
	            return -this._container.offsetWidth;
	        } else {
	            return this._container.offsetWidth;
	        }
	    },
	
	    _handleTransitionEvent: function _handleTransitionEvent(e) {
	        if (e.propertyName === 'left' || e.propertyName === 'right') L.Evented.prototype.fire.call(this, this.isVisible() ? 'shown' : 'hidden'); //this.fire(this.isVisible() ? 'shown' : 'hidden');
	    },
	
	    listens: function listens(type, propagate) {
	        var listeners = this._events && this._events[type];
	        if (listeners && listeners.length) {
	            return true;
	        }
	
	        if (propagate) {
	            // also check parents for listeners if event propagates
	            for (var id in this._eventParents) {
	                if (this._eventParents[id].listens(type, propagate)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	});
	
	L.control.sidebar = function (placeholder, options) {
	    return new L.Control.Sidebar(placeholder, options);
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 05.09.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_leaflet2.default.Control.ResizableControl = _leaflet2.default.Control.extend({
	    options: {
	        position: 'topleft'
	    },
	
	    initialize: function initialize(options) {
	        this.active = false;
	        _leaflet2.default.Util.setOptions(this, options);
	    },
	    onAdd: function onAdd(map) {
	        var _options = this.options,
	            title = _options.title,
	            iconLeft = _options.iconLeft;
	
	        this.container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom resizable-control-button');
	        this.header = _leaflet2.default.DomUtil.create('div', 'resizable-control-button-header', this.container);
	
	        if (iconLeft) {
	            _leaflet2.default.DomUtil.create('span', 'icon-left ' + iconLeft, this.header);
	        }
	        this.title = _leaflet2.default.DomUtil.create('span', '', this.header);
	        this.title.innerHTML = title;
	        this.icon = _leaflet2.default.DomUtil.create('span', 'fa fa-expand ml-2', this.header);
	
	        this.container.setAttribute('title', title);
	        this.container.setAttribute('role', 'button');
	
	        this.contentContainer = _leaflet2.default.DomUtil.create('div', 'resizable-control-content', this.container);
	
	        _leaflet2.default.DomEvent.on(this.container, 'click', this.toggle, this);
	
	        return this.container;
	    },
	    onRemove: function onRemove(map) {
	        _leaflet2.default.DomEvent.off(this.header);
	        this.icon = null;
	        this.contentContainer = null;
	        this.header = null;
	        this.container = null;
	    },
	    toggle: function toggle(e) {
	        _leaflet2.default.DomEvent.stopPropagation(e);
	        _leaflet2.default.DomEvent.preventDefault(e);
	        this.container.classList.toggle('active');
	        this.active = !this.active;
	        if (this.active) {
	            this.icon.classList.remove('fa-expand');
	            this.icon.classList.add('fa-compress');
	            this.options.onOpen ? this.options.onOpen() : null;
	        } else {
	            this.icon.classList.remove('fa-compress');
	            this.icon.classList.add('fa-expand');
	            this.options.onClose ? this.options.onClose() : null;
	        }
	    },
	    setContent: function setContent(content) {
	        while (this.contentContainer.firstChild) {
	            this.contentContainer.removeChild(this.contentContainer.firstChild);
	        }
	        this.contentContainer.appendChild(content);
	    }
	});
	
	exports.default = _leaflet2.default.control.resizableControl = function (opts) {
	    return new _leaflet2.default.Control.ResizableControl(opts);
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(110);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/index.js!./ResizableControl.scss", function() {
				var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../../node_modules/sass-loader/index.js!./ResizableControl.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-touch .leaflet-bar.leaflet-control-custom.resizable-control-button,.leaflet-touch .leaflet-bar a.resizable-control-button{cursor:pointer;font-size:15px;width:auto;padding:0 8px;transition:height .3s ease-in-out,width .3s ease-in-out}.leaflet-touch .leaflet-bar.leaflet-control-custom.resizable-control-button .resizable-control-button-header,.leaflet-touch .leaflet-bar a.resizable-control-button .resizable-control-button-header{display:flex;flex-direction:row;justify-content:space-between;align-items:center}.leaflet-touch .leaflet-bar.leaflet-control-custom.resizable-control-button .resizable-control-button-header .icon-left,.leaflet-touch .leaflet-bar a.resizable-control-button .resizable-control-button-header .icon-left{font-size:20px}.leaflet-touch .leaflet-bar.leaflet-control-custom.resizable-control-button>.resizable-control-content,.leaflet-touch .leaflet-bar a.resizable-control-button>.resizable-control-content{visibility:hidden;opacity:0;overflow-y:auto;transition:opacity 0s ease-in-out .3s}.leaflet-touch .leaflet-bar.leaflet-control-custom.resizable-control-button.active,.leaflet-touch .leaflet-bar a.resizable-control-button.active{width:250px;height:auto}.leaflet-touch .leaflet-bar.leaflet-control-custom.resizable-control-button.active>.resizable-control-content,.leaflet-touch .leaflet-bar a.resizable-control-button.active>.resizable-control-content{visibility:visible;opacity:1}", ""]);
	
	// exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(112);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./leaflet-sidebar.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./leaflet-sidebar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-sidebar{position:absolute;height:100%;box-sizing:border-box;z-index:470;color:#676a6c}@media (max-width:767px){.leaflet-sidebar{width:100%;padding:0}.leaflet-sidebar.left.visible~.leaflet-left{left:100%}.leaflet-sidebar.right.visible~.leaflet-right{right:100%}.leaflet-sidebar.right.visible~.leaflet-left{right:calc(100% + 40px)}.leaflet-sidebar.visible{position:fixed;top:0;right:0;left:0;bottom:0;z-index:1000}.leaflet-sidebar.left{left:-100%}.leaflet-sidebar.left.visible{left:0}.leaflet-sidebar.right{right:-100%}.leaflet-sidebar.right.visible{right:0}.leaflet-sidebar>.leaflet-control{box-shadow:none}.leaflet-touch .leaflet-sidebar>.leaflet-control{border:0}}@media (min-width:768px) and (max-width:991px){.leaflet-sidebar{width:305px}.leaflet-sidebar.right{right:-305px}.leaflet-sidebar.left{left:-305px}.leaflet-sidebar.left.visible~.leaflet-left{left:305px}.leaflet-sidebar.right.visible~.leaflet-right{right:305px}.leaflet-sidebar.right.visible~.leaflet-left{right:345px}}@media (min-width:992px) and (max-width:1199px){.leaflet-sidebar{width:390px}.leaflet-sidebar.right{right:-390px}.leaflet-sidebar.left{left:-390px}.leaflet-sidebar.left.visible~.leaflet-left{left:390px}.leaflet-sidebar.right.visible~.leaflet-right{right:390px}.leaflet-sidebar.right.visible~.leaflet-left{right:430px}}@media (min-width:1200px){.leaflet-sidebar{width:390px}.leaflet-sidebar.right{right:-390px}.leaflet-sidebar.left{left:-390px}.leaflet-sidebar.left.visible~.leaflet-left{left:390px}.leaflet-sidebar.right.visible~.leaflet-right{right:390px}.leaflet-sidebar.right.visible~.leaflet-left{right:430px}}.leaflet-sidebar.left{transition:left .5s,width .5s;padding-right:0}.leaflet-sidebar.left.visible{left:0}.leaflet-sidebar.right{transition:right .5s,width .5s;padding-left:0}.leaflet-sidebar.right.visible{right:0}.leaflet-sidebar.left.visible .sidebar-btn,.leaflet-sidebar.right.visible .sidebar-btn{color:#fff}.leaflet-sidebar>.leaflet-control{height:100%;width:100%;-webkit-overflow-scrolling:touch;font-size:1rem;background:#fff;box-sizing:border-box;overflow:auto}.leaflet-touch .leaflet-sidebar>.leaflet-control{background-clip:padding-box}.leaflet-left{transition:left .5s}.leaflet-right{transition:right .5s}.sidebar-btn{position:absolute;height:180px;background-color:#326487;color:#fff;z-index:7;top:50%;transform:translateY(-30%);margin-left:-30px;width:30px;cursor:pointer}.sidebar-btn.left{margin-left:100%}@media (min-width:768px) and (max-width:991px){.sidebar-btn.left{margin-left:305px}}@media (min-width:992px) and (max-width:1199px){.sidebar-btn.left{margin-left:390px}}@media (min-width:1200px){.sidebar-btn.left{margin-left:390px}}.sidebar-btn .sidebar-btn__content{writing-mode:vertical-lr;text-orientation:mixed;transform:rotate(-180deg);position:relative;display:flex;justify-content:center;align-items:center;height:180px;width:30px;padding:4px 7px;border:none;margin-left:2px;text-overflow:ellipsis;overflow:hidden;box-sizing:border-box;font-size:1.1em;white-space:nowrap;z-index:8}.sidebar-btn .sidebar-btn__content.left{margin-left:-65px;height:20px;margin-top:65px}.sidebar-btn .sidebar-btn__content .name~[class*=\" icon-fliwas-arrow-\"]{margin:.2em 0 0 .5em}.sidebar-btn__content .icon{padding-top:3px;padding-right:7px;padding-left:7px}.leaflet-sidebar__title{font-size:1.25em;font-weight:400}", ""]);
	
	// exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Carsten Hibbeler
	 * Date: 28.01.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _Map = __webpack_require__(21);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _MapConfigActions = __webpack_require__(114);
	
	var _MapConfigActions2 = _interopRequireDefault(_MapConfigActions);
	
	var _MapConfigForm = __webpack_require__(115);
	
	var _MapConfigForm2 = _interopRequireDefault(_MapConfigForm);
	
	var _StoreFactory = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapC = _liferayWidgetsReactWeb.DataLinkContainer.link(_Map2.default, {
	    mapConfig: (0, _StoreFactory.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext)
	});
	
	var MapConfigFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_MapConfigForm2.default);
	
	var MapConfigStore = (0, _StoreFactory.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext);
	
	var MapWidget = function (_PortletComponent) {
	    _inherits(MapWidget, _PortletComponent);
	
	    function MapWidget(props) {
	        _classCallCheck(this, MapWidget);
	
	        var _this = _possibleConstructorReturn(this, _PortletComponent.call(this, props));
	
	        _this.DATA = {
	            SELECTED_MAP_CONFIG: _this.withCtx('SelectedMapconfig')
	        };
	
	        _this.MAP_ID = _this.plid + '_' + _this.portletId;
	        return _this;
	    }
	
	    MapWidget.prototype.getChildContext = function getChildContext() {
	        return { contextId: this.MAP_ID };
	    };
	
	    MapWidget.getStores = function getStores() {
	        return [MapConfigStore];
	    };
	
	    MapWidget.calculateState = function calculateState(prevState, undefined, DATA) {
	        return _extends({}, prevState, {
	            defaultMapConfig: MapConfigStore.getRemoteData(DATA.SELECTED_MAP_CONFIG)
	        });
	    };
	
	    MapWidget.prototype.componentDidMount = function componentDidMount() {
	        _PortletComponent.prototype.componentDidMount.call(this);
	        _MapConfigActions2.default.itemDefaultGrouped(this.DATA.SELECTED_MAP_CONFIG, { groupId: this.props.scopeGroupId });
	    };
	
	    MapWidget.prototype.renderConfigForm = function renderConfigForm(props) {
	        return _react2.default.createElement(MapConfigFormHoc, _extends({}, props, this.state));
	    };
	
	    MapWidget.prototype.renderPortlet = function renderPortlet(config) {
	        return _react2.default.createElement(MapC, {
	            style: { height: config.height + 'px' },
	            mapKey: this.MAP_ID,
	            mapConfig: this.DATA.SELECTED_MAP_CONFIG,
	            portletConfig: config
	        });
	    };
	
	    return MapWidget;
	}(_liferayWidgetsReactWeb.PortletComponent);
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(MapWidget);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _MapConfigWebApi = __webpack_require__(50);
	
	var _MapConfigWebApi2 = _interopRequireDefault(_MapConfigWebApi);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _ClassNames2.default.MapConfig; /**
	                                                 * Copyright 2016 xdot GmbH
	                                                 * Author: Marius Runde
	                                                 * Date: 13.06.2016
	                                                 *
	                                                 */
	
	exports.default = {
	
	    allList: function allList(name) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className);
	    },
	    allGroupedList: function allGroupedList(name) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, {}, _MapConfigWebApi2.default.allListViewableMapConfigs);
	    },
	
	    item: function item(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query);
	    },
	    itemDefaultGrouped: function itemDefaultGrouped(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query, _MapConfigWebApi2.default.itemDefaultGrouped);
	    },
	    // moreItems: (name, query) => RemoteDataActions.moreItems(name, className, query),
	
	    updateMapConfig: function updateMapConfig(item, formId, closeForm) {
	        _liferayWidgetsReactWeb.FormActions.submitForm(_MapConfigWebApi2.default.updateMapConfig, item, formId, closeForm);
	    },
	
	    addMapConfig: function addMapConfig(item, formId, closeForm) {
	        _liferayWidgetsReactWeb.FormActions.submitForm(_MapConfigWebApi2.default.addMapConfig, item, formId, closeForm);
	    },
	
	    deleteMapConfig: function deleteMapConfig(item, formId, closeForm) {
	        _liferayWidgetsReactWeb.FormActions.submitForm(_MapConfigWebApi2.default.deleteMapConfig, item, formId, closeForm);
	    },
	
	    setDefaultMapConfig: function setDefaultMapConfig(item, formId, closeForm) {
	        _liferayWidgetsReactWeb.FormActions.submitForm(_MapConfigWebApi2.default.setDefaultMapConfig, item, formId, closeForm);
	    },
	
	    resetDefaultMapConfig: function resetDefaultMapConfig(item, formId, closeForm) {
	        _liferayWidgetsReactWeb.FormActions.submitForm(_MapConfigWebApi2.default.resetDefaultMapConfig, item, formId, closeForm);
	    }
	
	};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Carsten Hibbeler
	 * Date: 28.01.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _LayerChooser = __webpack_require__(101);
	
	var _Map = __webpack_require__(21);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _BoundingboxInputPlugin = __webpack_require__(116);
	
	var _BoundingboxInputPlugin2 = _interopRequireDefault(_BoundingboxInputPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigForm = function (_React$Component) {
	    _inherits(MapConfigForm, _React$Component);
	
	    function MapConfigForm(props) {
	        _classCallCheck(this, MapConfigForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onLayersChange = _this.onLayersChange.bind(_this);
	        _this.onBoundingBoxChange = _this.onBoundingBoxChange.bind(_this);
	        return _this;
	    }
	
	    MapConfigForm.prototype.componentDidMount = function componentDidMount() {
	        var formData = this.props.formData;
	
	        if (!formData.height) {
	            this.change({ height: formData.height || 600 });
	        }
	    };
	
	    MapConfigForm.prototype.onChangeHeight = function onChangeHeight(e) {
	        this.change({ height: e.target.value });
	    };
	
	    MapConfigForm.prototype.onBoundingBoxChange = function onBoundingBoxChange(item) {
	        this.change({ boundingBox: item });
	    };
	
	    MapConfigForm.prototype.onLayersChange = function onLayersChange(item) {
	        this.change({ activeLayerUuids: item });
	    };
	
	    MapConfigForm.prototype.change = function change(o) {
	        this.props.onChange(_extends({}, this.props.formData, o));
	    };
	
	    MapConfigForm.prototype.withCtx = function withCtx(s) {
	        return this.props.formId + '.' + s;
	    };
	
	    MapConfigForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            defaultMapConfig = _props.defaultMapConfig;
	
	        var mapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(defaultMapConfig);
	
	        return _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Container,
	                { className: 'py-3' },
	                _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Konfiguration' }),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { controlId: 'formControlMapBbox' },
	                            _react2.default.createElement(
	                                _reactBootstrap.FormLabel,
	                                null,
	                                'Standardkartenausschnitt'
	                            ),
	                            _react2.default.createElement(_Map2.default, {
	                                defaultFallbackMapConfigType: 'static',
	                                style: { height: '365px' },
	                                zoom: 12,
	                                plugins: [_BoundingboxInputPlugin2.default],
	                                boundingBox: formData.boundingBox,
	                                onBoundingBoxChanged: this.onBoundingBoxChange
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12 },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { controlId: 'formControlMapLayers' },
	                            _react2.default.createElement(
	                                _reactBootstrap.FormLabel,
	                                null,
	                                'Themen'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'layer-chooser' },
	                                _react2.default.createElement(_LayerChooser.LayerChooser, {
	                                    layerDescriptions: mapConfig && mapConfig.children,
	                                    onLayersChange: this.onLayersChange,
	                                    activeLayerUuids: formData.activeLayerUuids
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Col,
	                        { xs: 12, sm: 4 },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { controlId: 'formControlMapHeight' },
	                            _react2.default.createElement(
	                                _reactBootstrap.FormLabel,
	                                null,
	                                'H\xF6he (in Pixel)'
	                            ),
	                            _react2.default.createElement(_reactBootstrap.FormControl, {
	                                type: 'number',
	                                step: '10.0',
	                                value: formData.height,
	                                onChange: this.onChangeHeight.bind(this) })
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return MapConfigForm;
	}(_react2.default.Component);
	
	MapConfigForm.propTypes = {
	    formData: _propTypes2.default.object,
	    defaultMapConfig: _propTypes2.default.object,
	    onChange: _propTypes2.default.func,
	    formId: _propTypes2.default.string
	};
	
	exports.default = MapConfigForm;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 05.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _translateLeafletDrawer = __webpack_require__(66);
	
	var _translateLeafletDrawer2 = _interopRequireDefault(_translateLeafletDrawer);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BoundingboxInputPlugin = function () {
	    function BoundingboxInputPlugin(props) {
	        _classCallCheck(this, BoundingboxInputPlugin);
	
	        if (props.onBoundingBoxChanged) {
	            this.onBoundingBoxChanged = props.onBoundingBoxChanged.bind(this);
	        } else {
	            console.error('Required properties onBoundingBoxChanged are undefined!');
	        }
	    }
	
	    BoundingboxInputPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        (0, _liferayWidgetsReactWeb.amdRequire)(['leaflet-draw', 'css!leaflet-draw-css'], function () {
	            (0, _translateLeafletDrawer2.default)();
	            map.options.drawControl = true;
	
	            _this.drawnItems = new _leaflet2.default.FeatureGroup();
	            map.addLayer(_this.drawnItems);
	
	            if (o.boundingBox && o.boundingBox.longitudeMax > 0) {
	                _this.drawnItems.addLayer(new _leaflet2.default.geoJson({
	                    geometry: {
	                        type: 'Polygon',
	                        coordinates: [[[o.boundingBox.longitudeMax, o.boundingBox.latitudeMin], [o.boundingBox.longitudeMax, o.boundingBox.latitudeMax], [o.boundingBox.longitudeMin, o.boundingBox.latitudeMax], [o.boundingBox.longitudeMin, o.boundingBox.latitudeMin], [o.boundingBox.longitudeMax, o.boundingBox.latitudeMin]]]
	                    },
	                    type: 'Feature'
	                }));
	            }
	
	            var drawControl = new _leaflet2.default.Control.Draw({
	                draw: {
	                    circle: false,
	                    circlemarker: false,
	                    polyline: false,
	                    polygon: false,
	                    marker: false
	                },
	                edit: {
	                    featureGroup: _this.drawnItems
	                }
	            });
	            map.addControl(drawControl);
	
	            map.on(_leaflet2.default.Draw.Event.CREATED, _this.handleChange.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.EDITED, _this.handleChange.bind(_this));
	            map.on(_leaflet2.default.Draw.Event.DELETED, _this.handleDelete.bind(_this));
	        });
	    };
	
	    BoundingboxInputPlugin.prototype.handleChange = function handleChange(e) {
	        var layer = void 0;
	
	        if (e.layer) {
	            layer = e.layer;
	        } else {
	            layer = e.layers.getLayers()[0];
	        }
	
	        this.drawnItems.clearLayers();
	        this.drawnItems.addLayer(layer);
	
	        var geometry = layer.toGeoJSON().geometry;
	
	        var topLeft = geometry.coordinates[0][0];
	        var botRight = geometry.coordinates[0][2];
	
	        this.onBoundingBoxChanged({
	            latitudeMax: botRight[1],
	            latitudeMin: topLeft[1],
	            longitudeMax: botRight[0],
	            longitudeMin: topLeft[0]
	        });
	    };
	
	    BoundingboxInputPlugin.prototype.handleDelete = function handleDelete(e) {
	        this.onBoundingBoxChanged(null);
	    };
	
	    return BoundingboxInputPlugin;
	}();
	
	exports.default = BoundingboxInputPlugin;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 08.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _StoreFactory = __webpack_require__(44);
	
	var _LogicLayerListItem = __webpack_require__(118);
	
	var _LogicLayerListItem2 = _interopRequireDefault(_LogicLayerListItem);
	
	var _LogicLayerEditForm = __webpack_require__(119);
	
	var _LogicLayerEditForm2 = _interopRequireDefault(_LogicLayerEditForm);
	
	var _LayerDataSourceEditForm = __webpack_require__(120);
	
	var _LayerDataSourceEditForm2 = _interopRequireDefault(_LayerDataSourceEditForm);
	
	var _LogicLayerDetails = __webpack_require__(121);
	
	var _LogicLayerDetails2 = _interopRequireDefault(_LogicLayerDetails);
	
	var _LayerConfigActionButtons = __webpack_require__(122);
	
	var _LayerConfigActionButtons2 = _interopRequireDefault(_LayerConfigActionButtons);
	
	var _DataSourcesTable = __webpack_require__(123);
	
	var _DataSourcesTable2 = _interopRequireDefault(_DataSourcesTable);
	
	var _LogicalLayerWebApi = __webpack_require__(46);
	
	var _LogicalLayerWebApi2 = _interopRequireDefault(_LogicalLayerWebApi);
	
	var _LayerDataSourceWebApi = __webpack_require__(48);
	
	var _LayerDataSourceWebApi2 = _interopRequireDefault(_LayerDataSourceWebApi);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	var _LogicalLayerActions = __webpack_require__(126);
	
	var _LogicalLayerActions2 = _interopRequireDefault(_LogicalLayerActions);
	
	var _LayerDataSourceActions = __webpack_require__(127);
	
	var _LayerDataSourceActions2 = _interopRequireDefault(_LayerDataSourceActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogicalLayerStore = (0, _StoreFactory.getLogicalLayerStore)(_liferayWidgetsReactWeb.AppContext);
	var LayerDataSourceStore = (0, _StoreFactory.getLayerDataSourceStore)(_liferayWidgetsReactWeb.AppContext);
	
	var LogicLayerEditFormHoc = null;
	var LayerDataSourceEditFormHoc = null;
	
	var ScrollableDataListHOC = (0, _liferayWidgetsReactWeb.flagHOC)(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list']);
	var DataSourcesTableHOC = (0, _liferayWidgetsReactWeb.flagHOC)(_DataSourcesTable2.default, ['dataList']);
	
	var LayerConfigWidget = function (_React$Component) {
	    _inherits(LayerConfigWidget, _React$Component);
	
	    function LayerConfigWidget(props) {
	        _classCallCheck(this, LayerConfigWidget);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            LOGIC_LAYERS: 'logicLayers',
	            SELECTED_LOGIC_LAYER: 'selectedLogicLayer',
	            EDIT_LOGIC_LAYER_ITEM: 'editLogicLayerItem',
	            DELETE_LOGIC_LAYER_ITEM: 'deleteLogicLayerItem',
	
	            LAYER_DATA_SOURCES: 'layerDataSources',
	            EDIT_LAYER_DATA_SOURCES_ITEM: 'editLayerDataSourceItem',
	            DELETE_LAYER_DATA_SOURCES_ITEM: 'deleteLayerDataSourceItem'
	        };
	
	        LogicLayerEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_LogicLayerEditForm2.default);
	        LayerDataSourceEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_LayerDataSourceEditForm2.default);
	
	        return _this;
	    }
	
	    LayerConfigWidget.prototype.componentDidMount = function componentDidMount() {
	        _LogicalLayerActions2.default.list(this.DATA.LOGIC_LAYERS, {
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	        });
	
	        //AttachedLists
	        var linkedListQuery = {
	            $byId: _ClassNames2.default.LogicalLayer + '/' + this.DATA.SELECTED_LOGIC_LAYER + '/id',
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	        };
	        _LayerDataSourceActions2.default.list(this.DATA.LAYER_DATA_SOURCES, linkedListQuery);
	    };
	
	    LayerConfigWidget.getStores = function getStores() {
	        return [LogicalLayerStore, LayerDataSourceStore];
	    };
	
	    LayerConfigWidget.calculateState = function calculateState(prevState, prevProps, DATA) {
	        var _extends2;
	
	        return _extends({}, prevState, (_extends2 = {
	            i: prevState && prevState.i ? prevState.i + 1 : 1
	
	        }, _extends2[DATA.LOGIC_LAYERS] = LogicalLayerStore.getRemoteData(DATA.LOGIC_LAYERS), _extends2[DATA.SELECTED_LOGIC_LAYER] = LogicalLayerStore.getRemoteData(DATA.SELECTED_LOGIC_LAYER), _extends2[DATA.LAYER_DATA_SOURCES] = LayerDataSourceStore.getRemoteData(DATA.LAYER_DATA_SOURCES), _extends2));
	    };
	
	    //
	    // Logic Layer
	    //
	
	    LayerConfigWidget.prototype.onClickNewLogicLayer = function onClickNewLogicLayer() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.EDIT_LOGIC_LAYER_ITEM, {});
	    };
	
	    LayerConfigWidget.prototype.onClickEditLogicLayer = function onClickEditLogicLayer() {
	        var logicLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
	        logicLayer = logicLayer.item || logicLayer;
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.EDIT_LOGIC_LAYER_ITEM, _extends({}, logicLayer));
	    };
	
	    LayerConfigWidget.prototype.onClickDeleteLogicLayer = function onClickDeleteLogicLayer() {
	        var logicLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
	        logicLayer = logicLayer.item || logicLayer;
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.DELETE_LOGIC_LAYER_ITEM, _extends({}, logicLayer));
	    };
	
	    LayerConfigWidget.prototype.onLogicLayerFormSubmit = function onLogicLayerFormSubmit(logicalLayer, validation, formId) {
	        if (logicalLayer.id) {
	            _liferayWidgetsReactWeb.FormActions.submitForm(_LogicalLayerWebApi2.default.updateLogicLayer, logicalLayer, formId, true);
	        } else {
	            _liferayWidgetsReactWeb.FormActions.submitForm(_LogicalLayerWebApi2.default.addLogicalLayer, logicalLayer, formId, true);
	        }
	    };
	
	    LayerConfigWidget.prototype.onLogicLayerDeleteConfirm = function onLogicLayerDeleteConfirm(logicalLayer, validation, formId) {
	        _liferayWidgetsReactWeb.FormActions.submitForm(_LogicalLayerWebApi2.default.deleteLogicalLayer, logicalLayer, formId, true);
	    };
	
	    LayerConfigWidget.prototype.selectLogicLayer = function selectLogicLayer(logicLayer) {
	        _LogicalLayerActions2.default.item(this.DATA.SELECTED_LOGIC_LAYER, { item: logicLayer });
	    };
	
	    LayerConfigWidget.prototype.moreLogicLayers = function moreLogicLayers(query) {
	        _LogicalLayerActions2.default.moreItems(this.DATA.LOGIC_LAYERS, query);
	    };
	
	    //
	    // Layer Data Source
	    //
	
	
	    LayerConfigWidget.prototype.onClickNewLayerDataSource = function onClickNewLayerDataSource() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.EDIT_LAYER_DATA_SOURCES_ITEM, {
	            title: '',
	            typeKey: 'kml',
	            config: ''
	        });
	    };
	
	    LayerConfigWidget.prototype.onClickEditLayerDataSource = function onClickEditLayerDataSource(layerDataSource) {
	        layerDataSource = layerDataSource.item || layerDataSource;
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.EDIT_LAYER_DATA_SOURCES_ITEM, _extends({}, layerDataSource));
	    };
	
	    LayerConfigWidget.prototype.onClickDeleteLayerDataSource = function onClickDeleteLayerDataSource(layerDataSource) {
	        layerDataSource = layerDataSource.item || layerDataSource;
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.DELETE_LAYER_DATA_SOURCES_ITEM, _extends({}, layerDataSource));
	    };
	
	    LayerConfigWidget.prototype.onLayerDataSourceFormSubmit = function onLayerDataSourceFormSubmit(layerDataSource, validation, formId) {
	        var selectedLogicalLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
	        layerDataSource.logicalLayerId = selectedLogicalLayer.item.id;
	        if (layerDataSource.id) {
	            _liferayWidgetsReactWeb.FormActions.submitForm(_LayerDataSourceWebApi2.default.updateLayerDataSource, layerDataSource, formId, true);
	        } else {
	            _liferayWidgetsReactWeb.FormActions.submitForm(_LayerDataSourceWebApi2.default.addLayerDataSource, layerDataSource, formId, true);
	        }
	    };
	
	    LayerConfigWidget.prototype.onLayerDataSourceDeleteConfirm = function onLayerDataSourceDeleteConfirm(layerDataSource, validation, formId) {
	        _liferayWidgetsReactWeb.FormActions.submitForm(_LayerDataSourceWebApi2.default.deleteLayerDataSource, layerDataSource, formId, true);
	    };
	
	    LayerConfigWidget.prototype.moreLayerDataSource = function moreLayerDataSource() {
	        _LayerDataSourceActions2.default.moreItems(this.DATA.LAYER_DATA_SOURCES);
	    };
	
	    LayerConfigWidget.prototype.render = function render() {
	        var logicLayers = this.state[this.DATA.LOGIC_LAYERS];
	        var selectedLogicLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
	        var layerDataSources = this.state[this.DATA.LAYER_DATA_SOURCES];
	
	        /*eslint react/jsx-no-bind: 0*/
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { fluid: true },
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 3, md: 12, sm: 12, xs: 12, className: 'nopadding' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'padding-box' },
	                        _react2.default.createElement(
	                            _reactBootstrap.Button,
	                            { title: 'Neuen Layer anlegen', className: 'margin-bottom', variant: 'primary',
	                                onClick: this.onClickNewLogicLayer.bind(this) },
	                            'Erstellen'
	                        ),
	                        _react2.default.createElement(ScrollableDataListHOC, { list: logicLayers,
	                            activeIds: selectedLogicLayer,
	                            className: 'layer-config-logic-layer-list max-height-nav',
	                            ListItem: _LogicLayerListItem2.default,
	                            onClick: this.selectLogicLayer.bind(this),
	                            onClickMore: this.moreLogicLayers.bind(this) })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 9, md: 12, sm: 12, xs: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.Row,
	                        null,
	                        _react2.default.createElement(LogicLayerEditFormHoc, { formId: this.DATA.EDIT_LOGIC_LAYER_ITEM,
	                            onFormSubmit: this.onLogicLayerFormSubmit.bind(this) }),
	                        _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, {
	                            formId: this.DATA.DELETE_LOGIC_LAYER_ITEM,
	                            editRequired: false,
	                            onFormSubmit: this.onLogicLayerDeleteConfirm.bind(this)
	                            // submitButtonText={'Löschen'}
	                            , Content: function Content(_ref) {
	                                var formData = _ref.formData;
	                                return 'Wollen Sie den Layer ' + (formData.item || formData).title + ' wirklich löschen?';
	                            }
	                        }),
	                        (!selectedLogicLayer || !(selectedLogicLayer && selectedLogicLayer.item)) && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { lg: 12, md: 12, sm: 12, xs: 12 },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'error-message' },
	                                _liferayWidgetsReactWeb.translation.trans('please-choose-logic-layer')
	                            )
	                        ),
	                        selectedLogicLayer && selectedLogicLayer.item && _react2.default.createElement(
	                            _reactBootstrap.Col,
	                            { lg: 12, md: 12, sm: 12, xs: 12 },
	                            selectedLogicLayer && selectedLogicLayer._deleted && _react2.default.createElement(
	                                'h3',
	                                null,
	                                _liferayWidgetsReactWeb.translation.trans('item-was-deleted')
	                            ),
	                            !(selectedLogicLayer && selectedLogicLayer._deleted) && _react2.default.createElement(
	                                'div',
	                                { className: 'button-box-v' },
	                                _react2.default.createElement(_LayerConfigActionButtons2.default, {
	                                    onClickEdit: this.onClickEditLogicLayer.bind(this),
	                                    onClickDelete: this.onClickDeleteLogicLayer.bind(this) })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'padding-box' },
	                                _react2.default.createElement(_LogicLayerDetails2.default, { item: selectedLogicLayer }),
	                                _react2.default.createElement(LayerDataSourceEditFormHoc, { formId: this.DATA.EDIT_LAYER_DATA_SOURCES_ITEM,
	                                    onFormSubmit: this.onLayerDataSourceFormSubmit.bind(this) }),
	                                _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, {
	                                    formId: this.DATA.DELETE_LAYER_DATA_SOURCES_ITEM,
	                                    editRequired: false,
	                                    onFormSubmit: this.onLayerDataSourceDeleteConfirm.bind(this),
	                                    Content: function Content(_ref2) {
	                                        var formData = _ref2.formData;
	                                        return 'Wollen Sie die Datenquelle ' + (formData.item || formData).title + ' wirklich löschen?';
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                _liferayWidgetsReactWeb.translation.trans('LayerDataSources')
	                            ),
	                            !(selectedLogicLayer && selectedLogicLayer._deleted) && _react2.default.createElement(
	                                _reactBootstrap.Button,
	                                { title: 'Neue Datenquelle anf&ueml;gen', variant: 'primary',
	                                    onClick: this.onClickNewLayerDataSource.bind(this) },
	                                'Anf\xFCgen'
	                            ),
	                            _react2.default.createElement(DataSourcesTableHOC, { dataList: layerDataSources,
	                                onClickEdit: this.onClickEditLayerDataSource.bind(this),
	                                onClickDelete: this.onClickDeleteLayerDataSource.bind(this),
	                                onClickMore: this.moreLayerDataSource.bind(this) })
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return LayerConfigWidget;
	}(_react2.default.Component);
	
	LayerConfigWidget.propTypes = {};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(LayerConfigWidget);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogicLayerListItem = function (_React$Component) {
	    _inherits(LogicLayerListItem, _React$Component);
	
	    function LogicLayerListItem() {
	        _classCallCheck(this, LogicLayerListItem);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    LogicLayerListItem.prototype.onClick = function onClick(e) {
	        this.props.onClick(this.props.item, e);
	    };
	
	    LogicLayerListItem.prototype.render = function render() {
	        var dataItem = this.props.item,
	            item = dataItem && (dataItem.item || dataItem);
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            { onClick: this.onClick.bind(this) },
	            item.title
	        );
	    };
	
	    return LogicLayerListItem;
	}(_react2.default.Component);
	
	LogicLayerListItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = LogicLayerListItem;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogicLayerEditForm = function (_React$Component) {
	    _inherits(LogicLayerEditForm, _React$Component);
	
	    function LogicLayerEditForm() {
	        _classCallCheck(this, LogicLayerEditForm);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    LogicLayerEditForm.prototype.componentDidMount = function componentDidMount() {
	        var formData = this.props.formData;
	
	        return this.props.onChange(formData, this.validate(formData));
	    };
	
	    LogicLayerEditForm.prototype.onChange = function onChange(field, e) {
	        var _extends2;
	
	        var formData = this.props.formData,
	            item = formData.item || formData;
	
	        var newData = _extends({}, item, (_extends2 = {}, _extends2[field] = e.target.value, _extends2));
	
	        return this.props.onChange(newData, this.validate(newData));
	    };
	
	    LogicLayerEditForm.prototype.validate = function validate(formData) {
	        var titleValid = void 0,
	            descriptionValid = void 0;
	
	        if (!(formData.title && formData.title.length > 0)) {
	            titleValid = 'Bitte Titel eingeben';
	        }
	
	        if (formData.title && formData.title.length > 0 && !/\S/.test(formData.title)) {
	            titleValid = 'Titel darf nicht mit einem leerzeichen starten!';
	        }
	
	        if (formData.title && formData.title.length > 0 && !(formData.title.length <= 75)) {
	            titleValid = 'Titel zu lang. Maximal 75 Zeichen.';
	        }
	
	        if (formData.description && formData.description.length > 0 && !/\S/.test(formData.description)) {
	            descriptionValid = 'Beschreibung darf nicht mit einem leerzeichen starten!';
	        }
	
	        if (formData.description && formData.description.length > 0 && !(formData.description.length <= 75)) {
	            descriptionValid = 'Beschreibung zu lang. Maximal 75 Zeichen.';
	        }
	
	        return {
	            title: titleValid,
	            description: descriptionValid
	        };
	    };
	
	    LogicLayerEditForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation,
	            item = formData.item || formData;
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { className: 'py-3' },
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: _liferayWidgetsReactWeb.translation.trans('edit-logic-layer') }),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                { controlId: 'title' },
	                _react2.default.createElement(
	                    _reactBootstrap.FormLabel,
	                    null,
	                    _liferayWidgetsReactWeb.translation.trans('title') + '*'
	                ),
	                _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text', name: 'title',
	                    placeholder: _liferayWidgetsReactWeb.translation.trans('title'),
	                    value: item.title || '',
	                    onChange: this.onChange.bind(this, 'title'),
	                    required: true }),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'title' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                { controlId: 'description' },
	                _react2.default.createElement(
	                    _reactBootstrap.FormLabel,
	                    null,
	                    _liferayWidgetsReactWeb.translation.trans('description')
	                ),
	                _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text', name: 'description',
	                    placeholder: _liferayWidgetsReactWeb.translation.trans('description'),
	                    value: item.description || '',
	                    onChange: this.onChange.bind(this, 'description') }),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'description' })
	            )
	        );
	    };
	
	    return LogicLayerEditForm;
	}(_react2.default.Component);
	
	LogicLayerEditForm.propTypes = {
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    onChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = LogicLayerEditForm;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LayerDataSourceEditForm = function (_React$Component) {
	    _inherits(LayerDataSourceEditForm, _React$Component);
	
	    function LayerDataSourceEditForm() {
	        _classCallCheck(this, LayerDataSourceEditForm);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    LayerDataSourceEditForm.prototype.componentDidMount = function componentDidMount() {
	        var formData = this.props.formData;
	
	        return this.props.onChange(formData, this.validate(formData));
	    };
	
	    LayerDataSourceEditForm.prototype.onChange = function onChange(field, e) {
	        var _extends2;
	
	        var formData = this.props.formData,
	            item = formData.item || formData;
	
	        var newData = _extends({}, item, (_extends2 = {}, _extends2[field] = e.target.value, _extends2));
	
	        return this.props.onChange(newData, this.validate(newData));
	    };
	
	    LayerDataSourceEditForm.prototype.validate = function validate(formData) {
	        var titleValid = void 0,
	            typeValid = void 0,
	            configValid = void 0;
	
	        if (!(formData.title && formData.title.length > 0)) {
	            titleValid = 'Bitte Titel eingeben';
	        }
	
	        if (formData.title && formData.title.length > 0 && !/\S/.test(formData.title)) {
	            titleValid = 'Titel darf nicht mit einem leerzeichen starten!';
	        }
	
	        if (formData.title && formData.title.length > 0 && !(formData.title.length <= 75)) {
	            titleValid = 'Titel zu lang. Maximal 75 Zeichen.';
	        }
	
	        if (!formData.typeKey) {
	            typeValid = 'Bitte Typ auswählen';
	        }
	
	        if (!(formData.config && formData.config.length > 0)) {
	            configValid = 'Bitte Konfiguration angeben';
	        }
	
	        if (formData.config && formData.config.length > 0 && !/\S/.test(formData.config)) {
	            configValid = 'Konfiguration darf nicht mit einem leerzeichen starten!';
	        }
	
	        return {
	            title: titleValid,
	            typeKey: typeValid,
	            config: configValid
	        };
	    };
	
	    LayerDataSourceEditForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation,
	            item = formData.item || formData;
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { lg: 12, md: 12, sm: 12, xs: 12 },
	                _react2.default.createElement(
	                    'h1',
	                    { id: 'h1-config' },
	                    _liferayWidgetsReactWeb.translation.trans('edit-layer-data-source')
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    { controlId: 'title' },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormLabel,
	                        null,
	                        _liferayWidgetsReactWeb.translation.trans('title') + '*'
	                    ),
	                    _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text', name: 'title',
	                        placeholder: _liferayWidgetsReactWeb.translation.trans('title'),
	                        value: item.title,
	                        onChange: this.onChange.bind(this, 'title'),
	                        required: true }),
	                    _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'title' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    { controlId: 'typeKey' },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormLabel,
	                        null,
	                        _liferayWidgetsReactWeb.translation.trans('type') + '*'
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.FormControl,
	                        { as: 'select',
	                            name: 'typeKey',
	                            placeholder: 'select',
	                            value: item.typeKey || 'kml',
	                            onChange: this.onChange.bind(this, 'typeKey'),
	                            required: true },
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'cartodb' },
	                            _liferayWidgetsReactWeb.translation.trans('layer-cartodb')
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'remote-data-layer' },
	                            _liferayWidgetsReactWeb.translation.trans('layer-remote-data-layer')
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'leaflet-tile-layer' },
	                            _liferayWidgetsReactWeb.translation.trans('leaflet-tile-layer')
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'google-layer' },
	                            _liferayWidgetsReactWeb.translation.trans('google-layer')
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'wms' },
	                            _liferayWidgetsReactWeb.translation.trans('layer-wms')
	                        )
	                    ),
	                    _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'typeKey' })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    { controlId: 'config' },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormLabel,
	                        null,
	                        _liferayWidgetsReactWeb.translation.trans('config') + '*',
	                        ' '
	                    ),
	                    _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text',
	                        placeholder: JSON.stringify({ url: 'http://example.org/abc.json' }, null, '    '),
	                        onChange: this.onChange.bind(this, 'config'),
	                        value: item.config,
	                        required: true }),
	                    _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'config' })
	                )
	            )
	        );
	    };
	
	    return LayerDataSourceEditForm;
	}(_react2.default.Component);
	
	LayerDataSourceEditForm.propTypes = {
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    onChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = LayerDataSourceEditForm;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogicLayerDetails = function LogicLayerDetails(_ref) {
	    var item = _ref.item;
	
	    item = item && (item.item || item);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        item && _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: item.title }),
	        _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'border-box' },
	            _react2.default.createElement(
	                _reactBootstrap.Col,
	                { lg: 12, md: 12, sm: 12, xs: 12 },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _liferayWidgetsReactWeb.translation.trans('description'),
	                    ':'
	                ),
	                ' ',
	                item.description
	            )
	        )
	    );
	};
	
	LogicLayerDetails.propTypes = {
	    item: _propTypes2.default.object.isRequired
	};
	
	exports.default = LogicLayerDetails;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayerConfigActionButtons = function LayerConfigActionButtons(_ref) {
	    var onClickEdit = _ref.onClickEdit,
	        onClickDelete = _ref.onClickDelete;
	
	    return _react2.default.createElement(
	        _reactBootstrap.ButtonGroup,
	        { className: 'btnSettings' },
	        _react2.default.createElement(
	            _reactBootstrap.DropdownButton,
	            {
	                variant: 'primary',
	                id: 'layer-config-action-buttons',
	                title: _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('i', { className: 'fa fa-wrench' }),
	                    _liferayWidgetsReactWeb.translation.trans('settings')
	                )
	            },
	            onClickEdit && _react2.default.createElement(
	                _reactBootstrap.Dropdown.Item,
	                { variant: 'primary', onClick: onClickEdit.bind(undefined) },
	                _liferayWidgetsReactWeb.translation.trans('edit')
	            ),
	            ' ',
	            onClickDelete && _react2.default.createElement(
	                _reactBootstrap.Dropdown.Item,
	                { variant: 'primary', onClick: onClickDelete.bind(undefined) },
	                _liferayWidgetsReactWeb.translation.trans('delete')
	            )
	        )
	    );
	};
	
	LayerConfigActionButtons.propTypes = {
	    onClickEdit: _propTypes2.default.func,
	    onClickDelete: _propTypes2.default.func
	};
	
	exports.default = LayerConfigActionButtons;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _DataSourcesTableItem = __webpack_require__(124);
	
	var _DataSourcesTableItem2 = _interopRequireDefault(_DataSourcesTableItem);
	
	var _DataSourcesTableHeader = __webpack_require__(125);
	
	var _DataSourcesTableHeader2 = _interopRequireDefault(_DataSourcesTableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataSourcesTable = function DataSourcesTable(_ref) {
	    var dataList = _ref.dataList,
	        onClickEdit = _ref.onClickEdit,
	        onClickDelete = _ref.onClickDelete,
	        onClickMore = _ref.onClickMore,
	        ListHeader = _ref.ListHeader,
	        RowComponent = _ref.RowComponent,
	        defaultColspan = _ref.defaultColspan;
	
	
	    var colSpan = defaultColspan;
	
	    var fillLevelRows = dataList && dataList.item && dataList.item.length > 0 ? dataList.item.map(function (dataSource) {
	        return _react2.default.createElement(RowComponent, { item: dataSource,
	            onClickEdit: onClickEdit,
	            onClickDelete: onClickDelete,
	            key: dataSource.id });
	    }) : [];
	
	    if (onClickEdit) {
	        colSpan++;
	    }
	
	    if (onClickDelete) {
	        colSpan++;
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _reactBootstrap.Table,
	            { responsive: true, striped: true },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(ListHeader, null)
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                fillLevelRows,
	                !dataList && _react2.default.createElement(
	                    'tr',
	                    { key: '-1' },
	                    _react2.default.createElement(
	                        'td',
	                        { colSpan: colSpan },
	                        _liferayWidgetsReactWeb.translation.trans('no-entries')
	                    )
	                ),
	                dataList && !dataList._loading && !dataList._more && !fillLevelRows.length > 0 && _react2.default.createElement(
	                    'tr',
	                    { key: '-2' },
	                    _react2.default.createElement(
	                        'td',
	                        { colSpan: colSpan },
	                        _liferayWidgetsReactWeb.translation.trans('no-entries')
	                    )
	                ),
	                dataList && !dataList._loading && dataList._more && _react2.default.createElement(
	                    'tr',
	                    { key: '-2' },
	                    _react2.default.createElement(
	                        'td',
	                        { onClick: onClickMore, colSpan: colSpan },
	                        _liferayWidgetsReactWeb.translation.trans('load-more-results')
	                    )
	                )
	            )
	        )
	    );
	};
	
	DataSourcesTable.propTypes = {
	    dataList: _propTypes2.default.object,
	    defaultColspan: _propTypes2.default.number,
	    ListHeader: _propTypes2.default.func,
	    RowComponent: _propTypes2.default.func,
	    onClickMore: _propTypes2.default.func,
	    onClickEdit: _propTypes2.default.func,
	    onClickDelete: _propTypes2.default.func
	};
	
	DataSourcesTable.defaultProps = {
	    defaultColspan: 4,
	    ListHeader: _DataSourcesTableHeader2.default,
	    RowComponent: _DataSourcesTableItem2.default
	};
	
	exports.default = DataSourcesTable;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataSourcesTableItem = function DataSourcesTableItem(_ref) {
	    var item = _ref.item,
	        onClickEdit = _ref.onClickEdit,
	        onClickDelete = _ref.onClickDelete;
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            'td',
	            null,
	            item.title
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            item.typeKey
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            item.config
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { variant: 'primary', onClick: function onClick() {
	                        return onClickEdit(item);
	                    } },
	                _liferayWidgetsReactWeb.translation.trans('edit')
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                _reactBootstrap.Button,
	                { variant: 'primary', onClick: function onClick() {
	                        return onClickDelete(item);
	                    } },
	                _liferayWidgetsReactWeb.translation.trans('delete')
	            )
	        )
	    );
	};
	
	DataSourcesTableItem.propTypes = {
	    item: _propTypes2.default.object,
	    onClickEdit: _propTypes2.default.func,
	    onClickDelete: _propTypes2.default.func
	};
	
	exports.default = DataSourcesTableItem;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 09.06.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataSourcesTableHeader = function DataSourcesTableHeader() {
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            'th',
	            null,
	            _liferayWidgetsReactWeb.translation.trans('title')
	        ),
	        _react2.default.createElement(
	            'th',
	            null,
	            _liferayWidgetsReactWeb.translation.trans('type')
	        ),
	        _react2.default.createElement(
	            'th',
	            null,
	            _liferayWidgetsReactWeb.translation.trans('config')
	        ),
	        _react2.default.createElement(
	            'th',
	            null,
	            _liferayWidgetsReactWeb.translation.trans('actions')
	        )
	    );
	};
	
	DataSourcesTableHeader.propTypes = {};
	
	exports.default = DataSourcesTableHeader;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _LogicalLayerWebApi = __webpack_require__(46);
	
	var _LogicalLayerWebApi2 = _interopRequireDefault(_LogicalLayerWebApi);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _ClassNames2.default.LogicalLayer; /**
	                                                    * Copyright 2016 xdot GmbH
	                                                    * Author: Marius Runde
	                                                    * Date: 25.05.2016
	                                                    *
	                                                    */
	
	exports.default = {
	
	    list: function list(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query);
	    },
	    item: function item(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query);
	    },
	    moreItems: function moreItems(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, className, query);
	    },
	
	    allViewableGroupedList: function allViewableGroupedList(name) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, {}, _LogicalLayerWebApi2.default.listViewableLogicalLayersByGroupScope);
	    }
	
	    /*unsetSelectedLogicalLayer( name ) {
	        AppContext.getDispatcher().dispatch({
	                type: ActionTypesBase.RESET_DATA,
	                item: null,
	                meta: {
	                    name,
	                    storeKey: StoreKeys.LOGIC_LAYERS
	                }
	            }
	        );
	    }*/
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _ClassNames = __webpack_require__(11);
	
	var _ClassNames2 = _interopRequireDefault(_ClassNames);
	
	var _LayerDataSourceWebApi = __webpack_require__(48);
	
	var _LayerDataSourceWebApi2 = _interopRequireDefault(_LayerDataSourceWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _ClassNames2.default.LayerDataSource; /**
	                                                       * Copyright 2016 xdot GmbH
	                                                       * Author: Marius Runde
	                                                       * Date: 25.05.2016
	                                                       *
	                                                       */
	
	exports.default = {
	
	  list: function list(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query);
	  },
	  listByMapConfig: function listByMapConfig(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _LayerDataSourceWebApi2.default.listByMapConfig);
	  },
	  item: function item(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query);
	  },
	
	  moreItems: function moreItems(name, query) {
	    return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, className, query);
	  }
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 29.04.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _MapConfigActions = __webpack_require__(114);
	
	var _MapConfigActions2 = _interopRequireDefault(_MapConfigActions);
	
	var _LogicalLayerActions = __webpack_require__(126);
	
	var _LogicalLayerActions2 = _interopRequireDefault(_LogicalLayerActions);
	
	var _MapConfigChooser = __webpack_require__(129);
	
	var _MapConfigChooser2 = _interopRequireDefault(_MapConfigChooser);
	
	var _MapConfigEditForm = __webpack_require__(131);
	
	var _MapConfigEditForm2 = _interopRequireDefault(_MapConfigEditForm);
	
	var _DefaultMapConfigEditForm = __webpack_require__(143);
	
	var _DefaultMapConfigEditForm2 = _interopRequireDefault(_DefaultMapConfigEditForm);
	
	var _MapConfigCopyForm = __webpack_require__(144);
	
	var _MapConfigCopyForm2 = _interopRequireDefault(_MapConfigCopyForm);
	
	var _StoreFactory = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigStore = (0, _StoreFactory.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext);
	var LogicalLayerStore = (0, _StoreFactory.getLogicalLayerStore)(_liferayWidgetsReactWeb.AppContext);
	
	var MapConfigEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_MapConfigEditForm2.default);
	var DefaultMapConfigEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_DefaultMapConfigEditForm2.default);
	
	var MapConfigWidget = function (_React$Component) {
	    _inherits(MapConfigWidget, _React$Component);
	
	    function MapConfigWidget(props) {
	        _classCallCheck(this, MapConfigWidget);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            GROUP_MAP_CONFIGS: _this.withCtx('_GroupMapConfigs'),
	            MAP_CONFIGS: _this.withCtx('_MapConfigs'),
	            LOGIC_LAYERS: _this.withCtx('_LogicLayers'),
	            FORM_MAPCONFIGEDITFORM: _this.withCtx('_MapConfigEditForm'),
	            FORM_DEFAULTMAPCONFIGFORM: _this.withCtx('_DefaultMapConfigForm'),
	            FORM_RESETDEFAULTMAPCONFIGFORM: _this.withCtx('_ResetDefaultMapConfigForm')
	        };
	
	        _this.state = {
	            showCopyModal: false
	        };
	        return _this;
	    }
	
	    MapConfigWidget.prototype.componentDidMount = function componentDidMount() {
	        _MapConfigActions2.default.allList(this.DATA.GROUP_MAP_CONFIGS);
	        _MapConfigActions2.default.allGroupedList(this.DATA.MAP_CONFIGS);
	
	        _LogicalLayerActions2.default.allViewableGroupedList(this.DATA.LOGIC_LAYERS);
	    };
	
	    MapConfigWidget.getStores = function getStores() {
	        return [MapConfigStore, LogicalLayerStore];
	    };
	
	    MapConfigWidget.calculateState = function calculateState(prevState, prevProps, DATA) {
	        return _extends({}, prevState, {
	
	            groupMapConfigs: MapConfigStore.getRemoteData(DATA.GROUP_MAP_CONFIGS),
	            mapConfigs: MapConfigStore.getRemoteData(DATA.MAP_CONFIGS),
	            logicalLayers: LogicalLayerStore.getRemoteData(DATA.LOGIC_LAYERS)
	        });
	    };
	
	    MapConfigWidget.prototype.withCtx = function withCtx(s) {
	        return this.portletId + '.' + s;
	    };
	
	    MapConfigWidget.prototype.onNewMapConfig = function onNewMapConfig() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_MAPCONFIGEDITFORM, {});
	    };
	
	    MapConfigWidget.prototype.openDefaultMapConfigForm = function openDefaultMapConfigForm() {
	        var mapConfig = MapConfigStore.getDefaultMapConfig();
	        if (mapConfig && _liferayWidgetsReactWeb.DataUtil.asItem(mapConfig)) {
	            _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_DEFAULTMAPCONFIGFORM, { mapConfigId: _liferayWidgetsReactWeb.DataUtil.asItem(mapConfig).id });
	        } else {
	            _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_DEFAULTMAPCONFIGFORM, {});
	        }
	    };
	
	    MapConfigWidget.prototype.openDeleteDefaultMapConfigForm = function openDeleteDefaultMapConfigForm() {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_RESETDEFAULTMAPCONFIGFORM, {});
	    };
	
	    MapConfigWidget.prototype.onSubmitDefaultMapConfigForm = function onSubmitDefaultMapConfigForm(formData, validation, formId) {
	        if (!validation.mapConfigId) {
	            _MapConfigActions2.default.setDefaultMapConfig({
	                mapConfigId: formData.mapConfigId,
	                groupId: _liferayWidgetsReactWeb.AppContext.getScopeGroupId()
	            }, formId, true);
	
	            _MapConfigActions2.default.itemDefaultGrouped('GroupDefaultMapConfig_' + _liferayWidgetsReactWeb.AppContext.getScopeGroupId(), { groupId: _liferayWidgetsReactWeb.AppContext.getScopeGroupId() });
	        }
	    };
	
	    MapConfigWidget.prototype.onSubmitDefaultMapDeleteConfirmForm = function onSubmitDefaultMapDeleteConfirmForm(formData, validation, formId) {
	        _MapConfigActions2.default.resetDefaultMapConfig({
	            groupId: _liferayWidgetsReactWeb.AppContext.getScopeGroupId()
	        }, formId, true);
	    };
	
	    MapConfigWidget.prototype.onSelectMapConfig = function onSelectMapConfig(mapConfig) {
	        var copyConf = JSON.parse(JSON.stringify(mapConfig));
	
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_MAPCONFIGEDITFORM, copyConf);
	    };
	
	    MapConfigWidget.prototype.onDeleteMapConfig = function onDeleteMapConfig(mapConfig) {
	        _MapConfigActions2.default.deleteMapConfig(mapConfig);
	    };
	
	    MapConfigWidget.prototype.onSubmitMapConfig = function onSubmitMapConfig(mapConfig, validation, formId) {
	        if (!(validation.title || validation.description || validation.latitude || validation.longitude || validation.zoom)) {
	
	            if (mapConfig.id) {
	                _MapConfigActions2.default.updateMapConfig(mapConfig, formId, true);
	            } else {
	                _MapConfigActions2.default.addMapConfig(mapConfig, formId, true);
	            }
	        }
	    };
	
	    MapConfigWidget.prototype.handleSubmitCopyModal = function handleSubmitCopyModal(formData) {
	        var mapConfigCopy = JSON.parse(JSON.stringify(formData.mapConfig));
	
	        var deleteIDs = function deleteIDs(data) {
	            data.forEach(function (item) {
	                if (item.type === 'LayerSet') {
	                    delete item.id;
	                    return deleteIDs(item.children);
	                }
	            });
	        };
	
	        delete mapConfigCopy.uuid;
	        delete mapConfigCopy.id;
	        deleteIDs(mapConfigCopy.children);
	
	        this.onSelectMapConfig(mapConfigCopy);
	
	        this.setState({
	            showCopyModal: false
	        });
	    };
	
	    MapConfigWidget.prototype.handleCancelCopyModal = function handleCancelCopyModal() {
	        this.setState({
	            showCopyModal: false
	        });
	    };
	
	    MapConfigWidget.prototype.openCopyModal = function openCopyModal() {
	        this.setState({
	            showCopyModal: true
	        });
	    };
	
	    MapConfigWidget.prototype.render = function render() {
	        var _state = this.state,
	            groupMapConfigs = _state.groupMapConfigs,
	            mapConfigs = _state.mapConfigs,
	            logicalLayers = _state.logicalLayers,
	            showCopyModal = _state.showCopyModal;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'padding-box' },
	            _react2.default.createElement(_MapConfigChooser2.default, {
	                mapConfigs: groupMapConfigs,
	                onSelect: this.onSelectMapConfig.bind(this),
	                onDelete: this.onDeleteMapConfig.bind(this)
	            }),
	            _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { title: ' Neue Karte erstellen', variant: 'primary', onClick: this.onNewMapConfig.bind(this) },
	                    'Erstellen'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { title: 'Bestehende Karte kopieren',
	                        variant: 'primary',
	                        onClick: this.openCopyModal.bind(this) },
	                    'Kopieren'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { title: 'Standard-Konfiguration f\xFCr die Karte setzen', variant: 'primary',
	                        onClick: this.openDefaultMapConfigForm.bind(this) },
	                    'Standard einstellen'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { title: 'Standard-Konfiguration f\xFCr die Karte zur\xFCcksetzen', variant: 'primary',
	                        onClick: this.openDeleteDefaultMapConfigForm.bind(this) },
	                    'Standard zur\xFCcksetzen'
	                ),
	                _react2.default.createElement(
	                    _liferayWidgetsReactWeb.CustomModal,
	                    {
	                        show: showCopyModal,
	                        onHide: this.handleCancelCopyModal.bind(this) },
	                    _react2.default.createElement(
	                        _liferayWidgetsReactWeb.CustomModalBody,
	                        null,
	                        _react2.default.createElement(_MapConfigCopyForm2.default, {
	                            formData: mapConfigs,
	                            onSubmit: this.handleSubmitCopyModal.bind(this),
	                            onCancel: this.handleCancelCopyModal.bind(this)
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(MapConfigEditFormHoc, {
	                formId: this.DATA.FORM_MAPCONFIGEDITFORM,
	                logicalLayers: logicalLayers,
	                onFormSubmit: this.onSubmitMapConfig.bind(this)
	            }),
	            _react2.default.createElement(DefaultMapConfigEditFormHoc, { formId: this.DATA.FORM_DEFAULTMAPCONFIGFORM,
	                mapConfigs: mapConfigs,
	                onFormSubmit: this.onSubmitDefaultMapConfigForm.bind(this)
	            }),
	            _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, { formId: this.DATA.FORM_RESETDEFAULTMAPCONFIGFORM,
	                editRequired: false,
	                onFormSubmit: this.onSubmitDefaultMapDeleteConfirmForm.bind(this),
	                Content: 'Wollen Sie die Standard Kartenkonfiguration wirklich zur\xFCcksetzen?'
	
	            })
	        );
	    };
	
	    return MapConfigWidget;
	}(_react2.default.Component);
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(MapConfigWidget);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 13.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _MapConfigListItem = __webpack_require__(130);
	
	var _MapConfigListItem2 = _interopRequireDefault(_MapConfigListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollableDataListRVHOC = (0, _liferayWidgetsReactWeb.flagHOC)(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list']);
	
	var MapConfigChooser = function (_React$Component) {
	    _inherits(MapConfigChooser, _React$Component);
	
	    function MapConfigChooser(props) {
	        _classCallCheck(this, MapConfigChooser);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DATA = {
	            FORM_DELETE_CONFIRM: 'MapConfigChooserDeleteConfirm'
	        };
	        return _this;
	    }
	
	    MapConfigChooser.prototype.onSelect = function onSelect(item, e) {
	        this.props.onSelect(item);
	    };
	
	    MapConfigChooser.prototype.onDelete = function onDelete(item) {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_DELETE_CONFIRM, item);
	    };
	
	    MapConfigChooser.prototype.handleSubmitDeleteMapConfigModal = function handleSubmitDeleteMapConfigModal(item) {
	        this.props.onDelete(item);
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.FORM_DELETE_CONFIRM);
	    };
	
	    MapConfigChooser.prototype.render = function render() {
	        var mapConfigs = this.props.mapConfigs;
	
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'h3',
	                { className: 'widget-title' },
	                ' Kartenkonfigurationen '
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                ' Bitte w\xE4hlen Sie eine Kartenkonfiguration aus, um diese zu bearbeiten. '
	            ),
	            _react2.default.createElement(ScrollableDataListRVHOC, {
	                list: mapConfigs,
	                size: 'medium',
	                className: 'map-config-map-config-list',
	                ListItem: _MapConfigListItem2.default,
	                onClick: this.onSelect.bind(this),
	                onDelete: this.onDelete.bind(this)
	            }),
	            _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, {
	                editRequired: false,
	                submitButtonText: 'L\xF6schen',
	                formId: this.DATA.FORM_DELETE_CONFIRM,
	                onFormSubmit: this.handleSubmitDeleteMapConfigModal.bind(this),
	                Content: function Content(_ref) {
	                    var formData = _ref.formData;
	                    return 'Wollen Sie die Kartenkonfiguration \'' + (formData.item || formData).title + '\' wirklich löschen?';
	                }
	            })
	        );
	    };
	
	    return MapConfigChooser;
	}(_react2.default.Component);
	
	MapConfigChooser.propTypes = {
	    mapConfigs: _propTypes2.default.object,
	    onSelect: _propTypes2.default.func,
	    onDelete: _propTypes2.default.func
	};
	
	exports.default = MapConfigChooser;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 15.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigListItem = function (_React$Component) {
	    _inherits(MapConfigListItem, _React$Component);
	
	    function MapConfigListItem() {
	        _classCallCheck(this, MapConfigListItem);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    MapConfigListItem.prototype.onDelete = function onDelete(e) {
	        e.stopPropagation();
	        this.props.onDelete(this.props.item);
	    };
	
	    MapConfigListItem.prototype.render = function render() {
	        var dataItem = this.props.item,
	            item = dataItem && (dataItem.item || dataItem),
	            _props = this.props,
	            onClick = _props.onClick,
	            onDelete = _props.onDelete,
	            rest = _objectWithoutProperties(_props, ['onClick', 'onDelete']);
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            _extends({}, rest, {
	                className: 'd-flex align-items-center justify-content-between',
	                onClick: onClick.bind(this, dataItem),
	                action: true
	            }),
	            item.title + ' - (' + item.description + ')',
	            onDelete && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'outline-danger',
	                    size: 'sm',
	                    title: 'L\xF6schen',
	                    onClick: this.onDelete.bind(this)
	                },
	                _liferayWidgetsReactWeb.translation.trans('delete')
	            )
	        );
	    };
	
	    return MapConfigListItem;
	}(_react2.default.Component);
	
	MapConfigListItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func,
	    onDelete: _propTypes2.default.func
	});
	
	exports.default = MapConfigListItem;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 02.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _MapConfigDetails = __webpack_require__(132);
	
	var _MapConfigDetails2 = _interopRequireDefault(_MapConfigDetails);
	
	var _MapConfigPlugins = __webpack_require__(133);
	
	var _MapConfigPlugins2 = _interopRequireDefault(_MapConfigPlugins);
	
	var _MapConfigLayerTree = __webpack_require__(137);
	
	var _MapConfigLayerTree2 = _interopRequireDefault(_MapConfigLayerTree);
	
	var _MapConfigLayerOrdering = __webpack_require__(141);
	
	var _MapConfigLayerOrdering2 = _interopRequireDefault(_MapConfigLayerOrdering);
	
	var _MapConfigBaseLayerSelection = __webpack_require__(142);
	
	var _MapConfigBaseLayerSelection2 = _interopRequireDefault(_MapConfigBaseLayerSelection);
	
	var _mapConfigUtil = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigEditForm = function (_React$Component) {
	    _inherits(MapConfigEditForm, _React$Component);
	
	    function MapConfigEditForm(props) {
	        _classCallCheck(this, MapConfigEditForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            activeTabKey: 'tabBaseLayer'
	        };
	        return _this;
	    }
	
	    MapConfigEditForm.prototype.handleMapConfigChange = function handleMapConfigChange(mapConfig) {
	        this.handleChange(_extends({}, this.props.formData, mapConfig));
	    };
	
	    MapConfigEditForm.prototype.onBoundingBoxChanged = function onBoundingBoxChanged(boundingBox) {
	        this.handleChange(_extends({}, this.props.formData, {
	            boundingBox: boundingBox
	        }));
	    };
	
	    MapConfigEditForm.prototype.handlePluginsChange = function handlePluginsChange(plugins) {
	        this.handleChange(_extends({}, this.props.formData, {
	            plugins: plugins
	        }));
	    };
	
	    MapConfigEditForm.prototype.handleLogicalLayerOrderChange = function handleLogicalLayerOrderChange(logicalLayers) {
	        logicalLayers.forEach(function (ll, idx, arr) {
	            return ll.zIndex = arr.length - idx;
	        });
	        this.handleChange(this.props.formData);
	    };
	
	    MapConfigEditForm.prototype.handleLayerSetsChange = function handleLayerSetsChange(layerSets) {
	        this.handleChange(_extends({}, this.props.formData, {
	            children: layerSets
	        }));
	    };
	
	    MapConfigEditForm.prototype.handleChange = function handleChange(formData) {
	        this.props.onChange(formData, this.validate(formData));
	    };
	
	    MapConfigEditForm.prototype.validate = function validate(formData) {
	        var titleValid = void 0,
	            descriptionValid = void 0,
	            boundingboxValid = void 0,
	            defaultBaseLayerValid = void 0,
	            baseLayerValid = void 0,
	            zIndexesValid = void 0;
	
	        if (!(formData.title && formData.title.length > 0)) {
	            titleValid = 'Bitte Titel eingeben';
	        }
	
	        if (formData.title && formData.title.length > 0 && !/\S/.test(formData.title)) {
	            titleValid = 'Titel darf nicht mit einem Leerzeichen starten!';
	        }
	
	        if (formData.title && formData.title.length > 0 && !(formData.title.length <= 75)) {
	            titleValid = 'Titel zu lang. Maximal 75 Zeichen.';
	        }
	
	        if (formData.description && formData.description.length > 0 && !/\S/.test(formData.description)) {
	            descriptionValid = 'Beschreibung darf nicht mit einem Leerzeichen starten!';
	        }
	
	        if (formData.description && formData.description.length > 0 && !(formData.description.length <= 3999)) {
	            descriptionValid = 'Beschreibung zu lang. Maximal 3999 Zeichen.';
	        }
	
	        var bb = formData.boundingBox;
	        if (!(bb && bb.latitudeMax > 0 && bb.latitudeMin > 0 && bb.longitudeMax > 0 && bb.longitudeMin > 0)) {
	            boundingboxValid = 'Bitte Boundingbox angeben';
	        }
	
	        if (!(formData.defaultBaseLayerId && formData.defaultBaseLayerId > 0)) {
	            defaultBaseLayerValid = 'Bitte Standard BasisLayer auswählen';
	        }
	
	        if (!(formData.baseLayer && formData.baseLayer.length > 0)) {
	            baseLayerValid = 'Bitte min. 1 BasisLayer auswählen';
	        }
	
	        if (formData.children && formData.children.length > 0) {
	            var noZindexLayers = (0, _mapConfigUtil.findLogicalLayersWithoutZIndex)(formData.children);
	            if (noZindexLayers && noZindexLayers.length > 0) {
	                zIndexesValid = 'Bitte folgende Layer einsortieren:' + noZindexLayers.reduce(function (prev, cur) {
	                    return prev += ' ' + cur.title;
	                }, '');
	            }
	        }
	
	        return {
	            title: titleValid,
	            defaultBaseLayer: defaultBaseLayerValid,
	            baseLayer: baseLayerValid,
	            zIndexes: zIndexesValid,
	            description: descriptionValid,
	            boundingBox: boundingboxValid
	        };
	    };
	
	    MapConfigEditForm.prototype.handleSelectTab = function handleSelectTab(tabKey) {
	        this.setState({
	            activeTabKey: tabKey
	        });
	    };
	
	    MapConfigEditForm.prototype.render = function render() {
	        var _props = this.props,
	            mapConfig = _props.formData,
	            formValidation = _props.formValidation,
	            logicalLayers = _props.logicalLayers;
	
	        var mapConfigItem = mapConfig && mapConfig.item || mapConfig;
	
	        var logicalLayerItems = (0, _mapConfigUtil.findAndSortLogicalLayers)(mapConfigItem);
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { className: 'py-3' },
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Kartenkonfiguration bearbeiten' }),
	            _react2.default.createElement(_MapConfigDetails2.default, {
	                mapConfig: mapConfigItem,
	                onBoundingBoxChanged: this.onBoundingBoxChanged.bind(this),
	                formValidation: formValidation,
	                onChange: this.handleMapConfigChange.bind(this)
	            }),
	            _react2.default.createElement(
	                _reactBootstrap.Tabs,
	                {
	                    activeKey: this.state.activeTabKey,
	                    onSelect: this.handleSelectTab.bind(this),
	                    id: 'frb-tabs'
	                },
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'tabBaseLayer', title: 'Basislayer *' },
	                    _react2.default.createElement(_MapConfigBaseLayerSelection2.default, {
	                        layers: logicalLayers,
	                        mapConfig: mapConfig,
	                        formValidation: formValidation,
	                        onChange: this.handleMapConfigChange.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'tabLayerTree', title: 'Layer-Gruppierung' },
	                    _react2.default.createElement(_MapConfigLayerTree2.default, {
	                        layerSets: mapConfigItem.children,
	                        logicalLayers: logicalLayers,
	                        formValidation: formValidation,
	                        onChange: this.handleLayerSetsChange.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'tabZIndex', title: 'Layer-Reihenfolge' },
	                    _react2.default.createElement(_MapConfigLayerOrdering2.default, {
	                        logicalLayers: logicalLayerItems && logicalLayerItems.reverse(),
	                        formValidation: formValidation,
	                        onChange: this.handleLogicalLayerOrderChange.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Tab,
	                    { eventKey: 'tabPlugins', title: 'Plugins' },
	                    _react2.default.createElement(_MapConfigPlugins2.default, {
	                        plugins: mapConfigItem.plugins,
	                        onChange: this.handlePluginsChange.bind(this)
	                    })
	                )
	            )
	        );
	    };
	
	    return MapConfigEditForm;
	}(_react2.default.Component);
	
	MapConfigEditForm.propTypes = {
	    onChange: _propTypes2.default.func,
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    logicalLayers: _propTypes2.default.object
	};
	
	exports.default = MapConfigEditForm;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 02.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Map = __webpack_require__(21);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _BoundingboxInputPlugin = __webpack_require__(116);
	
	var _BoundingboxInputPlugin2 = _interopRequireDefault(_BoundingboxInputPlugin);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigDetails = function (_React$Component) {
	    _inherits(MapConfigDetails, _React$Component);
	
	    function MapConfigDetails(props) {
	        _classCallCheck(this, MapConfigDetails);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    MapConfigDetails.prototype.getMetaData = function getMetaData() {
	        var mapConfig = this.props.mapConfig;
	
	
	        return {
	            title: mapConfig.title,
	            description: mapConfig.description,
	            centerLatitude: mapConfig.centerLatitude,
	            centerLongitude: mapConfig.centerLongitude,
	            zoom: mapConfig.zoom
	        };
	    };
	
	    MapConfigDetails.prototype.updateTitle = function updateTitle(e) {
	        var metaData = this.getMetaData();
	        metaData.title = e.target.value;
	        this.props.onChange(metaData);
	    };
	
	    MapConfigDetails.prototype.updateDescription = function updateDescription(e) {
	        var metaData = this.getMetaData();
	        metaData.description = e.target.value;
	        this.props.onChange(metaData);
	    };
	
	    MapConfigDetails.prototype.updateCenterLatitude = function updateCenterLatitude(e) {
	        var metaData = this.getMetaData();
	        metaData.centerLatitude = parseFloat(e.target.value);
	        this.props.onChange(metaData);
	    };
	
	    MapConfigDetails.prototype.updateCenterLongitude = function updateCenterLongitude(e) {
	        var metaData = this.getMetaData();
	        metaData.centerLongitude = parseFloat(e.target.value);
	        this.props.onChange(metaData);
	    };
	
	    MapConfigDetails.prototype.updateZoom = function updateZoom(e) {
	        var metaData = this.getMetaData();
	        metaData.zoom = parseInt(e.target.value);
	        this.props.onChange(metaData);
	    };
	
	    MapConfigDetails.prototype.render = function render() {
	        var _props = this.props,
	            mapConfig = _props.mapConfig,
	            formValidation = _props.formValidation;
	
	        var boundingBox = mapConfig.boundingBox || null;
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 6, md: 6, sm: 12, xs: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { controlId: 'formControlsMetaDataTitle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormLabel,
	                            null,
	                            'Titel *'
	                        ),
	                        _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text',
	                            required: true,
	                            value: mapConfig.title || '',
	                            onChange: this.updateTitle.bind(this)
	                        }),
	                        _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'title' })
	                    ),
	                    _react2.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { controlId: 'formControlsMetaDataDescription' },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormLabel,
	                            null,
	                            'Beschreibung *'
	                        ),
	                        _react2.default.createElement(_reactBootstrap.FormControl, { as: 'textarea',
	                            required: true,
	                            value: mapConfig.description || '',
	                            onChange: this.updateDescription.bind(this)
	                        }),
	                        _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'description' })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 6, md: 6, sm: 12, xs: 12 },
	                    _react2.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { controlId: 'formControlsMetaDataTitle' },
	                        _react2.default.createElement(
	                            _reactBootstrap.FormLabel,
	                            null,
	                            'BoundingBox *'
	                        ),
	                        _react2.default.createElement(_reactBootstrap.InputGroup, { type: 'hidden',
	                            name: 'latitudeMax',
	                            id: 'latitudeMax',
	                            required: true,
	                            value: boundingBox && boundingBox.latitudeMax || undefined }),
	                        _react2.default.createElement(_reactBootstrap.InputGroup, { type: 'hidden',
	                            name: 'latitudeMin',
	                            id: 'latitudeMin',
	                            required: true,
	                            value: boundingBox && boundingBox.latitudeMin || undefined }),
	                        _react2.default.createElement(_reactBootstrap.InputGroup, { type: 'hidden',
	                            name: 'longitudeMax',
	                            id: 'longitudeMax',
	                            required: true,
	                            value: boundingBox && boundingBox.longitudeMax || undefined }),
	                        _react2.default.createElement(_reactBootstrap.InputGroup, { type: 'hidden',
	                            name: 'longitudeMin',
	                            id: 'longitudeMin',
	                            required: true,
	                            value: boundingBox && boundingBox.longitudeMin || undefined }),
	                        _react2.default.createElement(_Map2.default, { defaultFallbackMapConfigType: "static",
	                            plugins: [_BoundingboxInputPlugin2.default],
	                            boundingBox: boundingBox,
	                            onBoundingBoxChanged: this.props.onBoundingBoxChanged }),
	                        _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'boundingBox' })
	                    )
	                )
	            )
	        );
	    };
	
	    return MapConfigDetails;
	}(_react2.default.Component);
	
	MapConfigDetails.propTypes = {
	    mapConfig: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    onChange: _propTypes2.default.func,
	    onBoundingBoxChanged: _propTypes2.default.func
	};
	
	exports.default = MapConfigDetails;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 01.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _MapConfigEditPluginForm = __webpack_require__(134);
	
	var _MapConfigEditPluginForm2 = _interopRequireDefault(_MapConfigEditPluginForm);
	
	var _MapConfigPluginDragItem = __webpack_require__(135);
	
	var _MapConfigPluginDragItem2 = _interopRequireDefault(_MapConfigPluginDragItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigPlugins = function (_React$Component) {
	  _inherits(MapConfigPlugins, _React$Component);
	
	  function MapConfigPlugins(props) {
	    _classCallCheck(this, MapConfigPlugins);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedPlugin: null,
	      showEditPluginModal: false
	    };
	
	    _this.DATA = {
	      FORM_DELETE_CONFIRM: 'MapConfigPluginsDeleteConfirm'
	    };
	    return _this;
	  }
	
	  MapConfigPlugins.prototype.onEditPlugin = function onEditPlugin(plugin, e) {
	    e.stopPropagation();
	    this.setState({
	      selectedPlugin: plugin,
	      showEditPluginModal: true,
	      isNew: false
	    });
	  };
	
	  MapConfigPlugins.prototype.onAddPlugin = function onAddPlugin() {
	    this.setState({
	      selectedPlugin: null,
	      showEditPluginModal: true,
	      isNew: true
	    });
	  };
	
	  MapConfigPlugins.prototype.handleSubmitEditPluginModal = function handleSubmitEditPluginModal(formData) {
	    var plugins = this.props.plugins;
	    var selectedPlugin = this.state.selectedPlugin;
	    var path = formData.path,
	        config = formData.config,
	        valid = formData.valid;
	
	
	    var plugin = {
	      path: path,
	      config: config,
	      valid: valid,
	      key: selectedPlugin ? selectedPlugin.key : plugins && plugins.length || 0
	    };
	
	    var newPlugins = [plugin];
	    if (plugins) {
	      var replaced = false;
	      newPlugins = plugins.map(function (p) {
	        if (p.path === path) {
	          replaced = true;
	          return plugin;
	        }
	        return p;
	      });
	      if (!replaced) {
	        newPlugins.push(plugin);
	      }
	    }
	    this.props.onChange(newPlugins);
	
	    this.setState({
	      showEditPluginModal: false
	    });
	  };
	
	  MapConfigPlugins.prototype.handleCancelEditPluginModal = function handleCancelEditPluginModal() {
	    this.setState({
	      showEditPluginModal: false
	    });
	  };
	
	  MapConfigPlugins.prototype.onDeletePlugin = function onDeletePlugin(e, plugin) {
	    e.stopPropagation();
	    _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_DELETE_CONFIRM, plugin);
	    this.setState({
	      selectedPlugin: plugin
	    });
	  };
	
	  MapConfigPlugins.prototype.handleSubmitDeletePluginModal = function handleSubmitDeletePluginModal() {
	    var plugins = this.props.plugins;
	
	    _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.FORM_DELETE_CONFIRM);
	
	    plugins.splice(plugins.indexOf(this.state.selectedPlugin), 1);
	
	    this.setState({
	      selectedPlugin: null
	    });
	  };
	
	  MapConfigPlugins.prototype.render = function render() {
	    var _state = this.state,
	        selectedPlugin = _state.selectedPlugin,
	        showEditPluginModal = _state.showEditPluginModal,
	        isNew = _state.isNew;
	    var _props = this.props,
	        plugins = _props.plugins,
	        onChange = _props.onChange;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'button-box-v' },
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { variant: 'primary', type: 'button', onClick: this.onAddPlugin.bind(this) },
	          'Plugin hinzuf\xFCgen'
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.FormGroup,
	        null,
	        _react2.default.createElement(_liferayWidgetsReactWeb.DraggableList, {
	          DragItem: _MapConfigPluginDragItem2.default,
	          list: plugins && plugins.length > 0 ? [].concat(plugins) : [],
	          onEditElement: this.onEditPlugin.bind(this),
	          onDeleteElement: this.onDeletePlugin.bind(this),
	          changeOrder: onChange,
	          keyProp: 'path'
	        })
	      ),
	      _react2.default.createElement(
	        _liferayWidgetsReactWeb.CustomModal,
	        {
	          show: showEditPluginModal,
	          onHide: this.handleCancelEditPluginModal.bind(this) },
	        _react2.default.createElement(
	          _liferayWidgetsReactWeb.CustomModalBody,
	          null,
	          _react2.default.createElement(_MapConfigEditPluginForm2.default, {
	            formData: { plugin: selectedPlugin, plugins: plugins, isNew: isNew },
	            onSubmit: this.handleSubmitEditPluginModal.bind(this),
	            onCancel: this.handleCancelEditPluginModal.bind(this)
	          })
	        )
	      ),
	      _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, {
	        editRequired: false,
	        formId: this.DATA.FORM_DELETE_CONFIRM,
	        formData: _extends({}, selectedPlugin),
	        submitButtonText: 'L\xF6schen',
	        onFormSubmit: this.handleSubmitDeletePluginModal.bind(this),
	        Content: function Content(_ref) {
	          var formData = _ref.formData;
	          return 'Wollen Sie das Plugin \'' + (formData.item || formData).path + '\' wirklich löschen?';
	        }
	      })
	    );
	  };
	
	  return MapConfigPlugins;
	}(_react2.default.Component);
	
	MapConfigPlugins.propTypes = {
	  plugins: _propTypes2.default.array,
	  onChange: _propTypes2.default.func
	};
	
	exports.default = MapConfigPlugins;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 01.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigEditPluginForm = function (_React$Component) {
	    _inherits(MapConfigEditPluginForm, _React$Component);
	
	    function MapConfigEditPluginForm(props) {
	        _classCallCheck(this, MapConfigEditPluginForm);
	
	        // all available plugins
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.ELEMENTS = Object.keys(_liferayWidgetsReactWeb.amdRequire.s.contexts._.config.map['*']).filter(function (n) {
	            return n.indexOf('map/plugins') >= 0;
	        });
	        // already chosen plugins
	        _this.chosenPlugins = props.formData && props.formData.plugins && props.formData.plugins.map(function (p) {
	            return p.path;
	        }) || [];
	        // remove chosen plugins from available plugins
	        _this.availablePlugins = _this.ELEMENTS.filter(function (p) {
	            return _this.chosenPlugins.indexOf(p) < 0;
	        });
	
	        if (_this.props.formData.isNew) {
	            _this.state = {
	                path: '',
	                config: '',
	                availablePlugins: _this.availablePlugins
	            };
	        } else {
	            _this.state = _extends({}, props.formData.plugin);
	        }
	        return _this;
	    }
	
	    MapConfigEditPluginForm.prototype.handlePathChange = function handlePathChange(e) {
	        this.setState({
	            path: e.target.value,
	            pathValid: e.target.value.trim() ? undefined : 'Pfad ungültig'
	        });
	    };
	
	    MapConfigEditPluginForm.prototype.handleConfigChange = function handleConfigChange(e) {
	        var configValid = void 0;
	        try {
	            JSON.parse(e.target.value);
	        } catch (e) {
	            configValid = e.message;
	        }
	
	        this.setState({
	            config: e.target.value,
	            configValid: configValid
	        });
	    };
	
	    MapConfigEditPluginForm.prototype.handleSubmit = function handleSubmit(e) {
	        e.preventDefault();
	
	        var _state = this.state,
	            path = _state.path,
	            config = _state.config;
	
	
	        if (!path) {
	            return;
	        }
	
	        this.props.onSubmit(_extends({}, this.props.plugin, {
	            isNew: this.props.formData.isNew,
	            path: path,
	            config: config
	        }));
	    };
	
	    MapConfigEditPluginForm.prototype.onSelectPlugin = function onSelectPlugin(p) {
	        this.setState({
	            path: p
	        });
	    };
	
	    MapConfigEditPluginForm.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state2 = this.state,
	            path = _state2.path,
	            config = _state2.config,
	            availablePlugins = _state2.availablePlugins;
	        var isNew = this.props.formData.isNew;
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { className: 'py-3' },
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: isNew ? 'Plugin hinzufügen' : 'Plugin bearbeiten' }),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Bitte gib den Pfad und die Konfiguration des ',
	                isNew && _react2.default.createElement(
	                    'span',
	                    null,
	                    'neuen'
	                ),
	                ' Plugins ein.'
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.InputGroup,
	                    null,
	                    _react2.default.createElement(_reactBootstrap.FormControl, {
	                        type: 'text', placeholder: 'Pfad', value: path,
	                        onChange: this.handlePathChange.bind(this)
	                    }),
	                    _react2.default.createElement(
	                        _reactBootstrap.InputGroup.Append,
	                        null,
	                        _react2.default.createElement(
	                            _reactBootstrap.DropdownButton,
	                            {
	                                id: 'input-dropdown-addon',
	                                title: 'Plugins'
	                            },
	                            isNew && availablePlugins.map(function (p, i) {
	                                return _react2.default.createElement(
	                                    _reactBootstrap.Dropdown.Item,
	                                    { key: i, onClick: _this2.onSelectPlugin.bind(_this2, p) },
	                                    p
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: this.state, propName: 'pathValid' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.FormLabel,
	                    null,
	                    'Konfiguration'
	                ),
	                _react2.default.createElement(_reactBootstrap.FormControl, { as: 'textarea',
	                    placeholder: 'Konfiguration',
	                    value: config,
	                    onChange: this.handleConfigChange.bind(this) }),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: this.state, propName: 'configValid' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary',
	                        type: 'button',
	                        onClick: this.props.onCancel.bind(this)
	                    },
	                    'Abbrechen'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary',
	                        type: 'submit',
	                        onClick: this.handleSubmit.bind(this)
	                    },
	                    'Speichern'
	                )
	            )
	        );
	    };
	
	    return MapConfigEditPluginForm;
	}(_react2.default.Component);
	
	MapConfigEditPluginForm.propTypes = {
	    formData: _propTypes2.default.object,
	    plugin: _propTypes2.default.object,
	    onSubmit: _propTypes2.default.func,
	    onCancel: _propTypes2.default.func
	};
	
	exports.default = MapConfigEditPluginForm;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _Icon = __webpack_require__(136);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 04.10.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var MapConfigPluginDragItem = function (_React$Component) {
	  _inherits(MapConfigPluginDragItem, _React$Component);
	
	  function MapConfigPluginDragItem() {
	    _classCallCheck(this, MapConfigPluginDragItem);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MapConfigPluginDragItem.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var curPath = this.props && this.props.item && this.props.item.path;
	
	    if (curPath) {
	      (0, _liferayWidgetsReactWeb.amdRequire)([curPath], function (p) {
	        return _this2.setState({ plugin: p });
	      });
	    }
	  };
	
	  MapConfigPluginDragItem.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    var curPath = this.props && this.props.item && this.props.item.path,
	        nextPath = nextProps && nextProps.item && nextProps.item.path;
	
	    if (curPath !== nextPath) {
	      (0, _liferayWidgetsReactWeb.amdRequire)([curPath], function (p) {
	        return _this3.setState({ plugin: p });
	      });
	    }
	  };
	
	  MapConfigPluginDragItem.prototype.render = function render() {
	    var plugin = this.state && this.state.plugin;
	    var _props = this.props,
	        item = _props.item,
	        onDelete = _props.onDelete;
	
	    var exists = !!plugin;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'd-flex align-items-center justify-content-between w-100' },
	      _react2.default.createElement(
	        'a',
	        { onClick: this.props.onEdit && this.props.onEdit.bind(null, item) },
	        _react2.default.createElement('span', { className: exists ? 'status status-green' : 'status status-red' }),
	        _react2.default.createElement(
	          'h4',
	          null,
	          item && item.path
	        )
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        {
	          variant: 'link',
	          onClick: function onClick(e) {
	            return onDelete && onDelete(e, item);
	          }
	        },
	        _react2.default.createElement(_Icon2.default, { name: 'x red' })
	      )
	    );
	  };
	
	  return MapConfigPluginDragItem;
	}(_react2.default.Component);
	
	MapConfigPluginDragItem.propTypes = {
	  item: _propTypes2.default.object,
	  onEdit: _propTypes2.default.func,
	  onDelete: _propTypes2.default.func
	};
	
	exports.default = MapConfigPluginDragItem;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 17.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(_ref) {
	    var name = _ref.name,
	        onClick = _ref.onClick;
	
	    return _react2.default.createElement('span', { className: 'icon icon-map-' + name, onClick: onClick && onClick.bind(this) });
	};
	
	Icon.propTypes = {
	    name: _propTypes2.default.string,
	    onClick: _propTypes2.default.func
	};
	
	exports.default = Icon;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 29.04.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _Icon = __webpack_require__(136);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MapConfigEditLayerForm = __webpack_require__(138);
	
	var _MapConfigEditLayerForm2 = _interopRequireDefault(_MapConfigEditLayerForm);
	
	var _MapConfigLogicalLayerChooser = __webpack_require__(139);
	
	var _MapConfigLogicalLayerChooser2 = _interopRequireDefault(_MapConfigLogicalLayerChooser);
	
	var _mapConfigUtil = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var loop = function loop(data, parent, position, callback) {
	    data.forEach(function (item, index) {
	        if (item.position === position) {
	            return callback(item, index, parent);
	        } else if (item.children) {
	            return loop(item.children, item, position, callback);
	        }
	    });
	};
	
	var MapConfigEditLayerFormHoc = null;
	
	var MapConfigLayerTree = function (_React$Component) {
	    _inherits(MapConfigLayerTree, _React$Component);
	
	    function MapConfigLayerTree(props) {
	        _classCallCheck(this, MapConfigLayerTree);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        var layers = [{
	            title: 'Layer Sets',
	            type: 'LayerSet',
	            root: true
	        }];
	        var _this$props$layerSets = _this.props.layerSets,
	            layerSets = _this$props$layerSets === undefined ? [] : _this$props$layerSets;
	
	        layers[0].children = layerSets;
	
	        MapConfigEditLayerFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_MapConfigEditLayerForm2.default);
	
	        _this.DATA = {
	            FORM_MAP_CONFIG_EDIT_LAYER_FORM: 'MapConfigEditLayerForm',
	            FORM_MAP_CONFIG_DELETE_LAYER_FORM: 'MapConfigDeleteLayerForm'
	        };
	
	        var selectedLogicalLayers = (0, _mapConfigUtil.loopLogicalLayerIds)(layers[0], []);
	
	        _this.state = {
	            layers: layers,
	            selectedLogicalLayers: selectedLogicalLayers,
	            selectedKeys: []
	        };
	        return _this;
	    }
	
	    MapConfigLayerTree.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	        var _nextProps$layerSets = nextProps.layerSets,
	            layerSets = _nextProps$layerSets === undefined ? [] : _nextProps$layerSets;
	
	        var nextLayers = this.state.layers;
	        nextLayers[0].children = layerSets;
	
	        var selectedLogicalLayers = (0, _mapConfigUtil.loopLogicalLayerIds)(nextLayers[0], []);
	
	        this.setState({
	            layers: nextLayers,
	            selectedLogicalLayers: selectedLogicalLayers,
	            selectedKeys: []
	        });
	    };
	
	    MapConfigLayerTree.prototype.onDragEnter = function onDragEnter(info) {
	        this.setState({
	            expandedKeys: info.expandedKeys
	        });
	    };
	
	    MapConfigLayerTree.prototype.onDrop = function onDrop(info) {
	        var dropPos = parseInt(info.node.position);
	        var dragPos = parseInt(info.dragNode.position);
	
	        var layers = this.state.layers;
	
	
	        var dragObj = void 0,
	            prevIndex = void 0,
	            prevParent = void 0,
	            dropObj = void 0,
	            dropToGap = void 0;
	
	        loop(layers, null, dragPos, function (item, index, parent) {
	            dragObj = item;
	            prevIndex = index;
	            prevParent = parent;
	        });
	
	        loop(layers, null, dropPos, function (item, index, parent) {
	            // Only layer sets allowed on root level
	            if (item.root && (0, _mapConfigUtil.isLayerSet)(dragObj) || !item.root) {
	                if (info.dropToGap) {
	                    dropObj = parent;
	                    dropToGap = true;
	                } else if ((0, _mapConfigUtil.isLayerSet)(item)) {
	                    dropObj = item;
	                    dropToGap = false;
	                }
	            }
	        });
	
	        if (dropObj) {
	            prevParent.children.splice(prevIndex, 1);
	
	            if (dropToGap) {
	                dropObj.children.splice(info.dropPosition + 1, 0, dragObj);
	            } else {
	                dropObj.children.push(dragObj);
	            }
	        }
	
	        this.setState({
	            layers: layers,
	            selectedKeys: [],
	            selectedLayerSet: null
	        });
	    };
	
	    MapConfigLayerTree.prototype.onExpand = function onExpand(expandedKeys) {
	        this.setState({
	            expandedKeys: expandedKeys
	        });
	    };
	
	    MapConfigLayerTree.prototype.onSelect = function onSelect(selectedKeys, e) {
	        var _this2 = this;
	
	        var _state = this.state,
	            layers = _state.layers,
	            selectedLayerSet = _state.selectedLayerSet;
	
	
	        var layerPosition = parseInt(e.node.position);
	
	        loop(layers, null, layerPosition, function (item) {
	            if (!item.root && (0, _mapConfigUtil.isLayerSet)(item) && (!selectedLayerSet || layerPosition !== selectedLayerSet.position)) {
	                _this2.setState({
	                    selectedKeys: selectedKeys,
	                    selectedLayerSet: item
	                });
	            } else {
	                _this2.setState({
	                    selectedKeys: selectedKeys,
	                    selectedLayerSet: null
	                });
	            }
	        });
	    };
	
	    MapConfigLayerTree.prototype.onAddLayerSet = function onAddLayerSet(parentLayerSet, e) {
	        e.stopPropagation();
	
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_MAP_CONFIG_EDIT_LAYER_FORM, { isNew: true });
	        this.setState({
	            selectedLayerSet: parentLayerSet
	        });
	    };
	
	    MapConfigLayerTree.prototype.onEditLayerSet = function onEditLayerSet(layerSet, e) {
	        e.stopPropagation();
	
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_MAP_CONFIG_EDIT_LAYER_FORM, layerSet);
	        this.setState({
	            selectedLayerSet: layerSet
	        });
	    };
	
	    MapConfigLayerTree.prototype.handleSubmitEditLayerSetModal = function handleSubmitEditLayerSetModal(formData) {
	        var title = formData.title,
	            description = formData.description,
	            isNew = formData.isNew,
	            config = formData.config;
	        var _state2 = this.state,
	            layers = _state2.layers,
	            selectedLayerSet = _state2.selectedLayerSet;
	
	
	        if (isNew) {
	            var newLayerSet = {
	                title: title,
	                type: 'LayerSet',
	                description: description,
	                children: [],
	                config: config
	            };
	
	            loop(layers, null, selectedLayerSet.position, function (layerSet) {
	                layerSet.children.push(newLayerSet);
	            });
	        } else {
	            loop(layers, null, selectedLayerSet.position, function (layerSet) {
	                layerSet.title = title;
	                layerSet.description = description;
	                layerSet.config = config;
	            });
	        }
	
	        this.props.onChange(layers[0].children);
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.FORM_MAP_CONFIG_EDIT_LAYER_FORM);
	
	        this.setState({
	            layers: layers,
	            selectedLayerSet: isNew ? null : selectedLayerSet
	        });
	    };
	
	    MapConfigLayerTree.prototype.onAddLogicalLayer = function onAddLogicalLayer(logicalLayer) {
	        var _state3 = this.state,
	            layers = _state3.layers,
	            selectedLogicalLayers = _state3.selectedLogicalLayers,
	            selectedLayerSet = _state3.selectedLayerSet;
	
	
	        if (selectedLogicalLayers.indexOf(logicalLayer.uuid) < 0) {
	            var copyOfLogicalLayer = _extends({}, logicalLayer);
	            delete copyOfLogicalLayer.children;
	
	            if (selectedLayerSet) {
	                loop(layers, null, selectedLayerSet.position, function (layerSet) {
	                    layerSet.children.push(copyOfLogicalLayer);
	                    selectedLogicalLayers.push(copyOfLogicalLayer.uuid);
	                });
	
	                this.props.onChange(layers[0].children);
	
	                this.setState({
	                    layers: layers,
	                    selectedLogicalLayers: selectedLogicalLayers
	                });
	            }
	        }
	    };
	
	    MapConfigLayerTree.prototype.onDelete = function onDelete(layer, e) {
	        if (e) {
	            e.stopPropagation();
	        }
	
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_MAP_CONFIG_DELETE_LAYER_FORM, layer);
	
	        this.setState({
	            selectedLayer: layer,
	            showDeleteLayerModal: true
	        });
	    };
	
	    MapConfigLayerTree.prototype.handleSubmitDeleteLayerModal = function handleSubmitDeleteLayerModal() {
	        var _state4 = this.state,
	            layers = _state4.layers,
	            selectedLogicalLayers = _state4.selectedLogicalLayers,
	            selectedLayer = _state4.selectedLayer;
	
	
	        loop(layers, null, selectedLayer.position, function (item, index, parent) {
	            parent.children.splice(index, 1);
	        });
	
	        if ((0, _mapConfigUtil.isLogicalLayer)(selectedLayer)) {
	            selectedLogicalLayers.splice(selectedLogicalLayers.indexOf(selectedLayer.uuid), 1);
	        }
	
	        this.props.onChange(layers[0].children);
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.FORM_MAP_CONFIG_DELETE_LAYER_FORM);
	
	        this.setState({
	            layers: layers,
	            selectedLogicalLayers: selectedLogicalLayers,
	            selectedLayer: null,
	            showDeleteLayerModal: false
	        });
	    };
	
	    MapConfigLayerTree.prototype.renderLayerSet = function renderLayerSet(item) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	                'span',
	                null,
	                item.root ? 'Layer Sets' : item.title
	            ),
	            ' ',
	            _react2.default.createElement(_Icon2.default, { name: 'plus', onClick: this.onAddLayerSet.bind(this, item) }),
	            ' ',
	            !item.root && _react2.default.createElement(_Icon2.default, { name: 'pencil', onClick: this.onEditLayerSet.bind(this, item) }),
	            ' ',
	            !item.root && _react2.default.createElement(_Icon2.default, { name: 'x', onClick: this.onDelete.bind(this, item) })
	        );
	    };
	
	    MapConfigLayerTree.prototype.renderLogicalLayer = function renderLogicalLayer(item) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	                'span',
	                null,
	                item.title
	            ),
	            ' ',
	            _react2.default.createElement(_Icon2.default, { name: 'x', onClick: this.onDelete.bind(this, item) })
	        );
	    };
	
	    MapConfigLayerTree.prototype.getTreeData = function getTreeData(layers) {
	        var _this3 = this;
	
	        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        return layers.map(function (item, i) {
	            var key = level + '-' + i;
	            if ((0, _mapConfigUtil.isLayerSet)(item)) {
	                return {
	                    key: key,
	                    title: function title() {
	                        return _this3.renderLayerSet(item);
	                    },
	                    isLeaf: false,
	                    children: _this3.getTreeData(item.children, key),
	                    position: item.position
	                };
	            } else {
	                return {
	                    key: key,
	                    title: function title() {
	                        return _this3.renderLogicalLayer(item);
	                    },
	                    isLeaf: true,
	                    position: item.position
	                };
	            }
	        });
	    };
	
	    MapConfigLayerTree.prototype.render = function render() {
	        var _this4 = this;
	
	        var _state5 = this.state,
	            layers = _state5.layers,
	            selectedLogicalLayers = _state5.selectedLogicalLayers,
	            selectedKeys = _state5.selectedKeys,
	            selectedLayerSet = _state5.selectedLayerSet;
	        var formValidation = this.props.formValidation;
	
	
	        var counter = 0;
	
	        var appendPos = function appendPos(arr) {
	            arr.forEach(function (i) {
	                var item = i.item || i;
	                if ((0, _mapConfigUtil.isLayerSet)(item) || (0, _mapConfigUtil.isLogicalLayer)(item)) {
	                    item.position = counter;
	                    counter++;
	                }
	
	                if (item.children) {
	                    appendPos(item.children);
	                }
	            });
	        };
	
	        appendPos(layers);
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            null,
	            _react2.default.createElement(
	                _reactBootstrap.Row,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 6, md: 6, sm: 12, xs: 12 },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Layer-Gruppierung'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { height: 500, overflow: 'auto' } },
	                        _react2.default.createElement(
	                            _liferayWidgetsReactWeb.AmdRequireComponent,
	                            { dependencies: ['rc-tree', 'rcTreeCss'] },
	                            function (rcTree) {
	                                var Tree = rcTree['default'];
	
	                                var treeData = _this4.getTreeData(layers);
	                                return _react2.default.createElement(Tree, {
	                                    selectedKeys: selectedKeys,
	                                    onExpand: _this4.onExpand.bind(_this4),
	                                    autoExpandParent: true,
	                                    defaultExpandAll: true,
	                                    showLine: true,
	                                    draggable: true,
	                                    onDragEnter: _this4.onDragEnter.bind(_this4),
	                                    onDrop: _this4.onDrop.bind(_this4),
	                                    onSelect: _this4.onSelect.bind(_this4),
	                                    treeData: treeData
	                                });
	                            }
	                        )
	                    ),
	                    _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'children' }),
	                    _react2.default.createElement(MapConfigEditLayerFormHoc, {
	                        formId: this.DATA.FORM_MAP_CONFIG_EDIT_LAYER_FORM,
	                        onFormSubmit: this.handleSubmitEditLayerSetModal.bind(this)
	                    }),
	                    _react2.default.createElement(_liferayWidgetsReactWeb.ConfirmFormContainer, {
	                        formId: this.DATA.FORM_MAP_CONFIG_DELETE_LAYER_FORM,
	                        editRequired: false,
	                        onFormSubmit: this.handleSubmitDeleteLayerModal.bind(this),
	                        Content: function Content(_ref) {
	                            var formData = _ref.formData;
	                            return (formData.item || formData).type === 'LayerSet' ? 'Wollen Sie die Gruppierung ' + (formData.item || formData).title + ' wirklich löschen?' : 'Wollen Sie den Layer ' + (formData.item || formData).title + ' wirklich löschen?';
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Col,
	                    { lg: 6, md: 6, sm: 12, xs: 12 },
	                    _react2.default.createElement(_MapConfigLogicalLayerChooser2.default, {
	                        selectedLogicalLayers: selectedLogicalLayers,
	                        selectedLayerSet: selectedLayerSet,
	                        logicalLayers: this.props.logicalLayers,
	                        onSelect: this.onAddLogicalLayer.bind(this)
	                    })
	                )
	            )
	        );
	    };
	
	    return MapConfigLayerTree;
	}(_react2.default.Component);
	
	MapConfigLayerTree.propTypes = {
	    layerSets: _propTypes2.default.array,
	    logicalLayers: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    onChange: _propTypes2.default.func
	};
	
	exports.default = MapConfigLayerTree;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Hibbeler
	 * Date: 18.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigEditLayerForm = function (_React$Component) {
	    _inherits(MapConfigEditLayerForm, _React$Component);
	
	    function MapConfigEditLayerForm(props) {
	        _classCallCheck(this, MapConfigEditLayerForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        if (_this.props.formData.isNew) {
	            _this.state = {
	                title: '',
	                description: '',
	                config: ''
	            };
	        } else {
	            _this.state = _extends({}, props.formData.layerSet);
	        }
	        return _this;
	    }
	
	    MapConfigEditLayerForm.prototype.componentDidMount = function componentDidMount() {
	        var formData = this.props.formData;
	
	        return this.props.onChange(formData, this.validate(formData));
	    };
	
	    MapConfigEditLayerForm.prototype.validate = function validate(formData) {
	        var titleValid = void 0,
	            descriptionValid = void 0,
	            configValid = void 0;
	
	        if (!(formData.title && formData.title.length > 0)) {
	            titleValid = 'Bitte Titel eingeben';
	        }
	
	        if (formData.title && formData.title.length > 0 && !/\S/.test(formData.title)) {
	            titleValid = 'Titel darf nicht mit einem leerzeichen starten!';
	        }
	
	        if (formData.title && formData.title.length > 0 && !(formData.title.length <= 75)) {
	            titleValid = 'Titel zu lang. Maximal 75 Zeichen.';
	        }
	
	        if (formData.description && formData.description.length > 0 && !/\S/.test(formData.description)) {
	            descriptionValid = 'Beschreibung darf nicht mit einem leerzeichen starten!';
	        }
	
	        if (formData.description && formData.description.length > 0 && !(formData.description.length <= 3999)) {
	            descriptionValid = 'Beschreibung zu lang. Maximal 75 Zeichen.';
	        }
	
	        return {
	            title: titleValid,
	            description: descriptionValid,
	            config: configValid
	        };
	    };
	
	    MapConfigEditLayerForm.prototype.onChange = function onChange(field, e) {
	        var _extends2;
	
	        var formData = this.props.formData,
	            item = formData.item || formData;
	
	        var newData = _extends({}, item, (_extends2 = {}, _extends2[field] = e.target.value, _extends2));
	
	        return this.props.onChange(newData, this.validate(newData));
	    };
	
	    MapConfigEditLayerForm.prototype.render = function render() {
	        var _props = this.props,
	            formValidation = _props.formValidation,
	            formData = _props.formData;
	
	        var isNew = this.props.formData.isNew;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'p-3' },
	            isNew && _react2.default.createElement(
	                'h1',
	                null,
	                'Gruppierung hinzuf\xFCgen'
	            ) || _react2.default.createElement(
	                'h1',
	                null,
	                'Gruppierung bearbeiten'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Bitte geben Sie den Titel und die Beschreibung der ',
	                isNew && _react2.default.createElement(
	                    'span',
	                    null,
	                    'neuen'
	                ),
	                ' Gruppierung ein.'
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.FormLabel,
	                    { lg: 2, md: 3, sm: 12, xs: 12 },
	                    'Titel'
	                ),
	                _react2.default.createElement(_reactBootstrap.FormControl, { lg: 10, md: 9, sm: 12, xs: 12,
	                    type: 'text',
	                    placeholder: 'Titel',
	                    value: formData.title,
	                    onChange: this.onChange.bind(this, 'title') }),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'title' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.FormLabel,
	                    { lg: 2, md: 3, sm: 12, xs: 12 },
	                    'Beschreibung'
	                ),
	                _react2.default.createElement(_reactBootstrap.FormControl, { lg: 10, md: 9, sm: 12, xs: 12,
	                    type: 'text',
	                    placeholder: 'Beschreibung',
	                    value: formData.description,
	                    onChange: this.onChange.bind(this, 'description') }),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'description' })
	            ),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.FormLabel,
	                    { lg: 2, md: 3, sm: 12, xs: 12 },
	                    'Kofiguration'
	                ),
	                _react2.default.createElement(_reactBootstrap.FormControl, { lg: 10, md: 9, sm: 12, xs: 12,
	                    type: 'text',
	                    placeholder: 'Kofiguration',
	                    value: formData.config,
	                    onChange: this.onChange.bind(this, 'config') }),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'config' })
	            )
	        );
	    };
	
	    return MapConfigEditLayerForm;
	}(_react2.default.Component);
	
	MapConfigEditLayerForm.propTypes = {
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    onChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = MapConfigEditLayerForm;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 02.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _MapConfigLogicalLayerListItem = __webpack_require__(140);
	
	var _MapConfigLogicalLayerListItem2 = _interopRequireDefault(_MapConfigLogicalLayerListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigLogicalLayerChooser = function (_React$Component) {
	    _inherits(MapConfigLogicalLayerChooser, _React$Component);
	
	    function MapConfigLogicalLayerChooser(props) {
	        _classCallCheck(this, MapConfigLogicalLayerChooser);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            selectedLogicalLayer: null
	        };
	        return _this;
	    }
	
	    MapConfigLogicalLayerChooser.prototype.onSelect = function onSelect(item, e) {
	        this.setState({
	            selectedLogicalLayer: item
	        });
	
	        this.props.onSelect(item);
	    };
	
	    MapConfigLogicalLayerChooser.prototype.render = function render() {
	        var _props = this.props,
	            selectedLogicalLayers = _props.selectedLogicalLayers,
	            selectedLayerSet = _props.selectedLayerSet,
	            logicalLayers = _props.logicalLayers;
	
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Verf\xFCgbare Layer'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                selectedLayerSet ? 'Bitte wählen Sie einen Layer aus, den Sie hinzufügen möchten.' : 'Bitte wählen Sie eine Gruppierung aus.'
	            ),
	            _react2.default.createElement(_liferayWidgetsReactWeb.ScrollableDataListRV, { list: logicalLayers,
	                size: 'medium',
	                activeIds: this.state.selectedLogicalLayer,
	                className: 'map-config-logical-layer-list',
	                ListItem: _MapConfigLogicalLayerListItem2.default,
	                onClick: this.onSelect.bind(this),
	                selectedLogicalLayers: selectedLogicalLayers,
	                selectedLayerSet: selectedLayerSet
	            })
	        );
	    };
	
	    return MapConfigLogicalLayerChooser;
	}(_react2.default.Component);
	
	MapConfigLogicalLayerChooser.propTypes = {
	    selectedLogicalLayers: _propTypes2.default.array,
	    selectedLayerSet: _propTypes2.default.object,
	    logicalLayers: _propTypes2.default.object,
	    onSelect: _propTypes2.default.func
	};
	
	exports.default = MapConfigLogicalLayerChooser;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 23.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigLogicalLayerListItem = function (_React$Component) {
	    _inherits(MapConfigLogicalLayerListItem, _React$Component);
	
	    function MapConfigLogicalLayerListItem() {
	        _classCallCheck(this, MapConfigLogicalLayerListItem);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    MapConfigLogicalLayerListItem.prototype.onClick = function onClick(e) {
	        this.props.onClick(this.props.item, e);
	    };
	
	    MapConfigLogicalLayerListItem.prototype.render = function render() {
	        var _props = this.props,
	            selectedLogicalLayers = _props.selectedLogicalLayers,
	            selectedLayerSet = _props.selectedLayerSet;
	
	
	        var dataItem = this.props.item,
	            item = dataItem && (dataItem.item || dataItem);
	
	        var alreadyExisting = selectedLogicalLayers && selectedLogicalLayers.indexOf(item.uuid) >= 0;
	
	        var title = item.title + (alreadyExisting ? ' (in Kartenkonfiguration bereits enthalten)' : '');
	        title = title + (item.description ? ' (Beschreibung: ' + item.description.slice(0, 50) + '...)' : '');
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            {
	                disabled: !selectedLayerSet || alreadyExisting,
	                onClick: this.onClick.bind(this),
	                title: item.description || ''
	            },
	            title
	        );
	    };
	
	    return MapConfigLogicalLayerListItem;
	}(_react2.default.Component);
	
	MapConfigLogicalLayerListItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = MapConfigLogicalLayerListItem;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 01.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MapConfigLayerOrdering(_ref) {
	  var onChange = _ref.onChange,
	      _ref$logicalLayers = _ref.logicalLayers,
	      logicalLayers = _ref$logicalLayers === undefined ? [] : _ref$logicalLayers,
	      formValidation = _ref.formValidation;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'zIndexes' }),
	    _react2.default.createElement(
	      _reactBootstrap.FormGroup,
	      null,
	      _react2.default.createElement(_liferayWidgetsReactWeb.DraggableList, {
	        DragItem: function DragItem(_ref2) {
	          var item = _ref2.item;
	          return _react2.default.createElement(
	            'div',
	            { className: 'list-item-name' },
	            item.title + ' (' + (item.description || '---') + ')'
	          );
	        },
	        list: logicalLayers,
	        changeOrder: onChange,
	        keyProp: 'uuid'
	      })
	    ),
	    _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'zIndexes' })
	  );
	}
	
	MapConfigLayerOrdering.propTypes = {
	  logicalLayers: _propTypes2.default.array,
	  formValidation: _propTypes2.default.object,
	  onChange: _propTypes2.default.func
	};
	
	exports.default = MapConfigLayerOrdering;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(68);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 04.10.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Multiselect = function Multiselect(_ref) {
	    var layers = _ref.layers,
	        baseLayer = _ref.baseLayer,
	        defaultId = _ref.defaultId,
	        onSelectDefault = _ref.onSelectDefault,
	        onSelect = _ref.onSelect;
	
	    var selected = baseLayer.reduce(function (p, c) {
	        return (p[c.id] = true) && p;
	    }, {});
	    return _react2.default.createElement(
	        _reactBootstrap.ListGroup,
	        { as: 'ul' },
	        layers.map(function (l) {
	            return _react2.default.createElement(
	                _reactBootstrap.ListGroup.Item,
	                { as: 'li', key: 'BaseLayerSelect_' + l.id, className: 'd-flex align-items-center justify-content-between' },
	                _react2.default.createElement(_reactBootstrap.FormCheck, { checked: !!selected[l.id], onChange: function onChange() {
	                        return onSelect(l);
	                    } }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    l.title
	                ),
	                defaultId === l.id ? _react2.default.createElement(
	                    'span',
	                    { className: 'title' },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Standard'
	                    )
	                ) : _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary', onClick: function onClick() {
	                            return onSelectDefault(l);
	                        } },
	                    'Als Standard'
	                )
	            );
	        })
	    );
	};
	
	Multiselect.propTypes = {
	    layers: _propTypes2.default.array,
	    baseLayer: _propTypes2.default.array,
	    defaultId: _propTypes2.default.number,
	    onSelectDefault: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func
	};
	
	var MapConfigBaseLayerSelection = function (_React$Component) {
	    _inherits(MapConfigBaseLayerSelection, _React$Component);
	
	    function MapConfigBaseLayerSelection() {
	        _classCallCheck(this, MapConfigBaseLayerSelection);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    MapConfigBaseLayerSelection.prototype.onBaseLayerChange = function onBaseLayerChange(layers, mapConfig) {
	        var select = _reactDom2.default.findDOMNode(this.refs.baseLayerSelect);
	
	        var baseLayerIds = select && select.selectedOptions ? Array.prototype.map.call(select.selectedOptions, function (o) {
	            return o.value;
	        }) : undefined;
	        var baseLayer = [];
	
	        layers.forEach(function (layer) {
	            baseLayerIds.forEach(function (id) {
	                if (layer.id == id) {
	                    baseLayer.push(layer);
	                }
	            });
	        });
	
	        this.props.onChange(_extends({}, mapConfig, {
	            baseLayer: baseLayer
	        }));
	    };
	
	    MapConfigBaseLayerSelection.prototype.onSelect = function onSelect(layer) {
	        var mapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(this.props.mapConfig),
	            _mapConfig$baseLayer = mapConfig.baseLayer,
	            baseLayer = _mapConfig$baseLayer === undefined ? [] : _mapConfig$baseLayer,
	            filter = baseLayer.filter(function (l) {
	            return l.id !== layer.id;
	        });
	
	
	        if (mapConfig.defaultBaseLayerId === layer.id) {
	            delete mapConfig.defaultBaseLayerId;
	        }
	
	        this.props.onChange(_extends({}, mapConfig, {
	            baseLayer: filter.length !== baseLayer.length ? filter : baseLayer.concat(layer)
	        }));
	    };
	
	    MapConfigBaseLayerSelection.prototype.onSelectDefault = function onSelectDefault(layer) {
	        var mapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(this.props.mapConfig),
	            _mapConfig$baseLayer2 = mapConfig.baseLayer,
	            baseLayer = _mapConfig$baseLayer2 === undefined ? [] : _mapConfig$baseLayer2,
	            filter = baseLayer.filter(function (l) {
	            return l.id !== layer.id;
	        });
	
	        this.props.onChange(_extends({}, mapConfig, {
	            defaultBaseLayerId: layer.id,
	            baseLayer: filter.concat(layer)
	        }));
	    };
	
	    MapConfigBaseLayerSelection.prototype.handleChange = function handleChange(data) {
	        this.props.onChange(_extends({}, data));
	    };
	
	    MapConfigBaseLayerSelection.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        var _DataUtil$asItem = _liferayWidgetsReactWeb.DataUtil.asItem(this.props.mapConfig),
	            defaultBaseLayerId = _DataUtil$asItem.defaultBaseLayerId,
	            baseLayer = _DataUtil$asItem.baseLayer;
	
	        var _DataUtil$asItem2 = _liferayWidgetsReactWeb.DataUtil.asItem(nextProps.mapConfig),
	            nextDefaultBaseLayerId = _DataUtil$asItem2.nextDefaultBaseLayerId,
	            nextBaseLayer = _DataUtil$asItem2.nextBaseLayer;
	
	        return this.props.layers !== nextProps.layers || defaultBaseLayerId !== nextDefaultBaseLayerId || baseLayer !== nextBaseLayer || this.props.formValidation['defaultBaseLayer'] !== nextProps.formValidation['defaultBaseLayer'] || this.props.formValidation['baseLayer'] !== nextProps.formValidation['baseLayer'];
	    };
	
	    MapConfigBaseLayerSelection.prototype.render = function render() {
	        var layers = _liferayWidgetsReactWeb.DataUtil.asArray(this.props.layers) || [],
	            _DataUtil$asItem3 = _liferayWidgetsReactWeb.DataUtil.asItem(this.props.mapConfig),
	            defaultBaseLayerId = _DataUtil$asItem3.defaultBaseLayerId,
	            _DataUtil$asItem3$bas = _DataUtil$asItem3.baseLayer,
	            baseLayer = _DataUtil$asItem3$bas === undefined ? [] : _DataUtil$asItem3$bas,
	            formValidation = this.props.formValidation;
	
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'defaultBaseLayer' }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'baseLayer' }),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                { controlId: 'formControlsSelectMultiple' },
	                _react2.default.createElement(Multiselect, { layers: layers,
	                    baseLayer: baseLayer,
	                    defaultId: defaultBaseLayerId,
	                    onSelectDefault: this.onSelectDefault.bind(this),
	                    onSelect: this.onSelect.bind(this) })
	            ),
	            _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'defaultBaseLayer' }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'baseLayer' })
	        );
	    };
	
	    return MapConfigBaseLayerSelection;
	}(_react2.default.Component);
	
	MapConfigBaseLayerSelection.propTypes = {
	    formValidation: _propTypes2.default.object,
	    layers: _propTypes2.default.object,
	    mapConfig: _propTypes2.default.object,
	    onChange: _propTypes2.default.func
	};
	
	exports.default = MapConfigBaseLayerSelection;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 02.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultMapConfigEditForm = function (_React$Component) {
	    _inherits(DefaultMapConfigEditForm, _React$Component);
	
	    function DefaultMapConfigEditForm(props) {
	        _classCallCheck(this, DefaultMapConfigEditForm);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    DefaultMapConfigEditForm.prototype.componentDidMount = function componentDidMount() {
	        var formData = this.props.formData;
	
	        return this.props.onChange(formData, this.validate(formData));
	    };
	
	    DefaultMapConfigEditForm.prototype.onMapConfigChange = function onMapConfigChange(e) {
	        this.handleChange(_extends({}, this.props.formData, {
	            mapConfigId: e.target.value
	        }));
	    };
	
	    DefaultMapConfigEditForm.prototype.handleChange = function handleChange(formData) {
	        this.props.onChange(formData, this.validate(formData));
	    };
	
	    DefaultMapConfigEditForm.prototype.validate = function validate(formData) {
	        var mapConfigIdValid = void 0;
	
	        if (!(formData.mapConfigId > 0)) {
	            mapConfigIdValid = 'Bitte Standardkonfiguration auswählen.';
	        }
	
	        return {
	            mapConfigId: mapConfigIdValid
	        };
	    };
	
	    DefaultMapConfigEditForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation;
	
	        var mapConfigs = _liferayWidgetsReactWeb.DataUtil.asArray(this.props.mapConfigs);
	
	        var options = mapConfigs && mapConfigs.length > 0 ? mapConfigs.map(function (mapConfig) {
	            return _react2.default.createElement(
	                'option',
	                { key: 'DefaultMapConfigOption_' + mapConfig.id,
	                    value: mapConfig.id },
	                mapConfig.title
	            );
	        }) : [];
	
	        options.unshift(_react2.default.createElement(
	            'option',
	            { key: 'DefaultMapConfigOption_' + -1,
	                value: -1 },
	            'Bitte w\xE4hlen'
	        ));
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { className: 'py-3' },
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Standardkartenkonfiguration w\xE4hlen' }),
	            _react2.default.createElement(
	                _reactBootstrap.FormGroup,
	                { controlId: 'formControlsSelect' },
	                _react2.default.createElement(
	                    _reactBootstrap.FormLabel,
	                    null,
	                    'Standardkartenkonfiguration'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.FormControl,
	                    { as: 'select',
	                        value: formData.mapConfigId || -1,
	                        onChange: this.onMapConfigChange.bind(this) },
	                    options
	                ),
	                _react2.default.createElement(_liferayWidgetsReactWeb.ValidationMessage, { formValidation: formValidation, propName: 'mapConfigId' })
	            )
	        );
	    };
	
	    return DefaultMapConfigEditForm;
	}(_react2.default.Component);
	
	DefaultMapConfigEditForm.propTypes = {
	    formData: _propTypes2.default.object,
	    mapConfigs: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    onChange: _propTypes2.default.func
	};
	
	exports.default = DefaultMapConfigEditForm;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 11.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _MapConfigCopyItem = __webpack_require__(145);
	
	var _MapConfigCopyItem2 = _interopRequireDefault(_MapConfigCopyItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigCopyForm = function (_React$Component) {
	    _inherits(MapConfigCopyForm, _React$Component);
	
	    function MapConfigCopyForm(props) {
	        _classCallCheck(this, MapConfigCopyForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            selectedMapConfig: null
	        };
	        return _this;
	    }
	
	    MapConfigCopyForm.prototype.onSelect = function onSelect(item) {
	        this.setState({
	            selectedMapConfig: item
	        });
	    };
	
	    MapConfigCopyForm.prototype.handleSubmit = function handleSubmit(e) {
	        e.preventDefault();
	
	        var selectedMapConfig = this.state.selectedMapConfig;
	
	
	        if (selectedMapConfig) {
	            this.props.onSubmit({
	                mapConfig: selectedMapConfig
	            });
	        }
	    };
	
	    MapConfigCopyForm.prototype.render = function render() {
	        var selectedMapConfig = this.state.selectedMapConfig;
	        var viewableMapConfigs = this.props.formData;
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.Container,
	            { className: 'py-3' },
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Kartenkonfigurationen' }),
	            _react2.default.createElement(
	                'p',
	                null,
	                ' Bitte w\xE4hlen Sie eine Kartenkonfiguration aus, um diese zu kopieren. '
	            ),
	            _react2.default.createElement(_liferayWidgetsReactWeb.ScrollableDataListRV, {
	                list: viewableMapConfigs,
	                size: 'medium',
	                activeIds: selectedMapConfig,
	                className: 'map-config-copy-list',
	                ListItem: _MapConfigCopyItem2.default,
	                onClick: this.onSelect.bind(this)
	            }),
	            _react2.default.createElement(
	                _reactBootstrap.ButtonToolbar,
	                null,
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary', type: 'button', onClick: this.props.onCancel.bind(this) },
	                    'Abbrechen'
	                ),
	                _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary', type: 'submit', onClick: this.handleSubmit.bind(this) },
	                    'Kopieren'
	                )
	            )
	        );
	    };
	
	    return MapConfigCopyForm;
	}(_react2.default.Component);
	
	MapConfigCopyForm.propTypes = {
	    onCancel: _propTypes2.default.func,
	    onSubmit: _propTypes2.default.func,
	    formData: _propTypes2.default.object
	};
	
	exports.default = MapConfigCopyForm;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 11.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(19);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigCopyItem = function (_React$Component) {
	    _inherits(MapConfigCopyItem, _React$Component);
	
	    function MapConfigCopyItem() {
	        _classCallCheck(this, MapConfigCopyItem);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    MapConfigCopyItem.prototype.onClick = function onClick(e) {
	        this.props.onClick(this.props.item, e);
	    };
	
	    MapConfigCopyItem.prototype.render = function render() {
	
	        var dataItem = this.props.item,
	            item = dataItem && (dataItem.item || dataItem);
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            _extends({}, this.props, { onClick: this.onClick.bind(this) }),
	            item.title + ' - (' + item.description + ')'
	        );
	    };
	
	    return MapConfigCopyItem;
	}(_react2.default.Component);
	
	MapConfigCopyItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = MapConfigCopyItem;

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_146__;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(26);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 24.03.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	var logicalLayerService = function logicalLayerService(m, o) {
	    return _lwrClient.Client.invoke('/map.logicallayer/' + m, o);
	};
	//const logicalLayerServiceWithContext = (m, o, c) => Client.invokeWithContext('/map.logicallayer/' + m, o, c);
	
	var api = {
	    loadLayers: function loadLayers() {
	        return logicalLayerService('list-all.1', {});
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('LayerWebApi', api);
	
	exports.default = api;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(26);
	
	var servicePath = '/geo.geofeature/'; /**
	                                       * Created by Carsten Bühler
	                                       * User: CBuehler on 09.11.2015
	                                       * Copyright: xdot GmbH 2015
	                                       */
	
	var method = 'search-viewable-by-class-names-scope-group.5';
	
	exports.default = {
	    getGeoJson: function getGeoJson(query) {
	        return _lwrClient.Client.invokeWithContext(servicePath + method, query, {});
	    },
	    getExternalGeoJson: function getExternalGeoJson(url) {
	        return fetch(url).then(function (response) {
	            return response.json();
	        });
	    }
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 19.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var expandIcon = '<span class="fa fa-expand"/>';
	var collapseIcon = '<span class="fa fa-compress"/>';
	
	var FULLSCREEN_CLASS = 'map-fullscreen';
	
	var FullscreenPlugin = function () {
	    function FullscreenPlugin(props) {
	        _classCallCheck(this, FullscreenPlugin);
	
	        this.onEscape = this.onEscape.bind(this);
	        this.init = this.init.bind(this);
	    }
	
	    FullscreenPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        (0, _liferayWidgetsReactWeb.amdRequire)(['leaflet.fullscreen', 'css!leaflet.fullscreen-css'], function () {
	            _this.control = _leaflet2.default.control.fullscreen({
	                position: 'topright',
	                title: 'Vollbild öffnen',
	                titleCancel: 'Vollbild schließen',
	                content: expandIcon,
	                forcePseudoFullscreen: true
	            });
	            map.addControl(_this.control);
	
	            map.on('enterFullscreen', function () {
	                map.invalidateSize();
	                _this.control.link.innerHTML = collapseIcon;
	                map.gestureHandling.disable();
	                document.addEventListener('keyup', _this.onEscape);
	                document.body.classList.add(FULLSCREEN_CLASS);
	            });
	
	            map.on('exitFullscreen', function () {
	                map.invalidateSize();
	                _this.control.link.innerHTML = expandIcon;
	                map.gestureHandling.enable();
	                document.removeEventListener('keyup', _this.onEscape);
	                document.body.classList.remove(FULLSCREEN_CLASS);
	            });
	        });
	    };
	
	    FullscreenPlugin.prototype.onEscape = function onEscape(e) {
	        if (e.keyCode === 27) {
	            this.control.toggleFullScreen();
	        }
	    };
	
	    return FullscreenPlugin;
	}();
	
	exports.default = FullscreenPlugin;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 13.07.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _FeatureManager = __webpack_require__(13);
	
	var _FeatureManager2 = _interopRequireDefault(_FeatureManager);
	
	var _geoUtils = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FeatureDisplayPlugin = function () {
	    function FeatureDisplayPlugin(props) {
	        _classCallCheck(this, FeatureDisplayPlugin);
	
	        this.boundRequestHandled = false;
	        this.boundRequestCb = this.boundRequestCb.bind(this);
	    }
	
	    FeatureDisplayPlugin.prototype.init = function init(map, o) {
	        this.update(map, o);
	    };
	
	    FeatureDisplayPlugin.prototype.initOptions = function initOptions(o) {
	        return this.options(o);
	    };
	
	    FeatureDisplayPlugin.prototype.options = function options(o) {
	        if (o.features && !(0, _liferayWidgetsReactWeb.shallowEqual)(o.features, this.features) || o.features && !this.boundRequestHandled) {
	            this.boundRequestHandled = false;
	            var features = Array.isArray(o.features) ? o.features : [o.features];
	            var geometries = features.filter(function (f) {
	                return _liferayWidgetsReactWeb.DataUtil.asItem(f);
	            }).map(function (f) {
	                return _liferayWidgetsReactWeb.DataUtil.asItem(f).geometry;
	            });
	
	            if (geometries && geometries.length > 0) {
	                o.boundRequest = {
	                    bounds: (0, _geoUtils.getBoundsFromGeometries)(geometries),
	                    options: { animate: false },
	                    cb: this.boundRequestCb
	                };
	            }
	        }
	
	        return o;
	    };
	
	    FeatureDisplayPlugin.prototype.update = function update(map, o) {
	        var _this = this;
	
	        if (o.features && !(0, _liferayWidgetsReactWeb.shallowEqual)(o.features, this.features)) {
	            this.features = Array.isArray(o.features) ? o.features : [o.features];
	
	            var featureLayers = this.features.filter(function (f) {
	                return _liferayWidgetsReactWeb.DataUtil.asItem(f);
	            }).map(function (data) {
	                if (data.properties || !data.className) {
	                    throw new Error("Data expected", data);
	                }
	                var feature = _this.asFeature(data);
	                var layer = _FeatureManager2.default.createFeatureLayer(feature, {}, true);
	                if (layer.then) {
	                    var loadingLayer = _FeatureManager2.default.loadingMarker(feature);
	                    layer.then(function () {
	                        if (map.hasLayer(loadingLayer)) {
	                            map.removeLayer(loadingLayer);
	                            map.addLayer(_FeatureManager2.default.createFeatureLayer(feature, {}));
	                        }
	                    });
	                    layer = loadingLayer;
	                }
	                return layer;
	            });
	
	            if (!this.featureGroup && featureLayers) {
	                this.featureGroup = _leaflet2.default.featureGroup(featureLayers).addTo(map);
	            } else {
	                this.featureGroup.clearLayers();
	                featureLayers.forEach(function (layer) {
	                    return _this.featureGroup.addLayer(layer);
	                });
	            }
	        }
	    };
	
	    FeatureDisplayPlugin.prototype.asFeature = function asFeature(dataItem) {
	        var type = dataItem.className;
	        var item = _liferayWidgetsReactWeb.DataUtil.asItem(dataItem);
	        if (item === dataItem) {
	            console.error("Expected a dataItem not an item, because only dataItem knows which type it is.", dataItem);
	        }
	
	        if (item && item.geometry && type) {
	            return {
	                geometry: item.geometry,
	                properties: _extends({}, item, {
	                    type: type
	                }),
	                type: 'Feature'
	            };
	        }
	        throw new Error("Item incompatible!");
	    };
	
	    FeatureDisplayPlugin.prototype.boundRequestCb = function boundRequestCb() {
	        this.boundRequestHandled = true;
	    };
	
	    return FeatureDisplayPlugin;
	}();
	
	exports.default = FeatureDisplayPlugin;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 18.07.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalConfigStore = (0, _liferayWidgetsReactWeb.getLocalConfigStore)(_liferayWidgetsReactWeb.AppContext);
	
	var RememberMapStatePlugin = function () {
	    function RememberMapStatePlugin(props) {
	        _classCallCheck(this, RememberMapStatePlugin);
	
	        this.boundRequestHandled = false;
	        this.boundRequestCb = this.boundRequestCb.bind(this);
	    }
	
	    RememberMapStatePlugin.prototype.initOptions = function initOptions(o) {
	
	        var lastBounds = LocalConfigStore.getLocalConfig(this.getLastBoundKey());
	        if (lastBounds && lastBounds.properties) {
	            o.boundRequest = {
	                bounds: _leaflet2.default.latLngBounds(lastBounds.properties._southWest, lastBounds.properties._northEast),
	                options: { animate: false },
	                cb: this.boundRequestCb
	            };
	        }
	        return o;
	    };
	
	    /*
	     * Use this to mutate options pre update/map init
	     * @param {object} o - options
	     * @return {object} o - options
	     */
	
	
	    RememberMapStatePlugin.prototype.options = function options(o) {
	        return o;
	    };
	
	    RememberMapStatePlugin.prototype.init = function init(map, o) {
	        this.update(map, o);
	    };
	
	    RememberMapStatePlugin.prototype.update = function update(map, o) {
	        var _this = this;
	
	        if (this.dragendListener) {
	            map.off('moveend', this.dragendListener);
	        }
	        this.dragendListener = function (e) {
	            var bounds = map.getBounds();
	            _liferayWidgetsReactWeb.ConfigActions.updateLocalConfig(_this.getLastBoundKey(), _extends({}, bounds));
	        };
	
	        map.on('moveend', this.dragendListener);
	    };
	
	    RememberMapStatePlugin.prototype.getLastBoundKey = function getLastBoundKey() {
	        var key = 'Map_LastBounds';
	        key = this.context && this.context.contextId ? key + '_' + this.context.contextId : key;
	        return key;
	    };
	
	    RememberMapStatePlugin.prototype.boundRequestCb = function boundRequestCb() {
	        this.boundRequestHandled = true;
	    };
	
	    return RememberMapStatePlugin;
	}();
	
	exports.default = RememberMapStatePlugin;
	
	
	RememberMapStatePlugin.contextTypes = {
	    contextId: _propTypes2.default.string
	};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 06.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _DrawerGeoJsonLayer = __webpack_require__(91);
	
	var _DrawerGeoJsonLayer2 = _interopRequireDefault(_DrawerGeoJsonLayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ExportToImagePlugin = function () {
	    function ExportToImagePlugin(props, config) {
	        _classCallCheck(this, ExportToImagePlugin);
	
	        this.exportToImage = this.exportToImage.bind(this);
	    }
	
	    ExportToImagePlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        this.map = map;
	        map.options.preferCanvas = true;
	
	        var exportControl = _leaflet2.default.Control.extend({
	            options: {
	                position: 'topleft'
	            },
	            onAdd: function onAdd(map) {
	                _this.container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
	                _this.icon = _leaflet2.default.DomUtil.create('span', 'icon icon-map-download', _this.container);
	                _this.container.setAttribute('title', 'Karte als Bild exportieren');
	                _this.container.setAttribute('role', 'button');
	
	                _leaflet2.default.DomEvent.on(_this.container, 'click', _this.exportToImage, _this);
	                return _this.container;
	            }
	        });
	
	        map.addControl(new exportControl());
	    };
	
	    ExportToImagePlugin.prototype.update = function update(map, o) {
	        if (o.drawerGeoJSON) {
	            this.lastDrawerGeoJSON = o.drawerGeoJSON;
	            if (!this.drawerGeoJsonLayer) {
	                this.drawerGeoJsonLayer = new _DrawerGeoJsonLayer2.default(o.drawerGeoJSON, _extends({}, o, {
	                    renderer: _leaflet2.default.canvas()
	                })).addTo(map);
	                this.focus();
	            } else {
	                if (o.drawerGeoJSON !== this.lastDrawerGeoJSON) {
	                    this.drawerGeoJsonLayer.clearLayers();
	                    this.drawerGeoJsonLayer.addData(o.drawerGeoJSON);
	                    this.focus();
	                } else if (this.drawerGeoJsonLayer.getLayers().length === 0 && o.drawerGeoJSON && o.drawerGeoJSON.features && o.drawerGeoJSON.features.length > 0) {
	                    this.drawerGeoJsonLayer.addData(o.drawerGeoJSON);
	                    this.focus();
	                }
	            }
	        } else if (this.drawerGeoJsonLayer) {
	            this.drawerGeoJsonLayer.clearLayers();
	        }
	    };
	
	    ExportToImagePlugin.prototype.focus = function focus() {
	        var bounds = this.drawerGeoJsonLayer && this.drawerGeoJsonLayer.getBounds();
	        if (bounds && bounds.isValid()) {
	            this.map.fitBounds(bounds);
	        }
	    };
	
	    ExportToImagePlugin.prototype.exportToImage = function exportToImage() {
	        fetch('/o/data-preview/SituationMapData', {
	            method: 'POST',
	            body: JSON.stringify(this.lastDrawerGeoJSON)
	        }).then(function (res) {
	            if (!res.ok) {
	                console.error('Download fehlgeschlagen! Status: ', res);
	                window.alert('Download fehlgeschlagen! Status: ' + res.status);
	            }
	            return res.blob();
	        }).then(function (blob) {
	            if (navigator.msSaveBlob) {
	                navigator.msSaveBlob(blob, 'Lagekarte.jpg');
	            } else {
	                var link = document.createElement('a');
	                link.href = window.URL.createObjectURL(blob);
	                link.download = 'Lagekarte';
	                link.click();
	            }
	        }).catch(function (err) {
	            window.alert(err);
	        });
	    };
	
	    return ExportToImagePlugin;
	}();
	
	exports.default = ExportToImagePlugin;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 30.06.2016
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Source projection WGS84
	var SOURCE_PROJ = '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs';
	// Destination projection EPSG:31467
	var DEST_PROJ = '+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs';
	
	var HWRMPlugin = function () {
	    function HWRMPlugin(props, config) {
	        _classCallCheck(this, HWRMPlugin);
	
	        this.config = config;
	        this.props = props;
	
	        this.active = false;
	
	        this.toggleTextLabelControl = this.toggleTextLabelControl.bind(this);
	    }
	
	    HWRMPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        this._map = map;
	        this.hwrmControlTemplate = _leaflet2.default.Control.extend({
	            options: {
	                position: 'topleft'
	            },
	
	            onAdd: function onAdd(map) {
	                _this.container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
	                _this.icon = _leaflet2.default.DomUtil.create('span', 'icon icon-map-crosshairs-waves', _this.container);
	                _this.container.setAttribute('title', 'Hochwasserrisikomanagement-Abfrage (HWRM)');
	                _this.container.setAttribute('role', 'button');
	
	                _leaflet2.default.DomEvent.on(_this.container, 'click', _this.toggleTextLabelControl, _this);
	                return _this.container;
	            }
	        });
	        this.hwrmControl = new this.hwrmControlTemplate();
	        map.addControl(this.hwrmControl);
	
	        map.on('click', this.onHwrmClick.bind(this));
	
	        setTimeout(function () {
	            return (0, _liferayWidgetsReactWeb.amdRequire)(['proj4'], function () {});
	        }, 1500);
	    };
	
	    HWRMPlugin.prototype.toggleTextLabelControl = function toggleTextLabelControl(e) {
	        if (e) {
	            _leaflet2.default.DomEvent.stopPropagation(e);
	            _leaflet2.default.DomEvent.preventDefault(e);
	        }
	
	        if (this.active) {
	            this.active = false;
	            this._map.blockingControlActive = false;
	            this.container.classList.remove('active');
	            return;
	        }
	
	        if (this._map.blockingControlActive) {
	            return;
	        }
	
	        this.active = true;
	        this._map.blockingControlActive = true;
	        this.container.classList.add('active');
	    };
	
	    HWRMPlugin.prototype.onHwrmClick = function onHwrmClick(e) {
	        var _this2 = this;
	
	        if (this.active) {
	            _leaflet2.default.DomEvent.stopPropagation(e);
	            _leaflet2.default.DomEvent.preventDefault(e);
	            var HWRMwindow = window.open('', '_blank');
	            HWRMwindow.blur();
	            (0, _liferayWidgetsReactWeb.amdRequire)(['proj4'], function (proj4) {
	                var lat = e.latlng.lat;
	                var lng = e.latlng.lng;
	                var transformedCoordinates = proj4(SOURCE_PROJ, DEST_PROJ, [lng, lat]);
	                var easting = transformedCoordinates[0];
	                var northing = transformedCoordinates[1];
	
	                HWRMwindow.location.href = 'http://rips-dienste.lubw.baden-wuerttemberg.de/rips/ripsservices/apps/hwrm/Abfrage.aspx?x=' + easting + '&y=' + northing;
	                HWRMwindow.focus();
	
	                _this2.toggleTextLabelControl(e.originalEvent);
	            });
	        }
	    };
	
	    return HWRMPlugin;
	}();
	
	exports.default = HWRMPlugin;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GeoJsonPlugin = function () {
	    function GeoJsonPlugin() {
	        _classCallCheck(this, GeoJsonPlugin);
	    }
	
	    GeoJsonPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        o.plugins.forEach(function (p) {
	            if (p.path === 'map/plugins/GeoJsonPlugin') {
	                try {
	                    _this.config = JSON.parse(p.config);
	                } catch (e) {
	                    console.error('Error in JSON', e);
	                }
	            }
	        });
	
	        try {
	            map.addLayer(new _leaflet2.default.geoJson(this.config, {
	                weight: 2
	            }));
	        } catch (e) {
	            console.error(e);
	        }
	    };
	
	    return GeoJsonPlugin;
	}();
	
	exports.default = GeoJsonPlugin;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 19.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	var _datefns = __webpack_require__(27);
	
	var _datefns2 = _interopRequireDefault(_datefns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalConfigStore = (0, _liferayWidgetsReactWeb.getLocalConfigStore)(_liferayWidgetsReactWeb.AppContext);
	
	var PrintPlugin = function () {
	    function PrintPlugin(props) {
	        _classCallCheck(this, PrintPlugin);
	
	        this.init = this.init.bind(this);
	        this.onPrint = this.onPrint.bind(this);
	        this.ACTIVE_UUIDS_KEY = '';
	    }
	
	    PrintPlugin.prototype.withCtx = function withCtx(s) {
	        return (this.context && this.context.contextId ? this.context.contextId : 'DEFAULT_') + s;
	    };
	
	    PrintPlugin.prototype._getLocalStorageKeyWithMapConfig = function _getLocalStorageKeyWithMapConfig(key) {
	        if (this.context && this.context.contextId) {
	            var mapConf = this.context;
	            key += '_MAP_CONFIG_' + mapConf.contextId;
	        }
	        return key;
	    };
	
	    PrintPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        this.ACTIVE_UUIDS_KEY = this.withCtx('_ACTIVE_UUIDS');
	        this.map = map;
	        this.printControlTemplate = _leaflet2.default.Control.extend({
	            options: {
	                position: 'topleft'
	            },
	
	            onAdd: function onAdd(map) {
	                _this.container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom hidden-xs hidden-sm');
	                _this.icon = _leaflet2.default.DomUtil.create('span', 'fa fa-print', _this.container);
	
	                _this.container.setAttribute('title', 'Karte drucken');
	                _this.container.setAttribute('role', 'button');
	
	                _leaflet2.default.DomEvent.on(_this.container, 'click', _this.onPrint, _this);
	                return _this.container;
	            }
	        });
	        this.printControl = new this.printControlTemplate();
	        map.addControl(this.printControl);
	    };
	
	    PrintPlugin.prototype.update = function update(map, o) {
	        console.log('ExampleMapPlugin update()', map, o);
	    };
	
	    PrintPlugin.prototype.getLayerNames = function getLayerNames(layer, activeUuids, root) {
	        var _this2 = this;
	
	        var layerNames = '';
	        var childNames = '';
	
	        if (layer.children) {
	            layer.children.forEach(function (child) {
	                childNames += _this2.getLayerNames(child, activeUuids);
	            });
	        }
	        if (childNames !== '') {
	            layerNames += '<li><span class="' + (root ? 'bolder-heading' : 'bold-heading') + '">' + layer.title + '</span><ul>' + childNames + '</ul></li>';
	        } else {
	            if (activeUuids[layer.uuid]) {
	                layerNames += '<li>' + layer.title + '</li>';
	            }
	        }
	
	        return layerNames;
	    };
	
	    PrintPlugin.prototype.onPrint = function onPrint(e) {
	        var _this3 = this;
	
	        _leaflet2.default.DomEvent.stopPropagation(e);
	        _leaflet2.default.DomEvent.preventDefault(e);
	        var mapContainer = this.map.getContainer();
	        var isFullscreen = mapContainer.classList.contains('leaflet-pseudo-fullscreen');
	        var originalWidth = mapContainer.style.width;
	        var originalHeight = mapContainer.style.height;
	        var originalBounds = this.map.getBounds();
	
	        if (isFullscreen) {
	            mapContainer.classList.remove('leaflet-pseudo-fullscreen');
	        }
	        mapContainer.style.width = 1240 + 'px';
	        mapContainer.style.height = 1240 + 'px';
	        this.map.fitBounds(originalBounds, { animate: false });
	        this.map.invalidateSize(false);
	
	        var prtContent = this.map._container.parentNode.cloneNode(true);
	        prtContent.style.width = this.map._container.clientWidth + 'px';
	        prtContent.style.height = this.map._container.clientHeight + 'px';
	        var tiles = prtContent.getElementsByClassName('leaflet-tile');
	        for (var _iterator = tiles, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var tile = _ref;
	
	            tile.classList.add('leaflet-tile-loaded');
	        }
	
	        //reset original
	        mapContainer.style.width = originalWidth;
	        mapContainer.style.height = originalHeight;
	        if (isFullscreen) {
	            mapContainer.classList.add('leaflet-pseudo-fullscreen');
	        }
	        this.map.invalidateSize(false);
	        this.map.fitBounds(originalBounds, { animate: false });
	
	        var config = LocalConfigStore.getLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_UUIDS_KEY));
	        var activeUuids = config && config.properties;
	        var layerDescriptions = this.map.options.layerDescriptions;
	        var hasLayers = layerDescriptions && layerDescriptions.length > 0;
	        var activeLayerNames = '';
	        if (activeUuids && hasLayers) {
	            layerDescriptions.forEach(function (layerDescription) {
	                activeLayerNames += _this3.getLayerNames(layerDescription, activeUuids, true);
	            });
	        }
	
	        var controlContainer = prtContent.getElementsByClassName('leaflet-control-container')[0];
	        var controls = Array.from(controlContainer.children).filter(function (node) {
	            return node && !(node.classList.contains('leaflet-bottom') && node.classList.contains('leaflet-right'));
	        });
	        for (var _iterator2 = controls, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	            } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	            }
	
	            var control = _ref2;
	
	            control.style = 'display: none;';
	        }
	
	        // canvas inside the cloned node are empty -> use original
	        var original_cnavas = this.map._container.getElementsByTagName('canvas');
	        Array.from(prtContent.getElementsByTagName('canvas')).forEach(function (canvasCopy, idx) {
	            var canvas = original_cnavas.item(idx);
	            var img = new Image();
	            img.src = canvas.toDataURL('image/png');
	            img.style.cssText = canvas.style.cssText;
	            img.classList = canvas.classList;
	            canvasCopy.parentNode.replaceChild(img, canvasCopy);
	        });
	
	        var head = document.head.cloneNode(true);
	        Array.from(head.getElementsByTagName('script')).forEach(function (tag) {
	            tag.parentNode.removeChild(tag);
	        });
	
	        var html = '\n            ' + head.innerHTML + '\n            <body style="-webkit-print-color-adjust: exact;color-adjust: exact;">\n                <h3>FLIWAS-Karte</h3>\n                <div class="py-3">\n                    ' + (hasLayers ? '<h3>Aktive Themen</h3>' : '') + '\n                    <ul style="list-style: none; padding: 0">\n                        ' + activeLayerNames + '\n                    </ul>\n                </div>\n                ' + prtContent.innerHTML + '\n                <footer class="p-3">\n                     ' + _datefns2.default.format(new Date(), 'dd.MM.yy HH:mm') + ' Uhr, ' + window.themeDisplay.getUserName() + '\n                </footer>\n                <script>\n                    window.onload = function() {\n                        setTimeout(() => {    \n                            window.print();\n                        }, 100);\n                    };\n                </script>\n            </body>\n        ';
	        var WinPrint = window.open('', 'FLIWAS-Karte');
	        WinPrint.document.write(html);
	        WinPrint.document.close();
	        WinPrint.focus();
	
	        WinPrint.onafterprint = function (event) {
	            WinPrint.close();
	        };
	    };
	
	    return PrintPlugin;
	}();
	
	exports.default = PrintPlugin;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 *
	 * Author: Marius Runde
	 * Date: 19.07.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _datefns = __webpack_require__(27);
	
	var _datefns2 = _interopRequireDefault(_datefns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var situationMapMeta = function situationMapMeta(situationMap, selectedVersions) {
	    return '\n                    <table>\n                    <thead>\n                        <tr>\n                            <td><h5>Lagekarte: ' + situationMap.title + '</h5></td>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr>\n                            <td>Version:</td>\n                            <td>' + situationMap.version + '</td>\n                        </tr>\n                        <tr>\n                            <td>Aktiv:</td>\n                            <td>' + (situationMap.active ? 'Ja' : 'Nein') + '</td>\n                        </tr>\n                       <tr>\n                            <td>Geteilt:</td>\n                            <td>' + (situationMap.shared ? 'Ja' : 'Nein') + '</td>\n                        </tr>\n                        <tr>\n                            <td>Ausgew\xE4hlte Versionen:</td>\n                        </tr>\n                        ' + selectedVersions.map(function (item) {
	        return '\n                                    <tr>\n                                        <td>' + item.version + '</td>\n                                        <td class="py-3">\n                                        <p>Erstellt am: ' + new Date(item.modifiedDate).toLocaleString() + '</p>\n                                        <p>Bearbeiter: ' + item.userName + '</p>\n                                        <p>Beschreibung: ' + item.description + '</p>\n                                        </td>\n                                    </tr>\n                                ';
	    }) + '\n                    </tbody>\n                </table>\n';
	};
	
	var SituationMapPrintPlugin = function () {
	    function SituationMapPrintPlugin(props) {
	        _classCallCheck(this, SituationMapPrintPlugin);
	
	        this.init = this.init.bind(this);
	        this.onPrint = this.onPrint.bind(this);
	    }
	
	    SituationMapPrintPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        this.map = map;
	        this.situationMaps = o.situationMaps;
	        this.selectedSituationMapVersions = o.selectedSituationMapVersions;
	        this.drawerGeoJSON = o.drawerGeoJSON || o.situationMapData;
	        this.printControlTemplate = _leaflet2.default.Control.extend({
	            options: {
	                position: 'topright'
	            },
	
	            onAdd: function onAdd(map) {
	                _this.container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
	                _this.icon = _leaflet2.default.DomUtil.create('span', 'fa fa-print', _this.container);
	
	                _this.container.setAttribute('title', 'Lagekarte drucken');
	                _this.container.setAttribute('role', 'button');
	
	                _leaflet2.default.DomEvent.on(_this.container, 'click', _this.onPrint, _this);
	                return _this.container;
	            }
	        });
	        this.printControl = new this.printControlTemplate();
	        map.addControl(this.printControl);
	    };
	
	    SituationMapPrintPlugin.prototype.onPrint = function onPrint(e) {
	        var _this2 = this;
	
	        _leaflet2.default.DomEvent.stopPropagation(e);
	        _leaflet2.default.DomEvent.preventDefault(e);
	        if (!this.situationMaps || !this.selectedSituationMapVersions) {
	            alert('Keine Lagekarte gefunden!');
	            return;
	        }
	
	        var mapContainer = this.map.getContainer();
	        var isFullscreen = mapContainer.classList.contains('leaflet-pseudo-fullscreen');
	        var originalWidth = mapContainer.style.width;
	        var originalHeight = mapContainer.style.height;
	        var originalBounds = this.map.getBounds().pad(0.25);
	
	        if (isFullscreen) {
	            mapContainer.classList.remove('leaflet-pseudo-fullscreen');
	        }
	        mapContainer.style.width = 1240 + 'px';
	        mapContainer.style.height = 1240 + 'px';
	        this.map.fitBounds(originalBounds, { animate: false });
	        this.map.invalidateSize(false);
	
	        var prtContent = this.map._container.parentNode.cloneNode(true);
	        prtContent.style.width = this.map._container.clientWidth + 'px';
	        prtContent.style.height = this.map._container.clientHeight + 'px';
	        var tiles = prtContent.getElementsByClassName('leaflet-tile');
	        for (var _iterator = tiles, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var tile = _ref;
	
	            tile.classList.add('leaflet-tile-loaded');
	        }
	
	        //reset original
	        mapContainer.style.width = originalWidth;
	        mapContainer.style.height = originalHeight;
	        if (isFullscreen) {
	            mapContainer.classList.add('leaflet-pseudo-fullscreen');
	        }
	
	        this.map.invalidateSize(false);
	        this.map.fitBounds(originalBounds, { animate: false });
	
	        var textMarkers = this.drawerGeoJSON && this.drawerGeoJSON.features && this.drawerGeoJSON.features.filter(function (f) {
	            return f.properties.editFormData;
	        });
	        var mapText = '';
	        textMarkers && textMarkers.forEach(function (marker, i) {
	            mapText += '<li class="list-group-item">' + (i + 1) + '. ' + marker.properties.editFormData.text + '</li>';
	        });
	
	        var controlContainer = prtContent.getElementsByClassName('leaflet-control-container')[0];
	        var controls = Array.from(controlContainer.children).filter(function (node) {
	            return node && !(node.classList.contains('leaflet-bottom') && node.classList.contains('leaflet-right'));
	        });
	        for (var _iterator2 = controls, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	            } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	            }
	
	            var control = _ref2;
	
	            control.style = 'display: none;';
	        }
	
	        // canvas inside the cloned node are empty -> use original
	        var original_cnavas = this.map._container.getElementsByTagName('canvas');
	        Array.from(prtContent.getElementsByTagName('canvas')).forEach(function (canvasCopy, idx) {
	            var canvas = original_cnavas.item(idx);
	            var img = new Image();
	            img.src = canvas.toDataURL('image/png');
	            img.style.cssText = canvas.style.cssText;
	            img.classList = canvas.classList;
	            canvasCopy.parentNode.replaceChild(img, canvasCopy);
	        });
	
	        var head = document.head.cloneNode(true);
	        Array.from(head.getElementsByTagName('script')).forEach(function (tag) {
	            tag.parentNode.removeChild(tag);
	        });
	        0;
	        var html = '\n            ' + head.innerHTML + '\n            <body style="-webkit-print-color-adjust: exact;color-adjust: exact;">\n                <div class="py-3 d-flex" style="gap:3.5rem;">\n                ' + this.situationMaps.item.reduce(function (acc, situationMap) {
	            var selectedVersions = _this2.selectedSituationMapVersions.filter(function (v) {
	                return v.situationMapId === situationMap.id;
	            });
	            if (selectedVersions.length > 0) {
	                acc += situationMapMeta(situationMap, selectedVersions);
	            }
	            return acc;
	        }, '') + '\n                </div>\n                <div>\n                    <h5>Textelemente</h5>\n                    <ul class="list-group m-0">\n                       ' + (mapText || '<li class="list-group-item">---</li>') + '\n                    </ul>   \n                </div>\n                ' + prtContent.innerHTML + '\n                <footer class="p-3">\n                     ' + _datefns2.default.format(new Date(), 'dd.MM.yy HH:mm') + ' Uhr, ' + window.themeDisplay.getUserName() + '\n                </footer>\n                <script>\n                    window.onload = function() {\n                        window.print();\n                    };\n                </script>\n            </body>\n        ';
	        var WinPrint = window.open('', 'FLIWAS-Karte');
	        WinPrint.document.write(html);
	        WinPrint.document.close();
	        WinPrint.focus();
	
	        WinPrint.onafterprint = function (event) {
	            WinPrint.close();
	        };
	    };
	
	    return SituationMapPrintPlugin;
	}();
	
	exports.default = SituationMapPrintPlugin;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 30.06.2016
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DisplayCoordinatesPlugin = function () {
	    function DisplayCoordinatesPlugin(props, config) {
	        _classCallCheck(this, DisplayCoordinatesPlugin);
	
	        this.config = config;
	        this.props = props;
	
	        this.active = false;
	        this.latlng = undefined;
	
	        this.toggleActive = this.toggleActive.bind(this);
	        this.getCoordinates = this.getCoordinates.bind(this);
	        this.copyToClipboard = this.copyToClipboard.bind(this);
	    }
	
	    DisplayCoordinatesPlugin.prototype.init = function init(map, o) {
	        var _this = this;
	
	        this._map = map;
	        this.popup = _leaflet2.default.popup({ autoClose: false, interactive: true });
	        this.popupContent = _leaflet2.default.DomUtil.create('btn', 'btn display-coordinates-plugin-popup');
	        this.popupContentTextNode = _leaflet2.default.DomUtil.create('span', 'display-coordinates-plugin-popup__text', this.popupContent);
	        this.copyButton = _leaflet2.default.DomUtil.create('btn', 'display-coordinates-plugin-popup__icon fa fa-clipboard', this.popupContent);
	
	        _leaflet2.default.DomEvent.addListener(this.popupContent, 'click', this.copyToClipboard);
	
	        this.popup.setContent(this.popupContent);
	
	        this.coordinatesControlTemplate = _leaflet2.default.Control.extend({
	            options: {
	                position: 'topleft'
	            },
	
	            onAdd: function onAdd(map) {
	                _this.container = _leaflet2.default.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
	                _this.icon = _leaflet2.default.DomUtil.create('span', 'fa fa-crosshairs', _this.container);
	                _this.container.setAttribute('title', 'Koordinatenabfrage');
	                _this.container.setAttribute('role', 'button');
	
	                _leaflet2.default.DomEvent.on(_this.container, 'click', _this.toggleActive, _this);
	                return _this.container;
	            }
	        });
	        this.coordinatesControl = new this.coordinatesControlTemplate();
	        map.addControl(this.coordinatesControl);
	    };
	
	    DisplayCoordinatesPlugin.prototype.toggleActive = function toggleActive(e) {
	        if (e) {
	            _leaflet2.default.DomEvent.stopPropagation(e);
	            _leaflet2.default.DomEvent.preventDefault(e);
	        }
	
	        if (this.active) {
	            this.active = false;
	            this._map.blockingControlActive = false;
	            this.container.classList.remove('active');
	            this._map.off('click', this.getCoordinates);
	            this.popup.remove();
	            return;
	        }
	        if (this._map.blockingControlActive) {
	            return;
	        }
	        this.active = true;
	        this._map.blockingControlActive = true;
	        this.container.classList.add('active');
	        this._map.on('click', this.getCoordinates);
	    };
	
	    DisplayCoordinatesPlugin.prototype.copyToClipboard = function copyToClipboard() {
	        var _this2 = this;
	
	        if (navigator.clipboard) {
	            navigator.clipboard.writeText(this.latlng.lat.toFixed(5) + ', ' + this.latlng.lng.toFixed(5)).then(function () {
	                _this2._map.toast.success('', 'Koordinaten erfolgreich in die Zwischenablage kopiert!');
	            }).catch(function (e) {
	                _this2._map.toast.alert('', 'Kopieren der Koordinaten fehlgeschlagen!');
	            });
	        }
	    };
	
	    DisplayCoordinatesPlugin.prototype.getCoordinates = function getCoordinates(e) {
	        this.toggleActive();
	        var latlng = e.latlng;
	
	        this.latlng = latlng;
	        this.popupContentTextNode.innerHTML = 'Lat: ' + latlng.lat.toFixed(5) + ' </br> Lon: ' + latlng.lng.toFixed(5);
	        this.popup.setLatLng(latlng).openOn(this._map);
	    };
	
	    DisplayCoordinatesPlugin.prototype.remove = function remove() {
	        _leaflet2.default.DomEvent.removeListener(this.popupContent, 'click', this.copyToClipboard);
	        this.popup = null;
	        this._map = null;
	    };
	
	    return DisplayCoordinatesPlugin;
	}();
	
	exports.default = DisplayCoordinatesPlugin;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(159);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./display-coordinates-plugin-popup.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./display-coordinates-plugin-popup.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".display-coordinates-plugin-popup{display:flex;align-items:center;justify-content:space-between;padding:0;margin:0;border:0}.display-coordinates-plugin-popup .display-coordinates-plugin-popup__text{font-size:12px}.display-coordinates-plugin-popup .display-coordinates-plugin-popup__icon{font-size:16px;margin-left:10px}", ""]);
	
	// exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CustomBaseLayersControl = undefined;
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _leaflet = __webpack_require__(9);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(161);
	
	var _LogicalLayerActions = __webpack_require__(126);
	
	var _LogicalLayerActions2 = _interopRequireDefault(_LogicalLayerActions);
	
	var _StoreFactory = __webpack_require__(44);
	
	var _liferayWidgetsReactWeb = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LogicalLayerStore = (0, _StoreFactory.getLogicalLayerStore)(_liferayWidgetsReactWeb.AppContext);
	
	var DATA_LOGICAL_LAYERS = 'LOGICAL_LAYER_LIST';
	var ORTHO_PHOTO_LAYER_ID = 'lgl_wms_dop_aerialmap';
	var OMNISCALE_ROADS_LABELS_LAYER_ID = 'omniscale_roads_labels';
	
	var OrthoPhotoPlugin = function () {
	    function OrthoPhotoPlugin(props, config) {
	        var _this = this;
	
	        _classCallCheck(this, OrthoPhotoPlugin);
	
	        this.config = config;
	        this.props = props;
	
	        this.hasTileError = false;
	        this.interval = setInterval(function () {
	            _this.hasTileError = false;
	        }, 6000);
	
	        this.toggleActive = this.toggleActive.bind(this);
	        this.onTileError = this.onTileError.bind(this);
	        this.onLayersLoad = this.onLayersLoad.bind(this);
	    }
	
	    OrthoPhotoPlugin.prototype.initOptions = function initOptions(o) {
	        return o;
	    };
	
	    OrthoPhotoPlugin.prototype.init = function init(map, o) {
	        this._map = map;
	        _LogicalLayerActions2.default.allViewableGroupedList(DATA_LOGICAL_LAYERS);
	        this.subscription = LogicalLayerStore.addListener(this.onLayersLoad.bind(this));
	
	        this.customBaseLayerControl = new CustomBaseLayersControl(this.toggleActive);
	        map.addControl(this.customBaseLayerControl);
	    };
	
	    OrthoPhotoPlugin.prototype.options = function options(o) {
	        var _this2 = this;
	
	        this._options = o;
	        this._map.eachLayer(function (l) {
	            if (l.logicalLayerId === _this2._options.defaultBaseLayerId) {
	                _this2.baseLayer = l;
	            }
	        });
	        return o;
	    };
	
	    OrthoPhotoPlugin.prototype.onLayersLoad = function onLayersLoad() {
	        var list = LogicalLayerStore.getRemoteData(DATA_LOGICAL_LAYERS);
	        if (list && list._count > 0) {
	            var bwDopLayerDefinition = list.item.find(function (item) {
	                return item.uuid === ORTHO_PHOTO_LAYER_ID;
	            });
	            var omniscaleLayerDefinition = list.item.find(function (item) {
	                return item.uuid === OMNISCALE_ROADS_LABELS_LAYER_ID;
	            });
	
	            if (bwDopLayerDefinition) {
	                try {
	                    var config = JSON.parse(bwDopLayerDefinition.children[0].config);
	                    this.bwDopLayer = _leaflet2.default.tileLayer.wms(config.url, config);
	                } catch (e) {
	                    console.error('Failed to JSON parse bwDopLayerDefinition config', bwDopLayerDefinition);
	                }
	            }
	            if (omniscaleLayerDefinition) {
	                try {
	                    var _config = JSON.parse(omniscaleLayerDefinition.children[0].config);
	                    this.omniscaleFeatureLayer = _leaflet2.default.tileLayer.wms(_config.url, _config.config);
	                } catch (e) {
	                    console.error('Failed to JSON parse omniscaleLayerDefinition config', bwDopLayerDefinition);
	                }
	            }
	        }
	    };
	
	    OrthoPhotoPlugin.prototype.onTileError = function onTileError(e) {
	        console.info('TILE ERROR', e);
	        if (!this.hasTileError) {
	            this.hasTileError = true;
	            this._map.toast.warning('', 'Es kann zu Problemen beim Abruf der Satellitenbilder kommen.', { timeout: 10000 });
	        }
	    };
	
	    OrthoPhotoPlugin.prototype.toggleActive = function toggleActive(type) {
	        if (type === 'map') {
	            this._map.removeLayer(this.omniscaleFeatureLayer);
	            this.bwDopLayer.off('tileerror', this.onTileError);
	            this._map.removeLayer(this.bwDopLayer);
	            if (this.baseLayer) {
	                this._map.addLayer(this.baseLayer);
	                this.baseLayer.bringToBack();
	            }
	            return;
	        }
	        if (this.baseLayer) {
	            this._map.removeLayer(this.baseLayer);
	        }
	        this.bwDopLayer.on('tileerror', this.onTileError);
	        this._map.addLayer(this.bwDopLayer);
	        this._map.addLayer(this.omniscaleFeatureLayer);
	        this.omniscaleFeatureLayer.bringToBack();
	        this.bwDopLayer.bringToBack();
	    };
	
	    OrthoPhotoPlugin.prototype.remove = function remove() {
	        this._map = null;
	        this.baseLayer = null;
	        if (this.subscription) {
	            this.subscription.remove();
	        }
	    };
	
	    return OrthoPhotoPlugin;
	}();
	
	exports.default = OrthoPhotoPlugin;
	
	
	OrthoPhotoPlugin.contextTypes = {
	    contextId: _propTypes2.default.string
	};
	
	var CustomBaseLayersControl = exports.CustomBaseLayersControl = _leaflet2.default.Control.extend({
	    options: {
	        collapsed: true,
	        position: 'bottomleft'
	    },
	
	    initialize: function initialize(onClick, options) {
	        _leaflet2.default.Util.setOptions(this, options);
	        this.onClick = onClick;
	    },
	    onAdd: function onAdd(map) {
	        this._initLayout();
	        this._map = map;
	        if (!this.options.collapsed) {
	            // update the height of the container after resizing the window
	            map.on('resize', this._expandIfNotCollapsed, this);
	        }
	        return this._container;
	    },
	    addTo: function addTo(map) {
	        _leaflet2.default.Control.prototype.addTo.call(this, map);
	        // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
	        return this._expandIfNotCollapsed();
	    },
	    onRemove: function onRemove() {
	        this._map.off('resize', this._expandIfNotCollapsed, this);
	        _leaflet2.default.DomEvent.off(this.baseMapButton);
	        _leaflet2.default.DomEvent.off(this.satelliteButton);
	    },
	    expand: function expand() {
	        this._container.classList.add('leaflet-control-layers-expanded');
	        this._section.style.height = null;
	        var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
	        if (acceptableHeight < this._section.clientHeight) {
	            this._section.classList.add('leaflet-control-layers-scrollbar');
	            this._section.style.height = acceptableHeight + 'px';
	        } else {
	            this._section.classList.remove('leaflet-control-layers-scrollbar');
	        }
	        return this;
	    },
	
	
	    // @method collapse(): this
	    // Collapse the control container if expanded.
	    collapse: function collapse(ev) {
	        // On touch devices `pointerleave` is fired while clicking on a checkbox.
	        // The control was collapsed instead of adding the layer to the map.
	        // So we allow collapse if it is not touch and pointerleave.
	        if (!ev || !(ev.type === 'pointerleave' && ev.pointerType === 'touch')) {
	            this._container.classList.remove('leaflet-control-layers-expanded');
	        }
	        return this;
	    },
	    _initLayerButton: function _initLayerButton(className, title, type) {
	        var btn = _leaflet2.default.DomUtil.create('div', 'leaflet-control-orthophoto-btn ' + className);
	        btn.setAttribute('role', 'button');
	        btn.setAttribute('title', title);
	        var label = _leaflet2.default.DomUtil.create('span', 'leaflet-control-orthophoto-btn-label', btn);
	        label.innerHTML = title;
	        _leaflet2.default.DomEvent.on(btn, 'click', this._onClick.bind(this, type));
	        return btn;
	    },
	    _onClick: function _onClick(type, e) {
	        _leaflet2.default.DomEvent.stopPropagation(e);
	        _leaflet2.default.DomEvent.preventDefault(e);
	        if (type === 'map') {
	            this.baseMapButton.classList.add('active');
	            this.satelliteButton.classList.remove('active');
	        } else {
	            this.baseMapButton.classList.remove('active');
	            this.satelliteButton.classList.add('active');
	        }
	        if (this.onClick) {
	            this.onClick(type);
	        }
	    },
	    _initLayout: function _initLayout() {
	        var className = 'leaflet-control-layers',
	            container = this._container = _leaflet2.default.DomUtil.create('div', className + ' leaflet-control-orthophoto'),
	            collapsed = this.options.collapsed;
	
	        // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
	        container.setAttribute('aria-haspopup', true);
	
	        _leaflet2.default.DomEvent.disableClickPropagation(container);
	        _leaflet2.default.DomEvent.disableScrollPropagation(container);
	
	        var section = this._section = _leaflet2.default.DomUtil.create('fieldset', className + '-list');
	        this.baseMapButton = this._initLayerButton('leaflet-control-orthophoto-basemap-btn active', 'Karte', 'map');
	        this.satelliteButton = this._initLayerButton('leaflet-control-orthophoto-satellite-btn', 'Satellit', 'satellite');
	        section.appendChild(this.baseMapButton);
	        section.appendChild(this.satelliteButton);
	
	        if (collapsed) {
	            this._map.on('click', this.collapse, this);
	
	            _leaflet2.default.DomEvent.on(container, {
	                pointerenter: this._expandSafely,
	                pointerleave: this.collapse
	            }, this);
	        }
	        var link = this._layersLink = _leaflet2.default.DomUtil.create('a', className + '-toggle', container);
	        _leaflet2.default.DomUtil.create('span', 'icon icon-fliwas-layer', link);
	        link.href = '#';
	        link.title = 'Layers';
	        link.setAttribute('role', 'button');
	
	        _leaflet2.default.DomEvent.on(link, {
	            keydown: function keydown(e) {
	                if (e.code === 'Enter') {
	                    this._expandSafely();
	                }
	            },
	
	            // Certain screen readers intercept the key event and instead send a click event
	            click: function click(e) {
	                _leaflet2.default.DomEvent.preventDefault(e);
	                this._expandSafely();
	            }
	        }, this);
	
	        if (!collapsed) {
	            this.expand();
	        }
	        container.appendChild(section);
	    },
	    _expandIfNotCollapsed: function _expandIfNotCollapsed() {
	        if (this._map && !this.options.collapsed) {
	            this.expand();
	        }
	        return this;
	    },
	    _expandSafely: function _expandSafely() {
	        var section = this._section;
	        _leaflet2.default.DomEvent.on(section, 'click', _leaflet2.default.DomEvent.preventDefault);
	        this.expand();
	        setTimeout(function () {
	            _leaflet2.default.DomEvent.off(section, 'click', _leaflet2.default.DomEvent.preventDefault);
	        });
	    }
	});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(162);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./orthophoto-plugin.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./orthophoto-plugin.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-touch .leaflet-control-layers.leaflet-control-orthophoto .leaflet-control-layers-toggle{width:34px;height:34px;background-image:none;background-color:#3ba9ea;color:#fff;font-size:24px;text-align:center}.leaflet-touch .leaflet-control-layers.leaflet-control-orthophoto .leaflet-control-orthophoto-btn{cursor:pointer;width:70px;height:70px;background-position:50%;background-size:contain;background-color:rgba(0,0,0,.2);position:relative;border-radius:10px;margin:2px;box-sizing:border-box;border:2px solid var(--w2c-leaflet-map-basemap-selection-not-selected,#ccc)}.leaflet-touch .leaflet-control-layers.leaflet-control-orthophoto .leaflet-control-orthophoto-btn.active{border:2px solid #326487}.leaflet-touch .leaflet-control-layers.leaflet-control-orthophoto .leaflet-control-orthophoto-btn .leaflet-control-orthophoto-btn-label{position:absolute;bottom:0;left:0;right:0;background-color:hsla(0,0%,100%,.5);text-align:center;font-size:12px}.leaflet-touch .leaflet-control-layers.leaflet-control-orthophoto .leaflet-control-orthophoto-basemap-btn{background:url(\"/o/de.xdot.liferay.map.web/icons/baseMap.jpg\")}.leaflet-touch .leaflet-control-layers.leaflet-control-orthophoto .leaflet-control-orthophoto-satellite-btn{background:url(\"/o/de.xdot.liferay.map.web/icons/satellite.jpg\")}", ""]);
	
	// exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(164);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(56)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./icons.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./icons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(55)();
	// imports
	
	
	// module
	exports.push([module.id, "[class*=\" icon-map-\"],[class^=icon-map-]{font-family:fliwas-font!important}.icon-map-plus:before{content:\"\\E925\"}.icon-map-pencil:before{content:\"\\E924\"}.icon-map-x:before{content:\"\\E92B\"}.icon-map-crosshairs-waves:before{content:\"\\E908\"}.icon-map-layer:before{content:\"\\E918\"}.icon-map-gear:before{content:\"\\E910\"}.icon-map-download:before{content:\"\\E934\"}.icon-map-arrow-expand:before{content:\"\\E92D\"}", ""]);
	
	// exports


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// map-portlet.js